var hl = Object.defineProperty;
var gl = (e, o, t) => o in e ? hl(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t;
var Gr = (e, o, t) => gl(e, typeof o != "symbol" ? o + "" : o, t);
import { inject as So, getCurrentInstance as ci, computed as H, ref as Z, shallowRef as ml, watch as se, getCurrentScope as di, onScopeDispose as ui, shallowReadonly as bo, unref as k, warn as bl, provide as ro, onMounted as pi, onBeforeUnmount as vl, defineComponent as A, openBlock as g, createBlock as M, resolveDynamicComponent as fe, normalizeClass as L, withCtx as S, renderSlot as B, useCssVars as He, createElementBlock as $, toDisplayString as z, createCommentVNode as I, createElementVNode as P, pushScopeId as fi, popScopeId as hi, nextTick as gi, normalizeProps as wr, guardReactiveProps as Cr, withScopeId as yl, resolveComponent as Re, normalizeStyle as ht, withKeys as K, Fragment as pe, mergeProps as y, createVNode as R, createApp as kl, h as wl, resolveDirective as xr, withDirectives as co, Transition as mi, watchEffect as Cl, reactive as Ot, readonly as xl, createTextVNode as ie, Teleport as Sl, renderList as Ze, vShow as qr, capitalize as $l, mergeModels as $o, useModel as kt, toRaw as Xr, withModifiers as Qr, camelize as Bl, createStaticVNode as _l, toRef as Ml } from "vue";
import { useLink as Tl } from "vue-router";
if (typeof window < "u") {
  let e = function() {
    var o = document.body, t = document.getElementById("__svg__icons__dom__");
    t || (t = document.createElementNS("http://www.w3.org/2000/svg", "svg"), t.style.position = "absolute", t.style.width = "0", t.style.height = "0", t.id = "__svg__icons__dom__", t.setAttribute("xmlns", "http://www.w3.org/2000/svg"), t.setAttribute("xmlns:link", "http://www.w3.org/1999/xlink")), t.innerHTML = '<symbol viewBox="0 0 16 16"  id="bg-icon-accessible"><path d="m14.247 7.994-.403 4.915c-.103 1.272-1.997 1.097-1.894-.153l.313-3.828L10.977 9a4.865 4.865 0 0 1-.828 5.469L8.922 13.24c1.81-1.991.41-5.225-2.313-5.225-.809 0-1.546.309-2.1.812L3.281 7.6a4.847 4.847 0 0 1 2.544-1.256l2.353-2.678-1.331-.775-1.613 1.437c-.937.838-2.206-.578-1.265-1.419l2.125-1.896A.947.947 0 0 1 7.204.9s4.352 2.528 4.359 2.534c.506.316.646 1.125.19 1.644L9.928 7.156l3.316-.184a.948.948 0 0 1 1.003 1.022ZM12.219 3.18A1.591 1.591 0 1 0 12.218 0a1.591 1.591 0 0 0 0 3.182ZM6.613 14.266c-2.52 0-3.982-2.832-2.585-4.879l-1.24-1.24a4.807 4.807 0 0 0-1.038 2.99c0 4.085 4.71 6.294 7.856 3.829l-1.24-1.241c-.5.34-1.103.54-1.753.54Z" /></symbol><symbol viewBox="0 0 33 32"  id="bg-icon-alert-outline"><path d="M16.491 24c.423 0 .78-.143 1.072-.429.291-.286.437-.64.437-1.062 0-.423-.143-.78-.429-1.072A1.428 1.428 0 0 0 16.51 21c-.423 0-.78.143-1.072.429-.291.286-.437.64-.437 1.062 0 .423.143.78.429 1.072.286.291.64.437 1.062.437Zm0-6c.423 0 .78-.144 1.072-.431A1.44 1.44 0 0 0 18 16.5v-7c0-.425-.143-.781-.429-1.069A1.439 1.439 0 0 0 16.51 8c-.423 0-.78.144-1.072.431A1.44 1.44 0 0 0 15 9.5v7c0 .425.143.781.429 1.069.286.287.64.431 1.062.431Zm.02 14c-2.202 0-4.275-.417-6.22-1.25a16.127 16.127 0 0 1-5.104-3.438A16.132 16.132 0 0 1 1.75 22.21C.917 20.267.5 18.19.5 15.98c0-2.209.417-4.279 1.25-6.21a16.192 16.192 0 0 1 3.438-5.082A16.132 16.132 0 0 1 10.29 1.25C12.233.417 14.31 0 16.52 0c2.209 0 4.279.417 6.21 1.25a16.163 16.163 0 0 1 8.52 8.53c.833 1.937 1.25 4.006 1.25 6.208 0 2.203-.417 4.276-1.25 6.22a16.126 16.126 0 0 1-3.438 5.105 16.163 16.163 0 0 1-5.092 3.437c-1.937.833-4.006 1.25-6.208 1.25Zm-.011-3c3.611 0 6.68-1.264 9.208-3.792C28.236 22.681 29.5 19.611 29.5 16c0-3.611-1.264-6.68-3.792-9.208C23.181 4.264 20.111 3 16.5 3c-3.611 0-6.68 1.264-9.208 3.792C4.764 9.319 3.5 12.389 3.5 16c0 3.611 1.264 6.68 3.792 9.208C9.819 27.736 12.889 29 16.5 29Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-alert"><g clip-path="url(#bg-icon-alert_a)"><path d="M8 16A8 8 0 1 0 8-.001 8 8 0 0 0 8 16ZM8 4c.416 0 .75.334.75.75v3.5c0 .416-.334.75-.75.75a.748.748 0 0 1-.75-.75v-3.5c0-.416.334-.75.75-.75Zm-1 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z" /></g><defs><clipPath id="bg-icon-alert_a"><path d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 17"  id="bg-icon-arrow-right"><mask id="bg-icon-arrow-right_a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17"><path d="M0 .668h16v16H0z" /></mask><g mask="url(#bg-icon-arrow-right_a)"><path d="m9.6 8.668-4.7-4.7a.771.771 0 0 1-.233-.566c0-.223.077-.412.233-.567a.771.771 0 0 1 .567-.233c.222 0 .41.077.566.233l4.984 4.983c.122.122.21.256.266.4a1.244 1.244 0 0 1 0 .9 1.15 1.15 0 0 1-.266.4l-4.984 4.984a.772.772 0 0 1-.566.233.772.772 0 0 1-.567-.233.772.772 0 0 1-.233-.567c0-.222.077-.411.233-.567l4.7-4.7Z" /></g></symbol><symbol viewBox="0 0 8 9"  id="bg-icon-back-arrow"><path d="M6.625 6.546c0 .25.195.454.437.454a.446.446 0 0 0 .438-.454V5.182c0-.752-.588-1.363-1.313-1.363H1.994l1.004-1.043a.468.468 0 0 0 0-.643.427.427 0 0 0-.62 0L.628 3.951a.468.468 0 0 0 0 .643l1.75 1.818c.171.178.449.178.62 0a.468.468 0 0 0 0-.643L1.994 4.728h4.193c.242 0 .438.203.438.454v1.364Z" /></symbol><symbol viewBox="0 0 24 24"  id="bg-icon-bank"><path d="M0 0h24v24H0z" fill="none" /><path d="M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z" /></symbol><symbol viewBox="0 0 14 16"  id="bg-icon-bell"><path d="M7 16a2 2 0 0 0 2-2H5A2 2 0 0 0 7 16Zm6.731-4.678c-.604-.65-1.733-1.625-1.733-4.822 0-2.428-1.703-4.372-3.999-4.849V1a1 1 0 1 0-1.998 0v.651c-2.296.477-3.998 2.42-3.998 4.849 0 3.197-1.13 4.173-1.734 4.822A.976.976 0 0 0 0 12a1 1 0 0 0 1.003 1h11.994A1 1 0 0 0 14 12a.975.975 0 0 0-.269-.678Z" /></symbol><symbol viewBox="0 0 16 15"  id="bg-icon-bucket"><g clip-path="url(#bg-icon-bucket_a)"><path d="M1.15.261a.887.887 0 0 1 1.256 0l2.26 2.258 1.476-1.475a2 2 0 0 1 2.827 0l4.206 4.209a2 2 0 0 1 0 2.828l-5.289 5.291a2.667 2.667 0 0 1-3.772 0L.85 10.108a2.667 2.667 0 0 1 0-3.772l2.558-2.558L1.15 1.517a.89.89 0 0 1 0-1.259v.003Zm4.889 6.147L4.667 5.036 2.108 7.594A.898.898 0 0 0 1.875 8h8.867l1.175-1.175a.223.223 0 0 0 0-.314L7.714 2.303a.223.223 0 0 0-.314 0L5.925 3.778 7.297 5.15A.89.89 0 0 1 6.04 6.408Zm8.183 7.814a1.78 1.78 0 0 1-1.778-1.778c0-.7.906-2.21 1.423-3.019a.418.418 0 0 1 .708 0c.52.808 1.425 2.32 1.425 3.02a1.78 1.78 0 0 1-1.778 1.777Z" /></g><defs><clipPath id="bg-icon-bucket_a"><path fill="#fff" d="M0 0h16v14.222H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 23 26"  id="bg-icon-calendar_today"><path d="M2.6 25.8c-.66 0-1.225-.239-1.695-.716C.435 24.605.2 24.044.2 23.4V5.8c0-.644.235-1.205.705-1.683A2.292 2.292 0 0 1 2.6 3.4H5v-2c0-.34.114-.625.343-.855A1.15 1.15 0 0 1 6.193.2c.338 0 .624.115.857.345.233.23.35.515.35.855v2h8v-2c0-.34.114-.625.343-.855a1.15 1.15 0 0 1 .85-.345c.338 0 .624.115.857.345.233.23.35.515.35.855v2h2.4c.66 0 1.225.24 1.695.717.47.478.705 1.039.705 1.683v17.6c0 .645-.235 1.206-.705 1.684a2.292 2.292 0 0 1-1.695.716H2.6Zm0-2.4h17.6v-12H2.6v12ZM2.6 9h17.6V5.8H2.6V9Z" /></symbol><symbol viewBox="0 0 27 27"  id="bg-icon-cancel"><path d="m13.25 15.035 3.867 3.867c.244.244.527.36.85.35a1.23 1.23 0 0 0 .85-.383 1.167 1.167 0 0 0 0-1.7l-3.867-3.85 3.867-3.852a1.167 1.167 0 0 0 0-1.699 1.167 1.167 0 0 0-1.7 0l-3.867 3.867-3.867-3.867c-.244-.244-.522-.366-.833-.366-.311 0-.589.122-.833.366a1.171 1.171 0 0 0-.003 1.7l3.836 3.867-3.867 3.867c-.244.244-.36.522-.35.833.011.311.14.589.384.834a1.167 1.167 0 0 0 1.697.003l3.836-3.837Zm.01 11.1c-1.762 0-3.421-.333-4.977-1a12.903 12.903 0 0 1-4.083-2.75 12.907 12.907 0 0 1-2.75-4.082c-.667-1.555-1-3.216-1-4.983 0-1.768.333-3.424 1-4.968a12.906 12.906 0 0 1 6.832-6.817c1.555-.667 3.216-1 4.983-1 1.768 0 3.424.333 4.968 1 1.545.667 2.9 1.583 4.067 2.75a12.93 12.93 0 0 1 2.75 4.074c.667 1.55 1 3.205 1 4.967 0 1.762-.333 3.42-1 4.976a12.902 12.902 0 0 1-2.75 4.083 12.933 12.933 0 0 1-4.074 2.75c-1.55.667-3.205 1-4.967 1Zm-.01-2.4c2.889 0 5.345-1.011 7.367-3.033 2.022-2.022 3.033-4.478 3.033-7.367 0-2.889-1.011-5.344-3.033-7.367-2.023-2.022-4.478-3.033-7.367-3.033-2.889 0-5.344 1.011-7.367 3.033-2.022 2.023-3.033 4.478-3.033 7.367 0 2.889 1.011 5.345 3.033 7.367 2.023 2.022 4.478 3.033 7.367 3.033Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-caret-down"><path d="M2.807 5h10.386a.806.806 0 0 1 .569 1.376l-5.19 5.195a.809.809 0 0 1-1.143 0l-5.19-5.195A.806.806 0 0 1 2.806 5Z" /><path d="M2.807 5h10.386a.806.806 0 0 1 .569 1.376l-5.19 5.195a.809.809 0 0 1-1.143 0l-5.19-5.195A.806.806 0 0 1 2.806 5Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-caret-left"><path d="M12 2.807v10.386a.806.806 0 0 1-1.376.569l-5.195-5.19a.809.809 0 0 1 0-1.143l5.195-5.19A.806.806 0 0 1 12 2.806Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-caret-right"><path d="M5 13.193V2.807a.806.806 0 0 1 1.376-.569l5.195 5.19a.809.809 0 0 1 0 1.143l-5.195 5.19A.806.806 0 0 1 5 13.194Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-caret-up"><path d="M13.193 11.807H2.807a.806.806 0 0 1-.569-1.376l5.19-5.195a.809.809 0 0 1 1.143 0l5.19 5.195a.806.806 0 0 1-.568 1.376Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-check-box"><path d="M14.286 16H1.714A1.714 1.714 0 0 1 0 14.286V1.714C0 .767.767 0 1.714 0h12.572C15.233 0 16 .767 16 1.714v12.572c0 .947-.768 1.714-1.714 1.714Zm-7.31-3.502 6.57-6.572a.571.571 0 0 0 0-.808l-.807-.808a.571.571 0 0 0-.808 0L6.57 9.67 4.07 7.166a.571.571 0 0 0-.808 0l-.808.808a.571.571 0 0 0 0 .809l3.714 3.714a.571.571 0 0 0 .809 0Z" /></symbol><symbol viewBox="0 0 32 32"  id="bg-icon-check-outline"><path d="m13.875 17.75-2.5-2.458c-.306-.306-.653-.459-1.042-.459s-.736.153-1.041.459c-.306.305-.459.66-.459 1.062 0 .403.153.757.459 1.063l3.541 3.541c.306.306.653.459 1.042.459s.736-.153 1.042-.459l7.791-7.791c.306-.306.459-.66.459-1.063 0-.403-.153-.757-.459-1.062-.305-.306-.652-.459-1.041-.459-.39 0-.736.153-1.042.459l-6.75 6.708ZM16 32c-2.194 0-4.264-.417-6.208-1.25a16.127 16.127 0 0 1-5.104-3.438 16.126 16.126 0 0 1-3.438-5.104C.417 20.264 0 18.194 0 16c0-2.222.417-4.299 1.25-6.23a16.192 16.192 0 0 1 3.438-5.082A16.127 16.127 0 0 1 9.791 1.25C11.736.417 13.806 0 16 0c2.222 0 4.299.417 6.23 1.25a16.192 16.192 0 0 1 8.52 8.52C31.583 11.702 32 13.779 32 16c0 2.194-.417 4.264-1.25 6.208a16.126 16.126 0 0 1-3.438 5.105 16.192 16.192 0 0 1-5.083 3.437C20.3 31.583 18.222 32 16 32Zm0-3c3.611 0 6.68-1.264 9.208-3.792C27.736 22.681 29 19.611 29 16c0-3.611-1.264-6.68-3.792-9.208C22.681 4.264 19.611 3 16 3c-3.611 0-6.68 1.264-9.208 3.792C4.264 9.319 3 12.389 3 16c0 3.611 1.264 6.68 3.792 9.208C9.319 27.736 12.389 29 16 29Z" /></symbol><symbol viewBox="0 0 19 23"  id="bg-icon-check-price"><path d="m11.1 19.137 5.567-5.567c.244-.244.522-.367.833-.367.311 0 .589.123.833.367a1.166 1.166 0 0 1 0 1.7l-6.4 6.433a1.116 1.116 0 0 1-.827.367c-.315 0-.599-.126-.85-.378l-3.59-3.589a1.109 1.109 0 0 1-.35-.85 1.23 1.23 0 0 1 .384-.85 1.166 1.166 0 0 1 1.7 0l2.7 2.734Zm-7.9-5v-.4h-2c-.34 0-.625-.115-.855-.343a1.15 1.15 0 0 1-.345-.85c0-.338.115-.624.345-.857.23-.234.515-.35.855-.35h5.2v-2.4H1.6c-.453 0-.833-.154-1.14-.46A1.548 1.548 0 0 1 0 7.337v-4c0-.454.153-.834.46-1.14.307-.307.687-.46 1.14-.46h1.6v-.4c0-.34.114-.625.343-.855a1.15 1.15 0 0 1 .85-.345c.338 0 .624.115.857.345.233.23.35.515.35.855v.4h2c.34 0 .625.114.855.343.23.228.345.512.345.85 0 .338-.115.623-.345.857-.23.233-.515.35-.855.35H2.4v2.4h4.8c.453 0 .833.153 1.14.46.307.306.46.686.46 1.14v4c0 .453-.153.833-.46 1.14-.307.306-.687.46-1.14.46H5.6v.4c0 .34-.114.625-.343.855a1.15 1.15 0 0 1-.85.345c-.338 0-.624-.115-.857-.345a1.153 1.153 0 0 1-.35-.855Z" /></symbol><symbol viewBox="0 0 8 9"  id="bg-icon-check"><path d="M7.833 1.676a.622.622 0 0 1 0 .849l-4.571 4.8a.553.553 0 0 1-.81 0l-2.285-2.4a.622.622 0 0 1 0-.85.553.553 0 0 1 .81 0L2.857 6.05l4.168-4.373a.553.553 0 0 1 .808 0h-.001Z" /></symbol><symbol viewBox="0 0 27 27"  id="bg-icon-clock"><path d="M14.7 12.335v-5.8c0-.34-.114-.625-.343-.855a1.15 1.15 0 0 0-.85-.345c-.338 0-.624.115-.857.345-.233.23-.35.515-.35.855v6.3c0 .178.033.339.1.483.067.145.156.273.267.384l4.461 4.461c.248.248.533.367.855.355a1.23 1.23 0 0 0 .85-.383c.245-.244.367-.528.367-.85 0-.322-.126-.608-.378-.858L14.7 12.335Zm-1.2 13.8c-1.764 0-3.422-.333-4.973-1a12.923 12.923 0 0 1-4.077-2.75 12.907 12.907 0 0 1-2.75-4.082c-.667-1.555-1-3.216-1-4.983 0-1.768.333-3.43 1-4.985a12.706 12.706 0 0 1 2.75-4.067 13.047 13.047 0 0 1 4.082-2.733c1.555-.667 3.216-1 4.983-1 1.768 0 3.43.336 4.985 1.008a12.914 12.914 0 0 1 4.06 2.736 12.928 12.928 0 0 1 2.733 4.064c.671 1.557 1.007 3.222 1.007 4.992 0 1.764-.333 3.422-1 4.973a13.065 13.065 0 0 1-2.733 4.077 12.695 12.695 0 0 1-4.071 2.75c-1.559.667-3.224 1-4.996 1Zm.016-2.4c2.877 0 5.327-1.017 7.35-3.05 2.023-2.033 3.034-4.488 3.034-7.366 0-2.877-1.011-5.327-3.034-7.35-2.023-2.023-4.473-3.034-7.35-3.034S8.183 3.946 6.15 5.97C4.117 7.992 3.1 10.442 3.1 13.32s1.017 5.333 3.05 7.366c2.033 2.034 4.489 3.05 7.366 3.05Z" /></symbol><symbol viewBox="0 0 9 9"  id="bg-icon-close"><path d="M8.477 1.866A.8.8 0 0 0 7.345.734L4.714 3.368 2.08.737A.8.8 0 0 0 .948 1.869L3.582 4.5.95 7.134a.8.8 0 0 0 1.132 1.132l2.63-2.634 2.635 2.631A.8.8 0 0 0 8.48 7.131L5.846 4.5l2.631-2.634Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-code"><path d="M1.6 4.1c0-.882.717-1.6 1.6-1.6h9.6c.882 0 1.6.717 1.6 1.6v6.4h-1.6V4.1H3.2v6.4H1.6V4.1ZM0 11.78a.48.48 0 0 1 .48-.48h15.04a.48.48 0 0 1 .48.48c0 1.06-.86 1.92-1.92 1.92H1.92A1.92 1.92 0 0 1 0 11.78Zm7.025-4.855L6.25 7.7l.775.775a.6.6 0 0 1-.848.848l-1.2-1.2a.598.598 0 0 1 0-.848l1.2-1.2a.6.6 0 0 1 .848.848v.002Zm2.8-.85 1.2 1.2a.598.598 0 0 1 0 .848l-1.2 1.2a.6.6 0 0 1-.848-.848l.775-.775-.775-.775a.6.6 0 0 1 .848-.848v-.002Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-company"><path d="M.92 6.3h14.16a.92.92 0 0 0 .765-1.43l-1.89-2.835a1.194 1.194 0 0 0-.998-.535H3.043c-.4 0-.774.2-.997.535L.155 4.867A.921.921 0 0 0 .92 6.3Zm.68.8v6a1.2 1.2 0 0 0 1.2 1.2h5.6a1.2 1.2 0 0 0 1.2-1.2v-6H8v4H3.2v-4H1.6Zm11.2 0v6.4a.8.8 0 1 0 1.6 0V7.1h-1.6Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-compass"><g clip-path="url(#bg-icon-compass_a)"><path d="M10.998 3c0 .446-.097.871-.275 1.255l1.65 2.85A5.977 5.977 0 0 1 9.608 8.78l-1.61-2.781L5.874 9.67a7.033 7.033 0 0 0 2.128.328 6.983 6.983 0 0 0 5.464-2.624c.347-.432.975-.5 1.406-.157.431.344.5.975.156 1.406a9 9 0 0 1-7.03 3.375c-1.106 0-2.168-.2-3.146-.566l-1.768 3.056c-.147.253-.366.46-.628.59l-1.731.866A.501.501 0 0 1 0 15.497v-1.73c0-.263.069-.523.203-.754l1.875-3.24c-.4-.35-.772-.734-1.103-1.15a1 1 0 1 1 1.562-1.25c.178.222.369.432.569.629l2.168-3.747A3.003 3.003 0 0 1 7.998 0a3 3 0 0 1 3 3Zm.656 9.307c1.018-.4 1.953-.962 2.778-1.653l1.365 2.36c.131.227.203.487.203.752v1.731a.502.502 0 0 1-.725.447l-1.73-.866a1.506 1.506 0 0 1-.629-.59l-1.262-2.181ZM7.998 3.999a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" /></g><defs><clipPath id="bg-icon-compass_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-computer"><path d="M1.778 1A1.78 1.78 0 0 0 0 2.778v8c0 .98.797 1.778 1.778 1.778h4.889l-.298.888H4.444a.888.888 0 1 0 0 1.778h7.112a.888.888 0 1 0 0-1.778H9.63l-.298-.888h4.89A1.78 1.78 0 0 0 16 10.778v-8A1.78 1.78 0 0 0 14.222 1H1.778Zm12.444 1.778V9H1.778V2.778h12.444Z" /></symbol><symbol viewBox="0 0 22 24"  id="bg-icon-copy"><path d="M18.994 15.75H9.975a.753.753 0 0 1-.751-.75V3c0-.413.338-.75.751-.75h6.581l3.19 3.183V15c0 .412-.339.75-.752.75ZM9.975 18h9.019A3.006 3.006 0 0 0 22 15V5.433c0-.595-.24-1.167-.662-1.59L18.153.662A2.257 2.257 0 0 0 16.561 0H9.975A3.006 3.006 0 0 0 6.97 3v12c0 1.655 1.348 3 3.006 3ZM3.963 6A3.006 3.006 0 0 0 .957 9v12c0 1.655 1.348 3 3.006 3h9.018a3.006 3.006 0 0 0 3.007-3v-1.5h-2.255V21c0 .413-.338.75-.752.75H3.963A.753.753 0 0 1 3.21 21V9c0-.412.338-.75.752-.75h1.503V6H3.963Z" /></symbol><symbol viewBox="0 0 28 22"  id="bg-icon-credit-card"><path d="M27.334 3v16c0 .733-.261 1.36-.784 1.883a2.568 2.568 0 0 1-1.883.783H3.334a2.568 2.568 0 0 1-1.884-.783A2.568 2.568 0 0 1 .667 19V3c0-.734.261-1.361.783-1.884A2.568 2.568 0 0 1 3.334.333h21.333c.733 0 1.361.261 1.883.783.523.523.784 1.15.784 1.884Zm-24 2.666h21.333V3H3.334v2.666Zm0 5.334v8h21.333v-8H3.334Z" /></symbol><symbol viewBox="0 0 24 24"  id="bg-icon-credit-score"><mask id="bg-icon-credit-score_a" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24"><path d="M0 0h24v24H0z" /></mask><g mask="url(#bg-icon-credit-score_a)"><path d="M4.2 8.4h15.6V6.6H4.2v1.8ZM2.4 6.6c0-.483.18-.904.538-1.262.358-.359.779-.538 1.262-.538h15.6c.483 0 .904.18 1.262.538.359.358.538.779.538 1.262v4.5a.87.87 0 0 1-.259.641.871.871 0 0 1-.641.259H4.2v5.4h3.3c.255 0 .469.086.641.257a.863.863 0 0 1 .259.638.88.88 0 0 1-.259.642.864.864 0 0 1-.641.263H4.2a1.869 1.869 0 0 1-1.262-.537 1.668 1.668 0 0 1-.538-1.256V6.6Zm1.8 0v10.8-2.75 1.85-9.9Zm10.628 14.6c-.119 0-.236-.02-.353-.063a.799.799 0 0 1-.3-.187L11.2 17.975a.862.862 0 0 1-.275-.625c0-.233.092-.442.275-.625a.88.88 0 0 1 1.275 0L14.8 19.05l4.9-4.9a.818.818 0 0 1 .625-.263.953.953 0 0 1 .637.288.894.894 0 0 1-.012 1.275l-5.5 5.5a.884.884 0 0 1-.622.25Z" /></g></symbol><symbol viewBox="0 0 16 17"  id="bg-icon-delete"><path d="M2 14.5A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5V4H2v10.5Zm8.5-8a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7Zm-3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7Zm-3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7Zm10-5.5h-3.75l-.294-.584A.75.75 0 0 0 9.784 0H6.212a.741.741 0 0 0-.668.416L5.25 1H1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-dev"><path d="m6.973 14.786-1.525-.443a.3.3 0 0 1-.205-.372L8.655 2.217a.3.3 0 0 1 .372-.205l1.525.442a.3.3 0 0 1 .205.373L7.345 14.58a.3.3 0 0 1-.372.205Zm-2.85-2.805 1.087-1.16a.3.3 0 0 0-.02-.43L2.925 8.399 5.19 6.406a.298.298 0 0 0 .02-.43l-1.087-1.16a.3.3 0 0 0-.425-.012L.096 8.179a.298.298 0 0 0 0 .437l3.602 3.377c.122.115.312.11.425-.012Zm8.18.015 3.601-3.377a.298.298 0 0 0 0-.438l-3.602-3.38a.303.303 0 0 0-.425.013l-1.087 1.16a.3.3 0 0 0 .02.43l2.265 1.995-2.265 1.992a.298.298 0 0 0-.02.43l1.087 1.16a.3.3 0 0 0 .425.015Z" /></symbol><symbol viewBox="0 0 14 16"  id="bg-icon-doc"><g clip-path="url(#bg-icon-doc_a)"><path d="M0 2C0 .897.897 0 2 0h10c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V2Zm5.719 6.713A3.006 3.006 0 0 1 4.04 6.5h1.221c.05.95.241 1.681.457 2.213ZM7.009 9H6.99a3.268 3.268 0 0 1-.284-.516C6.52 8.06 6.32 7.412 6.262 6.5h1.472c-.056.912-.253 1.56-.443 1.984-.107.238-.21.407-.285.516h.003Zm1.272-.287c.213-.535.403-1.263.457-2.213h1.221a3.006 3.006 0 0 1-1.678 2.213ZM8.738 5.5c-.05-.95-.241-1.681-.457-2.212A3.006 3.006 0 0 1 9.96 5.5H8.738ZM6.99 3h.019c.074.11.178.278.284.516.187.425.387 1.072.444 1.984H6.265c.056-.912.253-1.56.443-1.984.107-.238.21-.407.285-.516H6.99Zm-1.272.288c-.213.534-.403 1.262-.457 2.212H4.042c.165-.981.806-1.8 1.678-2.212ZM11 6a4 4 0 1 0-8 0 4 4 0 0 0 8 0Zm-7.5 6c-.275 0-.5.225-.5.5s.225.5.5.5h7c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-7Z" /></g><defs><clipPath id="bg-icon-doc_a"><path fill="#fff" d="M0 0h14v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 12 16"  id="bg-icon-dollar-doc"><g clip-path="url(#bg-icon-dollar-doc_a)"><path d="M2 0C.897 0 0 .897 0 2v12c0 1.103.897 2 2 2h8c1.103 0 2-.897 2-2V5H8c-.553 0-1-.447-1-1V0H2Zm6 0v4h4L8 0ZM2 2.5c0-.275.225-.5.5-.5h2c.275 0 .5.225.5.5s-.225.5-.5.5h-2a.501.501 0 0 1-.5-.5Zm0 2c0-.275.225-.5.5-.5h2c.275 0 .5.225.5.5s-.225.5-.5.5h-2a.501.501 0 0 1-.5-.5Zm4 2.25c.275 0 .5.225.5.5v.54c.266.038.522.098.753.16a.5.5 0 1 1-.26.966c-.346-.094-.687-.163-1.002-.166-.263-.003-.544.056-.738.172-.178.106-.253.228-.253.4 0 .116.04.203.228.316.216.128.519.221.913.34l.015.003c.353.107.79.238 1.135.457.378.237.7.615.709 1.193.01.603-.3 1.04-.716 1.3-.24.15-.512.238-.784.285v.534c0 .275-.225.5-.5.5a.501.501 0 0 1-.5-.5v-.556a6.697 6.697 0 0 1-.966-.278l-.193-.066a.499.499 0 1 1 .315-.947c.078.025.15.05.222.075.425.144.769.263 1.135.272.284.01.559-.053.74-.166.16-.1.247-.228.244-.437-.003-.144-.056-.244-.24-.363-.213-.134-.516-.23-.907-.35l-.05-.015c-.344-.103-.76-.228-1.087-.428-.375-.225-.707-.591-.71-1.166-.003-.606.338-1.025.744-1.266.234-.137.494-.225.753-.271V7.25c0-.275.225-.5.5-.5Z" /></g><defs><clipPath id="bg-icon-dollar-doc_a"><path fill="#fff" d="M0 0h12v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-dollar"><path d="m10.536 7.294-3.375-.988a.922.922 0 0 1 .26-1.806h2.072c.38 0 .756.116 1.068.328.191.128.447.097.61-.062l1.087-1.063a.507.507 0 0 0-.056-.765A4.419 4.419 0 0 0 9.499 2V.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5V2H7.42C5.43 2 3.83 3.71 4.014 5.737c.132 1.441 1.232 2.613 2.62 3.02l3.202.937a.922.922 0 0 1-.26 1.806h-2.07c-.382 0-.757-.116-1.07-.328a.487.487 0 0 0-.609.062l-1.088 1.063a.507.507 0 0 0 .057.765c.765.6 1.722.935 2.703.938v1.5c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-1.506c1.456-.028 2.822-.894 3.303-2.272a3.432 3.432 0 0 0-2.266-4.428Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-download"><path d="M16 8c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8Zm-4.632-.932L9.032 9.503v-5.89a.772.772 0 0 0-.774-.774h-.516a.772.772 0 0 0-.774.774v5.89L4.632 7.068a.775.775 0 0 0-1.106-.013l-.352.355a.771.771 0 0 0 0 1.093l4.278 4.28a.771.771 0 0 0 1.093 0l4.28-4.28a.771.771 0 0 0 0-1.093l-.35-.355a.775.775 0 0 0-1.107.013Z" /></symbol><symbol viewBox="0 0 24 24"  id="bg-icon-edit"><path d="M22.106 1.017a2.623 2.623 0 0 0-3.712 0l-1.411 1.406 4.589 4.59 1.41-1.411a2.623 2.623 0 0 0 0-3.713l-.876-.872ZM8.081 11.33a2.59 2.59 0 0 0-.633 1.026L6.061 16.52a1.13 1.13 0 0 0 .272 1.153c.3.305.745.408 1.153.272l4.162-1.388a2.655 2.655 0 0 0 1.027-.633l7.842-7.846-4.594-4.594-7.842 7.847ZM4.5 3A4.501 4.501 0 0 0 0 7.5v12C0 21.984 2.016 24 4.5 24h12c2.484 0 4.5-2.016 4.5-4.5V15c0-.83-.67-1.5-1.5-1.5S18 14.17 18 15v4.5c0 .83-.67 1.5-1.5 1.5h-12c-.83 0-1.5-.67-1.5-1.5v-12C3 6.67 3.67 6 4.5 6H9c.83 0 1.5-.67 1.5-1.5S9.83 3 9 3H4.5Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-email"><path d="M1.5 2a1.5 1.5 0 0 0-.9 2.7l6.8 5.1c.356.266.844.266 1.2 0l6.8-5.1a1.5 1.5 0 0 0-.9-2.7h-13ZM0 5.5V12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V5.5l-6.8 5.1a1.997 1.997 0 0 1-2.4 0L0 5.5Z" /></symbol><symbol viewBox="0 0 26 26"  id="bg-icon-error"><path d="M13.193 19.4c.338 0 .624-.114.857-.343.233-.229.35-.512.35-.85 0-.338-.114-.623-.343-.857a1.143 1.143 0 0 0-.85-.35c-.338 0-.624.114-.857.343-.233.229-.35.512-.35.85 0 .338.114.624.343.857.229.233.512.35.85.35Zm0-4.8c.338 0 .624-.115.857-.345.233-.23.35-.515.35-.855V7.8c0-.34-.114-.625-.343-.855a1.15 1.15 0 0 0-.85-.345c-.338 0-.624.115-.857.345-.233.23-.35.515-.35.855v5.6c0 .34.114.625.343.855.229.23.512.345.85.345Zm.016 11.2c-1.761 0-3.42-.333-4.976-1a12.902 12.902 0 0 1-4.083-2.75 12.906 12.906 0 0 1-2.75-4.082c-.667-1.555-1-3.216-1-4.983 0-1.768.333-3.424 1-4.968A12.906 12.906 0 0 1 8.232 1.2c1.555-.666 3.216-1 4.983-1 1.768 0 3.424.334 4.968 1 1.545.667 2.9 1.584 4.067 2.75A12.932 12.932 0 0 1 25 8.024c.667 1.55 1 3.205 1 4.967 0 1.762-.333 3.42-1 4.976a12.904 12.904 0 0 1-2.75 4.083 12.931 12.931 0 0 1-4.074 2.75c-1.55.667-3.205 1-4.967 1Zm-.009-2.4c2.889 0 5.344-1.01 7.367-3.033C22.589 18.345 23.6 15.889 23.6 13c0-2.889-1.011-5.344-3.033-7.366C18.544 3.61 16.089 2.6 13.2 2.6c-2.889 0-5.344 1.011-7.367 3.034C3.811 7.656 2.8 10.11 2.8 13c0 2.89 1.011 5.345 3.033 7.367C7.856 22.389 10.311 23.4 13.2 23.4Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-euro-circle"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16ZM4.932 7.243c0-.053 0-.104.002-.157H4.62A.624.624 0 0 1 4 6.457c0-.348.278-.628.621-.628h.55C5.745 4.18 7.3 3 9.125 3h.466c.343 0 .62.28.62.629a.624.624 0 0 1-.62.628h-.466c-1.124 0-2.1.637-2.6 1.572H8.97c.344 0 .622.28.622.628a.624.624 0 0 1-.622.629H6.178a4.144 4.144 0 0 0-.004.157v.314c0 .053.002.106.004.157h2.791c.344 0 .622.281.622.629a.624.624 0 0 1-.622.628H6.525a2.947 2.947 0 0 0 2.6 1.572h.466c.343 0 .62.28.62.628a.624.624 0 0 1-.62.629h-.466c-1.825 0-3.38-1.18-3.954-2.829h-.55A.624.624 0 0 1 4 8.343c0-.348.278-.629.621-.629h.313c-.002-.053-.002-.104-.002-.157v-.314Z" fill="inherit" /></symbol><symbol viewBox="0 0 18 17"  id="bg-icon-eye"><g clip-path="url(#bg-icon-eye_a)"><path d="M9 3c-2.037 0-3.712.925-4.997 2.116C2.8 6.234 1.97 7.563 1.543 8.5 1.97 9.438 2.8 10.766 4 11.884 5.288 13.075 6.963 14 9 14c2.038 0 3.713-.925 4.997-2.116 1.203-1.118 2.034-2.447 2.46-3.384C16.03 7.562 15.2 6.234 14 5.116 12.713 3.925 11.038 3 9 3ZM2.981 4.019C4.453 2.65 6.475 1.5 9.001 1.5c2.524 0 4.546 1.15 6.018 2.519 1.462 1.36 2.44 2.981 2.906 4.097a.994.994 0 0 1 0 .768c-.465 1.116-1.444 2.741-2.906 4.097C13.547 14.35 11.525 15.5 9 15.5s-4.547-1.15-6.019-2.519C1.52 11.625.541 10 .078 8.884a.994.994 0 0 1 0-.768C.541 7 1.52 5.375 2.981 4.019ZM9.001 11a2.5 2.5 0 1 0 0-5h-.063A2.002 2.002 0 0 1 6.5 8.438V8.5A2.5 2.5 0 0 0 9 11Zm0-6.5a4 4 0 1 1 0 8 4 4 0 0 1 0-8Z" /></g><defs><clipPath id="bg-icon-eye_a"><path fill="#fff" transform="translate(0 .5)" d="M0 0h18v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 15"  id="bg-icon-filter"><path d="M7.022 14.98a.969.969 0 0 1-.697-.269.886.886 0 0 1-.281-.667V8.427L.2 1.287C-.03 1.022-.061.741.102.445A.808.808 0 0 1 .86 0h14.28c.342 0 .595.148.758.445.163.296.13.577-.098.842l-5.844 7.14v5.617a.886.886 0 0 1-.281.667.969.969 0 0 1-.697.27H7.022Z" /></symbol><symbol viewBox="0 0 51 40"  id="bg-icon-gears"><g clip-path="url(#bg-icon-gears_a)"><path d="M24.602 10.57c.555-.492.774-1.265.485-1.953-.18-.414-.375-.82-.594-1.21l-.242-.423c-.235-.39-.492-.773-.766-1.14-.445-.594-1.226-.79-1.93-.555l-2.203.727a9.9 9.9 0 0 0-2.828-1.633l-.476-2.266c-.149-.726-.711-1.304-1.446-1.39a11.61 11.61 0 0 0-1.57-.102h-.055c-.531 0-1.054.031-1.57.094-.734.086-1.297.672-1.445 1.39l-.477 2.274a9.978 9.978 0 0 0-2.828 1.633l-2.211-.72c-.703-.234-1.484-.038-1.93.556-.273.367-.53.75-.773 1.14l-.234.414c-.22.39-.415.797-.594 1.219-.29.68-.07 1.453.484 1.953l1.735 1.547a10.061 10.061 0 0 0 0 3.258L1.399 16.93c-.555.492-.773 1.265-.484 1.953.18.414.375.82.594 1.219l.234.406c.234.398.492.773.773 1.14.446.594 1.227.79 1.93.555l2.203-.726a9.9 9.9 0 0 0 2.828 1.632l.477 2.274c.148.726.71 1.305 1.445 1.39a13.43 13.43 0 0 0 3.188 0c.734-.085 1.296-.671 1.445-1.39l.477-2.274a9.98 9.98 0 0 0 2.828-1.632l2.203.726c.703.235 1.484.04 1.93-.555.273-.367.53-.742.765-1.14l.242-.422c.219-.39.414-.797.594-1.211.29-.68.07-1.453-.484-1.953l-1.735-1.547c.086-.531.133-1.078.133-1.633 0-.555-.047-1.101-.133-1.633l1.735-1.546.015.007ZM9.251 13.75a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0Zm30.68 25.352c.492.554 1.265.773 1.953.484.414-.18.82-.375 1.21-.594l.422-.242c.391-.234.774-.492 1.141-.766.594-.445.789-1.226.555-1.93l-.727-2.202a9.9 9.9 0 0 0 1.633-2.829l2.273-.476c.727-.149 1.305-.711 1.391-1.445a13.433 13.433 0 0 0 0-3.188c-.086-.734-.672-1.297-1.39-1.445l-2.274-.485a9.978 9.978 0 0 0-1.633-2.828l.727-2.203c.234-.703.039-1.484-.555-1.93-.367-.273-.75-.53-1.14-.773l-.415-.234c-.39-.22-.797-.414-1.218-.594-.68-.29-1.454-.07-1.954.484l-1.547 1.735a10.237 10.237 0 0 0-1.632-.133c-.555 0-1.102.047-1.633.133l-1.547-1.735c-.492-.554-1.266-.773-1.953-.484-.414.18-.82.375-1.219.594l-.406.234c-.398.234-.773.492-1.14.773-.595.446-.79 1.227-.555 1.93l.726 2.203a9.9 9.9 0 0 0-1.633 2.828l-2.273.47c-.727.148-1.305.71-1.39 1.444a13.432 13.432 0 0 0 0 3.188c.085.734.671 1.297 1.39 1.445l2.273.477a9.976 9.976 0 0 0 1.633 2.828l-.726 2.203c-.235.703-.04 1.484.554 1.93.367.273.742.531 1.14.765l.423.243c.39.218.797.414 1.21.593.68.29 1.454.07 1.954-.484l1.547-1.734c.531.086 1.078.132 1.633.132.554 0 1.101-.047 1.632-.132l1.547 1.734-.008.016ZM36.75 23.75a3.75 3.75 0 1 1 0 7.499 3.75 3.75 0 0 1 0-7.499Z" /></g><defs><clipPath id="bg-icon-gears_a"><path fill="#fff" transform="translate(.5)" d="M0 0h50v40H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 15"  id="bg-icon-group"><g clip-path="url(#bg-icon-group_a)"><path d="M.889 3.317A1.774 1.774 0 0 1 0 1.777C0 .798.797 0 1.778 0c.658 0 1.233.358 1.539.889h9.366A1.78 1.78 0 0 1 16 1.778c0 .658-.358 1.233-.889 1.539v7.589a1.778 1.778 0 1 1-2.428 2.427H3.317a1.778 1.778 0 1 1-2.428-2.427v-7.59Zm11.794-.65H3.317a1.78 1.78 0 0 1-.65.65v7.589c.27.155.494.38.65.65h9.366c.156-.27.38-.495.65-.65v-7.59a1.78 1.78 0 0 1-.65-.65ZM3.556 4.444c0-.491.397-.888.888-.888H8c.492 0 .889.397.889.888v2.667A.888.888 0 0 1 8 8H4.444a.888.888 0 0 1-.888-.889V4.444ZM7.11 8.89H8A1.78 1.78 0 0 0 9.778 7.11v-.889h1.778c.491 0 .888.397.888.89v2.666a.888.888 0 0 1-.888.889H8a.888.888 0 0 1-.889-.89V8.89Z" /></g><defs><clipPath id="bg-icon-group_a"><path fill="#fff" d="M0 0h16v14.222H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-image"><path d="M14.5 14h-13A1.5 1.5 0 0 1 0 12.5v-9A1.5 1.5 0 0 1 1.5 2h13A1.5 1.5 0 0 1 16 3.5v9a1.5 1.5 0 0 1-1.5 1.5ZM3.5 3.75a1.75 1.75 0 1 0 0 3.5 1.75 1.75 0 0 0 0-3.5ZM2 12h12V8.5l-2.735-2.735a.375.375 0 0 0-.53 0L6.5 10 4.765 8.265a.375.375 0 0 0-.53 0L2 10.5V12Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-info-outline"><g clip-path="url(#bg-icon-info-outline_a)"><path d="M8 14.4A6.408 6.408 0 0 1 1.6 8c0-3.528 2.872-6.4 6.4-6.4 3.528 0 6.4 2.872 6.4 6.4 0 3.528-2.872 6.4-6.4 6.4ZM8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Z" /><circle cx="8" cy="5.6" r=".8" /><path d="M7.2 8a.8.8 0 0 1 1.6 0v3.2a.8.8 0 0 1-1.6 0V8Z" /></g><defs><clipPath id="bg-icon-info-outline_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-info"><g clip-path="url(#bg-icon-info_a)"><path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0Zm0 12a.748.748 0 0 1-.75-.75v-3.5c0-.416.334-.75.75-.75s.75.334.75.75v3.5c0 .416-.334.75-.75.75Zm1-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" /></g><defs><clipPath id="bg-icon-info_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-key"><g clip-path="url(#bg-icon-key_a)"><path d="M10.5 11A5.5 5.5 0 1 0 5 5.5c0 .584.09 1.15.26 1.678l-5.041 5.04A.75.75 0 0 0 0 12.75v2.5c0 .416.334.75.75.75h2.5c.416 0 .75-.334.75-.75V14h1.25c.416 0 .75-.334.75-.75V12h1.25c.2 0 .39-.078.531-.219l1.04-1.04c.529.168 1.095.259 1.679.259Zm1.25-8a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" /></g><defs><clipPath id="bg-icon-key_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-left-arrow"><path d="M.335 7.191a1.148 1.148 0 0 0 0 1.621l5.714 5.726a1.143 1.143 0 0 0 1.618 0 1.148 1.148 0 0 0 0-1.621L3.9 9.145h10.958C15.49 9.145 16 8.633 16 8s-.51-1.145-1.143-1.145H3.903l3.76-3.772a1.148 1.148 0 0 0 0-1.62 1.143 1.143 0 0 0-1.617 0L.33 7.187l.004.003Z" /></symbol><symbol viewBox="0 0 30 24"  id="bg-icon-link"><path d="M26.678 12.548a6.776 6.776 0 0 0 0-9.585 6.777 6.777 0 0 0-8.733-.722l-.075.051a1.496 1.496 0 0 0-.347 2.09 1.5 1.5 0 0 0 2.091.348l.075-.052a3.773 3.773 0 0 1 4.866.403 3.777 3.777 0 0 1 0 5.344l-5.26 5.269a3.777 3.777 0 0 1-5.344 0 3.774 3.774 0 0 1-.403-4.866l.052-.075a1.5 1.5 0 0 0-.347-2.09 1.504 1.504 0 0 0-2.09.346l-.052.075a6.765 6.765 0 0 0 .717 8.729 6.776 6.776 0 0 0 9.586 0l5.264-5.265ZM2.322 11.452a6.776 6.776 0 0 0 0 9.586 6.777 6.777 0 0 0 8.733.721l.075-.051c.675-.483.83-1.42.346-2.09a1.5 1.5 0 0 0-2.09-.348l-.075.052a3.773 3.773 0 0 1-4.866-.403 3.783 3.783 0 0 1 0-5.349l5.26-5.264a3.78 3.78 0 0 1 5.747 4.87l-.052.076a1.499 1.499 0 0 0 .347 2.09c.67.478 1.612.324 2.09-.347l.052-.075A6.776 6.776 0 0 0 7.586 6.187l-5.264 5.265Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-mobile"><path d="M2.5 2c0-1.103.897-2 2-2h7c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2h-7c-1.103 0-2-.897-2-2V2ZM9 14a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm2.5-12h-7v10h7V2Z" /></symbol><symbol viewBox="0 0 4 16"  id="bg-icon-more-actions"><path d="M2 11a1.75 1.75 0 1 0 0 3.5A1.75 1.75 0 0 0 2 11Zm0-5a1.75 1.75 0 1 0 0 3.5A1.75 1.75 0 0 0 2 6Zm1.75-3.25a1.75 1.75 0 1 0-3.5 0 1.75 1.75 0 0 0 3.5 0Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-notebook"><path d="M3.2 2.5c-.883 0-1.6.717-1.6 1.6v6.4h1.6V4.1h9.6v6.4h1.6V4.1c0-.882-.718-1.6-1.6-1.6H3.2ZM.48 11.3a.48.48 0 0 0-.48.48c0 1.06.86 1.92 1.92 1.92h12.16c1.06 0 1.92-.86 1.92-1.92a.48.48 0 0 0-.48-.48H.48Z" /></symbol><symbol viewBox="0 0 47 40"  id="bg-icon-open-folder"><g clip-path="url(#bg-icon-open-folder_a)"><path d="M31.019 37.5h3.76c.892 0 1.715-.469 2.161-1.242l8.773-15a2.496 2.496 0 0 0 .008-2.508 2.482 2.482 0 0 0-2.17-1.25h-31.33c-.893 0-1.716.469-2.162 1.242L4.7 27.898V7.5c0-.688.564-1.25 1.253-1.25h9.204c.329 0 .65.133.885.367l2.076 2.07a8.786 8.786 0 0 0 6.203 2.563h9.203c.69 0 1.254.563 1.254 1.25V15h3.76v-2.5c0-2.758-2.249-5-5.014-5h-9.203a5.021 5.021 0 0 1-3.548-1.46l-2.076-2.08A5.021 5.021 0 0 0 15.15 2.5H5.954C3.19 2.5.941 4.742.941 7.5v25c0 2.758 2.248 5 5.013 5H31.02Z" /></g><defs><clipPath id="bg-icon-open-folder_a"><path transform="translate(.941)" d="M0 0h45.116v40H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 10 16"  id="bg-icon-order-by"><path d="M7.529 6H1.471a.474.474 0 0 1-.332-.809L4.167 2.14a.47.47 0 0 1 .666 0L7.861 5.19A.474.474 0 0 1 7.529 6ZM1.471 10h6.058c.42 0 .629.51.332.809L4.833 13.86a.47.47 0 0 1-.666 0L1.139 10.81A.474.474 0 0 1 1.471 10Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-pallete"><g clip-path="url(#bg-icon-pallete_a)"><path d="M16 8v.084C15.988 9.225 14.95 10 13.81 10h-3.06a1.5 1.5 0 0 0-1.469 1.81c.066.318.203.624.338.934.19.431.378.86.378 1.312 0 .994-.675 1.897-1.669 1.938-.11.003-.219.006-.331.006A7.999 7.999 0 0 1 0 8a8 8 0 0 1 8-8 8 8 0 0 1 8 8ZM4 9a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm0-3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm5-3a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm3 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" /></g><defs><clipPath id="bg-icon-pallete_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 17"  id="bg-icon-payment-link"><path d="M4.667 11.833a3.213 3.213 0 0 1-2.359-.975A3.213 3.213 0 0 1 1.333 8.5c0-.922.325-1.708.975-2.359a3.213 3.213 0 0 1 2.359-.974h2.222c.157 0 .29.053.396.16a.54.54 0 0 1 .16.397.54.54 0 0 1-.556.554H4.667c-.618 0-1.142.215-1.574.647a2.14 2.14 0 0 0-.648 1.572c0 .617.216 1.142.648 1.575.432.433.956.65 1.574.65h2.222c.157 0 .29.053.396.16a.54.54 0 0 1 .16.398c0 .158-.054.29-.16.395a.54.54 0 0 1-.396.158H4.667Zm1.278-2.778a.537.537 0 0 1-.396-.16.54.54 0 0 1-.16-.397.54.54 0 0 1 .556-.553h4.11c.158 0 .29.053.396.16a.54.54 0 0 1 .16.397c0 .158-.053.29-.16.395a.54.54 0 0 1-.396.158h-4.11Zm3.166 2.778a.536.536 0 0 1-.396-.16.54.54 0 0 1-.16-.397.54.54 0 0 1 .556-.554h2.222c.618 0 1.142-.216 1.574-.647.432-.432.649-.956.649-1.572 0-.617-.216-1.142-.649-1.575a2.14 2.14 0 0 0-1.574-.65H9.111a.536.536 0 0 1-.396-.16.54.54 0 0 1-.16-.398.54.54 0 0 1 .556-.554h2.222c.923 0 1.709.325 2.359.975.65.65.975 1.437.975 2.359 0 .922-.325 1.708-.975 2.358-.65.65-1.436.975-2.359.975H9.111Z" /></symbol><symbol viewBox="0 0 24 24"  id="bg-icon-pix"><path d="M18.688 18.354a3.498 3.498 0 0 1-2.484-1.026l-3.582-3.605a.68.68 0 0 0-.94 0l-3.597 3.613a3.506 3.506 0 0 1-2.484 1.034h-.705l4.545 4.563a3.622 3.622 0 0 0 5.134 0l4.552-4.571-.439-.008ZM5.602 5.622c.932 0 1.825.372 2.484 1.034l3.598 3.612a.665.665 0 0 0 .939 0l3.582-3.597a3.506 3.506 0 0 1 2.484-1.034h.432l-4.553-4.57a3.622 3.622 0 0 0-5.135 0L4.897 5.622h.705Z" /><path d="m22.891 9.417-2.75-2.762a.563.563 0 0 1-.196.039h-1.257c-.651 0-1.272.258-1.734.722l-3.582 3.598a1.718 1.718 0 0 1-2.438 0L7.336 7.401a2.442 2.442 0 0 0-1.734-.723H4.065a.482.482 0 0 1-.181-.038L1.11 9.417a3.66 3.66 0 0 0 0 5.156l2.765 2.777a.514.514 0 0 1 .181-.039h1.545c.651 0 1.272-.258 1.734-.722l3.598-3.613c.65-.654 1.787-.654 2.43 0l3.583 3.597a2.441 2.441 0 0 0 1.734.723h1.249c.068 0 .136.015.196.038l2.75-2.76a3.646 3.646 0 0 0 .015-5.157Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-plus"><path d="M14.857 6.286H9.714V1.143C9.714.512 9.203 0 8.571 0H7.43c-.631 0-1.143.512-1.143 1.143v5.143H1.143C.512 6.286 0 6.798 0 7.429V8.57c0 .632.512 1.143 1.143 1.143h5.143v5.143c0 .631.512 1.143 1.143 1.143H8.57c.632 0 1.143-.512 1.143-1.143V9.714h5.143c.631 0 1.143-.511 1.143-1.143V7.43c0-.631-.512-1.143-1.143-1.143Z" /></symbol><symbol viewBox="0 0 32 32"  id="bg-icon-receipt-long"><path d="M7.6 29.334c-1.018 0-1.884-.357-2.597-1.07-.713-.713-1.07-1.579-1.07-2.597v-3c0-.315.107-.579.32-.792.213-.213.477-.32.792-.32h3.044V3.334c0-.13.056-.217.167-.264.111-.046.215-.02.31.075L9.69 4.267a.531.531 0 0 0 .396.177c.15 0 .286-.059.404-.177l1.2-1.2a.531.531 0 0 1 .396-.178c.15 0 .286.06.404.178l1.178 1.2a.531.531 0 0 0 .396.177c.15 0 .285-.059.404-.177l1.2-1.2a.531.531 0 0 1 .396-.178c.15 0 .286.06.404.178l1.2 1.2a.531.531 0 0 0 .396.177c.15 0 .286-.059.404-.177l1.2-1.2a.531.531 0 0 1 .396-.178c.15 0 .286.06.404.178l1.2 1.2a.531.531 0 0 0 .396.177c.15 0 .286-.059.404-.177l1.2-1.2a.531.531 0 0 1 .396-.178c.15 0 .286.06.404.178l1.2 1.2a.531.531 0 0 0 .396.177c.15 0 .286-.059.404-.177l1.122-1.123c.097-.096.2-.12.311-.075.111.047.167.135.167.264v22.334c0 1.018-.357 1.884-1.07 2.597-.712.713-1.578 1.07-2.597 1.07H7.6Zm16.8-2.223c.423 0 .769-.135 1.04-.405.27-.27.405-.617.405-1.04V6.223H10.31v15.334h11.534c.315 0 .578.106.791.32.213.212.32.476.32.79v2.997c0 .425.135.772.405 1.043.27.27.617.405 1.04.405ZM13.045 9.29h5.778c.314 0 .578.107.791.32.213.214.32.48.32.795 0 .316-.107.58-.32.79a1.08 1.08 0 0 1-.791.317h-5.778c-.315 0-.579-.107-.792-.32a1.081 1.081 0 0 1-.32-.795c0-.316.107-.58.32-.79a1.08 1.08 0 0 1 .792-.317Zm0 4.311h5.778c.314 0 .578.107.791.32.213.214.32.48.32.795 0 .316-.107.58-.32.79a1.08 1.08 0 0 1-.791.317h-5.778c-.315 0-.579-.106-.792-.32a1.081 1.081 0 0 1-.32-.795c0-.316.107-.58.32-.79a1.08 1.08 0 0 1 .792-.317Zm9.844-2.089a1.07 1.07 0 0 1-.783-.327 1.069 1.069 0 0 1-.328-.784c0-.304.11-.565.328-.783a1.07 1.07 0 0 1 .783-.328c.304 0 .565.11.784.328.218.218.327.48.327.783 0 .304-.109.565-.327.784a1.07 1.07 0 0 1-.784.327Zm0 4.2a1.07 1.07 0 0 1-.783-.328 1.069 1.069 0 0 1-.328-.783c0-.304.11-.565.328-.783a1.07 1.07 0 0 1 .783-.328c.304 0 .565.11.784.328.218.218.327.48.327.783 0 .304-.109.565-.327.784a1.07 1.07 0 0 1-.784.327Zm-15.311 11.4h13.156v-3.333H6.156v1.889c0 .422.136.768.409 1.039.272.27.61.405 1.013.405Z" /></symbol><symbol viewBox="0 0 13 17"  id="bg-icon-receipt"><g clip-path="url(#bg-icon-receipt_a)"><path d="M.938.693a.749.749 0 0 1 .8.113L3 1.887 4.263.806a.749.749 0 0 1 .974 0L6.5 1.887 7.763.806a.749.749 0 0 1 .975 0L10 1.887 11.262.806a.749.749 0 0 1 1.238.569v14.5a.75.75 0 0 1-1.238.569L10 15.361l-1.262 1.082a.749.749 0 0 1-.975 0L6.5 15.361l-1.263 1.082a.749.749 0 0 1-.974 0L3 15.361l-1.262 1.082a.749.749 0 0 1-1.238-.57v-14.5a.75.75 0 0 1 .438-.68ZM3.5 5.125c-.275 0-.5.225-.5.5s.225.5.5.5h6c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-6Zm-.5 6.5c0 .275.225.5.5.5h6c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-6c-.275 0-.5.225-.5.5Zm.5-3.5c-.275 0-.5.225-.5.5s.225.5.5.5h6c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-6Z" /></g><defs><clipPath id="bg-icon-receipt_a"><path fill="#fff" transform="translate(.5 .625)" d="M0 0h12v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-recycle"><g clip-path="url(#bg-icon-recycle_a)"><path d="M5.46 1.41a2.994 2.994 0 0 1 5.08 0l1.207 1.927.844-.487a.747.747 0 0 1 .83.053c.241.184.348.497.27.79l-.732 2.732a.751.751 0 0 1-.918.531l-2.732-.731a.75.75 0 0 1-.181-1.372l.887-.512-1.171-1.872a.995.995 0 0 0-1.688 0l-.547.875a1.001 1.001 0 0 1-1.697-1.06l.547-.875Zm7.962 6.462a.999.999 0 0 1 1.362.328l.763 1.222a2.996 2.996 0 0 1-2.537 4.581L10 14v1a.75.75 0 0 1-1.281.531l-2-2a.747.747 0 0 1 0-1.06l2-2a.751.751 0 0 1 1.28.532v1h3.007a.996.996 0 0 0 .844-1.522l-.763-1.222a.999.999 0 0 1 .335-1.387ZM2.028 6.903l-.903-.522a.75.75 0 0 1 .181-1.372l2.731-.73c.4-.107.813.13.92.53l.73 2.728a.755.755 0 0 1-.268.791.742.742 0 0 1-.832.053l-.828-.478-1.61 2.575A.996.996 0 0 0 2.994 12H4a.999.999 0 1 1 0 2H2.994A2.994 2.994 0 0 1 .456 9.419l1.572-2.516Z" /></g><defs><clipPath id="bg-icon-recycle_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 11 17"  id="bg-icon-refund"><path d="M9.955 2.837c.55 0 .996-.447.996-1 0-.553-.445-1-.996-1H6.97a2.994 2.994 0 0 0-2.986 3v9.584l-2.282-2.294a.994.994 0 0 0-1.41 0 1.005 1.005 0 0 0 0 1.416l3.982 4a.994.994 0 0 0 1.409 0l3.981-4a1.005 1.005 0 0 0 0-1.416.994.994 0 0 0-1.409 0l-2.28 2.294V3.837c0-.553.445-1 .995-1h2.986Z" /></symbol><symbol viewBox="0 0 17 17"  id="bg-icon-rotate-arrow"><path d="M4.428 5.96H6a.999.999 0 1 1 0 2H2c-.553 0-1-.446-1-1v-4a.999.999 0 1 1 2 0v1.6l.55-.55a7 7 0 0 1 9.9 0 7 7 0 0 1 0 9.9 7 7 0 0 1-9.9 0 1.001 1.001 0 0 1 1.416-1.415 5 5 0 1 0 0-7.072l-.538.537Z" /></symbol><symbol viewBox="0 0 16 17"  id="bg-icon-search"><path d="m15.782 13.835-3.115-3.116a.75.75 0 0 0-.532-.218h-.51a6.47 6.47 0 0 0 1.376-4A6.5 6.5 0 0 0 6.501 0 6.5 6.5 0 0 0 0 6.5 6.5 6.5 0 0 0 6.5 13c1.51 0 2.898-.512 4-1.374v.51c0 .2.079.39.22.53l3.115 3.116a.747.747 0 0 0 1.06 0l.884-.884a.754.754 0 0 0 .003-1.063ZM6.5 10.501c-2.21 0-4-1.788-4-4 0-2.21 1.788-4 4-4 2.21 0 4 1.787 4 4 0 2.209-1.787 4-4 4Z" /></symbol><symbol viewBox="0 0 16 17"  id="bg-icon-settings"><path d="m15.121 9.923-1.374-.794a6.214 6.214 0 0 0 0-2.264l1.374-.794a.39.39 0 0 0 .178-.452 8.033 8.033 0 0 0-1.765-3.051.388.388 0 0 0-.477-.074l-1.375.793a6.087 6.087 0 0 0-1.96-1.132V.57a.386.386 0 0 0-.304-.377 8.11 8.11 0 0 0-3.523 0 .386.386 0 0 0-.303.377v1.587A6.28 6.28 0 0 0 3.631 3.29L2.26 2.497a.383.383 0 0 0-.478.074A7.986 7.986 0 0 0 .018 5.623a.386.386 0 0 0 .177.451l1.375.794a6.214 6.214 0 0 0 0 2.264l-1.375.794a.39.39 0 0 0-.177.451 8.034 8.034 0 0 0 1.764 3.052.388.388 0 0 0 .478.074l1.374-.793c.577.496 1.242.88 1.961 1.132v1.587c0 .18.126.339.304.377a8.11 8.11 0 0 0 3.522 0 .386.386 0 0 0 .303-.377v-1.587a6.28 6.28 0 0 0 1.962-1.132l1.374.793c.158.09.355.062.477-.074a7.986 7.986 0 0 0 1.765-3.052.398.398 0 0 0-.18-.454Zm-7.464.654a2.584 2.584 0 0 1-2.581-2.58 2.584 2.584 0 0 1 2.58-2.58 2.584 2.584 0 0 1 2.581 2.58 2.584 2.584 0 0 1-2.58 2.58Z" /></symbol><symbol viewBox="0 0 18 17"  id="bg-icon-share"><g clip-path="url(#bg-icon-share_a)"><path d="M12.5 8.606V7.125c0-.275-.225-.5-.5-.5H9.047a3.546 3.546 0 0 0-3.385 2.487 2.946 2.946 0 0 1-.162-.987c0-1.935 1.566-3.5 3.5-3.5h3c.275 0 .5-.225.5-.5V2.644l3.313 2.98L12.5 8.607Zm-2-.481h.5v1.5c0 .553.447 1 1 1h.116a1 1 0 0 0 .668-.257l4.344-3.909a1.118 1.118 0 0 0 0-1.669L12.81.903a1.083 1.083 0 0 0-1.81.806v1.416H9.001c-2.763 0-5 2.237-5 5 0 1.887 1.081 3.097 1.997 3.778a6.102 6.102 0 0 0 1.15.678.53.53 0 0 0 .222.044h.078c.306 0 .556-.25.556-.556 0-.244-.165-.46-.362-.61l-.035-.025a.965.965 0 0 1-.156-.128c-.025-.025-.053-.05-.078-.081l-.075-.09a1.651 1.651 0 0 1-.156-.267 1.733 1.733 0 0 1-.135-.7c0-1.128.916-2.046 2.047-2.046H10.5v.003Zm-8.25-6.5A2.249 2.249 0 0 0 0 3.875v10.5a2.249 2.249 0 0 0 2.25 2.25h10.5a2.249 2.249 0 0 0 2.25-2.25v-2a.748.748 0 0 0-.75-.75.748.748 0 0 0-.75.75v2c0 .415-.334.75-.75.75H2.25a.748.748 0 0 1-.75-.75v-10.5c0-.416.334-.75.75-.75h2c.416 0 .75-.335.75-.75a.748.748 0 0 0-.75-.75h-2Z" /></g><defs><clipPath id="bg-icon-share_a"><path fill="#fff" transform="translate(0 .625)" d="M0 0h18v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-shield"><g clip-path="url(#bg-icon-shield_a)"><path d="M7.5 0c.144 0 .287.031.419.09l5.884 2.497c.687.291 1.2.97 1.197 1.788-.016 3.1-1.29 8.772-6.678 11.35-.522.25-1.128.25-1.65 0C1.29 13.147.015 7.475 0 4.375a1.94 1.94 0 0 1 1.197-1.788L7.084.091A.995.995 0 0 1 7.5 0Zm0 2.087V13.9c4.312-2.088 5.472-6.71 5.5-9.481L7.5 2.088Z" /></g><defs><clipPath id="bg-icon-shield_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-sitemap"><path d="M5.778 3.083c0-.736.597-1.333 1.333-1.333H8.89c.736 0 1.333.597 1.333 1.333v1.778c0 .736-.597 1.333-1.333 1.333h-.222v1.112h4.222c.858 0 1.555.697 1.555 1.555v.889h.223c.736 0 1.333.597 1.333 1.333v1.778c0 .736-.597 1.333-1.333 1.333h-1.778a1.334 1.334 0 0 1-1.333-1.333v-1.778c0-.736.597-1.333 1.333-1.333h.222v-.889c0-.122-.1-.222-.222-.222H8.667V9.75h.222c.736 0 1.333.597 1.333 1.333v1.778c0 .736-.597 1.333-1.333 1.333H7.11a1.334 1.334 0 0 1-1.333-1.333v-1.778c0-.736.597-1.333 1.333-1.333h.222V8.639H3.111c-.122 0-.222.1-.222.222v.889h.222c.736 0 1.333.597 1.333 1.333v1.778c0 .736-.597 1.333-1.333 1.333H1.333A1.334 1.334 0 0 1 0 12.861v-1.778c0-.736.597-1.333 1.333-1.333h.223v-.889c0-.858.697-1.555 1.555-1.555h4.222V6.194h-.222a1.334 1.334 0 0 1-1.333-1.333V3.083Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-togheter"><g clip-path="url(#bg-icon-togheter_a)"><path d="M2 2.412c0-.313.126-.614.351-.835a1.21 1.21 0 0 1 1.698 0 1.172 1.172 0 0 1 0 1.67 1.21 1.21 0 0 1-1.698 0A1.172 1.172 0 0 1 2 2.413ZM3.6 7.18v1.603l1.275 1.255c.178.175.295.399.335.643l.38 2.237a.79.79 0 0 1-.657.906.8.8 0 0 1-.92-.647l-.358-2.115L1.67 9.108c-.3-.296-.47-.697-.47-1.115V5.824c0-.798.655-1.442 1.465-1.442.603 0 1.163.295 1.498.787l1.185 1.75.252.123V5.17c0-.435.358-.787.8-.787h3.2c.443 0 .8.352.8.787v1.876l.252-.123 1.186-1.753a1.805 1.805 0 0 1 1.497-.787c.81 0 1.465.644 1.465 1.442v2.169c0 .418-.168.82-.468 1.115l-1.985 1.954-.357 2.115a.8.8 0 0 1-.92.647.79.79 0 0 1-.658-.906l.38-2.237c.04-.244.158-.468.335-.643l1.275-1.255V7.18l-.474.702c-.116.172-.276.31-.463.401l-1.49.734a.73.73 0 0 1-.19.069.77.77 0 0 1-.197.02h-3.17a.806.806 0 0 1-.39-.092L4.54 8.281a1.206 1.206 0 0 1-.462-.402l-.475-.701-.003.002ZM.058 12.753l1.195-2.941 1.23 1.21-.94 2.315a.804.804 0 0 1-1.04.438.78.78 0 0 1-.445-1.022ZM12.8 1.231c.318 0 .623.124.848.346a1.172 1.172 0 0 1 0 1.67 1.21 1.21 0 0 1-1.697 0 1.172 1.172 0 0 1 0-1.67 1.21 1.21 0 0 1 .849-.346Zm1.947 8.58 1.196 2.942a.783.783 0 0 1-.445 1.024.804.804 0 0 1-1.04-.438l-.94-2.314 1.23-1.21v-.003Z" /></g><defs><clipPath id="bg-icon-togheter_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-update"><g clip-path="url(#bg-icon-update_a)"><path d="M4.466 4.466a5 5 0 0 1 7.04-.032L10.22 5.72A.751.751 0 0 0 10.75 7h4c.416 0 .75-.334.75-.75v-4a.749.749 0 0 0-1.281-.531l-1.3 1.3A6.998 6.998 0 0 0 1.4 5.669a1 1 0 0 0 1.884.665 4.95 4.95 0 0 1 1.182-1.868ZM.5 9.75v4a.75.75 0 0 0 1.281.531l1.3-1.3a6.998 6.998 0 0 0 9.869-.031 6.982 6.982 0 0 0 1.653-2.616 1 1 0 0 0-1.884-.665 4.95 4.95 0 0 1-1.181 1.868 5 5 0 0 1-7.041.032L5.78 10.28A.751.751 0 0 0 5.25 9h-4a.748.748 0 0 0-.75.75Z" /></g><defs><clipPath id="bg-icon-update_a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-upload"><path d="M0 8c0-4.42 3.58-8 8-8s8 3.58 8 8-3.58 8-8 8-8-3.58-8-8Zm4.632.932 2.336-2.435v5.89c0 .43.345.774.774.774h.516a.772.772 0 0 0 .774-.774v-5.89l2.336 2.435c.3.313.8.32 1.106.013l.352-.355a.771.771 0 0 0 0-1.093l-4.278-4.28a.771.771 0 0 0-1.093 0l-4.28 4.28a.771.771 0 0 0 0 1.093l.35.355c.307.307.807.3 1.107-.013Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-user-check"><path d="M5.6 8.4a3.2 3.2 0 1 0 0-6.4 3.2 3.2 0 0 0 0 6.4Zm2.24.8h-.417a4.357 4.357 0 0 1-3.646 0H3.36A3.36 3.36 0 0 0 0 12.56v1.04a1.2 1.2 0 0 0 1.2 1.2H10a1.2 1.2 0 0 0 1.2-1.2v-1.04A3.36 3.36 0 0 0 7.84 9.2Zm8.075-3.21-.695-.703a.296.296 0 0 0-.42-.002l-2.62 2.6-1.137-1.145a.296.296 0 0 0-.42-.003l-.703.698a.296.296 0 0 0-.003.42l2.043 2.057a.296.296 0 0 0 .42.003l3.532-3.505a.299.299 0 0 0 .003-.42Z" /></symbol><symbol viewBox="0 0 16 16"  id="bg-icon-user"><path d="M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm0 3.097a2.839 2.839 0 1 1 0 5.677 2.839 2.839 0 0 1 0-5.677Zm0 11.097a6.181 6.181 0 0 1-4.726-2.2c.607-1.142 1.794-1.93 3.178-1.93.077 0 .154.013.229.036.419.136.858.223 1.319.223.461 0 .903-.088 1.32-.223a.789.789 0 0 1 .228-.035c1.384 0 2.571.787 3.178 1.928A6.181 6.181 0 0 1 8 14.194Z" /></symbol>', o.insertBefore(t, o.lastChild);
  };
  document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", e) : e();
}
const le = {
  grey: {
    white: "#ffffff",
    light: "#ebeff2",
    semiLight: "#b2c1cd",
    normal: "#9dadbb",
    semiDark: "#72818d",
    dark: "#4d565d"
  },
  blue: {
    light: "#c4e9fc",
    semiLight: "#00aef3",
    normal: "#0096ed",
    semiDark: "#006cb2",
    dark: "#004876"
  },
  green: {
    light: "#cbf3ef",
    semiLight: "#1fd1c2",
    normal: "#1fbfae",
    semiDark: "#009182",
    dark: "#005f56"
  },
  yellow: {
    light: "#fff1d9",
    semiLight: "#ffcb71",
    normal: "#ffb748",
    semiDark: "#c68b2e",
    dark: "#845c1e"
  },
  red: {
    light: "#ffcbd7",
    semiLight: "#ff3569",
    normal: "#ff003a",
    semiDark: "#cb0026",
    dark: "#870017"
  },
  bg: { backgroundAlt: "#f5f5f7", background: "#f8fafa" }
}, Pl = { regular: 400, semiBold: 600, bold: 700 }, or = {
  0: "0.75rem",
  1: "0.875rem",
  2: "1rem",
  3: "1.125rem",
  4: "1.25rem",
  5: "1.5rem",
  6: "2rem",
  7: "2.5rem",
  8: "3rem",
  9: "4rem"
}, Fe = {
  h1: {
    regular: "400 4rem/4.5rem 'Nunito Sans'",
    bold: "700 4rem/4.5rem 'Nunito Sans'",
    semiBold: "600 4rem/4.5rem 'Nunito Sans'"
  },
  h2: {
    regular: "400 3rem/3.5rem 'Nunito Sans'",
    bold: "700 3rem/3.5rem 'Nunito Sans'",
    semiBold: "600 3rem/3.5rem 'Nunito Sans'"
  },
  h3: {
    regular: "400 2.5rem/3rem 'Nunito Sans'",
    bold: "700 2.5rem/3rem 'Nunito Sans'",
    semiBold: "600 2.5rem/3rem 'Nunito Sans'"
  },
  h4: {
    regular: "400 2rem/2.5rem 'Nunito Sans'",
    bold: "700 2rem/2.5rem 'Nunito Sans'",
    semiBold: "600 2rem/2.5rem 'Nunito Sans'"
  },
  h5: {
    regular: "400 1.5rem/2rem 'Nunito Sans'",
    bold: "700 1.5rem/2rem 'Nunito Sans'",
    semiBold: "600 1.5rem/2rem 'Nunito Sans'"
  },
  h6: {
    regular: "400 1.25rem/1.75rem 'Nunito Sans'",
    bold: "700 1.25rem/1.75rem 'Nunito Sans'",
    semiBold: "600 1.25rem/1.75rem 'Nunito Sans'"
  },
  bodyMd: {
    regular: "400 1rem/1.5rem Nunito",
    bold: "700 1rem/1.5rem Nunito",
    semiBold: "600 1rem/1.5rem Nunito"
  },
  bodySm: {
    regular: "400 0.875rem/1.375rem Nunito",
    bold: "700 0.875rem/1.375rem Nunito",
    semiBold: "600 0.875rem/1.375rem Nunito"
  },
  label: {
    regular: "400 0.75rem/1.25rem Nunito",
    bold: "700 0.75rem/1.25rem Nunito",
    semiBold: "600 0.75rem/1.25rem Nunito"
  }
}, Jr = {
  "3xSm": "4px",
  "2xSm": "8px",
  xSm: "16px",
  sm: "32px",
  md: "48px",
  lg: "64px",
  xLg: "80px",
  "2xLg": "128px",
  "3xLg": "256px"
}, en = { none: "0", sm: "4px", md: "8px", lg: "16px", xLg: "32px", "2xLg": "64px" }, xe = {
  "2xSm": "4px",
  xSm: "8px",
  sm: "16px",
  md: "32px",
  lg: "64px",
  xLg: "128px",
  "2xLg": "256px"
};
var gt = /* @__PURE__ */ ((e) => (e.Md = "md", e.Sm = "sm", e))(gt || {});
const Dl = Symbol("IdInjectionKey"), Bo = (e, o) => {
  const t = {
    prefix: Math.round(Math.random() * 1e10),
    current: 0
  }, r = So(Dl, t);
  return [o, r.prefix, e || ++r.current].filter(Boolean).join("-");
}, Sr = () => {
  const e = ci(), o = e == null ? void 0 : e.vnode;
  if (!o)
    throw new Error("useVNode must be called within a component");
  return { vnode: o };
}, $r = (e) => {
  const o = e.type;
  return (o == null ? void 0 : o.name) || (o == null ? void 0 : o.__name) || "unknown";
};
var wt = function() {
  return wt = Object.assign || function(o) {
    for (var t, r = 1, n = arguments.length; r < n; r++) {
      t = arguments[r];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (o[i] = t[i]);
    }
    return o;
  }, wt.apply(this, arguments);
};
function Ol(e) {
  return e.toLowerCase();
}
var Rl = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], Ll = /[^A-Z0-9]+/gi;
function Al(e, o) {
  o === void 0 && (o = {});
  for (var t = o.splitRegexp, r = t === void 0 ? Rl : t, n = o.stripRegexp, i = n === void 0 ? Ll : n, a = o.transform, l = a === void 0 ? Ol : a, s = o.delimiter, d = s === void 0 ? " " : s, c = on(on(e, r, "$1\0$2"), i, "\0"), f = 0, u = c.length; c.charAt(f) === "\0"; )
    f++;
  for (; c.charAt(u - 1) === "\0"; )
    u--;
  return c.slice(f, u).split("\0").map(l).join(d);
}
function on(e, o, t) {
  return o instanceof RegExp ? e.replace(o, t) : o.reduce(function(r, n) {
    return r.replace(n, t);
  }, e);
}
function Il(e, o) {
  return o === void 0 && (o = {}), Al(e, wt({ delimiter: "." }, o));
}
function Ct(e, o) {
  return o === void 0 && (o = {}), Il(e, wt({ delimiter: "-" }, o));
}
const nt = () => {
  const { vnode: e } = Sr(), o = e == null ? void 0 : e.key;
  if (!o)
    throw new Error(`<${Ct($r(e))}> must have a key`);
  return o;
}, El = ["top", "right", "bottom", "left"], tn = ["start", "end"], rn = /* @__PURE__ */ El.reduce((e, o) => e.concat(o, o + "-" + tn[0], o + "-" + tn[1]), []), po = Math.min, me = Math.max, xt = Math.round, oo = (e) => ({
  x: e,
  y: e
}), zl = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Nl = {
  start: "end",
  end: "start"
};
function tr(e, o, t) {
  return me(e, po(o, t));
}
function fo(e, o) {
  return typeof e == "function" ? e(o) : e;
}
function Ie(e) {
  return e.split("-")[0];
}
function Me(e) {
  return e.split("-")[1];
}
function bi(e) {
  return e === "x" ? "y" : "x";
}
function Br(e) {
  return e === "y" ? "height" : "width";
}
function it(e) {
  return ["top", "bottom"].includes(Ie(e)) ? "y" : "x";
}
function _r(e) {
  return bi(it(e));
}
function vi(e, o, t) {
  t === void 0 && (t = !1);
  const r = Me(e), n = _r(e), i = Br(n);
  let a = n === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return o.reference[i] > o.floating[i] && (a = $t(a)), [a, $t(a)];
}
function Hl(e) {
  const o = $t(e);
  return [St(e), o, St(o)];
}
function St(e) {
  return e.replace(/start|end/g, (o) => Nl[o]);
}
function Vl(e, o, t) {
  const r = ["left", "right"], n = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return t ? o ? n : r : o ? r : n;
    case "left":
    case "right":
      return o ? i : a;
    default:
      return [];
  }
}
function Fl(e, o, t, r) {
  const n = Me(e);
  let i = Vl(Ie(e), t === "start", r);
  return n && (i = i.map((a) => a + "-" + n), o && (i = i.concat(i.map(St)))), i;
}
function $t(e) {
  return e.replace(/left|right|bottom|top/g, (o) => zl[o]);
}
function jl(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function yi(e) {
  return typeof e != "number" ? jl(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function uo(e) {
  const {
    x: o,
    y: t,
    width: r,
    height: n
  } = e;
  return {
    width: r,
    height: n,
    top: t,
    left: o,
    right: o + r,
    bottom: t + n,
    x: o,
    y: t
  };
}
function nn(e, o, t) {
  let {
    reference: r,
    floating: n
  } = e;
  const i = it(o), a = _r(o), l = Br(a), s = Ie(o), d = i === "y", c = r.x + r.width / 2 - n.width / 2, f = r.y + r.height / 2 - n.height / 2, u = r[l] / 2 - n[l] / 2;
  let p;
  switch (s) {
    case "top":
      p = {
        x: c,
        y: r.y - n.height
      };
      break;
    case "bottom":
      p = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      p = {
        x: r.x - n.width,
        y: f
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (Me(o)) {
    case "start":
      p[a] -= u * (t && d ? -1 : 1);
      break;
    case "end":
      p[a] += u * (t && d ? -1 : 1);
      break;
  }
  return p;
}
const ki = async (e, o, t) => {
  const {
    placement: r = "bottom",
    strategy: n = "absolute",
    middleware: i = [],
    platform: a
  } = t, l = i.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(o));
  let d = await a.getElementRects({
    reference: e,
    floating: o,
    strategy: n
  }), {
    x: c,
    y: f
  } = nn(d, r, s), u = r, p = {}, h = 0;
  for (let m = 0; m < l.length; m++) {
    const {
      name: v,
      fn: C
    } = l[m], {
      x: w,
      y: b,
      data: x,
      reset: D
    } = await C({
      x: c,
      y: f,
      initialPlacement: r,
      placement: u,
      strategy: n,
      middlewareData: p,
      rects: d,
      platform: a,
      elements: {
        reference: e,
        floating: o
      }
    });
    if (c = w ?? c, f = b ?? f, p = {
      ...p,
      [v]: {
        ...p[v],
        ...x
      }
    }, D && h <= 50) {
      h++, typeof D == "object" && (D.placement && (u = D.placement), D.rects && (d = D.rects === !0 ? await a.getElementRects({
        reference: e,
        floating: o,
        strategy: n
      }) : D.rects), {
        x: c,
        y: f
      } = nn(d, u, s)), m = -1;
      continue;
    }
  }
  return {
    x: c,
    y: f,
    placement: u,
    strategy: n,
    middlewareData: p
  };
};
async function Rt(e, o) {
  var t;
  o === void 0 && (o = {});
  const {
    x: r,
    y: n,
    platform: i,
    rects: a,
    elements: l,
    strategy: s
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: f = "floating",
    altBoundary: u = !1,
    padding: p = 0
  } = fo(o, e), h = yi(p), v = l[u ? f === "floating" ? "reference" : "floating" : f], C = uo(await i.getClippingRect({
    element: (t = await (i.isElement == null ? void 0 : i.isElement(v))) == null || t ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: s
  })), w = f === "floating" ? {
    ...a.floating,
    x: r,
    y: n
  } : a.reference, b = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), x = await (i.isElement == null ? void 0 : i.isElement(b)) ? await (i.getScale == null ? void 0 : i.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, D = uo(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: w,
    offsetParent: b,
    strategy: s
  }) : w);
  return {
    top: (C.top - D.top + h.top) / x.y,
    bottom: (D.bottom - C.bottom + h.bottom) / x.y,
    left: (C.left - D.left + h.left) / x.x,
    right: (D.right - C.right + h.right) / x.x
  };
}
const Zl = (e) => ({
  name: "arrow",
  options: e,
  async fn(o) {
    const {
      x: t,
      y: r,
      placement: n,
      rects: i,
      platform: a,
      elements: l,
      middlewareData: s
    } = o, {
      element: d,
      padding: c = 0
    } = fo(e, o) || {};
    if (d == null)
      return {};
    const f = yi(c), u = {
      x: t,
      y: r
    }, p = _r(n), h = Br(p), m = await a.getDimensions(d), v = p === "y", C = v ? "top" : "left", w = v ? "bottom" : "right", b = v ? "clientHeight" : "clientWidth", x = i.reference[h] + i.reference[p] - u[p] - i.floating[h], D = u[p] - i.reference[p], _ = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(d));
    let T = _ ? _[b] : 0;
    (!T || !await (a.isElement == null ? void 0 : a.isElement(_))) && (T = l.floating[b] || i.floating[h]);
    const O = x / 2 - D / 2, Y = T / 2 - m[h] / 2 - 1, j = po(f[C], Y), q = po(f[w], Y), X = j, ae = T - m[h] - q, J = T / 2 - m[h] / 2 + O, re = tr(X, J, ae), ne = !s.arrow && Me(n) != null && J != re && i.reference[h] / 2 - (J < X ? j : q) - m[h] / 2 < 0, oe = ne ? J < X ? J - X : J - ae : 0;
    return {
      [p]: u[p] + oe,
      data: {
        [p]: re,
        centerOffset: J - re - oe,
        ...ne && {
          alignmentOffset: oe
        }
      },
      reset: ne
    };
  }
});
function Wl(e, o, t) {
  return (e ? [...t.filter((n) => Me(n) === e), ...t.filter((n) => Me(n) !== e)] : t.filter((n) => Ie(n) === n)).filter((n) => e ? Me(n) === e || (o ? St(n) !== n : !1) : !0);
}
const wi = function(e) {
  return e === void 0 && (e = {}), {
    name: "autoPlacement",
    options: e,
    async fn(o) {
      var t, r, n;
      const {
        rects: i,
        middlewareData: a,
        placement: l,
        platform: s,
        elements: d
      } = o, {
        crossAxis: c = !1,
        alignment: f,
        allowedPlacements: u = rn,
        autoAlignment: p = !0,
        ...h
      } = fo(e, o), m = f !== void 0 || u === rn ? Wl(f || null, p, u) : u, v = await Rt(o, h), C = ((t = a.autoPlacement) == null ? void 0 : t.index) || 0, w = m[C];
      if (w == null)
        return {};
      const b = vi(w, i, await (s.isRTL == null ? void 0 : s.isRTL(d.floating)));
      if (l !== w)
        return {
          reset: {
            placement: m[0]
          }
        };
      const x = [v[Ie(w)], v[b[0]], v[b[1]]], D = [...((r = a.autoPlacement) == null ? void 0 : r.overflows) || [], {
        placement: w,
        overflows: x
      }], _ = m[C + 1];
      if (_)
        return {
          data: {
            index: C + 1,
            overflows: D
          },
          reset: {
            placement: _
          }
        };
      const T = D.map((j) => {
        const q = Me(j.placement);
        return [j.placement, q && c ? (
          // Check along the mainAxis and main crossAxis side.
          j.overflows.slice(0, 2).reduce((X, ae) => X + ae, 0)
        ) : (
          // Check only the mainAxis.
          j.overflows[0]
        ), j.overflows];
      }).sort((j, q) => j[1] - q[1]), Y = ((n = T.filter((j) => j[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        Me(j[0]) ? 2 : 3
      ).every((q) => q <= 0))[0]) == null ? void 0 : n[0]) || T[0][0];
      return Y !== l ? {
        data: {
          index: C + 1,
          overflows: D
        },
        reset: {
          placement: Y
        }
      } : {};
    }
  };
}, Yl = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(o) {
      var t, r;
      const {
        placement: n,
        middlewareData: i,
        rects: a,
        initialPlacement: l,
        platform: s,
        elements: d
      } = o, {
        mainAxis: c = !0,
        crossAxis: f = !0,
        fallbackPlacements: u,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: m = !0,
        ...v
      } = fo(e, o);
      if ((t = i.arrow) != null && t.alignmentOffset)
        return {};
      const C = Ie(n), w = Ie(l) === l, b = await (s.isRTL == null ? void 0 : s.isRTL(d.floating)), x = u || (w || !m ? [$t(l)] : Hl(l));
      !u && h !== "none" && x.push(...Fl(l, m, h, b));
      const D = [l, ...x], _ = await Rt(o, v), T = [];
      let O = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (c && T.push(_[C]), f) {
        const X = vi(n, a, b);
        T.push(_[X[0]], _[X[1]]);
      }
      if (O = [...O, {
        placement: n,
        overflows: T
      }], !T.every((X) => X <= 0)) {
        var Y, j;
        const X = (((Y = i.flip) == null ? void 0 : Y.index) || 0) + 1, ae = D[X];
        if (ae)
          return {
            data: {
              index: X,
              overflows: O
            },
            reset: {
              placement: ae
            }
          };
        let J = (j = O.filter((re) => re.overflows[0] <= 0).sort((re, ne) => re.overflows[1] - ne.overflows[1])[0]) == null ? void 0 : j.placement;
        if (!J)
          switch (p) {
            case "bestFit": {
              var q;
              const re = (q = O.map((ne) => [ne.placement, ne.overflows.filter((oe) => oe > 0).reduce((oe, de) => oe + de, 0)]).sort((ne, oe) => ne[1] - oe[1])[0]) == null ? void 0 : q[0];
              re && (J = re);
              break;
            }
            case "initialPlacement":
              J = l;
              break;
          }
        if (n !== J)
          return {
            reset: {
              placement: J
            }
          };
      }
      return {};
    }
  };
};
async function Kl(e, o) {
  const {
    placement: t,
    platform: r,
    elements: n
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(n.floating)), a = Ie(t), l = Me(t), s = it(t) === "y", d = ["left", "top"].includes(a) ? -1 : 1, c = i && s ? -1 : 1, f = fo(o, e);
  let {
    mainAxis: u,
    crossAxis: p,
    alignmentAxis: h
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...f
  };
  return l && typeof h == "number" && (p = l === "end" ? h * -1 : h), s ? {
    x: p * c,
    y: u * d
  } : {
    x: u * d,
    y: p * c
  };
}
const Ci = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(o) {
      var t, r;
      const {
        x: n,
        y: i,
        placement: a,
        middlewareData: l
      } = o, s = await Kl(o, e);
      return a === ((t = l.offset) == null ? void 0 : t.placement) && (r = l.arrow) != null && r.alignmentOffset ? {} : {
        x: n + s.x,
        y: i + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, Ul = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(o) {
      const {
        x: t,
        y: r,
        placement: n
      } = o, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: C,
              y: w
            } = v;
            return {
              x: C,
              y: w
            };
          }
        },
        ...s
      } = fo(e, o), d = {
        x: t,
        y: r
      }, c = await Rt(o, s), f = it(Ie(n)), u = bi(f);
      let p = d[u], h = d[f];
      if (i) {
        const v = u === "y" ? "top" : "left", C = u === "y" ? "bottom" : "right", w = p + c[v], b = p - c[C];
        p = tr(w, p, b);
      }
      if (a) {
        const v = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", w = h + c[v], b = h - c[C];
        h = tr(w, h, b);
      }
      const m = l.fn({
        ...o,
        [u]: p,
        [f]: h
      });
      return {
        ...m,
        data: {
          x: m.x - t,
          y: m.y - r
        }
      };
    }
  };
}, Gl = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(o) {
      const {
        placement: t,
        rects: r,
        platform: n,
        elements: i
      } = o, {
        apply: a = () => {
        },
        ...l
      } = fo(e, o), s = await Rt(o, l), d = Ie(t), c = Me(t), f = it(t) === "y", {
        width: u,
        height: p
      } = r.floating;
      let h, m;
      d === "top" || d === "bottom" ? (h = d, m = c === (await (n.isRTL == null ? void 0 : n.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (m = d, h = c === "end" ? "top" : "bottom");
      const v = p - s[h], C = u - s[m], w = !o.middlewareData.shift;
      let b = v, x = C;
      if (f) {
        const _ = u - s.left - s.right;
        x = c || w ? po(C, _) : _;
      } else {
        const _ = p - s.top - s.bottom;
        b = c || w ? po(v, _) : _;
      }
      if (w && !c) {
        const _ = me(s.left, 0), T = me(s.right, 0), O = me(s.top, 0), Y = me(s.bottom, 0);
        f ? x = u - 2 * (_ !== 0 || T !== 0 ? _ + T : me(s.left, s.right)) : b = p - 2 * (O !== 0 || Y !== 0 ? O + Y : me(s.top, s.bottom));
      }
      await a({
        ...o,
        availableWidth: x,
        availableHeight: b
      });
      const D = await n.getDimensions(i.floating);
      return u !== D.width || p !== D.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Lt() {
  return typeof window < "u";
}
function Ye(e) {
  return Mr(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function ge(e) {
  var o;
  return (e == null || (o = e.ownerDocument) == null ? void 0 : o.defaultView) || window;
}
function no(e) {
  var o;
  return (o = (Mr(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : o.documentElement;
}
function Mr(e) {
  return Lt() ? e instanceof Node || e instanceof ge(e).Node : !1;
}
function Ee(e) {
  return Lt() ? e instanceof Element || e instanceof ge(e).Element : !1;
}
function ze(e) {
  return Lt() ? e instanceof HTMLElement || e instanceof ge(e).HTMLElement : !1;
}
function an(e) {
  return !Lt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof ge(e).ShadowRoot;
}
function at(e) {
  const {
    overflow: o,
    overflowX: t,
    overflowY: r,
    display: n
  } = ye(e);
  return /auto|scroll|overlay|hidden|clip/.test(o + r + t) && !["inline", "contents"].includes(n);
}
function ql(e) {
  return ["table", "td", "th"].includes(Ye(e));
}
function Xl(e) {
  return [":popover-open", ":modal"].some((o) => {
    try {
      return e.matches(o);
    } catch {
      return !1;
    }
  });
}
function Tr(e) {
  const o = Pr(), t = Ee(e) ? ye(e) : e;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !o && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !o && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (t.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (t.contain || "").includes(r));
}
function Ql(e) {
  let o = _o(e);
  for (; ze(o) && !At(o); ) {
    if (Tr(o))
      return o;
    if (Xl(o))
      return null;
    o = _o(o);
  }
  return null;
}
function Pr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function At(e) {
  return ["html", "body", "#document"].includes(Ye(e));
}
function ye(e) {
  return ge(e).getComputedStyle(e);
}
function It(e) {
  return Ee(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function _o(e) {
  if (Ye(e) === "html")
    return e;
  const o = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    an(e) && e.host || // Fallback.
    no(e)
  );
  return an(o) ? o.host : o;
}
function xi(e) {
  const o = _o(e);
  return At(o) ? e.ownerDocument ? e.ownerDocument.body : e.body : ze(o) && at(o) ? o : xi(o);
}
function rr(e, o, t) {
  var r;
  o === void 0 && (o = []), t === void 0 && (t = !0);
  const n = xi(e), i = n === ((r = e.ownerDocument) == null ? void 0 : r.body), a = ge(n);
  if (i) {
    const l = Jl(a);
    return o.concat(a, a.visualViewport || [], at(n) ? n : [], l && t ? rr(l) : []);
  }
  return o.concat(n, rr(n, [], t));
}
function Jl(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Si(e) {
  const o = ye(e);
  let t = parseFloat(o.width) || 0, r = parseFloat(o.height) || 0;
  const n = ze(e), i = n ? e.offsetWidth : t, a = n ? e.offsetHeight : r, l = xt(t) !== i || xt(r) !== a;
  return l && (t = i, r = a), {
    width: t,
    height: r,
    $: l
  };
}
function $i(e) {
  return Ee(e) ? e : e.contextElement;
}
function wo(e) {
  const o = $i(e);
  if (!ze(o))
    return oo(1);
  const t = o.getBoundingClientRect(), {
    width: r,
    height: n,
    $: i
  } = Si(o);
  let a = (i ? xt(t.width) : t.width) / r, l = (i ? xt(t.height) : t.height) / n;
  return (!a || !Number.isFinite(a)) && (a = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: a,
    y: l
  };
}
const es = /* @__PURE__ */ oo(0);
function Bi(e) {
  const o = ge(e);
  return !Pr() || !o.visualViewport ? es : {
    x: o.visualViewport.offsetLeft,
    y: o.visualViewport.offsetTop
  };
}
function os(e, o, t) {
  return o === void 0 && (o = !1), !t || o && t !== ge(e) ? !1 : o;
}
function jo(e, o, t, r) {
  o === void 0 && (o = !1), t === void 0 && (t = !1);
  const n = e.getBoundingClientRect(), i = $i(e);
  let a = oo(1);
  o && (r ? Ee(r) && (a = wo(r)) : a = wo(e));
  const l = os(i, t, r) ? Bi(i) : oo(0);
  let s = (n.left + l.x) / a.x, d = (n.top + l.y) / a.y, c = n.width / a.x, f = n.height / a.y;
  if (i) {
    const u = ge(i), p = r && Ee(r) ? ge(r) : r;
    let h = u.frameElement;
    for (; h && r && p !== u; ) {
      const m = wo(h), v = h.getBoundingClientRect(), C = ye(h), w = v.left + (h.clientLeft + parseFloat(C.paddingLeft)) * m.x, b = v.top + (h.clientTop + parseFloat(C.paddingTop)) * m.y;
      s *= m.x, d *= m.y, c *= m.x, f *= m.y, s += w, d += b, h = ge(h).frameElement;
    }
  }
  return uo({
    width: c,
    height: f,
    x: s,
    y: d
  });
}
function ts(e) {
  let {
    rect: o,
    offsetParent: t,
    strategy: r
  } = e;
  const n = ze(t), i = no(t);
  if (t === i)
    return o;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = oo(1);
  const s = oo(0);
  if ((n || !n && r !== "fixed") && ((Ye(t) !== "body" || at(i)) && (a = It(t)), ze(t))) {
    const d = jo(t);
    l = wo(t), s.x = d.x + t.clientLeft, s.y = d.y + t.clientTop;
  }
  return {
    width: o.width * l.x,
    height: o.height * l.y,
    x: o.x * l.x - a.scrollLeft * l.x + s.x,
    y: o.y * l.y - a.scrollTop * l.y + s.y
  };
}
function rs(e) {
  return Array.from(e.getClientRects());
}
function _i(e) {
  return jo(no(e)).left + It(e).scrollLeft;
}
function ns(e) {
  const o = no(e), t = It(e), r = e.ownerDocument.body, n = me(o.scrollWidth, o.clientWidth, r.scrollWidth, r.clientWidth), i = me(o.scrollHeight, o.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -t.scrollLeft + _i(e);
  const l = -t.scrollTop;
  return ye(r).direction === "rtl" && (a += me(o.clientWidth, r.clientWidth) - n), {
    width: n,
    height: i,
    x: a,
    y: l
  };
}
function is(e, o) {
  const t = ge(e), r = no(e), n = t.visualViewport;
  let i = r.clientWidth, a = r.clientHeight, l = 0, s = 0;
  if (n) {
    i = n.width, a = n.height;
    const d = Pr();
    (!d || d && o === "fixed") && (l = n.offsetLeft, s = n.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: l,
    y: s
  };
}
function as(e, o) {
  const t = jo(e, !0, o === "fixed"), r = t.top + e.clientTop, n = t.left + e.clientLeft, i = ze(e) ? wo(e) : oo(1), a = e.clientWidth * i.x, l = e.clientHeight * i.y, s = n * i.x, d = r * i.y;
  return {
    width: a,
    height: l,
    x: s,
    y: d
  };
}
function ln(e, o, t) {
  let r;
  if (o === "viewport")
    r = is(e, t);
  else if (o === "document")
    r = ns(no(e));
  else if (Ee(o))
    r = as(o, t);
  else {
    const n = Bi(e);
    r = {
      ...o,
      x: o.x - n.x,
      y: o.y - n.y
    };
  }
  return uo(r);
}
function Mi(e, o) {
  const t = _o(e);
  return t === o || !Ee(t) || At(t) ? !1 : ye(t).position === "fixed" || Mi(t, o);
}
function ls(e, o) {
  const t = o.get(e);
  if (t)
    return t;
  let r = rr(e, [], !1).filter((l) => Ee(l) && Ye(l) !== "body"), n = null;
  const i = ye(e).position === "fixed";
  let a = i ? _o(e) : e;
  for (; Ee(a) && !At(a); ) {
    const l = ye(a), s = Tr(a);
    !s && l.position === "fixed" && (n = null), (i ? !s && !n : !s && l.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || at(a) && !s && Mi(e, a)) ? r = r.filter((c) => c !== a) : n = l, a = _o(a);
  }
  return o.set(e, r), r;
}
function ss(e) {
  let {
    element: o,
    boundary: t,
    rootBoundary: r,
    strategy: n
  } = e;
  const a = [...t === "clippingAncestors" ? ls(o, this._c) : [].concat(t), r], l = a[0], s = a.reduce((d, c) => {
    const f = ln(o, c, n);
    return d.top = me(f.top, d.top), d.right = po(f.right, d.right), d.bottom = po(f.bottom, d.bottom), d.left = me(f.left, d.left), d;
  }, ln(o, l, n));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function cs(e) {
  const {
    width: o,
    height: t
  } = Si(e);
  return {
    width: o,
    height: t
  };
}
function ds(e, o, t) {
  const r = ze(o), n = no(o), i = t === "fixed", a = jo(e, !0, i, o);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = oo(0);
  if (r || !r && !i)
    if ((Ye(o) !== "body" || at(n)) && (l = It(o)), r) {
      const d = jo(o, !0, i, o);
      s.x = d.x + o.clientLeft, s.y = d.y + o.clientTop;
    } else n && (s.x = _i(n));
  return {
    x: a.left + l.scrollLeft - s.x,
    y: a.top + l.scrollTop - s.y,
    width: a.width,
    height: a.height
  };
}
function sn(e, o) {
  return !ze(e) || ye(e).position === "fixed" ? null : o ? o(e) : e.offsetParent;
}
function Ti(e, o) {
  const t = ge(e);
  if (!ze(e))
    return t;
  let r = sn(e, o);
  for (; r && ql(r) && ye(r).position === "static"; )
    r = sn(r, o);
  return r && (Ye(r) === "html" || Ye(r) === "body" && ye(r).position === "static" && !Tr(r)) ? t : r || Ql(e) || t;
}
const us = async function(e) {
  let {
    reference: o,
    floating: t,
    strategy: r
  } = e;
  const n = this.getOffsetParent || Ti, i = this.getDimensions;
  return {
    reference: ds(o, await n(t), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(t)
    }
  };
};
function ps(e) {
  return ye(e).direction === "rtl";
}
const fs = {
  convertOffsetParentRelativeRectToViewportRelativeRect: ts,
  getDocumentElement: no,
  getClippingRect: ss,
  getOffsetParent: Ti,
  getElementRects: us,
  getClientRects: rs,
  getDimensions: cs,
  getScale: wo,
  isElement: Ee,
  isRTL: ps
}, hs = wi, gs = (e, o, t) => {
  const r = /* @__PURE__ */ new Map(), n = {
    platform: fs,
    ...t
  }, i = {
    ...n.platform,
    _c: r
  };
  return ki(e, o, {
    ...n,
    platform: i
  });
};
function ms(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function cn(e) {
  if (ms(e)) {
    const o = e.$el;
    return Mr(o) && Ye(o) === "#comment" ? null : o;
  }
  return e;
}
function Do(e) {
  return typeof e == "function" ? e() : k(e);
}
function Pi(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function dn(e, o) {
  const t = Pi(e);
  return Math.round(o * t) / t;
}
function bs(e, o, t) {
  t === void 0 && (t = {});
  const r = t.whileElementsMounted, n = H(() => {
    var T;
    return (T = Do(t.open)) != null ? T : !0;
  }), i = H(() => Do(t.middleware)), a = H(() => {
    var T;
    return (T = Do(t.placement)) != null ? T : "bottom";
  }), l = H(() => {
    var T;
    return (T = Do(t.strategy)) != null ? T : "absolute";
  }), s = H(() => {
    var T;
    return (T = Do(t.transform)) != null ? T : !0;
  }), d = H(() => cn(e.value)), c = H(() => cn(o.value)), f = Z(0), u = Z(0), p = Z(l.value), h = Z(a.value), m = ml({}), v = Z(!1), C = H(() => {
    const T = {
      position: p.value,
      left: "0",
      top: "0"
    };
    if (!c.value)
      return T;
    const O = dn(c.value, f.value), Y = dn(c.value, u.value);
    return s.value ? {
      ...T,
      transform: "translate(" + O + "px, " + Y + "px)",
      ...Pi(c.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: p.value,
      left: O + "px",
      top: Y + "px"
    };
  });
  let w;
  function b() {
    if (d.value == null || c.value == null)
      return;
    const T = n.value;
    gs(d.value, c.value, {
      middleware: i.value,
      placement: a.value,
      strategy: l.value
    }).then((O) => {
      f.value = O.x, u.value = O.y, p.value = O.strategy, h.value = O.placement, m.value = O.middlewareData, v.value = T !== !1;
    });
  }
  function x() {
    typeof w == "function" && (w(), w = void 0);
  }
  function D() {
    if (x(), r === void 0) {
      b();
      return;
    }
    if (d.value != null && c.value != null) {
      w = r(d.value, c.value, b);
      return;
    }
  }
  function _() {
    n.value || (v.value = !1);
  }
  return se([i, a, l, n], b, {
    flush: "sync"
  }), se([d, c], D, {
    flush: "sync"
  }), se(n, _, {
    flush: "sync"
  }), di() && ui(x), {
    x: bo(f),
    y: bo(u),
    strategy: bo(p),
    placement: bo(h),
    middlewareData: bo(m),
    isPositioned: bo(v),
    floatingStyles: C,
    update: b
  };
}
function vs(e) {
  return di() ? (ui(e), !0) : !1;
}
function Di(e) {
  return typeof e == "function" ? e() : k(e);
}
const Oi = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const ys = Object.prototype.toString, ks = (e) => ys.call(e) === "[object Object]", mt = () => {
}, ws = /* @__PURE__ */ Cs();
function Cs() {
  var e, o;
  return Oi && ((e = window == null ? void 0 : window.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((o = window == null ? void 0 : window.navigator) == null ? void 0 : o.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window == null ? void 0 : window.navigator.userAgent));
}
function Lo(e) {
  var o;
  const t = Di(e);
  return (o = t == null ? void 0 : t.$el) != null ? o : t;
}
const Ri = Oi ? window : void 0;
function Zt(...e) {
  let o, t, r, n;
  if (typeof e[0] == "string" || Array.isArray(e[0]) ? ([t, r, n] = e, o = Ri) : [o, t, r, n] = e, !o)
    return mt;
  Array.isArray(t) || (t = [t]), Array.isArray(r) || (r = [r]);
  const i = [], a = () => {
    i.forEach((c) => c()), i.length = 0;
  }, l = (c, f, u, p) => (c.addEventListener(f, u, p), () => c.removeEventListener(f, u, p)), s = se(
    () => [Lo(o), Di(n)],
    ([c, f]) => {
      if (a(), !c)
        return;
      const u = ks(f) ? { ...f } : f;
      i.push(
        ...t.flatMap((p) => r.map((h) => l(c, p, h, u)))
      );
    },
    { immediate: !0, flush: "post" }
  ), d = () => {
    s(), a();
  };
  return vs(d), d;
}
let un = !1;
function xs(e, o, t = {}) {
  const { window: r = Ri, ignore: n = [], capture: i = !0, detectIframe: a = !1 } = t;
  if (!r)
    return mt;
  ws && !un && (un = !0, Array.from(r.document.body.children).forEach((u) => u.addEventListener("click", mt)), r.document.documentElement.addEventListener("click", mt));
  let l = !0;
  const s = (u) => n.some((p) => {
    if (typeof p == "string")
      return Array.from(r.document.querySelectorAll(p)).some((h) => h === u.target || u.composedPath().includes(h));
    {
      const h = Lo(p);
      return h && (u.target === h || u.composedPath().includes(h));
    }
  }), c = [
    Zt(r, "click", (u) => {
      const p = Lo(e);
      if (!(!p || p === u.target || u.composedPath().includes(p))) {
        if (u.detail === 0 && (l = !s(u)), !l) {
          l = !0;
          return;
        }
        o(u);
      }
    }, { passive: !0, capture: i }),
    Zt(r, "pointerdown", (u) => {
      const p = Lo(e);
      l = !s(u) && !!(p && !u.composedPath().includes(p));
    }, { passive: !0 }),
    a && Zt(r, "blur", (u) => {
      setTimeout(() => {
        var p;
        const h = Lo(e);
        ((p = r.document.activeElement) == null ? void 0 : p.tagName) === "IFRAME" && !(h != null && h.contains(r.document.activeElement)) && o(u);
      }, 0);
    })
  ].filter(Boolean);
  return () => c.forEach((u) => u());
}
const Ss = (e, o, t) => {
  const r = Z(!1), n = () => {
    r.value = !1;
  };
  xs(e, (l) => {
    var s;
    (s = o.value) != null && s.contains(l.target) || (r.value = !1);
  });
  const { floatingStyles: i, isPositioned: a } = bs(e, o, {
    open: r,
    placement: "bottom-end",
    middleware: [
      hs({
        allowedPlacements: ["bottom-end", "bottom-start", "top-end", "top-start"]
      }),
      Ci(({ rects: l }) => typeof (t == null ? void 0 : t.offset) == "function" ? t.offset(l) : (t == null ? void 0 : t.offset) || 0)
    ]
  });
  return se(a, (l) => {
    var s;
    l && ((s = o.value) == null || s.focus());
  }), {
    floatingStyles: i,
    opened: r,
    close: n
  };
}, io = (e, o) => (Array.from(new Set(o)).forEach((t) => {
  (e[t] === null || e[t] === void 0) && bl(`Missing required prop: "${String(t)}"`);
}), e), Dr = ({
  injectionKey: e,
  items: o,
  initialActiveItem: t
}) => {
  const r = Z(), n = (p) => o.value.findIndex((h) => h.key === p), i = () => o.value[0], a = () => o.value[o.value.length - 1], l = (p) => n(p.key) === 0, s = (p) => n(p.key) === o.value.length - 1, d = () => {
    r.value = !r.value || s(r.value) ? i() : o.value[n(r.value.key) + 1];
  }, c = () => {
    r.value = !r.value || l(r.value) ? a() : o.value[n(r.value.key) - 1];
  }, f = (p) => {
    p ? r.value = o.value.find((h) => h.key === p) : r.value = i();
  }, u = (p) => {
    r.value = o.value[p];
  };
  return t && f(t), ro(e, {
    activeItem: r,
    activateByIndex: u,
    next: d,
    prev: c,
    activate: f
  }), {
    activateByIndex: u,
    activeItem: r,
    next: d,
    prev: c,
    activate: f,
    items: o
  };
}, Et = ({ injectionKey: e, parentName: o }) => {
  const t = To({ injectionKey: e, parentName: o }), r = H(() => {
    var l;
    return ((l = t.activeItem.value) == null ? void 0 : l.key) === n;
  }), n = nt(), i = () => t.activate(n);
  return {
    ...t,
    toggle: () => {
      r.value ? t.activeItem.value = void 0 : i();
    },
    activate: i,
    isActive: r
  };
}, To = ({ injectionKey: e, parentName: o }) => {
  const t = So(e, null), { vnode: r } = Sr(), n = $r(r);
  if (!t)
    throw new Error(
      `<${Ct(n)}> must be used inside a <${Ct(o)}> component`
    );
  return t;
};
function $s(e, o = (t) => t) {
  return e.slice().sort((t, r) => {
    const n = o(t), i = o(r);
    if (n === null || i === null) return 0;
    const a = n.compareDocumentPosition(i);
    return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
const Bs = (e) => $s(e, (o) => o.vnode.el), Or = ({ injectionKey: e, onRegister: o }) => {
  const t = Z([]), r = Bo(), a = {
    items: t,
    getIndex: (l) => t.value.findIndex((s) => s.key === l),
    register: (l, s) => {
      var u;
      const c = `${$r(s)}-${r}-${l}`, f = {
        key: l,
        id: c,
        vnode: s,
        ref: (u = s.component) == null ? void 0 : u.exposed
      };
      return t.value = Bs([...t.value, f]), o == null || o(c, l), {
        id: c,
        unregister: () => {
          t.value = t.value.filter((p) => p.key !== l);
        }
      };
    }
  };
  return ro(e, a), a;
}, Rr = ({ injectionKey: e, parentName: o }) => {
  const t = To({
    injectionKey: e,
    parentName: o
  }), { vnode: r } = Sr();
  if (!r)
    throw new Error("useInjectList must be called within a component");
  const n = nt(), i = Z();
  return pi(() => {
    const { unregister: a, id: l } = t.register(n, r);
    i.value = l, vl(() => a());
  }), { ...t, id: i };
}, _s = /* @__PURE__ */ A({
  __name: "BgReset",
  props: {
    is: {},
    deep: { type: Boolean }
  },
  setup(e) {
    const o = e;
    return io(o, ["is"]), (t, r) => (g(), M(fe(o.is), {
      class: L({ deep: t.deep })
    }, {
      default: S(() => [
        B(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), W = (e, o) => {
  const t = e.__vccOpts || e;
  for (const [r, n] of o)
    t[r] = n;
  return t;
}, U = /* @__PURE__ */ W(_s, [["__scopeId", "data-v-638650be"]]);
var te = /* @__PURE__ */ ((e) => (e.GreyWhite = "grey-white", e.GreyLight = "grey-light", e.GreySemiLight = "grey-semi-light", e.GreyNormal = "grey-normal", e.GreySemiDark = "grey-semi-dark", e.GreyDark = "grey-dark", e.BlueLight = "blue-light", e.BlueSemiLight = "blue-semi-light", e.BlueNormal = "blue-normal", e.BlueSemiDark = "blue-semi-dark", e.BlueDark = "blue-dark", e.GreenLight = "green-light", e.GreenSemiLight = "green-semi-light", e.GreenNormal = "green-normal", e.GreenSemiDark = "green-semi-dark", e.GreenDark = "green-dark", e.YellowLight = "yellow-light", e.YellowSemiLight = "yellow-semi-light", e.YellowNormal = "yellow-normal", e.YellowSemiDark = "yellow-semi-dark", e.YellowDark = "yellow-dark", e.RedLight = "red-light", e.RedSemiLight = "red-semi-light", e.RedNormal = "red-normal", e.RedSemiDark = "red-semi-dark", e.RedDark = "red-dark", e.BgBackgroundAlt = "bg-background-alt", e.BgBackground = "bg-background", e))(te || {});
const Ms = () => {
  const e = le, o = {};
  for (const t in e) {
    const r = e[t];
    for (const n in r) {
      const i = `${t}-${Ct(n)}`;
      o[i] = r[n];
    }
  }
  return o;
}, ce = (e) => {
  const o = Ms()[e];
  return o || console.error("Color " + e + " not found"), o;
}, Ts = (e) => ({
  [te.YellowLight]: ce(te.YellowSemiDark),
  [te.GreyLight]: ce(te.GreySemiDark),
  [te.GreyWhite]: ce(te.GreySemiDark),
  [te.BgBackground]: ce(te.GreySemiDark),
  [te.BgBackgroundAlt]: ce(te.GreySemiDark)
})[e] || ce(te.GreyWhite), Ps = /* @__PURE__ */ A({
  __name: "BgBadge",
  props: {
    color: { default: te.GreySemiLight },
    size: { default: gt.Md },
    fullWidth: { type: Boolean }
  },
  setup(e) {
    He((n) => ({
      "216a6bf2": r.value.padding,
      "18d325a2": r.value.fontSize,
      "1177d48c": t.value.backgroundColor,
      "1dbcb888": t.value.color,
      e22edec6: r.value.borderRadius,
      "35b86126": r.value.height
    }));
    const o = e, t = H(() => ({
      backgroundColor: ce(o.color),
      color: Ts(o.color)
    })), r = H(() => ({
      [gt.Sm]: {
        height: "16px",
        borderRadius: "100px",
        fontSize: or[0],
        padding: `0 ${xe.xSm}`
      },
      [gt.Md]: {
        height: "32px",
        borderRadius: "100px",
        fontSize: or[1],
        padding: `0 ${xe.sm}`
      }
    })[o.size]);
    return (n, i) => (g(), M(k(U), {
      is: "div",
      class: L([n.$style.badge, {
        [n.$style.full]: n.fullWidth
      }])
    }, {
      default: S(() => [
        B(n.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Ds = "_badge_1ie0m_2", Os = "_full_1ie0m_17", Rs = {
  badge: Ds,
  full: Os
}, Ls = {
  $style: Rs
}, As = /* @__PURE__ */ W(Ps, [["__cssModules", Ls], ["__scopeId", "data-v-7783b983"]]);
var Ao = /* @__PURE__ */ ((e) => (e.Xs = "xs", e.Sm = "sm", e.Md = "md", e))(Ao || {});
const Is = ["aria-hidden", "role"], Es = { key: 0 }, zs = ["href"], Ns = /* @__PURE__ */ A({
  __name: "BgIcon",
  props: {
    name: {},
    size: { default: Ao.Sm },
    color: { default: "grey-semi-dark" },
    title: {}
  },
  setup(e) {
    He((a) => ({
      "86ebe1d2": t.value,
      64152328: i.value.color
    }));
    const o = e;
    io(o, ["name"]);
    const t = H(() => ({
      [Ao.Xs]: "8px",
      [Ao.Sm]: "16px",
      [Ao.Md]: "24px"
    })[o.size]), r = H(() => `#bg-icon-${o.name}`), n = H(() => !!o.title), i = H(() => ({
      color: ce(o.color)
    }));
    return (a, l) => (g(), $("svg", {
      "aria-hidden": n.value ? "false" : "true",
      role: n.value ? "img" : void 0
    }, [
      a.title ? (g(), $("title", Es, z(a.title), 1)) : I("", !0),
      P("use", { href: r.value }, null, 8, zs)
    ], 8, Is));
  }
}), Hs = {}, Vs = {
  $style: Hs
}, Co = /* @__PURE__ */ W(Ns, [["__cssModules", Vs], ["__scopeId", "data-v-bf09893e"]]);
var bt = /* @__PURE__ */ ((e) => (e.Sm = "sm", e.Md = "md", e))(bt || {}), Io = /* @__PURE__ */ ((e) => (e.Solid = "solid", e.Outline = "outline", e.Ghost = "ghost", e))(Io || {});
function be(e) {
  var o;
  return ((o = e.ownerDocument) == null ? void 0 : o.defaultView) || window;
}
function Le(e) {
  return be(e).getComputedStyle(e);
}
const pn = Math.min, zo = Math.max, Bt = Math.round;
function Li(e) {
  const o = Le(e);
  let t = parseFloat(o.width), r = parseFloat(o.height);
  const n = e.offsetWidth, i = e.offsetHeight, a = Bt(t) !== n || Bt(r) !== i;
  return a && (t = n, r = i), { width: t, height: r, fallback: a };
}
function to(e) {
  return Ii(e) ? (e.nodeName || "").toLowerCase() : "";
}
let ct;
function Ai() {
  if (ct) return ct;
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? (ct = e.brands.map((o) => o.brand + "/" + o.version).join(" "), ct) : navigator.userAgent;
}
function Ae(e) {
  return e instanceof be(e).HTMLElement;
}
function Je(e) {
  return e instanceof be(e).Element;
}
function Ii(e) {
  return e instanceof be(e).Node;
}
function fn(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof be(e).ShadowRoot || e instanceof ShadowRoot;
}
function zt(e) {
  const { overflow: o, overflowX: t, overflowY: r, display: n } = Le(e);
  return /auto|scroll|overlay|hidden|clip/.test(o + r + t) && !["inline", "contents"].includes(n);
}
function Fs(e) {
  return ["table", "td", "th"].includes(to(e));
}
function nr(e) {
  const o = /firefox/i.test(Ai()), t = Le(e), r = t.backdropFilter || t.WebkitBackdropFilter;
  return t.transform !== "none" || t.perspective !== "none" || !!r && r !== "none" || o && t.willChange === "filter" || o && !!t.filter && t.filter !== "none" || ["transform", "perspective"].some((n) => t.willChange.includes(n)) || ["paint", "layout", "strict", "content"].some((n) => {
    const i = t.contain;
    return i != null && i.includes(n);
  });
}
function Ei() {
  return !/^((?!chrome|android).)*safari/i.test(Ai());
}
function Lr(e) {
  return ["html", "body", "#document"].includes(to(e));
}
function zi(e) {
  return Je(e) ? e : e.contextElement;
}
const Ni = { x: 1, y: 1 };
function xo(e) {
  const o = zi(e);
  if (!Ae(o)) return Ni;
  const t = o.getBoundingClientRect(), { width: r, height: n, fallback: i } = Li(o);
  let a = (i ? Bt(t.width) : t.width) / r, l = (i ? Bt(t.height) : t.height) / n;
  return a && Number.isFinite(a) || (a = 1), l && Number.isFinite(l) || (l = 1), { x: a, y: l };
}
function Zo(e, o, t, r) {
  var n, i;
  o === void 0 && (o = !1), t === void 0 && (t = !1);
  const a = e.getBoundingClientRect(), l = zi(e);
  let s = Ni;
  o && (r ? Je(r) && (s = xo(r)) : s = xo(e));
  const d = l ? be(l) : window, c = !Ei() && t;
  let f = (a.left + (c && ((n = d.visualViewport) == null ? void 0 : n.offsetLeft) || 0)) / s.x, u = (a.top + (c && ((i = d.visualViewport) == null ? void 0 : i.offsetTop) || 0)) / s.y, p = a.width / s.x, h = a.height / s.y;
  if (l) {
    const m = be(l), v = r && Je(r) ? be(r) : r;
    let C = m.frameElement;
    for (; C && r && v !== m; ) {
      const w = xo(C), b = C.getBoundingClientRect(), x = getComputedStyle(C);
      b.x += (C.clientLeft + parseFloat(x.paddingLeft)) * w.x, b.y += (C.clientTop + parseFloat(x.paddingTop)) * w.y, f *= w.x, u *= w.y, p *= w.x, h *= w.y, f += b.x, u += b.y, C = be(C).frameElement;
    }
  }
  return { width: p, height: h, top: u, right: f + p, bottom: u + h, left: f, x: f, y: u };
}
function eo(e) {
  return ((Ii(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Nt(e) {
  return Je(e) ? { scrollLeft: e.scrollLeft, scrollTop: e.scrollTop } : { scrollLeft: e.pageXOffset, scrollTop: e.pageYOffset };
}
function Hi(e) {
  return Zo(eo(e)).left + Nt(e).scrollLeft;
}
function Wo(e) {
  if (to(e) === "html") return e;
  const o = e.assignedSlot || e.parentNode || fn(e) && e.host || eo(e);
  return fn(o) ? o.host : o;
}
function Vi(e) {
  const o = Wo(e);
  return Lr(o) ? o.ownerDocument.body : Ae(o) && zt(o) ? o : Vi(o);
}
function _t(e, o) {
  var t;
  o === void 0 && (o = []);
  const r = Vi(e), n = r === ((t = e.ownerDocument) == null ? void 0 : t.body), i = be(r);
  return n ? o.concat(i, i.visualViewport || [], zt(r) ? r : []) : o.concat(r, _t(r));
}
function hn(e, o, t) {
  return o === "viewport" ? uo(function(r, n) {
    const i = be(r), a = eo(r), l = i.visualViewport;
    let s = a.clientWidth, d = a.clientHeight, c = 0, f = 0;
    if (l) {
      s = l.width, d = l.height;
      const u = Ei();
      (u || !u && n === "fixed") && (c = l.offsetLeft, f = l.offsetTop);
    }
    return { width: s, height: d, x: c, y: f };
  }(e, t)) : Je(o) ? uo(function(r, n) {
    const i = Zo(r, !0, n === "fixed"), a = i.top + r.clientTop, l = i.left + r.clientLeft, s = Ae(r) ? xo(r) : { x: 1, y: 1 };
    return { width: r.clientWidth * s.x, height: r.clientHeight * s.y, x: l * s.x, y: a * s.y };
  }(o, t)) : uo(function(r) {
    const n = eo(r), i = Nt(r), a = r.ownerDocument.body, l = zo(n.scrollWidth, n.clientWidth, a.scrollWidth, a.clientWidth), s = zo(n.scrollHeight, n.clientHeight, a.scrollHeight, a.clientHeight);
    let d = -i.scrollLeft + Hi(r);
    const c = -i.scrollTop;
    return Le(a).direction === "rtl" && (d += zo(n.clientWidth, a.clientWidth) - l), { width: l, height: s, x: d, y: c };
  }(eo(e)));
}
function gn(e) {
  return Ae(e) && Le(e).position !== "fixed" ? e.offsetParent : null;
}
function mn(e) {
  const o = be(e);
  let t = gn(e);
  for (; t && Fs(t) && Le(t).position === "static"; ) t = gn(t);
  return t && (to(t) === "html" || to(t) === "body" && Le(t).position === "static" && !nr(t)) ? o : t || function(r) {
    let n = Wo(r);
    for (; Ae(n) && !Lr(n); ) {
      if (nr(n)) return n;
      n = Wo(n);
    }
    return null;
  }(e) || o;
}
function js(e, o, t) {
  const r = Ae(o), n = eo(o), i = Zo(e, !0, t === "fixed", o);
  let a = { scrollLeft: 0, scrollTop: 0 };
  const l = { x: 0, y: 0 };
  if (r || !r && t !== "fixed") if ((to(o) !== "body" || zt(n)) && (a = Nt(o)), Ae(o)) {
    const s = Zo(o, !0);
    l.x = s.x + o.clientLeft, l.y = s.y + o.clientTop;
  } else n && (l.x = Hi(n));
  return { x: i.left + a.scrollLeft - l.x, y: i.top + a.scrollTop - l.y, width: i.width, height: i.height };
}
const Zs = { getClippingRect: function(e) {
  let { element: o, boundary: t, rootBoundary: r, strategy: n } = e;
  const i = t === "clippingAncestors" ? function(d, c) {
    const f = c.get(d);
    if (f) return f;
    let u = _t(d).filter((v) => Je(v) && to(v) !== "body"), p = null;
    const h = Le(d).position === "fixed";
    let m = h ? Wo(d) : d;
    for (; Je(m) && !Lr(m); ) {
      const v = Le(m), C = nr(m);
      (h ? C || p : C || v.position !== "static" || !p || !["absolute", "fixed"].includes(p.position)) ? p = v : u = u.filter((w) => w !== m), m = Wo(m);
    }
    return c.set(d, u), u;
  }(o, this._c) : [].concat(t), a = [...i, r], l = a[0], s = a.reduce((d, c) => {
    const f = hn(o, c, n);
    return d.top = zo(f.top, d.top), d.right = pn(f.right, d.right), d.bottom = pn(f.bottom, d.bottom), d.left = zo(f.left, d.left), d;
  }, hn(o, l, n));
  return { width: s.right - s.left, height: s.bottom - s.top, x: s.left, y: s.top };
}, convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
  let { rect: o, offsetParent: t, strategy: r } = e;
  const n = Ae(t), i = eo(t);
  if (t === i) return o;
  let a = { scrollLeft: 0, scrollTop: 0 }, l = { x: 1, y: 1 };
  const s = { x: 0, y: 0 };
  if ((n || !n && r !== "fixed") && ((to(t) !== "body" || zt(i)) && (a = Nt(t)), Ae(t))) {
    const d = Zo(t);
    l = xo(t), s.x = d.x + t.clientLeft, s.y = d.y + t.clientTop;
  }
  return { width: o.width * l.x, height: o.height * l.y, x: o.x * l.x - a.scrollLeft * l.x + s.x, y: o.y * l.y - a.scrollTop * l.y + s.y };
}, isElement: Je, getDimensions: function(e) {
  return Ae(e) ? Li(e) : e.getBoundingClientRect();
}, getOffsetParent: mn, getDocumentElement: eo, getScale: xo, async getElementRects(e) {
  let { reference: o, floating: t, strategy: r } = e;
  const n = this.getOffsetParent || mn, i = this.getDimensions;
  return { reference: js(o, await n(t), r), floating: { x: 0, y: 0, ...await i(t) } };
}, getClientRects: (e) => Array.from(e.getClientRects()), isRTL: (e) => Le(e).direction === "rtl" }, Ws = (e, o, t) => {
  const r = /* @__PURE__ */ new Map(), n = { platform: Zs, ...t }, i = { ...n.platform, _c: r };
  return ki(e, o, { ...n, platform: i });
};
function Fi(e, o) {
  for (const t in o)
    Object.prototype.hasOwnProperty.call(o, t) && (typeof o[t] == "object" && e[t] ? Fi(e[t], o[t]) : e[t] = o[t]);
}
const Te = {
  // Disable popper components
  disabled: !1,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: !1,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: !0,
  // Flip to the opposite placement if needed
  flip: !0,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: !0,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: !0,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: !1,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: !1,
      // Enable HTML content in directive
      html: !1,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: !0,
      // Hide on clock outside
      autoHide: !0
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function Yo(e, o) {
  let t = Te.themes[e] || {}, r;
  do
    r = t[o], typeof r > "u" ? t.$extend ? t = Te.themes[t.$extend] || {} : (t = null, r = Te[o]) : t = null;
  while (t);
  return r;
}
function Ys(e) {
  const o = [e];
  let t = Te.themes[e] || {};
  do
    t.$extend && !t.$resetCss ? (o.push(t.$extend), t = Te.themes[t.$extend] || {}) : t = null;
  while (t);
  return o.map((r) => `v-popper--theme-${r}`);
}
function bn(e) {
  const o = [e];
  let t = Te.themes[e] || {};
  do
    t.$extend ? (o.push(t.$extend), t = Te.themes[t.$extend] || {}) : t = null;
  while (t);
  return o;
}
let Mo = !1;
if (typeof window < "u") {
  Mo = !1;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        Mo = !0;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let ji = !1;
typeof window < "u" && typeof navigator < "u" && (ji = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Zi = ["auto", "top", "bottom", "left", "right"].reduce((e, o) => e.concat([
  o,
  `${o}-start`,
  `${o}-end`
]), []), vn = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, yn = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function kn(e, o) {
  const t = e.indexOf(o);
  t !== -1 && e.splice(t, 1);
}
function Wt() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const _e = [];
let lo = null;
const wn = {};
function Cn(e) {
  let o = wn[e];
  return o || (o = wn[e] = []), o;
}
let ir = function() {
};
typeof window < "u" && (ir = window.Element);
function V(e) {
  return function(o) {
    return Yo(o.theme, e);
  };
}
const Yt = "__floating-vue__popper", Wi = () => A({
  name: "VPopper",
  provide() {
    return {
      [Yt]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [Yt]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: !0
    },
    targetNodes: {
      type: Function,
      required: !0
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: !0
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: V("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: V("positioningDisabled")
    },
    placement: {
      type: String,
      default: V("placement"),
      validator: (e) => Zi.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: V("delay")
    },
    distance: {
      type: [Number, String],
      default: V("distance")
    },
    skidding: {
      type: [Number, String],
      default: V("skidding")
    },
    triggers: {
      type: Array,
      default: V("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: V("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: V("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: V("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: V("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: V("popperHideTriggers")
    },
    container: {
      type: [String, Object, ir, Boolean],
      default: V("container")
    },
    boundary: {
      type: [String, ir],
      default: V("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: V("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: V("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: V("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: V("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: V("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: V("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: V("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: V("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: V("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: V("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: V("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: V("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: V("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: V("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: V("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: V("flip")
    },
    shift: {
      type: Boolean,
      default: V("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: V("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: V("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: V("disposeTimeout")
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  data() {
    return {
      isShown: !1,
      isMounted: !1,
      skipTransition: !1,
      classes: {
        showFrom: !1,
        showTo: !1,
        hideFrom: !1,
        hideTo: !0
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: !0,
      pendingHide: !1,
      containsGlobalTarget: !1,
      isDisposed: !0,
      mouseDownContains: !1
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[Yt]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, o;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((o = this.popperShowTriggers) == null ? void 0 : o.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: !0
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, o) => (e[o] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: o = !1, force: t = !1 } = {}) {
      var r, n;
      (r = this.parentPopper) != null && r.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = !1, (t || !this.disabled) && (((n = this.parentPopper) == null ? void 0 : n.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, o), this.$emit("show"), this.$_showFrameLocked = !0, requestAnimationFrame(() => {
        this.$_showFrameLocked = !1;
      })), this.$emit("update:shown", !0));
    },
    hide({ event: e = null, skipDelay: o = !1 } = {}) {
      var t;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = !0;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: o }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((t = this.parentPopper) == null ? void 0 : t.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = !1, this.$_scheduleHide(e, o), this.$emit("hide"), this.$emit("update:shown", !1);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = !1, this.isMounted = !1, this.$_events = [], this.$_preventShow = !1, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((o) => o.nodeType === o.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = !0, this.$_removeEventListeners(), this.hide({ skipDelay: !0 }), this.$_detachPopperNode(), this.isMounted = !1, this.isShown = !1, this.$_updateParentShownChildren(!1), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(Ci({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const o = this.placement.startsWith("auto");
      if (o ? e.middleware.push(wi({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(Ul({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !o && this.flip && e.middleware.push(Yl({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(Zl({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: r, rects: n, middlewareData: i }) => {
          let a;
          const { centerOffset: l } = i.arrow;
          return r.startsWith("top") || r.startsWith("bottom") ? a = Math.abs(l) > n.reference.width / 2 : a = Math.abs(l) > n.reference.height / 2, {
            data: {
              overflow: a
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const r = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: n, placement: i, middlewareData: a }) => {
            var l;
            if ((l = a.autoSize) != null && l.skip)
              return {};
            let s, d;
            return i.startsWith("top") || i.startsWith("bottom") ? s = n.reference.width : d = n.reference.height, this.$_innerNode.style[r === "min" ? "minWidth" : r === "max" ? "maxWidth" : "width"] = s != null ? `${s}px` : null, this.$_innerNode.style[r === "min" ? "minHeight" : r === "max" ? "maxHeight" : "height"] = d != null ? `${d}px` : null, {
              data: {
                skip: !0
              },
              reset: {
                rects: !0
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(Gl({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: r, availableHeight: n }) => {
          this.$_innerNode.style.maxWidth = r != null ? `${r}px` : null, this.$_innerNode.style.maxHeight = n != null ? `${n}px` : null;
        }
      })));
      const t = await Ws(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: t.x,
        y: t.y,
        placement: t.placement,
        strategy: t.strategy,
        arrow: {
          ...t.middlewareData.arrow,
          ...t.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, o = !1) {
      if (this.$_updateParentShownChildren(!0), this.$_hideInProgress = !1, clearTimeout(this.$_scheduleTimer), lo && this.instantMove && lo.instantMove && lo !== this.parentPopper) {
        lo.$_applyHide(!0), this.$_applyShow(!0);
        return;
      }
      o ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, o = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0;
        return;
      }
      this.$_updateParentShownChildren(!1), this.$_hideInProgress = !0, clearTimeout(this.$_scheduleTimer), this.isShown && (lo = this), o ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const o = this.delay;
      return parseInt(o && o[e] || o || 0);
    },
    async $_applyShow(e = !1) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await Wt(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ..._t(this.$_referenceNode),
        ..._t(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const o = this.$_referenceNode.getBoundingClientRect(), t = this.$_popperNode.querySelector(".v-popper__wrapper"), r = t.parentNode.getBoundingClientRect(), n = o.x + o.width / 2 - (r.left + t.offsetLeft), i = o.y + o.height / 2 - (r.top + t.offsetTop);
        this.result.transformOrigin = `${n}px ${i}px`;
      }
      this.isShown = !0, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let o;
        for (let t = 0; t < _e.length; t++)
          o = _e[t], o.showGroup !== e && (o.hide(), o.$emit("close-group"));
      }
      _e.push(this), document.body.classList.add("v-popper--some-open");
      for (const o of bn(this.theme))
        Cn(o).push(this), document.body.classList.add(`v-popper--some-open--${o}`);
      this.$emit("apply-show"), this.classes.showFrom = !0, this.classes.showTo = !1, this.classes.hideFrom = !1, this.classes.hideTo = !1, await Wt(), this.classes.showFrom = !1, this.classes.showTo = !0, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = !1) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = !0, this.$_hideInProgress = !1;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, kn(_e, this), _e.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const t of bn(this.theme)) {
        const r = Cn(t);
        kn(r, this), r.length === 0 && document.body.classList.remove(`v-popper--some-open--${t}`);
      }
      lo === this && (lo = null), this.isShown = !1, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const o = this.disposeTimeout;
      o !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = !1);
      }, o)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = !1, this.classes.showTo = !1, this.classes.hideFrom = !0, this.classes.hideTo = !1, await Wt(), this.classes.hideFrom = !1, this.classes.hideTo = !0;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === !1 && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = !0;
    },
    $_addEventListeners() {
      const e = (t) => {
        this.isShown && !this.$_hideInProgress || (t.usedByTooltip = !0, !this.$_preventShow && this.show({ event: t }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, vn, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], vn, this.popperTriggers, this.popperShowTriggers, e);
      const o = (t) => {
        t.usedByTooltip || this.hide({ event: t });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, yn, this.triggers, this.hideTriggers, o), this.$_registerTriggerListeners([this.$_popperNode], yn, this.popperTriggers, this.popperHideTriggers, o);
    },
    $_registerEventListeners(e, o, t) {
      this.$_events.push({ targetNodes: e, eventType: o, handler: t }), e.forEach((r) => r.addEventListener(o, t, Mo ? {
        passive: !0
      } : void 0));
    },
    $_registerTriggerListeners(e, o, t, r, n) {
      let i = t;
      r != null && (i = typeof r == "function" ? r(i) : r), i.forEach((a) => {
        const l = o[a];
        l && this.$_registerEventListeners(e, l, n);
      });
    },
    $_removeEventListeners(e) {
      const o = [];
      this.$_events.forEach((t) => {
        const { targetNodes: r, eventType: n, handler: i } = t;
        !e || e === n ? r.forEach((a) => a.removeEventListener(n, i)) : o.push(t);
      }), this.$_events = o;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, o = !1) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), o && (this.$_preventShow = !0, setTimeout(() => {
        this.$_preventShow = !1;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, o) {
      for (const t of this.$_targetNodes) {
        const r = t.getAttribute(e);
        r && (t.removeAttribute(e), t.setAttribute(o, r));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const o of this.$_targetNodes)
        for (const t in e) {
          const r = e[t];
          r == null ? o.removeAttribute(t) : o.setAttribute(t, r);
        }
    },
    $_updateParentShownChildren(e) {
      let o = this.parentPopper;
      for (; o; )
        e ? o.shownChildren.add(this.randomId) : (o.shownChildren.delete(this.randomId), o.pendingHide && o.hide()), o = o.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (No >= e.left && No <= e.right && Ho >= e.top && Ho <= e.bottom) {
        const o = this.$_popperNode.getBoundingClientRect(), t = No - Ke, r = Ho - Ue, n = o.left + o.width / 2 - Ke + (o.top + o.height / 2) - Ue + o.width + o.height, i = Ke + t * n, a = Ue + r * n;
        return dt(Ke, Ue, i, a, o.left, o.top, o.left, o.bottom) || // Left edge
        dt(Ke, Ue, i, a, o.left, o.top, o.right, o.top) || // Top edge
        dt(Ke, Ue, i, a, o.right, o.top, o.right, o.bottom) || // Right edge
        dt(Ke, Ue, i, a, o.left, o.bottom, o.right, o.bottom);
      }
      return !1;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (ji) {
    const e = Mo ? {
      passive: !0,
      capture: !0
    } : !0;
    document.addEventListener("touchstart", (o) => xn(o, !0), e), document.addEventListener("touchend", (o) => Sn(o, !0), e);
  } else
    window.addEventListener("mousedown", (e) => xn(e, !1), !0), window.addEventListener("click", (e) => Sn(e, !1), !0);
  window.addEventListener("resize", Us);
}
function xn(e, o) {
  if (Te.autoHideOnMousedown)
    Yi(e, o);
  else
    for (let t = 0; t < _e.length; t++) {
      const r = _e[t];
      try {
        r.mouseDownContains = r.popperNode().contains(e.target);
      } catch {
      }
    }
}
function Sn(e, o) {
  Te.autoHideOnMousedown || Yi(e, o);
}
function Yi(e, o) {
  const t = {};
  for (let r = _e.length - 1; r >= 0; r--) {
    const n = _e[r];
    try {
      const i = n.containsGlobalTarget = n.mouseDownContains || n.popperNode().contains(e.target);
      n.pendingHide = !1, requestAnimationFrame(() => {
        if (n.pendingHide = !1, !t[n.randomId] && $n(n, i, e)) {
          if (n.$_handleGlobalClose(e, o), !e.closeAllPopover && e.closePopover && i) {
            let l = n.parentPopper;
            for (; l; )
              t[l.randomId] = !0, l = l.parentPopper;
            return;
          }
          let a = n.parentPopper;
          for (; a && $n(a, a.containsGlobalTarget, e); )
            a.$_handleGlobalClose(e, o), a = a.parentPopper;
        }
      });
    } catch {
    }
  }
}
function $n(e, o, t) {
  return t.closeAllPopover || t.closePopover && o || Ks(e, t) && !o;
}
function Ks(e, o) {
  if (typeof e.autoHide == "function") {
    const t = e.autoHide(o);
    return e.lastAutoHide = t, t;
  }
  return e.autoHide;
}
function Us() {
  for (let e = 0; e < _e.length; e++)
    _e[e].$_computePosition();
}
let Ke = 0, Ue = 0, No = 0, Ho = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  Ke = No, Ue = Ho, No = e.clientX, Ho = e.clientY;
}, Mo ? {
  passive: !0
} : void 0);
function dt(e, o, t, r, n, i, a, l) {
  const s = ((a - n) * (o - i) - (l - i) * (e - n)) / ((l - i) * (t - e) - (a - n) * (r - o)), d = ((t - e) * (o - i) - (r - o) * (e - n)) / ((l - i) * (t - e) - (a - n) * (r - o));
  return s >= 0 && s <= 1 && d >= 0 && d <= 1;
}
const Gs = {
  extends: Wi()
}, Ht = (e, o) => {
  const t = e.__vccOpts || e;
  for (const [r, n] of o)
    t[r] = n;
  return t;
};
function qs(e, o, t, r, n, i) {
  return g(), $("div", {
    ref: "reference",
    class: L(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    B(e.$slots, "default", wr(Cr(e.slotData)))
  ], 2);
}
const Xs = /* @__PURE__ */ Ht(Gs, [["render", qs]]);
function Qs() {
  var e = window.navigator.userAgent, o = e.indexOf("MSIE ");
  if (o > 0)
    return parseInt(e.substring(o + 5, e.indexOf(".", o)), 10);
  var t = e.indexOf("Trident/");
  if (t > 0) {
    var r = e.indexOf("rv:");
    return parseInt(e.substring(r + 3, e.indexOf(".", r)), 10);
  }
  var n = e.indexOf("Edge/");
  return n > 0 ? parseInt(e.substring(n + 5, e.indexOf(".", n)), 10) : -1;
}
let vt;
function ar() {
  ar.init || (ar.init = !0, vt = Qs() !== -1);
}
var Vt = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: !1
    },
    ignoreWidth: {
      type: Boolean,
      default: !1
    },
    ignoreHeight: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    ar(), gi(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", vt && this.$el.appendChild(e), e.data = "about:blank", vt || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!vt && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const Js = /* @__PURE__ */ yl("data-v-b329ee4c");
fi("data-v-b329ee4c");
const ec = {
  class: "resize-observer",
  tabindex: "-1"
};
hi();
const oc = /* @__PURE__ */ Js((e, o, t, r, n, i) => (g(), M("div", ec)));
Vt.render = oc;
Vt.__scopeId = "data-v-b329ee4c";
Vt.__file = "src/components/ResizeObserver.vue";
const Ki = (e = "theme") => ({
  computed: {
    themeClass() {
      return Ys(this[e]);
    }
  }
}), tc = A({
  name: "VPopperContent",
  components: {
    ResizeObserver: Vt
  },
  mixins: [
    Ki()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), rc = ["id", "aria-hidden", "tabindex", "data-popper-placement"], nc = {
  ref: "inner",
  class: "v-popper__inner"
}, ic = /* @__PURE__ */ P("div", { class: "v-popper__arrow-outer" }, null, -1), ac = /* @__PURE__ */ P("div", { class: "v-popper__arrow-inner" }, null, -1), lc = [
  ic,
  ac
];
function sc(e, o, t, r, n, i) {
  const a = Re("ResizeObserver");
  return g(), $("div", {
    id: e.popperId,
    ref: "popover",
    class: L(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: ht(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: o[2] || (o[2] = K((l) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    P("div", {
      class: "v-popper__backdrop",
      onClick: o[0] || (o[0] = (l) => e.autoHide && e.$emit("hide"))
    }),
    P("div", {
      class: "v-popper__wrapper",
      style: ht(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      P("div", nc, [
        e.mounted ? (g(), $(pe, { key: 0 }, [
          P("div", null, [
            B(e.$slots, "default")
          ]),
          e.handleResize ? (g(), M(a, {
            key: 0,
            onNotify: o[1] || (o[1] = (l) => e.$emit("resize", l))
          })) : I("", !0)
        ], 64)) : I("", !0)
      ], 512),
      P("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: ht(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, lc, 4)
    ], 4)
  ], 46, rc);
}
const Ui = /* @__PURE__ */ Ht(tc, [["render", sc]]), Gi = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let lr = function() {
};
typeof window < "u" && (lr = window.Element);
const cc = A({
  name: "VPopperWrapper",
  components: {
    Popper: Xs,
    PopperContent: Ui
  },
  mixins: [
    Gi,
    Ki("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: !1
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, lr, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, lr],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => !0,
    hide: () => !0,
    "update:shown": (e) => !0,
    "apply-show": () => !0,
    "apply-hide": () => !0,
    "close-group": () => !0,
    "close-directive": () => !0,
    "auto-hide": () => !0,
    resize: () => !0
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function dc(e, o, t, r, n, i) {
  const a = Re("PopperContent"), l = Re("Popper");
  return g(), M(l, y({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: o[0] || (o[0] = () => e.$emit("show")),
    onHide: o[1] || (o[1] = () => e.$emit("hide")),
    "onUpdate:shown": o[2] || (o[2] = (s) => e.$emit("update:shown", s)),
    onApplyShow: o[3] || (o[3] = () => e.$emit("apply-show")),
    onApplyHide: o[4] || (o[4] = () => e.$emit("apply-hide")),
    onCloseGroup: o[5] || (o[5] = () => e.$emit("close-group")),
    onCloseDirective: o[6] || (o[6] = () => e.$emit("close-directive")),
    onAutoHide: o[7] || (o[7] = () => e.$emit("auto-hide")),
    onResize: o[8] || (o[8] = () => e.$emit("resize"))
  }), {
    default: S(({
      popperId: s,
      isShown: d,
      shouldMountContent: c,
      skipTransition: f,
      autoHide: u,
      show: p,
      hide: h,
      handleResize: m,
      onResize: v,
      classes: C,
      result: w
    }) => [
      B(e.$slots, "default", {
        shown: d,
        show: p,
        hide: h
      }),
      R(a, {
        ref: "popperContent",
        "popper-id": s,
        theme: e.finalTheme,
        shown: d,
        mounted: c,
        "skip-transition": f,
        "auto-hide": u,
        "handle-resize": m,
        classes: C,
        result: w,
        onHide: h,
        onResize: v
      }, {
        default: S(() => [
          B(e.$slots, "popper", {
            shown: d,
            hide: h
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const Ar = /* @__PURE__ */ Ht(cc, [["render", dc]]), uc = {
  ...Ar,
  name: "VDropdown",
  vPopperTheme: "dropdown"
}, pc = {
  ...Ar,
  name: "VMenu",
  vPopperTheme: "menu"
}, fc = {
  ...Ar,
  name: "VTooltip",
  vPopperTheme: "tooltip"
}, hc = A({
  name: "VTooltipDirective",
  components: {
    Popper: Wi(),
    PopperContent: Ui
  },
  mixins: [
    Gi
  ],
  inheritAttrs: !1,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => Yo(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => Yo(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: !0
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(!0);
      },
      immediate: !0
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = !0;
        const o = ++this.$_fetchId, t = this.content(this);
        t.then ? t.then((r) => this.onResult(o, r)) : this.onResult(o, t);
      }
    },
    onResult(e, o) {
      e === this.$_fetchId && (this.$_loading = !1, this.asyncContent = o);
    },
    onShow() {
      this.$_isShown = !0, this.fetchContent();
    },
    onHide() {
      this.$_isShown = !1;
    }
  }
}), gc = ["innerHTML"], mc = ["textContent"];
function bc(e, o, t, r, n, i) {
  const a = Re("PopperContent"), l = Re("Popper");
  return g(), M(l, y({ ref: "popper" }, e.$attrs, {
    theme: e.theme,
    "target-nodes": e.targetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    onApplyShow: e.onShow,
    onApplyHide: e.onHide
  }), {
    default: S(({
      popperId: s,
      isShown: d,
      shouldMountContent: c,
      skipTransition: f,
      autoHide: u,
      hide: p,
      handleResize: h,
      onResize: m,
      classes: v,
      result: C
    }) => [
      R(a, {
        ref: "popperContent",
        class: L({
          "v-popper--tooltip-loading": e.loading
        }),
        "popper-id": s,
        theme: e.theme,
        shown: d,
        mounted: c,
        "skip-transition": f,
        "auto-hide": u,
        "handle-resize": h,
        classes: v,
        result: C,
        onHide: p,
        onResize: m
      }, {
        default: S(() => [
          e.html ? (g(), $("div", {
            key: 0,
            innerHTML: e.finalContent
          }, null, 8, gc)) : (g(), $("div", {
            key: 1,
            textContent: z(e.finalContent)
          }, null, 8, mc))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "target-nodes", "popper-node", "onApplyShow", "onApplyHide"]);
}
const vc = /* @__PURE__ */ Ht(hc, [["render", bc]]), qi = "v-popper--has-tooltip";
function yc(e, o) {
  let t = e.placement;
  if (!t && o)
    for (const r of Zi)
      o[r] && (t = r);
  return t || (t = Yo(e.theme || "tooltip", "placement")), t;
}
function Xi(e, o, t) {
  let r;
  const n = typeof o;
  return n === "string" ? r = { content: o } : o && n === "object" ? r = o : r = { content: !1 }, r.placement = yc(r, t), r.targetNodes = () => [e], r.referenceNode = () => e, r;
}
let Kt, Ko, kc = 0;
function wc() {
  if (Kt)
    return;
  Ko = Z([]), Kt = kl({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: Ko
      };
    },
    render() {
      return this.directives.map((o) => wl(vc, {
        ...o.options,
        shown: o.shown || o.options.shown,
        key: o.id
      }));
    },
    devtools: {
      hide: !0
    }
  });
  const e = document.createElement("div");
  document.body.appendChild(e), Kt.mount(e);
}
function Cc(e, o, t) {
  wc();
  const r = Z(Xi(e, o, t)), n = Z(!1), i = {
    id: kc++,
    options: r,
    shown: n
  };
  return Ko.value.push(i), e.classList && e.classList.add(qi), e.$_popper = {
    options: r,
    item: i,
    show() {
      n.value = !0;
    },
    hide() {
      n.value = !1;
    }
  };
}
function Qi(e) {
  if (e.$_popper) {
    const o = Ko.value.indexOf(e.$_popper.item);
    o !== -1 && Ko.value.splice(o, 1), delete e.$_popper, delete e.$_popperOldShown, delete e.$_popperMountTarget;
  }
  e.classList && e.classList.remove(qi);
}
function Bn(e, { value: o, modifiers: t }) {
  const r = Xi(e, o, t);
  if (!r.content || Yo(r.theme || "tooltip", "disabled"))
    Qi(e);
  else {
    let n;
    e.$_popper ? (n = e.$_popper, n.options.value = r) : n = Cc(e, o, t), typeof o.shown < "u" && o.shown !== e.$_popperOldShown && (e.$_popperOldShown = o.shown, o.shown ? n.show() : n.hide());
  }
}
const Ji = {
  beforeMount: Bn,
  updated: Bn,
  beforeUnmount(e) {
    Qi(e);
  }
};
function _n(e) {
  e.addEventListener("mousedown", Mt), e.addEventListener("click", Mt), e.addEventListener("touchstart", ea, Mo ? {
    passive: !0
  } : !1);
}
function Mn(e) {
  e.removeEventListener("mousedown", Mt), e.removeEventListener("click", Mt), e.removeEventListener("touchstart", ea), e.removeEventListener("touchend", oa), e.removeEventListener("touchcancel", ta);
}
function Mt(e) {
  const o = e.currentTarget;
  e.closePopover = !o.$_vclosepopover_touch, e.closeAllPopover = o.$_closePopoverModifiers && !!o.$_closePopoverModifiers.all;
}
function ea(e) {
  if (e.changedTouches.length === 1) {
    const o = e.currentTarget;
    o.$_vclosepopover_touch = !0;
    const t = e.changedTouches[0];
    o.$_vclosepopover_touchPoint = t, o.addEventListener("touchend", oa), o.addEventListener("touchcancel", ta);
  }
}
function oa(e) {
  const o = e.currentTarget;
  if (o.$_vclosepopover_touch = !1, e.changedTouches.length === 1) {
    const t = e.changedTouches[0], r = o.$_vclosepopover_touchPoint;
    e.closePopover = Math.abs(t.screenY - r.screenY) < 20 && Math.abs(t.screenX - r.screenX) < 20, e.closeAllPopover = o.$_closePopoverModifiers && !!o.$_closePopoverModifiers.all;
  }
}
function ta(e) {
  const o = e.currentTarget;
  o.$_vclosepopover_touch = !1;
}
const xc = {
  beforeMount(e, { value: o, modifiers: t }) {
    e.$_closePopoverModifiers = t, (typeof o > "u" || o) && _n(e);
  },
  updated(e, { value: o, oldValue: t, modifiers: r }) {
    e.$_closePopoverModifiers = r, o !== t && (typeof o > "u" || o ? _n(e) : Mn(e));
  },
  beforeUnmount(e) {
    Mn(e);
  }
}, Ut = Ji;
function Sc(e, o = {}) {
  e.$_vTooltipInstalled || (e.$_vTooltipInstalled = !0, Fi(Te, o), e.directive("tooltip", Ji), e.directive("close-popper", xc), e.component("VTooltip", fc), e.component("VDropdown", uc), e.component("VMenu", pc));
}
const ra = {
  // eslint-disable-next-line no-undef
  version: "5.2.2",
  install: Sc,
  options: Te
};
ra.options.distance = 8;
ra.options.themes.tooltip.html = !1;
const $c = {
  beforeMount: Ut.beforeMount,
  beforeUnmount: Ut.beforeUnmount,
  updated: Ut.updated
}, Bc = /* @__PURE__ */ A({
  directives: {
    tooltip: $c
  },
  __name: "BgButton",
  props: {
    size: { default: bt.Md },
    variant: { default: Io.Solid },
    ariaLabel: {},
    icon: {},
    leftIcon: { default: null },
    rightIcon: { default: null },
    fullWidth: { type: Boolean }
  },
  setup(e) {
    He((i) => ({
      b90b70b6: t.value.height,
      a2845456: r.value.border,
      "6be55553": t.value.padding,
      "2aff634c": r.value.backgroundColor,
      "894316cc": r.value.color,
      e9a97338: n.value,
      "6f7540b0": r.value.hoverColor
    }));
    const o = e;
    if (o.icon && !o.ariaLabel)
      throw new Error("You must provide an aria-label when using an icon button");
    const t = H(() => ({
      [bt.Sm]: {
        height: Jr.sm,
        padding: o.icon ? 0 : `0 ${en.lg}`
      },
      [bt.Md]: {
        height: Jr.md,
        padding: o.icon ? 0 : `0 ${en.xLg}`
      }
    })[o.size]), r = H(() => ({
      [Io.Solid]: {
        backgroundColor: ce(te.BlueNormal),
        color: ce(te.GreyWhite),
        hoverColor: ce(te.BlueSemiDark),
        iconColor: te.GreyWhite,
        border: "none"
      },
      [Io.Outline]: {
        backgroundColor: "transparent",
        color: ce(te.BlueSemiDark),
        hoverColor: ce(te.BlueLight),
        iconColor: te.BlueSemiDark,
        border: `1px solid ${ce(te.BlueSemiDark)}`
      },
      [Io.Ghost]: {
        backgroundColor: "transparent",
        color: ce(te.BlueSemiDark),
        hoverColor: ce(te.BlueLight),
        iconColor: te.BlueSemiDark,
        border: "none"
      }
    })[o.variant]), n = H(() => o.icon ? t.value.height : o.fullWidth ? "100%" : "auto");
    return (i, a) => {
      const l = xr("tooltip");
      return co((g(), M(k(U), {
        is: "button",
        type: "button",
        "aria-label": o.ariaLabel,
        class: L(i.$style[o.variant])
      }, {
        default: S(() => [
          i.icon ? (g(), M(k(Co), {
            key: 0,
            name: i.icon,
            color: r.value.iconColor
          }, null, 8, ["name", "color"])) : (g(), $(pe, { key: 1 }, [
            o.leftIcon ? (g(), M(k(Co), {
              key: 0,
              name: o.leftIcon,
              color: r.value.iconColor,
              class: L(i.$style.leftIcon)
            }, null, 8, ["name", "color", "class"])) : I("", !0),
            B(i.$slots, "default", {}, void 0, !0),
            o.rightIcon ? (g(), M(k(Co), {
              key: 1,
              name: o.rightIcon,
              color: r.value.iconColor,
              class: L(i.$style.rightIcon)
            }, null, 8, ["name", "color", "class"])) : I("", !0)
          ], 64))
        ]),
        _: 3
      }, 8, ["aria-label", "class"])), [
        [l, o.ariaLabel]
      ]);
    };
  }
}), _c = "_ghost_7lqoj_34", Mc = "_left-icon_7lqoj_43", Tc = "_right-icon_7lqoj_48", Pc = {
  ghost: _c,
  leftIcon: Mc,
  rightIcon: Tc
}, Dc = {
  $style: Pc
}, Oe = /* @__PURE__ */ W(Bc, [["__cssModules", Dc], ["__scopeId", "data-v-161d7faf"]]), Oc = {}, Rc = { class: "bg-card" };
function Lc(e, o) {
  return g(), $("div", Rc, [
    B(e.$slots, "default", {}, void 0, !0)
  ]);
}
const cg = /* @__PURE__ */ W(Oc, [["render", Lc], ["__scopeId", "data-v-e567d788"]]);
var na = /* @__PURE__ */ ((e) => (e.Content = "content", e.Fluid = "fluid", e.One = "1/12", e.Two = "2/12", e.Three = "3/12", e.Four = "4/12", e.Five = "5/12", e.Six = "6/12", e.Seven = "7/12", e.Eight = "8/12", e.Nine = "9/12", e.Ten = "10/12", e.Eleven = "11/12", e.Twelve = "12/12", e))(na || {}), ia = /* @__PURE__ */ ((e) => (e.Left = "left", e.Center = "center", e.Right = "right", e))(ia || {}), aa = /* @__PURE__ */ ((e) => (e.Top = "top", e.Center = "center", e.Bottom = "bottom", e))(aa || {});
const dg = Symbol("BgColumnsInjectionKey"), Ac = /* @__PURE__ */ A({
  __name: "BgColumns",
  props: {
    is: { default: "div" },
    hAlign: { default: ia.Left },
    vAlign: { default: aa.Center }
  },
  setup(e) {
    He((r) => ({
      "5a17be5e": t.value.alignItems,
      "41d709df": t.value.justifyContent
    }));
    const o = e, t = H(() => ({
      alignItems: {
        top: "flex-start",
        center: "center",
        bottom: "flex-end"
      }[o.vAlign],
      justifyContent: {
        left: "flex-start",
        center: "center",
        right: "flex-end"
      }[o.hAlign]
    }));
    return (r, n) => (g(), M(k(U), {
      is: r.is,
      class: L(r.$style.columns)
    }, {
      default: S(() => [
        B(r.$slots, "default")
      ]),
      _: 3
    }, 8, ["is", "class"]));
  }
}), Ic = "_columns_18w6o_2", Ec = {
  columns: Ic
}, zc = {
  $style: Ec
}, ug = /* @__PURE__ */ W(Ac, [["__cssModules", zc]]), ut = 12, Tn = 16, Nc = /* @__PURE__ */ A({
  __name: "BgColumn",
  props: {
    is: { default: "div" },
    width: { default: na.Fluid }
  },
  setup(e) {
    He((i) => ({
      "2b0694a3": n.value
    }));
    const o = e, t = H(() => {
      var i;
      return (i = o.width) != null && i.includes(`/${ut}`) ? "fixed" : o.width;
    }), r = H(
      () => t.value === "fixed" ? Number(o.width.split(`/${ut}`)[0]) : 0
    ), n = H(() => {
      const i = "100%", a = `${(ut - 1) * Tn}px`, l = `${(r.value - 1) * Tn}px`;
      return `calc(((${i} - ${a}) / ${ut}) * ${r.value} + ${l})`;
    });
    return (i, a) => (g(), M(k(U), {
      is: i.is,
      class: L([
        {
          fixed: i.$style.fixed,
          fluid: i.$style.fluid,
          content: i.$style.content
        }[t.value]
      ])
    }, {
      default: S(() => [
        B(i.$slots, "default")
      ]),
      _: 3
    }, 8, ["is", "class"]));
  }
}), Hc = "_content_eokq3_2", Vc = "_fluid_eokq3_7", Fc = "_fixed_eokq3_12", jc = {
  content: Hc,
  fluid: Vc,
  fixed: Fc
}, Zc = {
  $style: jc
}, pg = /* @__PURE__ */ W(Nc, [["__cssModules", Zc]]);
var Ge = /* @__PURE__ */ ((e) => (e["2xSm"] = "2x-sm", e.XSm = "x-sm", e.Sm = "sm", e.Md = "md", e.Lg = "lg", e.XLg = "x-lg", e["2xLg"] = "2x-lg", e))(Ge || {});
const Wc = /* @__PURE__ */ A({
  __name: "BgStack",
  props: {
    space: {},
    is: { default: "div" }
  },
  setup(e) {
    He((r) => ({
      "06ffa1c0": t.value
    }));
    const o = e;
    io(o, ["space"]);
    const t = H(() => ({
      [Ge["2xSm"]]: xe["2xSm"],
      [Ge.XSm]: xe.xSm,
      [Ge.Sm]: xe.sm,
      [Ge.Md]: xe.md,
      [Ge.Lg]: xe.lg,
      [Ge.XLg]: xe.xLg,
      [Ge["2xLg"]]: xe["2xLg"]
    })[o.space]);
    return (r, n) => (g(), M(U, {
      is: r.is,
      class: L(r.$style.container)
    }, {
      default: S(() => [
        B(r.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["is", "class"]));
  }
}), Yc = "_container_ri13c_2", Kc = {
  container: Yc
}, Uc = {
  $style: Kc
}, Gc = /* @__PURE__ */ W(Wc, [["__cssModules", Uc], ["__scopeId", "data-v-cd44c365"]]), qc = /* @__PURE__ */ A({
  __name: "BgDataTable",
  setup(e) {
    return (o, t) => (g(), M(Gc, { space: "sm" }, {
      default: S(() => [
        B(o.$slots, "default"),
        P("div", {
          class: L(o.$style.pagination)
        }, [
          B(o.$slots, "pagination")
        ], 2)
      ]),
      _: 3
    }));
  }
}), Xc = "_pagination_s677h_2", Qc = {
  pagination: Xc
}, Jc = {
  $style: Qc
}, fg = /* @__PURE__ */ W(qc, [["__cssModules", Jc]]), ed = /* @__PURE__ */ A({
  __name: "BgTransition",
  props: {
    type: {}
  },
  setup(e) {
    return (o, t) => (g(), M(mi, {
      name: `bg-${o.type}`
    }, {
      default: S(() => [
        B(o.$slots, "default")
      ]),
      _: 3
    }, 8, ["name"]));
  }
}), od = ["id", "role", "aria-labelledby"], td = /* @__PURE__ */ A({
  inheritAttrs: !1,
  __name: "BgPopover",
  props: {
    offset: { type: [Number, Function] },
    role: {},
    focusTriggerOnClose: { type: Boolean }
  },
  emits: ["close"],
  setup(e, { expose: o, emit: t }) {
    const r = e, n = Z(null), i = Z(null), a = Bo("bg-popover-button"), l = Bo("bg-popover"), { floatingStyles: s, opened: d, close: c } = Ss(i, n, {
      offset: r.offset
    }), f = t;
    o({ close: c });
    const u = () => {
      var h;
      (h = i.value) == null || h.focus();
    };
    Cl(() => {
      d.value || (f("close"), r.focusTriggerOnClose && u());
    });
    const p = Ot({
      id: a,
      "aria-controls": l,
      "aria-haspopup": r.role,
      "aria-expanded": d,
      onClick: () => d.value = !d.value,
      ref: (h) => {
        i.value = (h == null ? void 0 : h.$el) ?? h;
      }
    });
    return (h, m) => (g(), $(pe, null, [
      B(h.$slots, "button", wr(Cr(p)), void 0, !0),
      R(k(ed), { type: "fade" }, {
        default: S(() => [
          k(d) ? (g(), $("div", y({ key: 0 }, h.$attrs, {
            id: k(l),
            ref_key: "floating",
            ref: n,
            role: h.role,
            style: k(s),
            "aria-labelledby": k(a)
          }), [
            B(h.$slots, "default", {}, void 0, !0)
          ], 16, od)) : I("", !0)
        ]),
        _: 3
      })
    ], 64));
  }
}), rd = {}, nd = {
  $style: rd
}, Ir = /* @__PURE__ */ W(td, [["__cssModules", nd], ["__scopeId", "data-v-e80ed2dd"]]);
function id(e, o) {
  return e ? e.classList ? e.classList.contains(o) : new RegExp("(^| )" + o + "( |$)", "gi").test(e.className) : !1;
}
function ad(e, o) {
  if (e && o) {
    const t = (r) => {
      id(e, r) || (e.classList ? e.classList.add(r) : e.className += " " + r);
    };
    [o].flat().filter(Boolean).forEach((r) => r.split(" ").forEach(t));
  }
}
function Tt(e) {
  for (const o of document == null ? void 0 : document.styleSheets)
    try {
      for (const t of o == null ? void 0 : o.cssRules)
        for (const r of t == null ? void 0 : t.style)
          if (e.test(r))
            return { name: r, value: t.style.getPropertyValue(r).trim() };
    } catch {
    }
  return null;
}
function Gt(e, o) {
  if (e && o) {
    const t = (r) => {
      e.classList ? e.classList.remove(r) : e.className = e.className.replace(new RegExp("(^|\\b)" + r.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };
    [o].flat().filter(Boolean).forEach((r) => r.split(" ").forEach(t));
  }
}
function la(e) {
  let o = { width: 0, height: 0 };
  return e && (e.style.visibility = "hidden", e.style.display = "block", o.width = e.offsetWidth, o.height = e.offsetHeight, e.style.display = "none", e.style.visibility = "visible"), o;
}
function sa() {
  let e = window, o = document, t = o.documentElement, r = o.getElementsByTagName("body")[0], n = e.innerWidth || t.clientWidth || r.clientWidth, i = e.innerHeight || t.clientHeight || r.clientHeight;
  return { width: n, height: i };
}
function ld() {
  let e = document.documentElement;
  return (window.pageXOffset || e.scrollLeft) - (e.clientLeft || 0);
}
function sd() {
  let e = document.documentElement;
  return (window.pageYOffset || e.scrollTop) - (e.clientTop || 0);
}
function cd(e, o, t = !0) {
  var r, n, i, a;
  if (e) {
    const l = e.offsetParent ? { width: e.offsetWidth, height: e.offsetHeight } : la(e), s = l.height, d = l.width, c = o.offsetHeight, f = o.offsetWidth, u = o.getBoundingClientRect(), p = sd(), h = ld(), m = sa();
    let v, C, w = "top";
    u.top + c + s > m.height ? (v = u.top + p - s, w = "bottom", v < 0 && (v = p)) : v = c + u.top + p, u.left + d > m.width ? C = Math.max(0, u.left + h + f - d) : C = u.left + h, e.style.top = v + "px", e.style.left = C + "px", e.style.transformOrigin = w, t && (e.style.marginTop = w === "bottom" ? `calc(${(n = (r = Tt(/-anchor-gutter$/)) == null ? void 0 : r.value) != null ? n : "2px"} * -1)` : (a = (i = Tt(/-anchor-gutter$/)) == null ? void 0 : i.value) != null ? a : "");
  }
}
function dd(e, o) {
  e && (typeof o == "string" ? e.style.cssText = o : Object.entries(o || {}).forEach(([t, r]) => e.style[t] = r));
}
function yt(e, o) {
  return e instanceof HTMLElement ? e.offsetWidth : 0;
}
function ud(e, o, t = !0) {
  var r, n, i, a;
  if (e) {
    const l = e.offsetParent ? { width: e.offsetWidth, height: e.offsetHeight } : la(e), s = o.offsetHeight, d = o.getBoundingClientRect(), c = sa();
    let f, u, p = "top";
    d.top + s + l.height > c.height ? (f = -1 * l.height, p = "bottom", d.top + f < 0 && (f = -1 * d.top)) : f = s, l.width > c.width ? u = d.left * -1 : d.left + l.width > c.width ? u = (d.left + l.width - c.width) * -1 : u = 0, e.style.top = f + "px", e.style.left = u + "px", e.style.transformOrigin = p, t && (e.style.marginTop = p === "bottom" ? `calc(${(n = (r = Tt(/-anchor-gutter$/)) == null ? void 0 : r.value) != null ? n : "2px"} * -1)` : (a = (i = Tt(/-anchor-gutter$/)) == null ? void 0 : i.value) != null ? a : "");
  }
}
function lt(e) {
  return typeof HTMLElement == "object" ? e instanceof HTMLElement : e && typeof e == "object" && e !== null && e.nodeType === 1 && typeof e.nodeName == "string";
}
function Pt(e, o = {}) {
  if (lt(e)) {
    const t = (r, n) => {
      var i, a;
      const l = (i = e == null ? void 0 : e.$attrs) != null && i[r] ? [(a = e == null ? void 0 : e.$attrs) == null ? void 0 : a[r]] : [];
      return [n].flat().reduce((s, d) => {
        if (d != null) {
          const c = typeof d;
          if (c === "string" || c === "number")
            s.push(d);
          else if (c === "object") {
            const f = Array.isArray(d) ? t(r, d) : Object.entries(d).map(([u, p]) => r === "style" && (p || p === 0) ? `${u.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}:${p}` : p ? u : void 0);
            s = f.length ? s.concat(f.filter((u) => !!u)) : s;
          }
        }
        return s;
      }, l);
    };
    Object.entries(o).forEach(([r, n]) => {
      if (n != null) {
        const i = r.match(/^on(.+)/);
        i ? e.addEventListener(i[1].toLowerCase(), n) : r === "p-bind" || r === "pBind" ? Pt(e, n) : (n = r === "class" ? [...new Set(t("class", n))].join(" ").trim() : r === "style" ? t("style", n).join(";").trim() : n, (e.$attrs = e.$attrs || {}) && (e.$attrs[r] = n), e.setAttribute(r, n));
      }
    });
  }
}
function pd(e, o = {}, ...t) {
  {
    const r = document.createElement(e);
    return Pt(r, o), r.append(...t), r;
  }
}
function qe(e, o) {
  return lt(e) ? Array.from(e.querySelectorAll(o)) : [];
}
function Ce(e, o) {
  return lt(e) ? e.matches(o) ? e : e.querySelector(o) : null;
}
function so(e, o) {
  if (lt(e)) {
    const t = e.getAttribute(o);
    return isNaN(t) ? t === "true" || t === "false" ? t === "true" : t : +t;
  }
}
function Pn(e, o = "") {
  let t = qe(
    e,
    `button:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${o},
            [href][clientHeight][clientWidth]:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${o},
            input:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${o},
            select:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${o},
            textarea:not([tabindex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${o},
            [tabIndex]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${o},
            [contenteditable]:not([tabIndex = "-1"]):not([disabled]):not([style*="display:none"]):not([hidden])${o}`
  ), r = [];
  for (let n of t)
    getComputedStyle(n).display != "none" && getComputedStyle(n).visibility != "hidden" && r.push(n);
  return r;
}
function Dn(e) {
  if (e) {
    let o = e.offsetHeight, t = getComputedStyle(e);
    return o -= parseFloat(t.paddingTop) + parseFloat(t.paddingBottom) + parseFloat(t.borderTopWidth) + parseFloat(t.borderBottomWidth), o;
  }
  return 0;
}
function Er(e) {
  if (e) {
    let o = e.parentNode;
    return o && o instanceof ShadowRoot && o.host && (o = o.host), o;
  }
  return null;
}
function Oo(e) {
  var o;
  if (e) {
    let t = (o = Er(e)) == null ? void 0 : o.childNodes, r = 0;
    if (t)
      for (let n = 0; n < t.length; n++) {
        if (t[n] === e) return r;
        t[n].nodeType === 1 && r++;
      }
  }
  return -1;
}
function fd(e) {
  if (e) {
    let o = e.getBoundingClientRect();
    return {
      top: o.top + (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0),
      left: o.left + (window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft || 0)
    };
  }
  return {
    top: "auto",
    left: "auto"
  };
}
function hd(e, o) {
  return e ? e.offsetHeight : 0;
}
function ca(e, o = []) {
  const t = Er(e);
  return t === null ? o : ca(t, o.concat([t]));
}
function gd(e) {
  let o = [];
  if (e) {
    let t = ca(e);
    const r = /(auto|scroll)/, n = (i) => {
      try {
        let a = window.getComputedStyle(i, null);
        return r.test(a.getPropertyValue("overflow")) || r.test(a.getPropertyValue("overflowX")) || r.test(a.getPropertyValue("overflowY"));
      } catch {
        return !1;
      }
    };
    for (let i of t) {
      let a = i.nodeType === 1 && i.dataset.scrollselectors;
      if (a) {
        let l = a.split(",");
        for (let s of l) {
          let d = Ce(i, s);
          d && n(d) && o.push(d);
        }
      }
      i.nodeType !== 9 && n(i) && o.push(i);
    }
  }
  return o;
}
function md(e) {
  return !!(e !== null && typeof e < "u" && e.nodeName && Er(e));
}
function On(e) {
  if (e) {
    let o = e.offsetWidth, t = getComputedStyle(e);
    return o -= parseFloat(t.paddingLeft) + parseFloat(t.paddingRight) + parseFloat(t.borderLeftWidth) + parseFloat(t.borderRightWidth), o;
  }
  return 0;
}
function zr() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function bd() {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
function da(e, o = "", t) {
  lt(e) && t !== null && t !== void 0 && e.setAttribute(o, t);
}
var vd = Object.defineProperty, Rn = Object.getOwnPropertySymbols, yd = Object.prototype.hasOwnProperty, kd = Object.prototype.propertyIsEnumerable, Ln = (e, o, t) => o in e ? vd(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t, wd = (e, o) => {
  for (var t in o || (o = {}))
    yd.call(o, t) && Ln(e, t, o[t]);
  if (Rn)
    for (var t of Rn(o))
      kd.call(o, t) && Ln(e, t, o[t]);
  return e;
};
function ho(e) {
  return e == null || e === "" || Array.isArray(e) && e.length === 0 || !(e instanceof Date) && typeof e == "object" && Object.keys(e).length === 0;
}
function sr(e, o, t = /* @__PURE__ */ new WeakSet()) {
  if (e === o) return !0;
  if (!e || !o || typeof e != "object" || typeof o != "object" || t.has(e) || t.has(o)) return !1;
  t.add(e).add(o);
  let r = Array.isArray(e), n = Array.isArray(o), i, a, l;
  if (r && n) {
    if (a = e.length, a != o.length) return !1;
    for (i = a; i-- !== 0; ) if (!sr(e[i], o[i], t)) return !1;
    return !0;
  }
  if (r != n) return !1;
  let s = e instanceof Date, d = o instanceof Date;
  if (s != d) return !1;
  if (s && d) return e.getTime() == o.getTime();
  let c = e instanceof RegExp, f = o instanceof RegExp;
  if (c != f) return !1;
  if (c && f) return e.toString() == o.toString();
  let u = Object.keys(e);
  if (a = u.length, a !== Object.keys(o).length) return !1;
  for (i = a; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(o, u[i])) return !1;
  for (i = a; i-- !== 0; )
    if (l = u[i], !sr(e[l], o[l], t)) return !1;
  return !0;
}
function Cd(e, o) {
  return sr(e, o);
}
function Nr(e) {
  return !!(e && e.constructor && e.call && e.apply);
}
function ee(e) {
  return !ho(e);
}
function xd(e, o, t) {
  return Cd(e, o);
}
function Ne(e, o = !0) {
  return e instanceof Object && e.constructor === Object && (o || Object.keys(e).length !== 0);
}
function ve(e, ...o) {
  return Nr(e) ? e(...o) : e;
}
function he(e, o = !0) {
  return typeof e == "string" && (o || e !== "");
}
function $e(e) {
  return he(e) ? e.replace(/(-|_)/g, "").toLowerCase() : e;
}
function Hr(e, o = "", t = {}) {
  const r = $e(o).split("."), n = r.shift();
  return n ? Ne(e) ? Hr(ve(e[Object.keys(e).find((i) => $e(i) === n) || ""], t), r.join("."), t) : void 0 : ve(e, t);
}
function Ft(e, o = !0) {
  return Array.isArray(e) && (o || e.length !== 0);
}
function Sd(e) {
  return ee(e) && !isNaN(e);
}
function $d() {
  return new Intl.Collator(void 0, { numeric: !0 }).compare;
}
function We(e, o) {
  if (o) {
    const t = o.test(e);
    return o.lastIndex = 0, t;
  }
  return !1;
}
function ua(...e) {
  const o = (t = {}, r = {}) => {
    const n = wd({}, t);
    return Object.keys(r).forEach((i) => {
      Ne(r[i]) && i in t && Ne(t[i]) ? n[i] = o(t[i], r[i]) : n[i] = r[i];
    }), n;
  };
  return e.reduce((t, r, n) => n === 0 ? r : o(t, r), {});
}
function Vo(e) {
  return e && e.replace(/\/\*(?:(?!\*\/)[\s\S])*\*\/|[\r\n\t]+/g, "").replace(/ {2,}/g, " ").replace(/ ([{:}]) /g, "$1").replace(/([;,]) /g, "$1").replace(/ !/g, "!").replace(/: /g, ":");
}
function Bd(e) {
  return he(e, !1) ? e[0].toUpperCase() + e.slice(1) : e;
}
function pa(e) {
  return he(e) ? e.replace(/(_)/g, "-").replace(/[A-Z]/g, (o, t) => t === 0 ? o : "-" + o.toLowerCase()).toLowerCase() : e;
}
function An(e) {
  return he(e) ? e.replace(/[A-Z]/g, (o, t) => t === 0 ? o : "." + o.toLowerCase()).toLowerCase() : e;
}
function _d() {
  let e = [];
  const o = (a, l, s = 999) => {
    const d = n(a, l, s), c = d.value + (d.key === a ? 0 : s) + 1;
    return e.push({ key: a, value: c }), c;
  }, t = (a) => {
    e = e.filter((l) => l.value !== a);
  }, r = (a, l) => n(a).value, n = (a, l, s = 0) => [...e].reverse().find((d) => !0) || { key: a, value: s }, i = (a) => a && parseInt(a.style.zIndex, 10) || 0;
  return {
    get: i,
    set: (a, l, s) => {
      l && (l.style.zIndex = String(o(a, !0, s)));
    },
    clear: (a) => {
      a && (t(i(a)), a.style.zIndex = "");
    },
    getCurrent: (a) => r(a)
  };
}
var qt = _d();
function Vr() {
  const e = /* @__PURE__ */ new Map();
  return {
    on(o, t) {
      let r = e.get(o);
      return r ? r.push(t) : r = [t], e.set(o, r), this;
    },
    off(o, t) {
      let r = e.get(o);
      return r && r.splice(r.indexOf(t) >>> 0, 1), this;
    },
    emit(o, t) {
      let r = e.get(o);
      r && r.slice().map((n) => {
        n(t);
      });
    },
    clear() {
      e.clear();
    }
  };
}
var pt = {};
function Fr(e = "pui_id_") {
  return pt.hasOwnProperty(e) || (pt[e] = 0), pt[e]++, `${e}${pt[e]}`;
}
function Uo(e) {
  "@babel/helpers - typeof";
  return Uo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Uo(e);
}
function Md(e, o) {
  if (!(e instanceof o)) throw new TypeError("Cannot call a class as a function");
}
function Td(e, o) {
  for (var t = 0; t < o.length; t++) {
    var r = o[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, Dd(r.key), r);
  }
}
function Pd(e, o, t) {
  return o && Td(e.prototype, o), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Dd(e) {
  var o = Od(e, "string");
  return Uo(o) == "symbol" ? o : o + "";
}
function Od(e, o) {
  if (Uo(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o);
    if (Uo(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
var Rd = /* @__PURE__ */ function() {
  function e(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {
    };
    Md(this, e), this.element = o, this.listener = t;
  }
  return Pd(e, [{
    key: "bindScrollListener",
    value: function() {
      this.scrollableParents = gd(this.element);
      for (var t = 0; t < this.scrollableParents.length; t++)
        this.scrollableParents[t].addEventListener("scroll", this.listener);
    }
  }, {
    key: "unbindScrollListener",
    value: function() {
      if (this.scrollableParents)
        for (var t = 0; t < this.scrollableParents.length; t++)
          this.scrollableParents[t].removeEventListener("scroll", this.listener);
    }
  }, {
    key: "destroy",
    value: function() {
      this.unbindScrollListener(), this.element = null, this.listener = null, this.scrollableParents = null;
    }
  }]);
}();
function In() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "pv_id_";
  return Fr(e);
}
var Ld = Object.defineProperty, Ad = Object.defineProperties, Id = Object.getOwnPropertyDescriptors, Dt = Object.getOwnPropertySymbols, fa = Object.prototype.hasOwnProperty, ha = Object.prototype.propertyIsEnumerable, En = (e, o, t) => o in e ? Ld(e, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[o] = t, Be = (e, o) => {
  for (var t in o || (o = {}))
    fa.call(o, t) && En(e, t, o[t]);
  if (Dt)
    for (var t of Dt(o))
      ha.call(o, t) && En(e, t, o[t]);
  return e;
}, Xt = (e, o) => Ad(e, Id(o)), je = (e, o) => {
  var t = {};
  for (var r in e)
    fa.call(e, r) && o.indexOf(r) < 0 && (t[r] = e[r]);
  if (e != null && Dt)
    for (var r of Dt(e))
      o.indexOf(r) < 0 && ha.call(e, r) && (t[r] = e[r]);
  return t;
};
function Ed(...e) {
  return ua(...e);
}
var zd = Vr(), Se = zd;
function zn(e, o) {
  Ft(e) ? e.push(...o || []) : Ne(e) && Object.assign(e, o);
}
function Nd(e) {
  return Ne(e) && e.hasOwnProperty("value") && e.hasOwnProperty("type") ? e.value : e;
}
function Hd(e) {
  return e.replaceAll(/ /g, "").replace(/[^\w]/g, "-");
}
function cr(e = "", o = "") {
  return Hd(`${he(e, !1) && he(o, !1) ? `${e}-` : e}${o}`);
}
function ga(e = "", o = "") {
  return `--${cr(e, o)}`;
}
function Vd(e = "") {
  const o = (e.match(/{/g) || []).length, t = (e.match(/}/g) || []).length;
  return (o + t) % 2 !== 0;
}
function ma(e, o = "", t = "", r = [], n) {
  if (he(e)) {
    const i = /{([^}]*)}/g, a = e.trim();
    if (Vd(a))
      return;
    if (We(a, i)) {
      const l = a.replaceAll(i, (c) => {
        const u = c.replace(/{|}/g, "").split(".").filter((p) => !r.some((h) => We(p, h)));
        return `var(${ga(t, pa(u.join("-")))}${ee(n) ? `, ${n}` : ""})`;
      }), s = /(\d+\s+[\+\-\*\/]\s+\d+)/g, d = /var\([^)]+\)/g;
      return We(l.replace(d, "0"), s) ? `calc(${l})` : l;
    }
    return a;
  } else if (Sd(e))
    return e;
}
function Fd(e, o, t) {
  he(o, !1) && e.push(`${o}:${t};`);
}
function vo(e, o) {
  return e ? `${e}{${o}}` : "";
}
var Fo = (...e) => jd(G.getTheme(), ...e), jd = (e = {}, o, t, r) => {
  if (o) {
    const { variable: n, options: i } = G.defaults || {}, { prefix: a, transform: l } = (e == null ? void 0 : e.options) || i || {}, d = We(o, /{([^}]*)}/g) ? o : `{${o}}`;
    return r === "value" || ho(r) && l === "strict" ? G.getTokenValue(o) : ma(d, void 0, a, [n.excludedKeyRegex], t);
  }
  return "";
};
function Zd(e, o = {}) {
  const t = G.defaults.variable, { prefix: r = t.prefix, selector: n = t.selector, excludedKeyRegex: i = t.excludedKeyRegex } = o, a = (d, c = "") => Object.entries(d).reduce(
    (f, [u, p]) => {
      const h = We(u, i) ? cr(c) : cr(c, pa(u)), m = Nd(p);
      if (Ne(m)) {
        const { variables: v, tokens: C } = a(m, h);
        zn(f.tokens, C), zn(f.variables, v);
      } else
        f.tokens.push((r ? h.replace(`${r}-`, "") : h).replaceAll("-", ".")), Fd(f.variables, ga(h), ma(m, h, r, [i]));
      return f;
    },
    { variables: [], tokens: [] }
  ), { variables: l, tokens: s } = a(e, r);
  return {
    value: l,
    tokens: s,
    declarations: l.join(""),
    css: vo(n, l.join(""))
  };
}
var ke = {
  regex: {
    rules: {
      class: {
        pattern: /^\.([a-zA-Z][\w-]*)$/,
        resolve(e) {
          return { type: "class", selector: e, matched: this.pattern.test(e.trim()) };
        }
      },
      attr: {
        pattern: /^\[(.*)\]$/,
        resolve(e) {
          return { type: "attr", selector: `:root${e}`, matched: this.pattern.test(e.trim()) };
        }
      },
      media: {
        pattern: /^@media (.*)$/,
        resolve(e) {
          return { type: "media", selector: `${e}{:root{[CSS]}}`, matched: this.pattern.test(e.trim()) };
        }
      },
      system: {
        pattern: /^system$/,
        resolve(e) {
          return { type: "system", selector: "@media (prefers-color-scheme: dark){:root{[CSS]}}", matched: this.pattern.test(e.trim()) };
        }
      },
      custom: {
        resolve(e) {
          return { type: "custom", selector: e, matched: !0 };
        }
      }
    },
    resolve(e) {
      const o = Object.keys(this.rules).filter((t) => t !== "custom").map((t) => this.rules[t]);
      return [e].flat().map((t) => {
        var r;
        return (r = o.map((n) => n.resolve(t)).find((n) => n.matched)) != null ? r : this.rules.custom.resolve(t);
      });
    }
  },
  _toVariables(e, o) {
    return Zd(e, { prefix: o == null ? void 0 : o.prefix });
  },
  getCommon({ name: e = "", theme: o = {}, params: t, set: r, defaults: n }) {
    var i, a, l, s, d, c, f;
    const { preset: u, options: p } = o;
    let h, m, v, C, w, b, x;
    if (ee(u) && p.transform !== "strict") {
      const { primitive: D, semantic: _, extend: T } = u, O = _ || {}, { colorScheme: Y } = O, j = je(O, ["colorScheme"]), q = T || {}, { colorScheme: X } = q, ae = je(q, ["colorScheme"]), J = Y || {}, { dark: re } = J, ne = je(J, ["dark"]), oe = X || {}, { dark: de } = oe, go = je(oe, ["dark"]), Ve = ee(D) ? this._toVariables({ primitive: D }, p) : {}, Pe = ee(j) ? this._toVariables({ semantic: j }, p) : {}, ao = ee(ne) ? this._toVariables({ light: ne }, p) : {}, st = ee(re) ? this._toVariables({ dark: re }, p) : {}, mo = ee(ae) ? this._toVariables({ semantic: ae }, p) : {}, Kr = ee(go) ? this._toVariables({ light: go }, p) : {}, Ur = ee(de) ? this._toVariables({ dark: de }, p) : {}, [qa, Xa] = [(i = Ve.declarations) != null ? i : "", Ve.tokens], [Qa, Ja] = [(a = Pe.declarations) != null ? a : "", Pe.tokens || []], [el, ol] = [(l = ao.declarations) != null ? l : "", ao.tokens || []], [tl, rl] = [(s = st.declarations) != null ? s : "", st.tokens || []], [nl, il] = [(d = mo.declarations) != null ? d : "", mo.tokens || []], [al, ll] = [(c = Kr.declarations) != null ? c : "", Kr.tokens || []], [sl, cl] = [(f = Ur.declarations) != null ? f : "", Ur.tokens || []];
      h = this.transformCSS(e, qa, "light", "variable", p, r, n), m = Xa;
      const dl = this.transformCSS(e, `${Qa}${el}`, "light", "variable", p, r, n), ul = this.transformCSS(e, `${tl}`, "dark", "variable", p, r, n);
      v = `${dl}${ul}`, C = [.../* @__PURE__ */ new Set([...Ja, ...ol, ...rl])];
      const pl = this.transformCSS(e, `${nl}${al}color-scheme:light`, "light", "variable", p, r, n), fl = this.transformCSS(e, `${sl}color-scheme:dark`, "dark", "variable", p, r, n);
      w = `${pl}${fl}`, b = [.../* @__PURE__ */ new Set([...il, ...ll, ...cl])], x = ve(u.css, { dt: Fo });
    }
    return {
      primitive: {
        css: h,
        tokens: m
      },
      semantic: {
        css: v,
        tokens: C
      },
      global: {
        css: w,
        tokens: b
      },
      style: x
    };
  },
  getPreset({ name: e = "", preset: o = {}, options: t, params: r, set: n, defaults: i, selector: a }) {
    var l, s, d;
    let c, f, u;
    if (ee(o) && t.transform !== "strict") {
      const p = e.replace("-directive", ""), h = o, { colorScheme: m, extend: v, css: C } = h, w = je(h, ["colorScheme", "extend", "css"]), b = v || {}, { colorScheme: x } = b, D = je(b, ["colorScheme"]), _ = m || {}, { dark: T } = _, O = je(_, ["dark"]), Y = x || {}, { dark: j } = Y, q = je(Y, ["dark"]), X = ee(w) ? this._toVariables({ [p]: Be(Be({}, w), D) }, t) : {}, ae = ee(O) ? this._toVariables({ [p]: Be(Be({}, O), q) }, t) : {}, J = ee(T) ? this._toVariables({ [p]: Be(Be({}, T), j) }, t) : {}, [re, ne] = [(l = X.declarations) != null ? l : "", X.tokens || []], [oe, de] = [(s = ae.declarations) != null ? s : "", ae.tokens || []], [go, Ve] = [(d = J.declarations) != null ? d : "", J.tokens || []], Pe = this.transformCSS(p, `${re}${oe}`, "light", "variable", t, n, i, a), ao = this.transformCSS(p, go, "dark", "variable", t, n, i, a);
      c = `${Pe}${ao}`, f = [.../* @__PURE__ */ new Set([...ne, ...de, ...Ve])], u = ve(C, { dt: Fo });
    }
    return {
      css: c,
      tokens: f,
      style: u
    };
  },
  getPresetC({ name: e = "", theme: o = {}, params: t, set: r, defaults: n }) {
    var i;
    const { preset: a, options: l } = o, s = (i = a == null ? void 0 : a.components) == null ? void 0 : i[e];
    return this.getPreset({ name: e, preset: s, options: l, params: t, set: r, defaults: n });
  },
  getPresetD({ name: e = "", theme: o = {}, params: t, set: r, defaults: n }) {
    var i;
    const a = e.replace("-directive", ""), { preset: l, options: s } = o, d = (i = l == null ? void 0 : l.directives) == null ? void 0 : i[a];
    return this.getPreset({ name: a, preset: d, options: s, params: t, set: r, defaults: n });
  },
  applyDarkColorScheme(e) {
    return !(e.darkModeSelector === "none" || e.darkModeSelector === !1);
  },
  getColorSchemeOption(e, o) {
    var t;
    return this.applyDarkColorScheme(e) ? this.regex.resolve(e.darkModeSelector === !0 ? o.options.darkModeSelector : (t = e.darkModeSelector) != null ? t : o.options.darkModeSelector) : [];
  },
  getLayerOrder(e, o = {}, t, r) {
    const { cssLayer: n } = o;
    return n ? `@layer ${ve(n.order || "primeui", t)}` : "";
  },
  getCommonStyleSheet({ name: e = "", theme: o = {}, params: t, props: r = {}, set: n, defaults: i }) {
    const a = this.getCommon({ name: e, theme: o, params: t, set: n, defaults: i }), l = Object.entries(r).reduce((s, [d, c]) => s.push(`${d}="${c}"`) && s, []).join(" ");
    return Object.entries(a || {}).reduce((s, [d, c]) => {
      if (c != null && c.css) {
        const f = Vo(c == null ? void 0 : c.css), u = `${d}-variables`;
        s.push(`<style type="text/css" data-primevue-style-id="${u}" ${l}>${f}</style>`);
      }
      return s;
    }, []).join("");
  },
  getStyleSheet({ name: e = "", theme: o = {}, params: t, props: r = {}, set: n, defaults: i }) {
    var a;
    const l = { name: e, theme: o, params: t, set: n, defaults: i }, s = (a = e.includes("-directive") ? this.getPresetD(l) : this.getPresetC(l)) == null ? void 0 : a.css, d = Object.entries(r).reduce((c, [f, u]) => c.push(`${f}="${u}"`) && c, []).join(" ");
    return s ? `<style type="text/css" data-primevue-style-id="${e}-variables" ${d}>${Vo(s)}</style>` : "";
  },
  createTokens(e = {}, o, t = "", r = "", n = {}) {
    return Object.entries(e).forEach(([i, a]) => {
      const l = We(i, o.variable.excludedKeyRegex) ? t : t ? `${t}.${An(i)}` : An(i), s = r ? `${r}.${i}` : i;
      Ne(a) ? this.createTokens(a, o, l, s, n) : (n[l] || (n[l] = {
        paths: [],
        computed(d, c = {}) {
          var f, u;
          return this.paths.length === 1 ? (f = this.paths[0]) == null ? void 0 : f.computed(this.paths[0].scheme, c.binding) : d && d !== "none" ? (u = this.paths.find((p) => p.scheme === d)) == null ? void 0 : u.computed(d, c.binding) : this.paths.map((p) => p.computed(p.scheme, c[p.scheme]));
        }
      }), n[l].paths.push({
        path: s,
        value: a,
        scheme: s.includes("colorScheme.light") ? "light" : s.includes("colorScheme.dark") ? "dark" : "none",
        computed(d, c = {}) {
          const f = /{([^}]*)}/g;
          let u = a;
          if (c.name = this.path, c.binding || (c.binding = {}), We(a, f)) {
            const h = a.trim().replaceAll(f, (C) => {
              var w;
              const b = C.replace(/{|}/g, ""), x = (w = n[b]) == null ? void 0 : w.computed(d, c);
              return Ft(x) && x.length === 2 ? `light-dark(${x[0].value},${x[1].value})` : x == null ? void 0 : x.value;
            }), m = /(\d+\w*\s+[\+\-\*\/]\s+\d+\w*)/g, v = /var\([^)]+\)/g;
            u = We(h.replace(v, "0"), m) ? `calc(${h})` : h;
          }
          return ho(c.binding) && delete c.binding, {
            colorScheme: d,
            path: this.path,
            paths: c,
            value: u.includes("undefined") ? void 0 : u
          };
        }
      }));
    }), n;
  },
  getTokenValue(e, o, t) {
    var r;
    const i = ((s) => s.split(".").filter((c) => !We(c.toLowerCase(), t.variable.excludedKeyRegex)).join("."))(o), a = o.includes("colorScheme.light") ? "light" : o.includes("colorScheme.dark") ? "dark" : void 0, l = [(r = e[i]) == null ? void 0 : r.computed(a)].flat().filter((s) => s);
    return l.length === 1 ? l[0].value : l.reduce((s = {}, d) => {
      const c = d, { colorScheme: f } = c, u = je(c, ["colorScheme"]);
      return s[f] = u, s;
    }, void 0);
  },
  getSelectorRule(e, o, t, r) {
    return t === "class" || t === "attr" ? vo(ee(o) ? `${e}${o},${e} ${o}` : e, r) : vo(e, ee(o) ? vo(o, r) : r);
  },
  transformCSS(e, o, t, r, n = {}, i, a, l) {
    if (ee(o)) {
      const { cssLayer: s } = n;
      if (r !== "style") {
        const d = this.getColorSchemeOption(n, a);
        o = t === "dark" ? d.reduce((c, { type: f, selector: u }) => (ee(u) && (c += u.includes("[CSS]") ? u.replace("[CSS]", o) : this.getSelectorRule(u, l, f, o)), c), "") : vo(l ?? ":root", o);
      }
      if (s) {
        const d = {
          name: "primeui",
          order: "primeui"
        };
        Ne(s) && (d.name = ve(s.name, { name: e, type: r })), ee(d.name) && (o = vo(`@layer ${d.name}`, o), i == null || i.layerNames(d.name));
      }
      return o;
    }
    return "";
  }
}, G = {
  defaults: {
    variable: {
      prefix: "p",
      selector: ":root",
      excludedKeyRegex: /^(primitive|semantic|components|directives|variables|colorscheme|light|dark|common|root|states|extend|css)$/gi
    },
    options: {
      prefix: "p",
      darkModeSelector: "system",
      cssLayer: !1
    }
  },
  _theme: void 0,
  _layerNames: /* @__PURE__ */ new Set(),
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  _loadingStyles: /* @__PURE__ */ new Set(),
  _tokens: {},
  update(e = {}) {
    const { theme: o } = e;
    o && (this._theme = Xt(Be({}, o), {
      options: Be(Be({}, this.defaults.options), o.options)
    }), this._tokens = ke.createTokens(this.preset, this.defaults), this.clearLoadedStyleNames());
  },
  get theme() {
    return this._theme;
  },
  get preset() {
    var e;
    return ((e = this.theme) == null ? void 0 : e.preset) || {};
  },
  get options() {
    var e;
    return ((e = this.theme) == null ? void 0 : e.options) || {};
  },
  get tokens() {
    return this._tokens;
  },
  getTheme() {
    return this.theme;
  },
  setTheme(e) {
    this.update({ theme: e }), Se.emit("theme:change", e);
  },
  getPreset() {
    return this.preset;
  },
  setPreset(e) {
    this._theme = Xt(Be({}, this.theme), { preset: e }), this._tokens = ke.createTokens(e, this.defaults), this.clearLoadedStyleNames(), Se.emit("preset:change", e), Se.emit("theme:change", this.theme);
  },
  getOptions() {
    return this.options;
  },
  setOptions(e) {
    this._theme = Xt(Be({}, this.theme), { options: e }), this.clearLoadedStyleNames(), Se.emit("options:change", e), Se.emit("theme:change", this.theme);
  },
  getLayerNames() {
    return [...this._layerNames];
  },
  setLayerNames(e) {
    this._layerNames.add(e);
  },
  getLoadedStyleNames() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded(e) {
    return this._loadedStyleNames.has(e);
  },
  setLoadedStyleName(e) {
    this._loadedStyleNames.add(e);
  },
  deleteLoadedStyleName(e) {
    this._loadedStyleNames.delete(e);
  },
  clearLoadedStyleNames() {
    this._loadedStyleNames.clear();
  },
  getTokenValue(e) {
    return ke.getTokenValue(this.tokens, e, this.defaults);
  },
  getCommon(e = "", o) {
    return ke.getCommon({ name: e, theme: this.theme, params: o, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  getComponent(e = "", o) {
    const t = { name: e, theme: this.theme, params: o, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ke.getPresetC(t);
  },
  getDirective(e = "", o) {
    const t = { name: e, theme: this.theme, params: o, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ke.getPresetD(t);
  },
  getCustomPreset(e = "", o, t, r) {
    const n = { name: e, preset: o, options: this.options, selector: t, params: r, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } };
    return ke.getPreset(n);
  },
  getLayerOrderCSS(e = "") {
    return ke.getLayerOrder(e, this.options, { names: this.getLayerNames() }, this.defaults);
  },
  transformCSS(e = "", o, t = "style", r) {
    return ke.transformCSS(e, o, r, t, this.options, { layerNames: this.setLayerNames.bind(this) }, this.defaults);
  },
  getCommonStyleSheet(e = "", o, t = {}) {
    return ke.getCommonStyleSheet({ name: e, theme: this.theme, params: o, props: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  getStyleSheet(e, o, t = {}) {
    return ke.getStyleSheet({ name: e, theme: this.theme, params: o, props: t, defaults: this.defaults, set: { layerNames: this.setLayerNames.bind(this) } });
  },
  onStyleMounted(e) {
    this._loadingStyles.add(e);
  },
  onStyleUpdated(e) {
    this._loadingStyles.add(e);
  },
  onStyleLoaded(e, { name: o }) {
    this._loadingStyles.size && (this._loadingStyles.delete(o), Se.emit(`theme:${o}:load`, e), !this._loadingStyles.size && Se.emit("theme:load"));
  }
}, Xe = {
  _loadedStyleNames: /* @__PURE__ */ new Set(),
  getLoadedStyleNames: function() {
    return this._loadedStyleNames;
  },
  isStyleNameLoaded: function(o) {
    return this._loadedStyleNames.has(o);
  },
  setLoadedStyleName: function(o) {
    this._loadedStyleNames.add(o);
  },
  deleteLoadedStyleName: function(o) {
    this._loadedStyleNames.delete(o);
  },
  clearLoadedStyleNames: function() {
    this._loadedStyleNames.clear();
  }
};
function Go(e) {
  "@babel/helpers - typeof";
  return Go = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Go(e);
}
function Nn(e, o) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Hn(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Nn(Object(t), !0).forEach(function(r) {
      Wd(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Nn(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function Wd(e, o, t) {
  return (o = Yd(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function Yd(e) {
  var o = Kd(e, "string");
  return Go(o) == "symbol" ? o : o + "";
}
function Kd(e, o) {
  if (Go(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (Go(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
function Ud(e) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
  ci() ? pi(e) : o ? e() : gi(e);
}
var Gd = 0;
function qd(e) {
  var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, t = Z(!1), r = Z(e), n = Z(null), i = zr() ? window.document : void 0, a = o.document, l = a === void 0 ? i : a, s = o.immediate, d = s === void 0 ? !0 : s, c = o.manual, f = c === void 0 ? !1 : c, u = o.name, p = u === void 0 ? "style_".concat(++Gd) : u, h = o.id, m = h === void 0 ? void 0 : h, v = o.media, C = v === void 0 ? void 0 : v, w = o.nonce, b = w === void 0 ? void 0 : w, x = o.first, D = x === void 0 ? !1 : x, _ = o.onMounted, T = _ === void 0 ? void 0 : _, O = o.onUpdated, Y = O === void 0 ? void 0 : O, j = o.onLoad, q = j === void 0 ? void 0 : j, X = o.props, ae = X === void 0 ? {} : X, J = function() {
  }, re = function(de) {
    var go = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (l) {
      var Ve = Hn(Hn({}, ae), go), Pe = Ve.name || p, ao = Ve.id || m, st = Ve.nonce || b;
      n.value = l.querySelector('style[data-primevue-style-id="'.concat(Pe, '"]')) || l.getElementById(ao) || l.createElement("style"), n.value.isConnected || (r.value = de || e, Pt(n.value, {
        type: "text/css",
        id: ao,
        media: C,
        nonce: st
      }), D ? l.head.prepend(n.value) : l.head.appendChild(n.value), da(n.value, "data-primevue-style-id", Pe), Pt(n.value, Ve), n.value.onload = function(mo) {
        return q == null ? void 0 : q(mo, {
          name: Pe
        });
      }, T == null || T(Pe)), !t.value && (J = se(r, function(mo) {
        n.value.textContent = mo, Y == null || Y(Pe);
      }, {
        immediate: !0
      }), t.value = !0);
    }
  }, ne = function() {
    !l || !t.value || (J(), md(n.value) && l.head.removeChild(n.value), t.value = !1);
  };
  return d && !f && Ud(re), {
    id: m,
    name: p,
    el: n,
    css: r,
    unload: ne,
    load: re,
    isLoaded: xl(t)
  };
}
function qo(e) {
  "@babel/helpers - typeof";
  return qo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, qo(e);
}
function Vn(e, o) {
  return eu(e) || Jd(e, o) || Qd(e, o) || Xd();
}
function Xd() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qd(e, o) {
  if (e) {
    if (typeof e == "string") return Fn(e, o);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Fn(e, o) : void 0;
  }
}
function Fn(e, o) {
  (o == null || o > e.length) && (o = e.length);
  for (var t = 0, r = Array(o); t < o; t++) r[t] = e[t];
  return r;
}
function Jd(e, o) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r, n, i, a, l = [], s = !0, d = !1;
    try {
      if (i = (t = t.call(e)).next, o !== 0) for (; !(s = (r = i.call(t)).done) && (l.push(r.value), l.length !== o); s = !0) ;
    } catch (c) {
      d = !0, n = c;
    } finally {
      try {
        if (!s && t.return != null && (a = t.return(), Object(a) !== a)) return;
      } finally {
        if (d) throw n;
      }
    }
    return l;
  }
}
function eu(e) {
  if (Array.isArray(e)) return e;
}
function jn(e, o) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Qt(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = arguments[o] != null ? arguments[o] : {};
    o % 2 ? jn(Object(t), !0).forEach(function(r) {
      ou(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : jn(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function ou(e, o, t) {
  return (o = tu(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function tu(e) {
  var o = ru(e, "string");
  return qo(o) == "symbol" ? o : o + "";
}
function ru(e, o) {
  if (qo(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (qo(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
var nu = function(o) {
  var t = o.dt;
  return `
* {
    box-sizing: border-box;
}

/* Non vue overlay animations */
.p-connected-overlay {
    opacity: 0;
    transform: scaleY(0.8);
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1),
        opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-visible {
    opacity: 1;
    transform: scaleY(1);
}

.p-connected-overlay-hidden {
    opacity: 0;
    transform: scaleY(1);
    transition: opacity 0.1s linear;
}

/* Vue based overlay animations */
.p-connected-overlay-enter-from {
    opacity: 0;
    transform: scaleY(0.8);
}

.p-connected-overlay-leave-to {
    opacity: 0;
}

.p-connected-overlay-enter-active {
    transition: transform 0.12s cubic-bezier(0, 0, 0.2, 1),
        opacity 0.12s cubic-bezier(0, 0, 0.2, 1);
}

.p-connected-overlay-leave-active {
    transition: opacity 0.1s linear;
}

/* Toggleable Content */
.p-toggleable-content-enter-from,
.p-toggleable-content-leave-to {
    max-height: 0;
}

.p-toggleable-content-enter-to,
.p-toggleable-content-leave-from {
    max-height: 1000px;
}

.p-toggleable-content-leave-active {
    overflow: hidden;
    transition: max-height 0.45s cubic-bezier(0, 1, 0, 1);
}

.p-toggleable-content-enter-active {
    overflow: hidden;
    transition: max-height 1s ease-in-out;
}

.p-disabled,
.p-disabled * {
    cursor: default;
    pointer-events: none;
    user-select: none;
}

.p-disabled,
.p-component:disabled {
    opacity: `.concat(t("disabled.opacity"), `;
}

.pi {
    font-size: `).concat(t("icon.size"), `;
}

.p-icon {
    width: `).concat(t("icon.size"), `;
    height: `).concat(t("icon.size"), `;
}

.p-overlay-mask {
    background: `).concat(t("mask.background"), `;
    color: `).concat(t("mask.color"), `;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.p-overlay-mask-enter {
    animation: p-overlay-mask-enter-animation `).concat(t("mask.transition.duration"), ` forwards;
}

.p-overlay-mask-leave {
    animation: p-overlay-mask-leave-animation `).concat(t("mask.transition.duration"), ` forwards;
}

@keyframes p-overlay-mask-enter-animation {
    from {
        background: transparent;
    }
    to {
        background: `).concat(t("mask.background"), `;
    }
}
@keyframes p-overlay-mask-leave-animation {
    from {
        background: `).concat(t("mask.background"), `;
    }
    to {
        background: transparent;
    }
}
`);
}, iu = function(o) {
  var t = o.dt;
  return `
.p-hidden-accessible {
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}

.p-hidden-accessible input,
.p-hidden-accessible select {
    transform: scale(0);
}

.p-overflow-hidden {
    overflow: hidden;
    padding-right: `.concat(t("scrollbar.width"), `;
}
`);
}, au = {}, lu = {}, Q = {
  name: "base",
  css: iu,
  theme: nu,
  classes: au,
  inlineStyles: lu,
  load: function(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function(i) {
      return i;
    }, n = r(ve(o, {
      dt: Fo
    }));
    return ee(n) ? qd(Vo(n), Qt({
      name: this.name
    }, t)) : {};
  },
  loadCSS: function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return this.load(this.css, o);
  },
  loadTheme: function() {
    var o = this, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return this.load(this.theme, t, function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return G.transformCSS(t.name || o.name, "".concat(n).concat(r));
    });
  },
  getCommonTheme: function(o) {
    return G.getCommon(this.name, o);
  },
  getComponentTheme: function(o) {
    return G.getComponent(this.name, o);
  },
  getDirectiveTheme: function(o) {
    return G.getDirective(this.name, o);
  },
  getPresetTheme: function(o, t, r) {
    return G.getCustomPreset(this.name, o, t, r);
  },
  getLayerOrderThemeCSS: function() {
    return G.getLayerOrderCSS(this.name);
  },
  getStyleSheet: function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (this.css) {
      var r = ve(this.css, {
        dt: Fo
      }) || "", n = Vo("".concat(r).concat(o)), i = Object.entries(t).reduce(function(a, l) {
        var s = Vn(l, 2), d = s[0], c = s[1];
        return a.push("".concat(d, '="').concat(c, '"')) && a;
      }, []).join(" ");
      return ee(n) ? '<style type="text/css" data-primevue-style-id="'.concat(this.name, '" ').concat(i, ">").concat(n, "</style>") : "";
    }
    return "";
  },
  getCommonThemeStyleSheet: function(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return G.getCommonStyleSheet(this.name, o, t);
  },
  getThemeStyleSheet: function(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = [G.getStyleSheet(this.name, o, t)];
    if (this.theme) {
      var n = this.name === "base" ? "global-style" : "".concat(this.name, "-style"), i = ve(this.theme, {
        dt: Fo
      }), a = Vo(G.transformCSS(n, i)), l = Object.entries(t).reduce(function(s, d) {
        var c = Vn(d, 2), f = c[0], u = c[1];
        return s.push("".concat(f, '="').concat(u, '"')) && s;
      }, []).join(" ");
      ee(a) && r.push('<style type="text/css" data-primevue-style-id="'.concat(n, '" ').concat(l, ">").concat(a, "</style>"));
    }
    return r.join("");
  },
  extend: function(o) {
    return Qt(Qt({}, this), {}, {
      css: void 0,
      theme: void 0
    }, o);
  }
}, Zn = Q.extend({
  name: "common"
});
function Xo(e) {
  "@babel/helpers - typeof";
  return Xo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Xo(e);
}
function su(e) {
  return ya(e) || cu(e) || va(e) || ba();
}
function cu(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Ro(e, o) {
  return ya(e) || du(e, o) || va(e, o) || ba();
}
function ba() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function va(e, o) {
  if (e) {
    if (typeof e == "string") return Wn(e, o);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? Wn(e, o) : void 0;
  }
}
function Wn(e, o) {
  (o == null || o > e.length) && (o = e.length);
  for (var t = 0, r = Array(o); t < o; t++) r[t] = e[t];
  return r;
}
function du(e, o) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r, n, i, a, l = [], s = !0, d = !1;
    try {
      if (i = (t = t.call(e)).next, o === 0) {
        if (Object(t) !== t) return;
        s = !1;
      } else for (; !(s = (r = i.call(t)).done) && (l.push(r.value), l.length !== o); s = !0) ;
    } catch (c) {
      d = !0, n = c;
    } finally {
      try {
        if (!s && t.return != null && (a = t.return(), Object(a) !== a)) return;
      } finally {
        if (d) throw n;
      }
    }
    return l;
  }
}
function ya(e) {
  if (Array.isArray(e)) return e;
}
function Yn(e, o) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function N(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Yn(Object(t), !0).forEach(function(r) {
      Eo(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Yn(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function Eo(e, o, t) {
  return (o = uu(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function uu(e) {
  var o = pu(e, "string");
  return Xo(o) == "symbol" ? o : o + "";
}
function pu(e, o) {
  if (Xo(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (Xo(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
var jt = {
  name: "BaseComponent",
  props: {
    pt: {
      type: Object,
      default: void 0
    },
    ptOptions: {
      type: Object,
      default: void 0
    },
    unstyled: {
      type: Boolean,
      default: void 0
    },
    dt: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    }
  },
  watch: {
    isUnstyled: {
      immediate: !0,
      handler: function(o) {
        o || (this._loadCoreStyles(), this._themeChangeListener(this._loadCoreStyles));
      }
    },
    dt: {
      immediate: !0,
      handler: function(o) {
        var t = this;
        o ? (this._loadScopedThemeStyles(o), this._themeChangeListener(function() {
          return t._loadScopedThemeStyles(o);
        })) : this._unloadScopedThemeStyles();
      }
    }
  },
  scopedStyleEl: void 0,
  rootEl: void 0,
  $attrSelector: void 0,
  beforeCreate: function() {
    var o, t, r, n, i, a, l, s, d, c, f, u = (o = this.pt) === null || o === void 0 ? void 0 : o._usept, p = u ? (t = this.pt) === null || t === void 0 || (t = t.originalValue) === null || t === void 0 ? void 0 : t[this.$.type.name] : void 0, h = u ? (r = this.pt) === null || r === void 0 || (r = r.value) === null || r === void 0 ? void 0 : r[this.$.type.name] : this.pt;
    (n = h || p) === null || n === void 0 || (n = n.hooks) === null || n === void 0 || (i = n.onBeforeCreate) === null || i === void 0 || i.call(n);
    var m = (a = this.$primevueConfig) === null || a === void 0 || (a = a.pt) === null || a === void 0 ? void 0 : a._usept, v = m ? (l = this.$primevue) === null || l === void 0 || (l = l.config) === null || l === void 0 || (l = l.pt) === null || l === void 0 ? void 0 : l.originalValue : void 0, C = m ? (s = this.$primevue) === null || s === void 0 || (s = s.config) === null || s === void 0 || (s = s.pt) === null || s === void 0 ? void 0 : s.value : (d = this.$primevue) === null || d === void 0 || (d = d.config) === null || d === void 0 ? void 0 : d.pt;
    (c = C || v) === null || c === void 0 || (c = c[this.$.type.name]) === null || c === void 0 || (c = c.hooks) === null || c === void 0 || (f = c.onBeforeCreate) === null || f === void 0 || f.call(c), this.$attrSelector = Fr("pc");
  },
  created: function() {
    this._hook("onCreated");
  },
  beforeMount: function() {
    this.rootEl = Ce(this.$el, '[data-pc-name="'.concat($e(this.$.type.name), '"]')), this.rootEl && (this.$attrSelector && !this.rootEl.hasAttribute(this.$attrSelector) && this.rootEl.setAttribute(this.$attrSelector, ""), this.rootEl.$pc = N({
      name: this.$.type.name,
      attrSelector: this.$attrSelector
    }, this.$params)), this._loadStyles(), this._hook("onBeforeMount");
  },
  mounted: function() {
    this._hook("onMounted");
  },
  beforeUpdate: function() {
    this._hook("onBeforeUpdate");
  },
  updated: function() {
    this._hook("onUpdated");
  },
  beforeUnmount: function() {
    this._hook("onBeforeUnmount");
  },
  unmounted: function() {
    this._unloadScopedThemeStyles(), this._hook("onUnmounted");
  },
  methods: {
    _hook: function(o) {
      if (!this.$options.hostName) {
        var t = this._usePT(this._getPT(this.pt, this.$.type.name), this._getOptionValue, "hooks.".concat(o)), r = this._useDefaultPT(this._getOptionValue, "hooks.".concat(o));
        t == null || t(), r == null || r();
      }
    },
    _mergeProps: function(o) {
      for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
        r[n - 1] = arguments[n];
      return Nr(o) ? o.apply(void 0, r) : y.apply(void 0, r);
    },
    _loadStyles: function() {
      var o = this, t = function() {
        Xe.isStyleNameLoaded("base") || (Q.loadCSS(o.$styleOptions), o._loadGlobalStyles(), Xe.setLoadedStyleName("base")), o._loadThemeStyles();
      };
      t(), this._themeChangeListener(t);
    },
    _loadCoreStyles: function() {
      var o, t;
      !Xe.isStyleNameLoaded((o = this.$style) === null || o === void 0 ? void 0 : o.name) && (t = this.$style) !== null && t !== void 0 && t.name && (Zn.loadCSS(this.$styleOptions), this.$options.style && this.$style.loadCSS(this.$styleOptions), Xe.setLoadedStyleName(this.$style.name));
    },
    _loadGlobalStyles: function() {
      var o = this._useGlobalPT(this._getOptionValue, "global.css", this.$params);
      ee(o) && Q.load(o, N({
        name: "global"
      }, this.$styleOptions));
    },
    _loadThemeStyles: function() {
      var o, t;
      if (!(this.isUnstyled || this.$theme === "none")) {
        if (!G.isStyleNameLoaded("common")) {
          var r, n, i = ((r = this.$style) === null || r === void 0 || (n = r.getCommonTheme) === null || n === void 0 ? void 0 : n.call(r)) || {}, a = i.primitive, l = i.semantic, s = i.global, d = i.style;
          Q.load(a == null ? void 0 : a.css, N({
            name: "primitive-variables"
          }, this.$styleOptions)), Q.load(l == null ? void 0 : l.css, N({
            name: "semantic-variables"
          }, this.$styleOptions)), Q.load(s == null ? void 0 : s.css, N({
            name: "global-variables"
          }, this.$styleOptions)), Q.loadTheme(N({
            name: "global-style"
          }, this.$styleOptions), d), G.setLoadedStyleName("common");
        }
        if (!G.isStyleNameLoaded((o = this.$style) === null || o === void 0 ? void 0 : o.name) && (t = this.$style) !== null && t !== void 0 && t.name) {
          var c, f, u, p, h = ((c = this.$style) === null || c === void 0 || (f = c.getComponentTheme) === null || f === void 0 ? void 0 : f.call(c)) || {}, m = h.css, v = h.style;
          (u = this.$style) === null || u === void 0 || u.load(m, N({
            name: "".concat(this.$style.name, "-variables")
          }, this.$styleOptions)), (p = this.$style) === null || p === void 0 || p.loadTheme(N({
            name: "".concat(this.$style.name, "-style")
          }, this.$styleOptions), v), G.setLoadedStyleName(this.$style.name);
        }
        if (!G.isStyleNameLoaded("layer-order")) {
          var C, w, b = (C = this.$style) === null || C === void 0 || (w = C.getLayerOrderThemeCSS) === null || w === void 0 ? void 0 : w.call(C);
          Q.load(b, N({
            name: "layer-order",
            first: !0
          }, this.$styleOptions)), G.setLoadedStyleName("layer-order");
        }
      }
    },
    _loadScopedThemeStyles: function(o) {
      var t, r, n, i = ((t = this.$style) === null || t === void 0 || (r = t.getPresetTheme) === null || r === void 0 ? void 0 : r.call(t, o, "[".concat(this.$attrSelector, "]"))) || {}, a = i.css, l = (n = this.$style) === null || n === void 0 ? void 0 : n.load(a, N({
        name: "".concat(this.$attrSelector, "-").concat(this.$style.name)
      }, this.$styleOptions));
      this.scopedStyleEl = l.el;
    },
    _unloadScopedThemeStyles: function() {
      var o;
      (o = this.scopedStyleEl) === null || o === void 0 || (o = o.value) === null || o === void 0 || o.remove();
    },
    _themeChangeListener: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
      };
      Xe.clearLoadedStyleNames(), Se.on("theme:change", o);
    },
    _getHostInstance: function(o) {
      return o ? this.$options.hostName ? o.$.type.name === this.$options.hostName ? o : this._getHostInstance(o.$parentInstance) : o.$parentInstance : void 0;
    },
    _getPropValue: function(o) {
      var t;
      return this[o] || ((t = this._getHostInstance(this)) === null || t === void 0 ? void 0 : t[o]);
    },
    _getOptionValue: function(o) {
      var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return Hr(o, t, r);
    },
    _getPTValue: function() {
      var o, t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0, a = /./g.test(r) && !!n[r.split(".")[0]], l = this._getPropValue("ptOptions") || ((o = this.$primevueConfig) === null || o === void 0 ? void 0 : o.ptOptions) || {}, s = l.mergeSections, d = s === void 0 ? !0 : s, c = l.mergeProps, f = c === void 0 ? !1 : c, u = i ? a ? this._useGlobalPT(this._getPTClassValue, r, n) : this._useDefaultPT(this._getPTClassValue, r, n) : void 0, p = a ? void 0 : this._getPTSelf(t, this._getPTClassValue, r, N(N({}, n), {}, {
        global: u || {}
      })), h = this._getPTDatasets(r);
      return d || !d && p ? f ? this._mergeProps(f, u, p, h) : N(N(N({}, u), p), h) : N(N({}, p), h);
    },
    _getPTSelf: function() {
      for (var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
        r[n - 1] = arguments[n];
      return y(
        this._usePT.apply(this, [this._getPT(o, this.$name)].concat(r)),
        // Exp; <component :pt="{}"
        this._usePT.apply(this, [this.$_attrsPT].concat(r))
        // Exp; <component :pt:[passthrough_key]:[attribute]="{value}" or <component :pt:[passthrough_key]="() =>{value}"
      );
    },
    _getPTDatasets: function() {
      var o, t, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = "data-pc-", i = r === "root" && ee((o = this.pt) === null || o === void 0 ? void 0 : o["data-pc-section"]);
      return r !== "transition" && N(N({}, r === "root" && N(N(Eo({}, "".concat(n, "name"), $e(i ? (t = this.pt) === null || t === void 0 ? void 0 : t["data-pc-section"] : this.$.type.name)), i && Eo({}, "".concat(n, "extend"), $e(this.$.type.name))), zr() && Eo({}, "".concat(this.$attrSelector), ""))), {}, Eo({}, "".concat(n, "section"), $e(r)));
    },
    _getPTClassValue: function() {
      var o = this._getOptionValue.apply(this, arguments);
      return he(o) || Ft(o) ? {
        class: o
      } : o;
    },
    _getPT: function(o) {
      var t = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", n = arguments.length > 2 ? arguments[2] : void 0, i = function(l) {
        var s, d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, c = n ? n(l) : l, f = $e(r), u = $e(t.$name);
        return (s = d ? f !== u ? c == null ? void 0 : c[f] : void 0 : c == null ? void 0 : c[f]) !== null && s !== void 0 ? s : c;
      };
      return o != null && o.hasOwnProperty("_usept") ? {
        _usept: o._usept,
        originalValue: i(o.originalValue),
        value: i(o.value)
      } : i(o, !0);
    },
    _usePT: function(o, t, r, n) {
      var i = function(m) {
        return t(m, r, n);
      };
      if (o != null && o.hasOwnProperty("_usept")) {
        var a, l = o._usept || ((a = this.$primevueConfig) === null || a === void 0 ? void 0 : a.ptOptions) || {}, s = l.mergeSections, d = s === void 0 ? !0 : s, c = l.mergeProps, f = c === void 0 ? !1 : c, u = i(o.originalValue), p = i(o.value);
        return u === void 0 && p === void 0 ? void 0 : he(p) ? p : he(u) ? u : d || !d && p ? f ? this._mergeProps(f, u, p) : N(N({}, u), p) : p;
      }
      return i(o);
    },
    _useGlobalPT: function(o, t, r) {
      return this._usePT(this.globalPT, o, t, r);
    },
    _useDefaultPT: function(o, t, r) {
      return this._usePT(this.defaultPT, o, t, r);
    },
    ptm: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this._getPTValue(this.pt, o, N(N({}, this.$params), t));
    },
    ptmi: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return y(this.$_attrsWithoutPT, this.ptm(o, t));
    },
    ptmo: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      return this._getPTValue(o, t, N({
        instance: this
      }, r), !1);
    },
    cx: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.isUnstyled ? void 0 : this._getOptionValue(this.$style.classes, o, N(N({}, this.$params), t));
    },
    sx: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
      if (t) {
        var n = this._getOptionValue(this.$style.inlineStyles, o, N(N({}, this.$params), r)), i = this._getOptionValue(Zn.inlineStyles, o, N(N({}, this.$params), r));
        return [i, n];
      }
    }
  },
  computed: {
    globalPT: function() {
      var o, t = this;
      return this._getPT((o = this.$primevueConfig) === null || o === void 0 ? void 0 : o.pt, void 0, function(r) {
        return ve(r, {
          instance: t
        });
      });
    },
    defaultPT: function() {
      var o, t = this;
      return this._getPT((o = this.$primevueConfig) === null || o === void 0 ? void 0 : o.pt, void 0, function(r) {
        return t._getOptionValue(r, t.$name, N({}, t.$params)) || ve(r, N({}, t.$params));
      });
    },
    isUnstyled: function() {
      var o;
      return this.unstyled !== void 0 ? this.unstyled : (o = this.$primevueConfig) === null || o === void 0 ? void 0 : o.unstyled;
    },
    $inProps: function() {
      var o, t = Object.keys(((o = this.$.vnode) === null || o === void 0 ? void 0 : o.props) || {});
      return Object.fromEntries(Object.entries(this.$props).filter(function(r) {
        var n = Ro(r, 1), i = n[0];
        return t == null ? void 0 : t.includes(i);
      }));
    },
    $theme: function() {
      var o;
      return (o = this.$primevueConfig) === null || o === void 0 ? void 0 : o.theme;
    },
    $style: function() {
      return N(N({
        classes: void 0,
        inlineStyles: void 0,
        load: function() {
        },
        loadCSS: function() {
        },
        loadTheme: function() {
        }
      }, (this._getHostInstance(this) || {}).$style), this.$options.style);
    },
    $styleOptions: function() {
      var o;
      return {
        nonce: (o = this.$primevueConfig) === null || o === void 0 || (o = o.csp) === null || o === void 0 ? void 0 : o.nonce
      };
    },
    $primevueConfig: function() {
      var o;
      return (o = this.$primevue) === null || o === void 0 ? void 0 : o.config;
    },
    $name: function() {
      return this.$options.hostName || this.$.type.name;
    },
    $params: function() {
      var o = this._getHostInstance(this) || this.$parent;
      return {
        instance: this,
        props: this.$props,
        state: this.$data,
        attrs: this.$attrs,
        parent: {
          instance: o,
          props: o == null ? void 0 : o.$props,
          state: o == null ? void 0 : o.$data,
          attrs: o == null ? void 0 : o.$attrs
        }
      };
    },
    $_attrsPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(o) {
        var t = Ro(o, 1), r = t[0];
        return r == null ? void 0 : r.startsWith("pt:");
      }).reduce(function(o, t) {
        var r = Ro(t, 2), n = r[0], i = r[1], a = n.split(":"), l = su(a), s = l.slice(1);
        return s == null || s.reduce(function(d, c, f, u) {
          return !d[c] && (d[c] = f === u.length - 1 ? i : {}), d[c];
        }, o), o;
      }, {});
    },
    $_attrsWithoutPT: function() {
      return Object.entries(this.$attrs || {}).filter(function(o) {
        var t = Ro(o, 1), r = t[0];
        return !(r != null && r.startsWith("pt:"));
      }).reduce(function(o, t) {
        var r = Ro(t, 2), n = r[0], i = r[1];
        return o[n] = i, o;
      }, {});
    }
  }
}, fu = `
.p-icon {
    display: inline-block;
    vertical-align: baseline;
}

.p-icon-spin {
    -webkit-animation: p-icon-spin 2s infinite linear;
    animation: p-icon-spin 2s infinite linear;
}

@-webkit-keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

@keyframes p-icon-spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
`, hu = Q.extend({
  name: "baseicon",
  css: fu
});
function Qo(e) {
  "@babel/helpers - typeof";
  return Qo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Qo(e);
}
function Kn(e, o) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Un(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Kn(Object(t), !0).forEach(function(r) {
      gu(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Kn(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function gu(e, o, t) {
  return (o = mu(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function mu(e) {
  var o = bu(e, "string");
  return Qo(o) == "symbol" ? o : o + "";
}
function bu(e, o) {
  if (Qo(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (Qo(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
var Po = {
  name: "BaseIcon",
  extends: jt,
  props: {
    label: {
      type: String,
      default: void 0
    },
    spin: {
      type: Boolean,
      default: !1
    }
  },
  style: hu,
  provide: function() {
    return {
      $pcIcon: this,
      $parentInstance: this
    };
  },
  methods: {
    pti: function() {
      var o = ho(this.label);
      return Un(Un({}, !this.isUnstyled && {
        class: ["p-icon", {
          "p-icon-spin": this.spin
        }]
      }), {}, {
        role: o ? void 0 : "img",
        "aria-label": o ? void 0 : this.label,
        "aria-hidden": o
      });
    }
  }
}, ka = {
  name: "CalendarIcon",
  extends: Po
};
function vu(e, o, t, r, n, i) {
  return g(), $("svg", y({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), o[0] || (o[0] = [P("path", {
    d: "M10.7838 1.51351H9.83783V0.567568C9.83783 0.417039 9.77804 0.272676 9.6716 0.166237C9.56516 0.0597971 9.42079 0 9.27027 0C9.11974 0 8.97538 0.0597971 8.86894 0.166237C8.7625 0.272676 8.7027 0.417039 8.7027 0.567568V1.51351H5.29729V0.567568C5.29729 0.417039 5.2375 0.272676 5.13106 0.166237C5.02462 0.0597971 4.88025 0 4.72973 0C4.5792 0 4.43484 0.0597971 4.3284 0.166237C4.22196 0.272676 4.16216 0.417039 4.16216 0.567568V1.51351H3.21621C2.66428 1.51351 2.13494 1.73277 1.74467 2.12305C1.35439 2.51333 1.13513 3.04266 1.13513 3.59459V11.9189C1.13513 12.4709 1.35439 13.0002 1.74467 13.3905C2.13494 13.7807 2.66428 14 3.21621 14H10.7838C11.3357 14 11.865 13.7807 12.2553 13.3905C12.6456 13.0002 12.8649 12.4709 12.8649 11.9189V3.59459C12.8649 3.04266 12.6456 2.51333 12.2553 2.12305C11.865 1.73277 11.3357 1.51351 10.7838 1.51351ZM3.21621 2.64865H4.16216V3.59459C4.16216 3.74512 4.22196 3.88949 4.3284 3.99593C4.43484 4.10237 4.5792 4.16216 4.72973 4.16216C4.88025 4.16216 5.02462 4.10237 5.13106 3.99593C5.2375 3.88949 5.29729 3.74512 5.29729 3.59459V2.64865H8.7027V3.59459C8.7027 3.74512 8.7625 3.88949 8.86894 3.99593C8.97538 4.10237 9.11974 4.16216 9.27027 4.16216C9.42079 4.16216 9.56516 4.10237 9.6716 3.99593C9.77804 3.88949 9.83783 3.74512 9.83783 3.59459V2.64865H10.7838C11.0347 2.64865 11.2753 2.74831 11.4527 2.92571C11.6301 3.10311 11.7297 3.34371 11.7297 3.59459V5.67568H2.27027V3.59459C2.27027 3.34371 2.36993 3.10311 2.54733 2.92571C2.72473 2.74831 2.96533 2.64865 3.21621 2.64865ZM10.7838 12.8649H3.21621C2.96533 12.8649 2.72473 12.7652 2.54733 12.5878C2.36993 12.4104 2.27027 12.1698 2.27027 11.9189V6.81081H11.7297V11.9189C11.7297 12.1698 11.6301 12.4104 11.4527 12.5878C11.2753 12.7652 11.0347 12.8649 10.7838 12.8649Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
ka.render = vu;
var wa = {
  name: "ChevronDownIcon",
  extends: Po
};
function yu(e, o, t, r, n, i) {
  return g(), $("svg", y({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), o[0] || (o[0] = [P("path", {
    d: "M7.01744 10.398C6.91269 10.3985 6.8089 10.378 6.71215 10.3379C6.61541 10.2977 6.52766 10.2386 6.45405 10.1641L1.13907 4.84913C1.03306 4.69404 0.985221 4.5065 1.00399 4.31958C1.02276 4.13266 1.10693 3.95838 1.24166 3.82747C1.37639 3.69655 1.55301 3.61742 1.74039 3.60402C1.92777 3.59062 2.11386 3.64382 2.26584 3.75424L7.01744 8.47394L11.769 3.75424C11.9189 3.65709 12.097 3.61306 12.2748 3.62921C12.4527 3.64535 12.6199 3.72073 12.7498 3.84328C12.8797 3.96582 12.9647 4.12842 12.9912 4.30502C13.0177 4.48162 12.9841 4.662 12.8958 4.81724L7.58083 10.1322C7.50996 10.2125 7.42344 10.2775 7.32656 10.3232C7.22968 10.3689 7.12449 10.3944 7.01744 10.398Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
wa.render = yu;
var Ca = {
  name: "ChevronLeftIcon",
  extends: Po
};
function ku(e, o, t, r, n, i) {
  return g(), $("svg", y({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), o[0] || (o[0] = [P("path", {
    d: "M9.61296 13C9.50997 13.0005 9.40792 12.9804 9.3128 12.9409C9.21767 12.9014 9.13139 12.8433 9.05902 12.7701L3.83313 7.54416C3.68634 7.39718 3.60388 7.19795 3.60388 6.99022C3.60388 6.78249 3.68634 6.58325 3.83313 6.43628L9.05902 1.21039C9.20762 1.07192 9.40416 0.996539 9.60724 1.00012C9.81032 1.00371 10.0041 1.08597 10.1477 1.22959C10.2913 1.37322 10.3736 1.56698 10.3772 1.77005C10.3808 1.97313 10.3054 2.16968 10.1669 2.31827L5.49496 6.99022L10.1669 11.6622C10.3137 11.8091 10.3962 12.0084 10.3962 12.2161C10.3962 12.4238 10.3137 12.6231 10.1669 12.7701C10.0945 12.8433 10.0083 12.9014 9.91313 12.9409C9.81801 12.9804 9.71596 13.0005 9.61296 13Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Ca.render = ku;
var xa = {
  name: "ChevronRightIcon",
  extends: Po
};
function wu(e, o, t, r, n, i) {
  return g(), $("svg", y({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), o[0] || (o[0] = [P("path", {
    d: "M4.38708 13C4.28408 13.0005 4.18203 12.9804 4.08691 12.9409C3.99178 12.9014 3.9055 12.8433 3.83313 12.7701C3.68634 12.6231 3.60388 12.4238 3.60388 12.2161C3.60388 12.0084 3.68634 11.8091 3.83313 11.6622L8.50507 6.99022L3.83313 2.31827C3.69467 2.16968 3.61928 1.97313 3.62287 1.77005C3.62645 1.56698 3.70872 1.37322 3.85234 1.22959C3.99596 1.08597 4.18972 1.00371 4.3928 1.00012C4.59588 0.996539 4.79242 1.07192 4.94102 1.21039L10.1669 6.43628C10.3137 6.58325 10.3962 6.78249 10.3962 6.99022C10.3962 7.19795 10.3137 7.39718 10.1669 7.54416L4.94102 12.7701C4.86865 12.8433 4.78237 12.9014 4.68724 12.9409C4.59212 12.9804 4.49007 13.0005 4.38708 13Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
xa.render = wu;
var Sa = {
  name: "ChevronUpIcon",
  extends: Po
};
function Cu(e, o, t, r, n, i) {
  return g(), $("svg", y({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), o[0] || (o[0] = [P("path", {
    d: "M12.2097 10.4113C12.1057 10.4118 12.0027 10.3915 11.9067 10.3516C11.8107 10.3118 11.7237 10.2532 11.6506 10.1792L6.93602 5.46461L2.22139 10.1476C2.07272 10.244 1.89599 10.2877 1.71953 10.2717C1.54307 10.2556 1.3771 10.1808 1.24822 10.0593C1.11933 9.93766 1.035 9.77633 1.00874 9.6011C0.982477 9.42587 1.0158 9.2469 1.10338 9.09287L6.37701 3.81923C6.52533 3.6711 6.72639 3.58789 6.93602 3.58789C7.14565 3.58789 7.3467 3.6711 7.49502 3.81923L12.7687 9.09287C12.9168 9.24119 13 9.44225 13 9.65187C13 9.8615 12.9168 10.0626 12.7687 10.2109C12.616 10.3487 12.4151 10.4207 12.2097 10.4113Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
Sa.render = Cu;
var $a = {
  name: "SpinnerIcon",
  extends: Po
};
function xu(e, o, t, r, n, i) {
  return g(), $("svg", y({
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, e.pti()), o[0] || (o[0] = [P("path", {
    d: "M6.99701 14C5.85441 13.999 4.72939 13.7186 3.72012 13.1832C2.71084 12.6478 1.84795 11.8737 1.20673 10.9284C0.565504 9.98305 0.165424 8.89526 0.041387 7.75989C-0.0826496 6.62453 0.073125 5.47607 0.495122 4.4147C0.917119 3.35333 1.59252 2.4113 2.46241 1.67077C3.33229 0.930247 4.37024 0.413729 5.4857 0.166275C6.60117 -0.0811796 7.76026 -0.0520535 8.86188 0.251112C9.9635 0.554278 10.9742 1.12227 11.8057 1.90555C11.915 2.01493 11.9764 2.16319 11.9764 2.31778C11.9764 2.47236 11.915 2.62062 11.8057 2.73C11.7521 2.78503 11.688 2.82877 11.6171 2.85864C11.5463 2.8885 11.4702 2.90389 11.3933 2.90389C11.3165 2.90389 11.2404 2.8885 11.1695 2.85864C11.0987 2.82877 11.0346 2.78503 10.9809 2.73C9.9998 1.81273 8.73246 1.26138 7.39226 1.16876C6.05206 1.07615 4.72086 1.44794 3.62279 2.22152C2.52471 2.99511 1.72683 4.12325 1.36345 5.41602C1.00008 6.70879 1.09342 8.08723 1.62775 9.31926C2.16209 10.5513 3.10478 11.5617 4.29713 12.1803C5.48947 12.7989 6.85865 12.988 8.17414 12.7157C9.48963 12.4435 10.6711 11.7264 11.5196 10.6854C12.3681 9.64432 12.8319 8.34282 12.8328 7C12.8328 6.84529 12.8943 6.69692 13.0038 6.58752C13.1132 6.47812 13.2616 6.41667 13.4164 6.41667C13.5712 6.41667 13.7196 6.47812 13.8291 6.58752C13.9385 6.69692 14 6.84529 14 7C14 8.85651 13.2622 10.637 11.9489 11.9497C10.6356 13.2625 8.85432 14 6.99701 14Z",
    fill: "currentColor"
  }, null, -1)]), 16);
}
$a.render = xu;
var Su = function(o) {
  var t = o.dt;
  return `
.p-badge {
    display: inline-flex;
    border-radius: `.concat(t("badge.border.radius"), `;
    align-items: center;
    justify-content: center;
    padding: `).concat(t("badge.padding"), `;
    background: `).concat(t("badge.primary.background"), `;
    color: `).concat(t("badge.primary.color"), `;
    font-size: `).concat(t("badge.font.size"), `;
    font-weight: `).concat(t("badge.font.weight"), `;
    min-width: `).concat(t("badge.min.width"), `;
    height: `).concat(t("badge.height"), `;
}

.p-badge-dot {
    width: `).concat(t("badge.dot.size"), `;
    min-width: `).concat(t("badge.dot.size"), `;
    height: `).concat(t("badge.dot.size"), `;
    border-radius: 50%;
    padding: 0;
}

.p-badge-circle {
    padding: 0;
    border-radius: 50%;
}

.p-badge-secondary {
    background: `).concat(t("badge.secondary.background"), `;
    color: `).concat(t("badge.secondary.color"), `;
}

.p-badge-success {
    background: `).concat(t("badge.success.background"), `;
    color: `).concat(t("badge.success.color"), `;
}

.p-badge-info {
    background: `).concat(t("badge.info.background"), `;
    color: `).concat(t("badge.info.color"), `;
}

.p-badge-warn {
    background: `).concat(t("badge.warn.background"), `;
    color: `).concat(t("badge.warn.color"), `;
}

.p-badge-danger {
    background: `).concat(t("badge.danger.background"), `;
    color: `).concat(t("badge.danger.color"), `;
}

.p-badge-contrast {
    background: `).concat(t("badge.contrast.background"), `;
    color: `).concat(t("badge.contrast.color"), `;
}

.p-badge-sm {
    font-size: `).concat(t("badge.sm.font.size"), `;
    min-width: `).concat(t("badge.sm.min.width"), `;
    height: `).concat(t("badge.sm.height"), `;
}

.p-badge-lg {
    font-size: `).concat(t("badge.lg.font.size"), `;
    min-width: `).concat(t("badge.lg.min.width"), `;
    height: `).concat(t("badge.lg.height"), `;
}

.p-badge-xl {
    font-size: `).concat(t("badge.xl.font.size"), `;
    min-width: `).concat(t("badge.xl.min.width"), `;
    height: `).concat(t("badge.xl.height"), `;
}
`);
}, $u = {
  root: function(o) {
    var t = o.props, r = o.instance;
    return ["p-badge p-component", {
      "p-badge-circle": ee(t.value) && String(t.value).length === 1,
      "p-badge-dot": ho(t.value) && !r.$slots.default,
      "p-badge-sm": t.size === "small",
      "p-badge-lg": t.size === "large",
      "p-badge-xl": t.size === "xlarge",
      "p-badge-info": t.severity === "info",
      "p-badge-success": t.severity === "success",
      "p-badge-warn": t.severity === "warn",
      "p-badge-danger": t.severity === "danger",
      "p-badge-secondary": t.severity === "secondary",
      "p-badge-contrast": t.severity === "contrast"
    }];
  }
}, Bu = Q.extend({
  name: "badge",
  theme: Su,
  classes: $u
}), _u = {
  name: "BaseBadge",
  extends: jt,
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    severity: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  style: Bu,
  provide: function() {
    return {
      $pcBadge: this,
      $parentInstance: this
    };
  }
}, Ba = {
  name: "Badge",
  extends: _u,
  inheritAttrs: !1
};
function Mu(e, o, t, r, n, i) {
  return g(), $("span", y({
    class: e.cx("root")
  }, e.ptmi("root")), [B(e.$slots, "default", {}, function() {
    return [ie(z(e.value), 1)];
  })], 16);
}
Ba.render = Mu;
var yo = Vr();
function Jo(e) {
  "@babel/helpers - typeof";
  return Jo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, Jo(e);
}
function Gn(e, o) {
  return Ou(e) || Du(e, o) || Pu(e, o) || Tu();
}
function Tu() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Pu(e, o) {
  if (e) {
    if (typeof e == "string") return qn(e, o);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? qn(e, o) : void 0;
  }
}
function qn(e, o) {
  (o == null || o > e.length) && (o = e.length);
  for (var t = 0, r = Array(o); t < o; t++) r[t] = e[t];
  return r;
}
function Du(e, o) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var r, n, i, a, l = [], s = !0, d = !1;
    try {
      if (i = (t = t.call(e)).next, o !== 0) for (; !(s = (r = i.call(t)).done) && (l.push(r.value), l.length !== o); s = !0) ;
    } catch (c) {
      d = !0, n = c;
    } finally {
      try {
        if (!s && t.return != null && (a = t.return(), Object(a) !== a)) return;
      } finally {
        if (d) throw n;
      }
    }
    return l;
  }
}
function Ou(e) {
  if (Array.isArray(e)) return e;
}
function Xn(e, o) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function F(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = arguments[o] != null ? arguments[o] : {};
    o % 2 ? Xn(Object(t), !0).forEach(function(r) {
      dr(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Xn(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function dr(e, o, t) {
  return (o = Ru(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function Ru(e) {
  var o = Lu(e, "string");
  return Jo(o) == "symbol" ? o : o + "";
}
function Lu(e, o) {
  if (Jo(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (Jo(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
var E = {
  _getMeta: function() {
    return [Ne(arguments.length <= 0 ? void 0 : arguments[0]) || arguments.length <= 0 ? void 0 : arguments[0], ve(Ne(arguments.length <= 0 ? void 0 : arguments[0]) ? arguments.length <= 0 ? void 0 : arguments[0] : arguments.length <= 1 ? void 0 : arguments[1])];
  },
  _getConfig: function(o, t) {
    var r, n, i;
    return (r = (o == null || (n = o.instance) === null || n === void 0 ? void 0 : n.$primevue) || (t == null || (i = t.ctx) === null || i === void 0 || (i = i.appContext) === null || i === void 0 || (i = i.config) === null || i === void 0 || (i = i.globalProperties) === null || i === void 0 ? void 0 : i.$primevue)) === null || r === void 0 ? void 0 : r.config;
  },
  _getOptionValue: Hr,
  _getPTValue: function() {
    var o, t, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "", a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, l = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0, s = function() {
      var w = E._getOptionValue.apply(E, arguments);
      return he(w) || Ft(w) ? {
        class: w
      } : w;
    }, d = ((o = r.binding) === null || o === void 0 || (o = o.value) === null || o === void 0 ? void 0 : o.ptOptions) || ((t = r.$primevueConfig) === null || t === void 0 ? void 0 : t.ptOptions) || {}, c = d.mergeSections, f = c === void 0 ? !0 : c, u = d.mergeProps, p = u === void 0 ? !1 : u, h = l ? E._useDefaultPT(r, r.defaultPT(), s, i, a) : void 0, m = E._usePT(r, E._getPT(n, r.$name), s, i, F(F({}, a), {}, {
      global: h || {}
    })), v = E._getPTDatasets(r, i);
    return f || !f && m ? p ? E._mergeProps(r, p, h, m, v) : F(F(F({}, h), m), v) : F(F({}, m), v);
  },
  _getPTDatasets: function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = "data-pc-";
    return F(F({}, t === "root" && dr({}, "".concat(r, "name"), $e(o.$name))), {}, dr({}, "".concat(r, "section"), $e(t)));
  },
  _getPT: function(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", r = arguments.length > 2 ? arguments[2] : void 0, n = function(a) {
      var l, s = r ? r(a) : a, d = $e(t);
      return (l = s == null ? void 0 : s[d]) !== null && l !== void 0 ? l : s;
    };
    return o != null && o.hasOwnProperty("_usept") ? {
      _usept: o._usept,
      originalValue: n(o.originalValue),
      value: n(o.value)
    } : n(o);
  },
  _usePT: function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0, n = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 ? arguments[4] : void 0, a = function(v) {
      return r(v, n, i);
    };
    if (t != null && t.hasOwnProperty("_usept")) {
      var l, s = t._usept || ((l = o.$primevueConfig) === null || l === void 0 ? void 0 : l.ptOptions) || {}, d = s.mergeSections, c = d === void 0 ? !0 : d, f = s.mergeProps, u = f === void 0 ? !1 : f, p = a(t.originalValue), h = a(t.value);
      return p === void 0 && h === void 0 ? void 0 : he(h) ? h : he(p) ? p : c || !c && h ? u ? E._mergeProps(o, u, p, h) : F(F({}, p), h) : h;
    }
    return a(t);
  },
  _useDefaultPT: function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 ? arguments[2] : void 0, n = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 ? arguments[4] : void 0;
    return E._usePT(o, t, r, n, i);
  },
  _loadStyles: function(o, t, r) {
    var n, i = E._getConfig(t, r), a = {
      nonce: i == null || (n = i.csp) === null || n === void 0 ? void 0 : n.nonce
    };
    E._loadCoreStyles(o.$instance, a), E._loadThemeStyles(o.$instance, a), E._loadScopedThemeStyles(o.$instance, a), E._themeChangeListener(function() {
      return E._loadThemeStyles(o.$instance, a);
    });
  },
  _loadCoreStyles: function() {
    var o, t, r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0;
    if (!Xe.isStyleNameLoaded((o = r.$style) === null || o === void 0 ? void 0 : o.name) && (t = r.$style) !== null && t !== void 0 && t.name) {
      var i;
      Q.loadCSS(n), (i = r.$style) === null || i === void 0 || i.loadCSS(n), Xe.setLoadedStyleName(r.$style.name);
    }
  },
  _loadThemeStyles: function() {
    var o, t, r, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, i = arguments.length > 1 ? arguments[1] : void 0;
    if (!(n != null && n.isUnstyled() || (n == null || (o = n.theme) === null || o === void 0 ? void 0 : o.call(n)) === "none")) {
      if (!G.isStyleNameLoaded("common")) {
        var a, l, s = ((a = n.$style) === null || a === void 0 || (l = a.getCommonTheme) === null || l === void 0 ? void 0 : l.call(a)) || {}, d = s.primitive, c = s.semantic, f = s.global, u = s.style;
        Q.load(d == null ? void 0 : d.css, F({
          name: "primitive-variables"
        }, i)), Q.load(c == null ? void 0 : c.css, F({
          name: "semantic-variables"
        }, i)), Q.load(f == null ? void 0 : f.css, F({
          name: "global-variables"
        }, i)), Q.loadTheme(F({
          name: "global-style"
        }, i), u), G.setLoadedStyleName("common");
      }
      if (!G.isStyleNameLoaded((t = n.$style) === null || t === void 0 ? void 0 : t.name) && (r = n.$style) !== null && r !== void 0 && r.name) {
        var p, h, m, v, C = ((p = n.$style) === null || p === void 0 || (h = p.getDirectiveTheme) === null || h === void 0 ? void 0 : h.call(p)) || {}, w = C.css, b = C.style;
        (m = n.$style) === null || m === void 0 || m.load(w, F({
          name: "".concat(n.$style.name, "-variables")
        }, i)), (v = n.$style) === null || v === void 0 || v.loadTheme(F({
          name: "".concat(n.$style.name, "-style")
        }, i), b), G.setLoadedStyleName(n.$style.name);
      }
      if (!G.isStyleNameLoaded("layer-order")) {
        var x, D, _ = (x = n.$style) === null || x === void 0 || (D = x.getLayerOrderThemeCSS) === null || D === void 0 ? void 0 : D.call(x);
        Q.load(_, F({
          name: "layer-order",
          first: !0
        }, i)), G.setLoadedStyleName("layer-order");
      }
    }
  },
  _loadScopedThemeStyles: function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0, r = o.preset();
    if (r && o.$attrSelector) {
      var n, i, a, l = ((n = o.$style) === null || n === void 0 || (i = n.getPresetTheme) === null || i === void 0 ? void 0 : i.call(n, r, "[".concat(o.$attrSelector, "]"))) || {}, s = l.css, d = (a = o.$style) === null || a === void 0 ? void 0 : a.load(s, F({
        name: "".concat(o.$attrSelector, "-").concat(o.$style.name)
      }, t));
      o.scopedStyleEl = d.el;
    }
  },
  _themeChangeListener: function() {
    var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : function() {
    };
    Xe.clearLoadedStyleNames(), Se.on("theme:change", o);
  },
  _hook: function(o, t, r, n, i, a) {
    var l, s, d = "on".concat(Bd(t)), c = E._getConfig(n, i), f = r == null ? void 0 : r.$instance, u = E._usePT(f, E._getPT(n == null || (l = n.value) === null || l === void 0 ? void 0 : l.pt, o), E._getOptionValue, "hooks.".concat(d)), p = E._useDefaultPT(f, c == null || (s = c.pt) === null || s === void 0 || (s = s.directives) === null || s === void 0 ? void 0 : s[o], E._getOptionValue, "hooks.".concat(d)), h = {
      el: r,
      binding: n,
      vnode: i,
      prevVnode: a
    };
    u == null || u(f, h), p == null || p(f, h);
  },
  _mergeProps: function() {
    for (var o = arguments.length > 1 ? arguments[1] : void 0, t = arguments.length, r = new Array(t > 2 ? t - 2 : 0), n = 2; n < t; n++)
      r[n - 2] = arguments[n];
    return Nr(o) ? o.apply(void 0, r) : y.apply(void 0, r);
  },
  _extend: function(o) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = function(a, l, s, d, c) {
      var f, u, p, h;
      l._$instances = l._$instances || {};
      var m = E._getConfig(s, d), v = l._$instances[o] || {}, C = ho(v) ? F(F({}, t), t == null ? void 0 : t.methods) : {};
      l._$instances[o] = F(F({}, v), {}, {
        /* new instance variables to pass in directive methods */
        $name: o,
        $host: l,
        $binding: s,
        $modifiers: s == null ? void 0 : s.modifiers,
        $value: s == null ? void 0 : s.value,
        $el: v.$el || l || void 0,
        $style: F({
          classes: void 0,
          inlineStyles: void 0,
          load: function() {
          },
          loadCSS: function() {
          },
          loadTheme: function() {
          }
        }, t == null ? void 0 : t.style),
        $primevueConfig: m,
        $attrSelector: (f = l.$pd) === null || f === void 0 || (f = f[o]) === null || f === void 0 ? void 0 : f.attrSelector,
        /* computed instance variables */
        defaultPT: function() {
          return E._getPT(m == null ? void 0 : m.pt, void 0, function(b) {
            var x;
            return b == null || (x = b.directives) === null || x === void 0 ? void 0 : x[o];
          });
        },
        isUnstyled: function() {
          var b, x;
          return ((b = l.$instance) === null || b === void 0 || (b = b.$binding) === null || b === void 0 || (b = b.value) === null || b === void 0 ? void 0 : b.unstyled) !== void 0 ? (x = l.$instance) === null || x === void 0 || (x = x.$binding) === null || x === void 0 || (x = x.value) === null || x === void 0 ? void 0 : x.unstyled : m == null ? void 0 : m.unstyled;
        },
        theme: function() {
          var b;
          return (b = l.$instance) === null || b === void 0 || (b = b.$primevueConfig) === null || b === void 0 ? void 0 : b.theme;
        },
        preset: function() {
          var b;
          return (b = l.$instance) === null || b === void 0 || (b = b.$binding) === null || b === void 0 || (b = b.value) === null || b === void 0 ? void 0 : b.dt;
        },
        /* instance's methods */
        ptm: function() {
          var b, x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return E._getPTValue(l.$instance, (b = l.$instance) === null || b === void 0 || (b = b.$binding) === null || b === void 0 || (b = b.value) === null || b === void 0 ? void 0 : b.pt, x, F({}, D));
        },
        ptmo: function() {
          var b = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", D = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return E._getPTValue(l.$instance, b, x, D, !1);
        },
        cx: function() {
          var b, x, D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", _ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          return (b = l.$instance) !== null && b !== void 0 && b.isUnstyled() ? void 0 : E._getOptionValue((x = l.$instance) === null || x === void 0 || (x = x.$style) === null || x === void 0 ? void 0 : x.classes, D, F({}, _));
        },
        sx: function() {
          var b, x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", D = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, _ = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
          return D ? E._getOptionValue((b = l.$instance) === null || b === void 0 || (b = b.$style) === null || b === void 0 ? void 0 : b.inlineStyles, x, F({}, _)) : void 0;
        }
      }, C), l.$instance = l._$instances[o], (u = (p = l.$instance)[a]) === null || u === void 0 || u.call(p, l, s, d, c), l["$".concat(o)] = l.$instance, E._hook(o, a, l, s, d, c), l.$pd || (l.$pd = {}), l.$pd[o] = F(F({}, (h = l.$pd) === null || h === void 0 ? void 0 : h[o]), {}, {
        name: o,
        instance: l.$instance
      });
    }, n = function(a) {
      var l, s, d, c, f, u = (l = a.$instance) === null || l === void 0 ? void 0 : l.watch;
      u == null || (s = u.config) === null || s === void 0 || s.call(a.$instance, (d = a.$instance) === null || d === void 0 ? void 0 : d.$primevueConfig), yo.on("config:change", function(p) {
        var h, m = p.newValue, v = p.oldValue;
        return u == null || (h = u.config) === null || h === void 0 ? void 0 : h.call(a.$instance, m, v);
      }), u == null || (c = u["config.ripple"]) === null || c === void 0 || c.call(a.$instance, (f = a.$instance) === null || f === void 0 || (f = f.$primevueConfig) === null || f === void 0 ? void 0 : f.ripple), yo.on("config:ripple:change", function(p) {
        var h, m = p.newValue, v = p.oldValue;
        return u == null || (h = u["config.ripple"]) === null || h === void 0 ? void 0 : h.call(a.$instance, m, v);
      });
    };
    return {
      created: function(a, l, s, d) {
        a.$pd || (a.$pd = {}), a.$pd[o] = {
          name: o,
          attrSelector: Fr("pd")
        }, r("created", a, l, s, d);
      },
      beforeMount: function(a, l, s, d) {
        E._loadStyles(a, l, s), r("beforeMount", a, l, s, d), n(a);
      },
      mounted: function(a, l, s, d) {
        E._loadStyles(a, l, s), r("mounted", a, l, s, d);
      },
      beforeUpdate: function(a, l, s, d) {
        r("beforeUpdate", a, l, s, d);
      },
      updated: function(a, l, s, d) {
        E._loadStyles(a, l, s), r("updated", a, l, s, d);
      },
      beforeUnmount: function(a, l, s, d) {
        r("beforeUnmount", a, l, s, d);
      },
      unmounted: function(a, l, s, d) {
        var c;
        (c = a.$instance) === null || c === void 0 || (c = c.scopedStyleEl) === null || c === void 0 || (c = c.value) === null || c === void 0 || c.remove(), r("unmounted", a, l, s, d);
      }
    };
  },
  extend: function() {
    var o = E._getMeta.apply(E, arguments), t = Gn(o, 2), r = t[0], n = t[1];
    return F({
      extend: function() {
        var a = E._getMeta.apply(E, arguments), l = Gn(a, 2), s = l[0], d = l[1];
        return E.extend(s, F(F(F({}, n), n == null ? void 0 : n.methods), d));
      }
    }, E._extend(r, n));
  }
}, Au = function(o) {
  var t = o.dt;
  return `
.p-ink {
    display: block;
    position: absolute;
    background: `.concat(t("ripple.background"), `;
    border-radius: 100%;
    transform: scale(0);
    pointer-events: none;
}

.p-ink-active {
    animation: ripple 0.4s linear;
}

@keyframes ripple {
    100% {
        opacity: 0;
        transform: scale(2.5);
    }
}
`);
}, Iu = {
  root: "p-ink"
}, Eu = Q.extend({
  name: "ripple-directive",
  theme: Au,
  classes: Iu
}), zu = E.extend({
  style: Eu
});
function et(e) {
  "@babel/helpers - typeof";
  return et = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, et(e);
}
function Nu(e) {
  return ju(e) || Fu(e) || Vu(e) || Hu();
}
function Hu() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Vu(e, o) {
  if (e) {
    if (typeof e == "string") return ur(e, o);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? ur(e, o) : void 0;
  }
}
function Fu(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function ju(e) {
  if (Array.isArray(e)) return ur(e);
}
function ur(e, o) {
  (o == null || o > e.length) && (o = e.length);
  for (var t = 0, r = Array(o); t < o; t++) r[t] = e[t];
  return r;
}
function Qn(e, o, t) {
  return (o = Zu(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function Zu(e) {
  var o = Wu(e, "string");
  return et(o) == "symbol" ? o : o + "";
}
function Wu(e, o) {
  if (et(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (et(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
var _a = zu.extend("ripple", {
  watch: {
    "config.ripple": function(o) {
      o ? (this.createRipple(this.$host), this.bindEvents(this.$host), this.$host.setAttribute("data-pd-ripple", !0), this.$host.style.overflow = "hidden", this.$host.style.position = "relative") : (this.remove(this.$host), this.$host.removeAttribute("data-pd-ripple"));
    }
  },
  unmounted: function(o) {
    this.remove(o);
  },
  timeout: void 0,
  methods: {
    bindEvents: function(o) {
      o.addEventListener("mousedown", this.onMouseDown.bind(this));
    },
    unbindEvents: function(o) {
      o.removeEventListener("mousedown", this.onMouseDown.bind(this));
    },
    createRipple: function(o) {
      var t = pd("span", Qn(Qn({
        role: "presentation",
        "aria-hidden": !0,
        "data-p-ink": !0,
        "data-p-ink-active": !1,
        class: !this.isUnstyled() && this.cx("root"),
        onAnimationEnd: this.onAnimationEnd.bind(this)
      }, this.$attrSelector, ""), "p-bind", this.ptm("root")));
      o.appendChild(t), this.$el = t;
    },
    remove: function(o) {
      var t = this.getInk(o);
      t && (this.$host.style.overflow = "", this.$host.style.position = "", this.unbindEvents(o), t.removeEventListener("animationend", this.onAnimationEnd), t.remove());
    },
    onMouseDown: function(o) {
      var t = this, r = o.currentTarget, n = this.getInk(r);
      if (!(!n || getComputedStyle(n, null).display === "none")) {
        if (!this.isUnstyled() && Gt(n, "p-ink-active"), n.setAttribute("data-p-ink-active", "false"), !Dn(n) && !On(n)) {
          var i = Math.max(yt(r), hd(r));
          n.style.height = i + "px", n.style.width = i + "px";
        }
        var a = fd(r), l = o.pageX - a.left + document.body.scrollTop - On(n) / 2, s = o.pageY - a.top + document.body.scrollLeft - Dn(n) / 2;
        n.style.top = s + "px", n.style.left = l + "px", !this.isUnstyled() && ad(n, "p-ink-active"), n.setAttribute("data-p-ink-active", "true"), this.timeout = setTimeout(function() {
          n && (!t.isUnstyled() && Gt(n, "p-ink-active"), n.setAttribute("data-p-ink-active", "false"));
        }, 401);
      }
    },
    onAnimationEnd: function(o) {
      this.timeout && clearTimeout(this.timeout), !this.isUnstyled() && Gt(o.currentTarget, "p-ink-active"), o.currentTarget.setAttribute("data-p-ink-active", "false");
    },
    getInk: function(o) {
      return o && o.children ? Nu(o.children).find(function(t) {
        return so(t, "data-pc-name") === "ripple";
      }) : void 0;
    }
  }
});
function ot(e) {
  "@babel/helpers - typeof";
  return ot = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, ot(e);
}
function De(e, o, t) {
  return (o = Yu(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function Yu(e) {
  var o = Ku(e, "string");
  return ot(o) == "symbol" ? o : o + "";
}
function Ku(e, o) {
  if (ot(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (ot(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
var Uu = function(o) {
  var t = o.dt;
  return `
.p-button {
    display: inline-flex;
    cursor: pointer;
    user-select: none;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    color: `.concat(t("button.primary.color"), `;
    background: `).concat(t("button.primary.background"), `;
    border: 1px solid `).concat(t("button.primary.border.color"), `;
    padding: `).concat(t("button.padding.y"), " ").concat(t("button.padding.x"), `;
    font-size: 1rem;
    font-family: inherit;
    font-feature-settings: inherit;
    transition: background `).concat(t("button.transition.duration"), ", color ").concat(t("button.transition.duration"), ", border-color ").concat(t("button.transition.duration"), `,
            outline-color `).concat(t("button.transition.duration"), ", box-shadow ").concat(t("button.transition.duration"), `;
    border-radius: `).concat(t("button.border.radius"), `;
    outline-color: transparent;
    gap: `).concat(t("button.gap"), `;
}

.p-button:disabled {
    cursor: default;
}

.p-button-icon-right {
    order: 1;
}

.p-button-icon-right:dir(rtl) {
    order: -1;
}

.p-button:not(.p-button-vertical) .p-button-icon:not(.p-button-icon-right):dir(rtl) {
    order: 1;
}

.p-button-icon-bottom {
    order: 2;
}

.p-button-icon-only {
    width: `).concat(t("button.icon.only.width"), `;
    padding-inline-start: 0;
    padding-inline-end: 0;
    gap: 0;
}

.p-button-icon-only.p-button-rounded {
    border-radius: 50%;
    height: `).concat(t("button.icon.only.width"), `;
}

.p-button-icon-only .p-button-label {
    visibility: hidden;
    width: 0;
}

.p-button-sm {
    font-size: `).concat(t("button.sm.font.size"), `;
    padding: `).concat(t("button.sm.padding.y"), " ").concat(t("button.sm.padding.x"), `;
}

.p-button-sm .p-button-icon {
    font-size: `).concat(t("button.sm.font.size"), `;
}

.p-button-lg {
    font-size: `).concat(t("button.lg.font.size"), `;
    padding: `).concat(t("button.lg.padding.y"), " ").concat(t("button.lg.padding.x"), `;
}

.p-button-lg .p-button-icon {
    font-size: `).concat(t("button.lg.font.size"), `;
}

.p-button-vertical {
    flex-direction: column;
}

.p-button-label {
    font-weight: `).concat(t("button.label.font.weight"), `;
}

.p-button-fluid {
    width: 100%;
}

.p-button-fluid.p-button-icon-only {
    width: `).concat(t("button.icon.only.width"), `;
}

.p-button:not(:disabled):hover {
    background: `).concat(t("button.primary.hover.background"), `;
    border: 1px solid `).concat(t("button.primary.hover.border.color"), `;
    color: `).concat(t("button.primary.hover.color"), `;
}

.p-button:not(:disabled):active {
    background: `).concat(t("button.primary.active.background"), `;
    border: 1px solid `).concat(t("button.primary.active.border.color"), `;
    color: `).concat(t("button.primary.active.color"), `;
}

.p-button:focus-visible {
    box-shadow: `).concat(t("button.primary.focus.ring.shadow"), `;
    outline: `).concat(t("button.focus.ring.width"), " ").concat(t("button.focus.ring.style"), " ").concat(t("button.primary.focus.ring.color"), `;
    outline-offset: `).concat(t("button.focus.ring.offset"), `;
}

.p-button .p-badge {
    min-width: `).concat(t("button.badge.size"), `;
    height: `).concat(t("button.badge.size"), `;
    line-height: `).concat(t("button.badge.size"), `;
}

.p-button-raised {
    box-shadow: `).concat(t("button.raised.shadow"), `;
}

.p-button-rounded {
    border-radius: `).concat(t("button.rounded.border.radius"), `;
}

.p-button-secondary {
    background: `).concat(t("button.secondary.background"), `;
    border: 1px solid `).concat(t("button.secondary.border.color"), `;
    color: `).concat(t("button.secondary.color"), `;
}

.p-button-secondary:not(:disabled):hover {
    background: `).concat(t("button.secondary.hover.background"), `;
    border: 1px solid `).concat(t("button.secondary.hover.border.color"), `;
    color: `).concat(t("button.secondary.hover.color"), `;
}

.p-button-secondary:not(:disabled):active {
    background: `).concat(t("button.secondary.active.background"), `;
    border: 1px solid `).concat(t("button.secondary.active.border.color"), `;
    color: `).concat(t("button.secondary.active.color"), `;
}

.p-button-secondary:focus-visible {
    outline-color: `).concat(t("button.secondary.focus.ring.color"), `;
    box-shadow: `).concat(t("button.secondary.focus.ring.shadow"), `;
}

.p-button-success {
    background: `).concat(t("button.success.background"), `;
    border: 1px solid `).concat(t("button.success.border.color"), `;
    color: `).concat(t("button.success.color"), `;
}

.p-button-success:not(:disabled):hover {
    background: `).concat(t("button.success.hover.background"), `;
    border: 1px solid `).concat(t("button.success.hover.border.color"), `;
    color: `).concat(t("button.success.hover.color"), `;
}

.p-button-success:not(:disabled):active {
    background: `).concat(t("button.success.active.background"), `;
    border: 1px solid `).concat(t("button.success.active.border.color"), `;
    color: `).concat(t("button.success.active.color"), `;
}

.p-button-success:focus-visible {
    outline-color: `).concat(t("button.success.focus.ring.color"), `;
    box-shadow: `).concat(t("button.success.focus.ring.shadow"), `;
}

.p-button-info {
    background: `).concat(t("button.info.background"), `;
    border: 1px solid `).concat(t("button.info.border.color"), `;
    color: `).concat(t("button.info.color"), `;
}

.p-button-info:not(:disabled):hover {
    background: `).concat(t("button.info.hover.background"), `;
    border: 1px solid `).concat(t("button.info.hover.border.color"), `;
    color: `).concat(t("button.info.hover.color"), `;
}

.p-button-info:not(:disabled):active {
    background: `).concat(t("button.info.active.background"), `;
    border: 1px solid `).concat(t("button.info.active.border.color"), `;
    color: `).concat(t("button.info.active.color"), `;
}

.p-button-info:focus-visible {
    outline-color: `).concat(t("button.info.focus.ring.color"), `;
    box-shadow: `).concat(t("button.info.focus.ring.shadow"), `;
}

.p-button-warn {
    background: `).concat(t("button.warn.background"), `;
    border: 1px solid `).concat(t("button.warn.border.color"), `;
    color: `).concat(t("button.warn.color"), `;
}

.p-button-warn:not(:disabled):hover {
    background: `).concat(t("button.warn.hover.background"), `;
    border: 1px solid `).concat(t("button.warn.hover.border.color"), `;
    color: `).concat(t("button.warn.hover.color"), `;
}

.p-button-warn:not(:disabled):active {
    background: `).concat(t("button.warn.active.background"), `;
    border: 1px solid `).concat(t("button.warn.active.border.color"), `;
    color: `).concat(t("button.warn.active.color"), `;
}

.p-button-warn:focus-visible {
    outline-color: `).concat(t("button.warn.focus.ring.color"), `;
    box-shadow: `).concat(t("button.warn.focus.ring.shadow"), `;
}

.p-button-help {
    background: `).concat(t("button.help.background"), `;
    border: 1px solid `).concat(t("button.help.border.color"), `;
    color: `).concat(t("button.help.color"), `;
}

.p-button-help:not(:disabled):hover {
    background: `).concat(t("button.help.hover.background"), `;
    border: 1px solid `).concat(t("button.help.hover.border.color"), `;
    color: `).concat(t("button.help.hover.color"), `;
}

.p-button-help:not(:disabled):active {
    background: `).concat(t("button.help.active.background"), `;
    border: 1px solid `).concat(t("button.help.active.border.color"), `;
    color: `).concat(t("button.help.active.color"), `;
}

.p-button-help:focus-visible {
    outline-color: `).concat(t("button.help.focus.ring.color"), `;
    box-shadow: `).concat(t("button.help.focus.ring.shadow"), `;
}

.p-button-danger {
    background: `).concat(t("button.danger.background"), `;
    border: 1px solid `).concat(t("button.danger.border.color"), `;
    color: `).concat(t("button.danger.color"), `;
}

.p-button-danger:not(:disabled):hover {
    background: `).concat(t("button.danger.hover.background"), `;
    border: 1px solid `).concat(t("button.danger.hover.border.color"), `;
    color: `).concat(t("button.danger.hover.color"), `;
}

.p-button-danger:not(:disabled):active {
    background: `).concat(t("button.danger.active.background"), `;
    border: 1px solid `).concat(t("button.danger.active.border.color"), `;
    color: `).concat(t("button.danger.active.color"), `;
}

.p-button-danger:focus-visible {
    outline-color: `).concat(t("button.danger.focus.ring.color"), `;
    box-shadow: `).concat(t("button.danger.focus.ring.shadow"), `;
}

.p-button-contrast {
    background: `).concat(t("button.contrast.background"), `;
    border: 1px solid `).concat(t("button.contrast.border.color"), `;
    color: `).concat(t("button.contrast.color"), `;
}

.p-button-contrast:not(:disabled):hover {
    background: `).concat(t("button.contrast.hover.background"), `;
    border: 1px solid `).concat(t("button.contrast.hover.border.color"), `;
    color: `).concat(t("button.contrast.hover.color"), `;
}

.p-button-contrast:not(:disabled):active {
    background: `).concat(t("button.contrast.active.background"), `;
    border: 1px solid `).concat(t("button.contrast.active.border.color"), `;
    color: `).concat(t("button.contrast.active.color"), `;
}

.p-button-contrast:focus-visible {
    outline-color: `).concat(t("button.contrast.focus.ring.color"), `;
    box-shadow: `).concat(t("button.contrast.focus.ring.shadow"), `;
}

.p-button-outlined {
    background: transparent;
    border-color: `).concat(t("button.outlined.primary.border.color"), `;
    color: `).concat(t("button.outlined.primary.color"), `;
}

.p-button-outlined:not(:disabled):hover {
    background: `).concat(t("button.outlined.primary.hover.background"), `;
    border-color: `).concat(t("button.outlined.primary.border.color"), `;
    color: `).concat(t("button.outlined.primary.color"), `;
}

.p-button-outlined:not(:disabled):active {
    background: `).concat(t("button.outlined.primary.active.background"), `;
    border-color: `).concat(t("button.outlined.primary.border.color"), `;
    color: `).concat(t("button.outlined.primary.color"), `;
}

.p-button-outlined.p-button-secondary {
    border-color: `).concat(t("button.outlined.secondary.border.color"), `;
    color: `).concat(t("button.outlined.secondary.color"), `;
}

.p-button-outlined.p-button-secondary:not(:disabled):hover {
    background: `).concat(t("button.outlined.secondary.hover.background"), `;
    border-color: `).concat(t("button.outlined.secondary.border.color"), `;
    color: `).concat(t("button.outlined.secondary.color"), `;
}

.p-button-outlined.p-button-secondary:not(:disabled):active {
    background: `).concat(t("button.outlined.secondary.active.background"), `;
    border-color: `).concat(t("button.outlined.secondary.border.color"), `;
    color: `).concat(t("button.outlined.secondary.color"), `;
}

.p-button-outlined.p-button-success {
    border-color: `).concat(t("button.outlined.success.border.color"), `;
    color: `).concat(t("button.outlined.success.color"), `;
}

.p-button-outlined.p-button-success:not(:disabled):hover {
    background: `).concat(t("button.outlined.success.hover.background"), `;
    border-color: `).concat(t("button.outlined.success.border.color"), `;
    color: `).concat(t("button.outlined.success.color"), `;
}

.p-button-outlined.p-button-success:not(:disabled):active {
    background: `).concat(t("button.outlined.success.active.background"), `;
    border-color: `).concat(t("button.outlined.success.border.color"), `;
    color: `).concat(t("button.outlined.success.color"), `;
}

.p-button-outlined.p-button-info {
    border-color: `).concat(t("button.outlined.info.border.color"), `;
    color: `).concat(t("button.outlined.info.color"), `;
}

.p-button-outlined.p-button-info:not(:disabled):hover {
    background: `).concat(t("button.outlined.info.hover.background"), `;
    border-color: `).concat(t("button.outlined.info.border.color"), `;
    color: `).concat(t("button.outlined.info.color"), `;
}

.p-button-outlined.p-button-info:not(:disabled):active {
    background: `).concat(t("button.outlined.info.active.background"), `;
    border-color: `).concat(t("button.outlined.info.border.color"), `;
    color: `).concat(t("button.outlined.info.color"), `;
}

.p-button-outlined.p-button-warn {
    border-color: `).concat(t("button.outlined.warn.border.color"), `;
    color: `).concat(t("button.outlined.warn.color"), `;
}

.p-button-outlined.p-button-warn:not(:disabled):hover {
    background: `).concat(t("button.outlined.warn.hover.background"), `;
    border-color: `).concat(t("button.outlined.warn.border.color"), `;
    color: `).concat(t("button.outlined.warn.color"), `;
}

.p-button-outlined.p-button-warn:not(:disabled):active {
    background: `).concat(t("button.outlined.warn.active.background"), `;
    border-color: `).concat(t("button.outlined.warn.border.color"), `;
    color: `).concat(t("button.outlined.warn.color"), `;
}

.p-button-outlined.p-button-help {
    border-color: `).concat(t("button.outlined.help.border.color"), `;
    color: `).concat(t("button.outlined.help.color"), `;
}

.p-button-outlined.p-button-help:not(:disabled):hover {
    background: `).concat(t("button.outlined.help.hover.background"), `;
    border-color: `).concat(t("button.outlined.help.border.color"), `;
    color: `).concat(t("button.outlined.help.color"), `;
}

.p-button-outlined.p-button-help:not(:disabled):active {
    background: `).concat(t("button.outlined.help.active.background"), `;
    border-color: `).concat(t("button.outlined.help.border.color"), `;
    color: `).concat(t("button.outlined.help.color"), `;
}

.p-button-outlined.p-button-danger {
    border-color: `).concat(t("button.outlined.danger.border.color"), `;
    color: `).concat(t("button.outlined.danger.color"), `;
}

.p-button-outlined.p-button-danger:not(:disabled):hover {
    background: `).concat(t("button.outlined.danger.hover.background"), `;
    border-color: `).concat(t("button.outlined.danger.border.color"), `;
    color: `).concat(t("button.outlined.danger.color"), `;
}

.p-button-outlined.p-button-danger:not(:disabled):active {
    background: `).concat(t("button.outlined.danger.active.background"), `;
    border-color: `).concat(t("button.outlined.danger.border.color"), `;
    color: `).concat(t("button.outlined.danger.color"), `;
}

.p-button-outlined.p-button-contrast {
    border-color: `).concat(t("button.outlined.contrast.border.color"), `;
    color: `).concat(t("button.outlined.contrast.color"), `;
}

.p-button-outlined.p-button-contrast:not(:disabled):hover {
    background: `).concat(t("button.outlined.contrast.hover.background"), `;
    border-color: `).concat(t("button.outlined.contrast.border.color"), `;
    color: `).concat(t("button.outlined.contrast.color"), `;
}

.p-button-outlined.p-button-contrast:not(:disabled):active {
    background: `).concat(t("button.outlined.contrast.active.background"), `;
    border-color: `).concat(t("button.outlined.contrast.border.color"), `;
    color: `).concat(t("button.outlined.contrast.color"), `;
}

.p-button-outlined.p-button-plain {
    border-color: `).concat(t("button.outlined.plain.border.color"), `;
    color: `).concat(t("button.outlined.plain.color"), `;
}

.p-button-outlined.p-button-plain:not(:disabled):hover {
    background: `).concat(t("button.outlined.plain.hover.background"), `;
    border-color: `).concat(t("button.outlined.plain.border.color"), `;
    color: `).concat(t("button.outlined.plain.color"), `;
}

.p-button-outlined.p-button-plain:not(:disabled):active {
    background: `).concat(t("button.outlined.plain.active.background"), `;
    border-color: `).concat(t("button.outlined.plain.border.color"), `;
    color: `).concat(t("button.outlined.plain.color"), `;
}

.p-button-text {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.primary.color"), `;
}

.p-button-text:not(:disabled):hover {
    background: `).concat(t("button.text.primary.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.primary.color"), `;
}

.p-button-text:not(:disabled):active {
    background: `).concat(t("button.text.primary.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.primary.color"), `;
}

.p-button-text.p-button-secondary {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.secondary.color"), `;
}

.p-button-text.p-button-secondary:not(:disabled):hover {
    background: `).concat(t("button.text.secondary.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.secondary.color"), `;
}

.p-button-text.p-button-secondary:not(:disabled):active {
    background: `).concat(t("button.text.secondary.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.secondary.color"), `;
}

.p-button-text.p-button-success {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.success.color"), `;
}

.p-button-text.p-button-success:not(:disabled):hover {
    background: `).concat(t("button.text.success.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.success.color"), `;
}

.p-button-text.p-button-success:not(:disabled):active {
    background: `).concat(t("button.text.success.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.success.color"), `;
}

.p-button-text.p-button-info {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.info.color"), `;
}

.p-button-text.p-button-info:not(:disabled):hover {
    background: `).concat(t("button.text.info.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.info.color"), `;
}

.p-button-text.p-button-info:not(:disabled):active {
    background: `).concat(t("button.text.info.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.info.color"), `;
}

.p-button-text.p-button-warn {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.warn.color"), `;
}

.p-button-text.p-button-warn:not(:disabled):hover {
    background: `).concat(t("button.text.warn.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.warn.color"), `;
}

.p-button-text.p-button-warn:not(:disabled):active {
    background: `).concat(t("button.text.warn.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.warn.color"), `;
}

.p-button-text.p-button-help {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.help.color"), `;
}

.p-button-text.p-button-help:not(:disabled):hover {
    background: `).concat(t("button.text.help.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.help.color"), `;
}

.p-button-text.p-button-help:not(:disabled):active {
    background: `).concat(t("button.text.help.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.help.color"), `;
}

.p-button-text.p-button-danger {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.danger.color"), `;
}

.p-button-text.p-button-danger:not(:disabled):hover {
    background: `).concat(t("button.text.danger.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.danger.color"), `;
}

.p-button-text.p-button-danger:not(:disabled):active {
    background: `).concat(t("button.text.danger.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.danger.color"), `;
}

.p-button-text.p-button-contrast {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.contrast.color"), `;
}

.p-button-text.p-button-contrast:not(:disabled):hover {
    background: `).concat(t("button.text.contrast.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.contrast.color"), `;
}

.p-button-text.p-button-contrast:not(:disabled):active {
    background: `).concat(t("button.text.contrast.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.contrast.color"), `;
}

.p-button-text.p-button-plain {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.text.plain.color"), `;
}

.p-button-text.p-button-plain:not(:disabled):hover {
    background: `).concat(t("button.text.plain.hover.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.plain.color"), `;
}

.p-button-text.p-button-plain:not(:disabled):active {
    background: `).concat(t("button.text.plain.active.background"), `;
    border-color: transparent;
    color: `).concat(t("button.text.plain.color"), `;
}

.p-button-link {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.link.color"), `;
}

.p-button-link:not(:disabled):hover {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.link.hover.color"), `;
}

.p-button-link:not(:disabled):hover .p-button-label {
    text-decoration: underline;
}

.p-button-link:not(:disabled):active {
    background: transparent;
    border-color: transparent;
    color: `).concat(t("button.link.active.color"), `;
}
`);
}, Gu = {
  root: function(o) {
    var t = o.instance, r = o.props;
    return ["p-button p-component", De(De(De(De(De(De(De(De(De({
      "p-button-icon-only": t.hasIcon && !r.label && !r.badge,
      "p-button-vertical": (r.iconPos === "top" || r.iconPos === "bottom") && r.label,
      "p-button-loading": r.loading,
      "p-button-link": r.link || r.variant === "link"
    }, "p-button-".concat(r.severity), r.severity), "p-button-raised", r.raised), "p-button-rounded", r.rounded), "p-button-text", r.text || r.variant === "text"), "p-button-outlined", r.outlined || r.variant === "outlined"), "p-button-sm", r.size === "small"), "p-button-lg", r.size === "large"), "p-button-plain", r.plain), "p-button-fluid", t.hasFluid)];
  },
  loadingIcon: "p-button-loading-icon",
  icon: function(o) {
    var t = o.props;
    return ["p-button-icon", De({}, "p-button-icon-".concat(t.iconPos), t.label)];
  },
  label: "p-button-label"
}, qu = Q.extend({
  name: "button",
  theme: Uu,
  classes: Gu
}), Xu = {
  name: "BaseButton",
  extends: jt,
  props: {
    label: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    iconPos: {
      type: String,
      default: "left"
    },
    iconClass: {
      type: [String, Object],
      default: null
    },
    badge: {
      type: String,
      default: null
    },
    badgeClass: {
      type: [String, Object],
      default: null
    },
    badgeSeverity: {
      type: String,
      default: "secondary"
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loadingIcon: {
      type: String,
      default: void 0
    },
    as: {
      type: [String, Object],
      default: "BUTTON"
    },
    asChild: {
      type: Boolean,
      default: !1
    },
    link: {
      type: Boolean,
      default: !1
    },
    severity: {
      type: String,
      default: null
    },
    raised: {
      type: Boolean,
      default: !1
    },
    rounded: {
      type: Boolean,
      default: !1
    },
    text: {
      type: Boolean,
      default: !1
    },
    outlined: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: null
    },
    plain: {
      type: Boolean,
      default: !1
    },
    fluid: {
      type: Boolean,
      default: null
    }
  },
  style: qu,
  provide: function() {
    return {
      $pcButton: this,
      $parentInstance: this
    };
  }
}, Ma = {
  name: "Button",
  extends: Xu,
  inheritAttrs: !1,
  inject: {
    $pcFluid: {
      default: null
    }
  },
  methods: {
    getPTOptions: function(o) {
      var t = o === "root" ? this.ptmi : this.ptm;
      return t(o, {
        context: {
          disabled: this.disabled
        }
      });
    }
  },
  computed: {
    disabled: function() {
      return this.$attrs.disabled || this.$attrs.disabled === "" || this.loading;
    },
    defaultAriaLabel: function() {
      return this.label ? this.label + (this.badge ? " " + this.badge : "") : this.$attrs.ariaLabel;
    },
    hasIcon: function() {
      return this.icon || this.$slots.icon;
    },
    attrs: function() {
      return y(this.asAttrs, this.a11yAttrs, this.getPTOptions("root"));
    },
    asAttrs: function() {
      return this.as === "BUTTON" ? {
        type: "button",
        disabled: this.disabled
      } : void 0;
    },
    a11yAttrs: function() {
      return {
        "aria-label": this.defaultAriaLabel,
        "data-pc-name": "button",
        "data-p-disabled": this.disabled,
        "data-p-severity": this.severity
      };
    },
    hasFluid: function() {
      return ho(this.fluid) ? !!this.$pcFluid : this.fluid;
    }
  },
  components: {
    SpinnerIcon: $a,
    Badge: Ba
  },
  directives: {
    ripple: _a
  }
};
function Qu(e, o, t, r, n, i) {
  var a = Re("SpinnerIcon"), l = Re("Badge"), s = xr("ripple");
  return e.asChild ? B(e.$slots, "default", {
    key: 1,
    class: L(e.cx("root")),
    a11yAttrs: i.a11yAttrs
  }) : co((g(), M(fe(e.as), y({
    key: 0,
    class: e.cx("root")
  }, i.attrs), {
    default: S(function() {
      return [B(e.$slots, "default", {}, function() {
        return [e.loading ? B(e.$slots, "loadingicon", y({
          key: 0,
          class: [e.cx("loadingIcon"), e.cx("icon")]
        }, e.ptm("loadingIcon")), function() {
          return [e.loadingIcon ? (g(), $("span", y({
            key: 0,
            class: [e.cx("loadingIcon"), e.cx("icon"), e.loadingIcon]
          }, e.ptm("loadingIcon")), null, 16)) : (g(), M(a, y({
            key: 1,
            class: [e.cx("loadingIcon"), e.cx("icon")],
            spin: ""
          }, e.ptm("loadingIcon")), null, 16, ["class"]))];
        }) : B(e.$slots, "icon", y({
          key: 1,
          class: [e.cx("icon")]
        }, e.ptm("icon")), function() {
          return [e.icon ? (g(), $("span", y({
            key: 0,
            class: [e.cx("icon"), e.icon, e.iconClass]
          }, e.ptm("icon")), null, 16)) : I("", !0)];
        }), P("span", y({
          class: e.cx("label")
        }, e.ptm("label")), z(e.label || " "), 17), e.badge ? (g(), M(l, {
          key: 2,
          value: e.badge,
          class: L(e.badgeClass),
          severity: e.badgeSeverity,
          unstyled: e.unstyled,
          pt: e.ptm("pcBadge")
        }, null, 8, ["value", "class", "severity", "unstyled", "pt"])) : I("", !0)];
      })];
    }),
    _: 3
  }, 16, ["class"])), [[s]]);
}
Ma.render = Qu;
var Ju = {
  name: "BaseEditableHolder",
  extends: jt,
  emits: ["update:modelValue", "value-change"],
  props: {
    modelValue: {
      type: null,
      default: void 0
    },
    defaultValue: {
      type: null,
      default: void 0
    },
    name: {
      type: String,
      default: void 0
    },
    invalid: {
      type: Boolean,
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    formControl: {
      type: Object,
      default: void 0
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcForm: {
      default: void 0
    },
    $pcFormField: {
      default: void 0
    }
  },
  data: function() {
    return {
      d_value: this.defaultValue || this.modelValue
    };
  },
  watch: {
    modelValue: function(o) {
      this.d_value = o;
    },
    defaultValue: function(o) {
      this.d_value = o;
    },
    $formName: {
      immediate: !0,
      handler: function(o) {
        var t, r;
        this.formField = ((t = this.$pcForm) === null || t === void 0 || (r = t.register) === null || r === void 0 ? void 0 : r.call(t, o, this.$formControl)) || {};
      }
    },
    $formControl: {
      immediate: !0,
      handler: function(o) {
        var t, r;
        this.formField = ((t = this.$pcForm) === null || t === void 0 || (r = t.register) === null || r === void 0 ? void 0 : r.call(t, this.$formName, o)) || {};
      }
    },
    $formDefaultValue: {
      immediate: !0,
      handler: function(o) {
        this.d_value !== o && (this.d_value = o);
      }
    }
  },
  formField: {},
  methods: {
    writeValue: function(o, t) {
      var r, n;
      this.controlled && (this.d_value = o, this.$emit("update:modelValue", o)), this.$emit("value-change", o), (r = (n = this.formField).onChange) === null || r === void 0 || r.call(n, {
        originalEvent: t,
        value: o
      });
    }
  },
  computed: {
    $filled: function() {
      return ee(this.d_value);
    },
    $invalid: function() {
      var o, t, r, n;
      return (o = (t = this.invalid) !== null && t !== void 0 ? t : (r = this.$pcFormField) === null || r === void 0 || (r = r.$field) === null || r === void 0 ? void 0 : r.invalid) !== null && o !== void 0 ? o : (n = this.$pcForm) === null || n === void 0 || (n = n.states) === null || n === void 0 || (n = n[this.$formName]) === null || n === void 0 ? void 0 : n.invalid;
    },
    $formName: function() {
      var o;
      return this.name || ((o = this.$formControl) === null || o === void 0 ? void 0 : o.name);
    },
    $formControl: function() {
      var o;
      return this.formControl || ((o = this.$pcFormField) === null || o === void 0 ? void 0 : o.formControl);
    },
    $formDefaultValue: function() {
      var o, t, r, n;
      return (o = (t = this.d_value) !== null && t !== void 0 ? t : (r = this.$pcFormField) === null || r === void 0 ? void 0 : r.initialValue) !== null && o !== void 0 ? o : (n = this.$pcForm) === null || n === void 0 || (n = n.initialValues) === null || n === void 0 ? void 0 : n[this.$formName];
    },
    controlled: function() {
      return this.$inProps.hasOwnProperty("modelValue") || !this.$inProps.hasOwnProperty("modelValue") && !this.$inProps.hasOwnProperty("defaultValue");
    },
    // @deprecated use $filled instead
    filled: function() {
      return this.$filled;
    }
  }
}, jr = {
  name: "BaseInput",
  extends: Ju,
  props: {
    size: {
      type: String,
      default: null
    },
    fluid: {
      type: Boolean,
      default: null
    },
    variant: {
      type: String,
      default: null
    }
  },
  inject: {
    $parentInstance: {
      default: void 0
    },
    $pcFluid: {
      default: void 0
    }
  },
  computed: {
    $variant: function() {
      var o;
      return (o = this.variant) !== null && o !== void 0 ? o : this.$primevue.config.inputStyle || this.$primevue.config.inputVariant;
    },
    $fluid: function() {
      var o;
      return (o = this.fluid) !== null && o !== void 0 ? o : !!this.$pcFluid;
    },
    // @deprecated use $fluid instead
    hasFluid: function() {
      return this.$fluid;
    }
  }
}, e0 = function(o) {
  var t = o.dt;
  return `
.p-inputtext {
    font-family: inherit;
    font-feature-settings: inherit;
    font-size: 1rem;
    color: `.concat(t("inputtext.color"), `;
    background: `).concat(t("inputtext.background"), `;
    padding-block: `).concat(t("inputtext.padding.y"), `;
    padding-inline: `).concat(t("inputtext.padding.x"), `;
    border: 1px solid `).concat(t("inputtext.border.color"), `;
    transition: background `).concat(t("inputtext.transition.duration"), ", color ").concat(t("inputtext.transition.duration"), ", border-color ").concat(t("inputtext.transition.duration"), ", outline-color ").concat(t("inputtext.transition.duration"), ", box-shadow ").concat(t("inputtext.transition.duration"), `;
    appearance: none;
    border-radius: `).concat(t("inputtext.border.radius"), `;
    outline-color: transparent;
    box-shadow: `).concat(t("inputtext.shadow"), `;
}

.p-inputtext:enabled:hover {
    border-color: `).concat(t("inputtext.hover.border.color"), `;
}

.p-inputtext:enabled:focus {
    border-color: `).concat(t("inputtext.focus.border.color"), `;
    box-shadow: `).concat(t("inputtext.focus.ring.shadow"), `;
    outline: `).concat(t("inputtext.focus.ring.width"), " ").concat(t("inputtext.focus.ring.style"), " ").concat(t("inputtext.focus.ring.color"), `;
    outline-offset: `).concat(t("inputtext.focus.ring.offset"), `;
}

.p-inputtext.p-invalid {
    border-color: `).concat(t("inputtext.invalid.border.color"), `;
}

.p-inputtext.p-variant-filled {
    background: `).concat(t("inputtext.filled.background"), `;
}

.p-inputtext.p-variant-filled:enabled:hover {
    background: `).concat(t("inputtext.filled.hover.background"), `;
}

.p-inputtext.p-variant-filled:enabled:focus {
    background: `).concat(t("inputtext.filled.focus.background"), `;
}

.p-inputtext:disabled {
    opacity: 1;
    background: `).concat(t("inputtext.disabled.background"), `;
    color: `).concat(t("inputtext.disabled.color"), `;
}

.p-inputtext::placeholder {
    color: `).concat(t("inputtext.placeholder.color"), `;
}

.p-inputtext.p-invalid::placeholder {
    color: `).concat(t("inputtext.invalid.placeholder.color"), `;
}

.p-inputtext-sm {
    font-size: `).concat(t("inputtext.sm.font.size"), `;
    padding-block: `).concat(t("inputtext.sm.padding.y"), `;
    padding-inline: `).concat(t("inputtext.sm.padding.x"), `;
}

.p-inputtext-lg {
    font-size: `).concat(t("inputtext.lg.font.size"), `;
    padding-block: `).concat(t("inputtext.lg.padding.y"), `;
    padding-inline: `).concat(t("inputtext.lg.padding.x"), `;
}

.p-inputtext-fluid {
    width: 100%;
}
`);
}, o0 = {
  root: function(o) {
    var t = o.instance, r = o.props;
    return ["p-inputtext p-component", {
      "p-filled": t.$filled,
      "p-inputtext-sm p-inputfield-sm": r.size === "small",
      "p-inputtext-lg p-inputfield-lg": r.size === "large",
      "p-invalid": t.$invalid,
      "p-variant-filled": t.$variant === "filled",
      "p-inputtext-fluid": t.$fluid
    }];
  }
}, t0 = Q.extend({
  name: "inputtext",
  theme: e0,
  classes: o0
}), r0 = {
  name: "BaseInputText",
  extends: jr,
  style: t0,
  provide: function() {
    return {
      $pcInputText: this,
      $parentInstance: this
    };
  }
}, Ta = {
  name: "InputText",
  extends: r0,
  inheritAttrs: !1,
  methods: {
    onInput: function(o) {
      this.writeValue(o.target.value, o);
    }
  },
  computed: {
    attrs: function() {
      return y(this.ptmi("root", {
        context: {
          filled: this.$filled,
          disabled: this.disabled
        }
      }), this.formField);
    }
  }
}, n0 = ["value", "disabled", "aria-invalid"];
function i0(e, o, t, r, n, i) {
  return g(), $("input", y({
    type: "text",
    class: e.cx("root"),
    value: e.d_value,
    disabled: e.disabled,
    "aria-invalid": e.$invalid || void 0,
    onInput: o[0] || (o[0] = function() {
      return i.onInput && i.onInput.apply(i, arguments);
    })
  }, i.attrs), null, 16, n0);
}
Ta.render = i0;
var a0 = Vr(), Pa = {
  name: "Portal",
  props: {
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  data: function() {
    return {
      mounted: !1
    };
  },
  mounted: function() {
    this.mounted = zr();
  },
  computed: {
    inline: function() {
      return this.disabled || this.appendTo === "self";
    }
  }
};
function l0(e, o, t, r, n, i) {
  return i.inline ? B(e.$slots, "default", {
    key: 0
  }) : n.mounted ? (g(), M(Sl, {
    key: 1,
    to: t.appendTo
  }, [B(e.$slots, "default")], 8, ["to"])) : I("", !0);
}
Pa.render = l0;
var s0 = function(o) {
  var t = o.dt;
  return `
.p-datepicker {
    display: inline-flex;
    max-width: 100%;
}

.p-datepicker-input {
    flex: 1 1 auto;
    width: 1%;
}

.p-datepicker:has(.p-datepicker-dropdown) .p-datepicker-input {
    border-start-end-radius: 0;
    border-end-end-radius: 0;
}

.p-datepicker-dropdown {
    cursor: pointer;
    display: inline-flex;
    user-select: none;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
    width: `.concat(t("datepicker.dropdown.width"), `;
    border-start-end-radius: `).concat(t("datepicker.dropdown.border.radius"), `;
    border-end-end-radius: `).concat(t("datepicker.dropdown.border.radius"), `;
    background: `).concat(t("datepicker.dropdown.background"), `;
    border: 1px solid `).concat(t("datepicker.dropdown.border.color"), `;
    border-inline-start: 0 none;
    color: `).concat(t("datepicker.dropdown.color"), `;
    transition: background `).concat(t("datepicker.transition.duration"), ", color ").concat(t("datepicker.transition.duration"), ", border-color ").concat(t("datepicker.transition.duration"), ", outline-color ").concat(t("datepicker.transition.duration"), `;
    outline-color: transparent;
}

.p-datepicker-dropdown:not(:disabled):hover {
    background: `).concat(t("datepicker.dropdown.hover.background"), `;
    border-color: `).concat(t("datepicker.dropdown.hover.border.color"), `;
    color: `).concat(t("datepicker.dropdown.hover.color"), `;
}

.p-datepicker-dropdown:not(:disabled):active {
    background: `).concat(t("datepicker.dropdown.active.background"), `;
    border-color: `).concat(t("datepicker.dropdown.active.border.color"), `;
    color: `).concat(t("datepicker.dropdown.active.color"), `;
}

.p-datepicker-dropdown:focus-visible {
    box-shadow: `).concat(t("datepicker.dropdown.focus.ring.shadow"), `;
    outline: `).concat(t("datepicker.dropdown.focus.ring.width"), " ").concat(t("datepicker.dropdown.focus.ring.style"), " ").concat(t("datepicker.dropdown.focus.ring.color"), `;
    outline-offset: `).concat(t("datepicker.dropdown.focus.ring.offset"), `;
}

.p-datepicker:has(.p-datepicker-input-icon-container) {
    position: relative;
}

.p-datepicker:has(.p-datepicker-input-icon-container) .p-datepicker-input {
    padding-inline-end: calc((`).concat(t("form.field.padding.x"), " * 2) + ").concat(t("icon.size"), `);
}

.p-datepicker-input-icon-container {
    cursor: pointer;
    position: absolute;
    top: 50%;
    inset-inline-end: `).concat(t("form.field.padding.x"), `;
    margin-block-start: calc(-1 * (`).concat(t("icon.size"), ` / 2));
    color: `).concat(t("datepicker.input.icon.color"), `;
}

.p-datepicker-fluid {
    display: flex;
}

.p-datepicker-fluid .p-datepicker-input {
    width: 1%;
}

.p-datepicker .p-datepicker-panel {
    min-width: 100%;
}

.p-datepicker-panel {
    width: auto;
    padding: `).concat(t("datepicker.panel.padding"), `;
    background: `).concat(t("datepicker.panel.background"), `;
    color: `).concat(t("datepicker.panel.color"), `;
    border: 1px solid `).concat(t("datepicker.panel.border.color"), `;
    border-radius: `).concat(t("datepicker.panel.border.radius"), `;
    box-shadow: `).concat(t("datepicker.panel.shadow"), `;
}

.p-datepicker-panel-inline {
    display: inline-block;
    overflow-x: auto;
    box-shadow: none;
}

.p-datepicker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: `).concat(t("datepicker.header.padding"), `;
    background: `).concat(t("datepicker.header.background"), `;
    color: `).concat(t("datepicker.header.color"), `;
    border-block-end: 1px solid `).concat(t("datepicker.header.border.color"), `;
}

.p-datepicker-next-button:dir(rtl) {
    order: -1;
}

.p-datepicker-prev-button:dir(rtl) {
    order: 1;
}

.p-datepicker-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: `).concat(t("datepicker.title.gap"), `;
    font-weight: `).concat(t("datepicker.title.font.weight"), `;
}

.p-datepicker-select-year,
.p-datepicker-select-month {
    border: none;
    background: transparent;
    margin: 0;
    cursor: pointer;
    font-weight: inherit;
    transition: background `).concat(t("datepicker.transition.duration"), ", color ").concat(t("datepicker.transition.duration"), ", border-color ").concat(t("datepicker.transition.duration"), ", outline-color ").concat(t("datepicker.transition.duration"), ", box-shadow ").concat(t("datepicker.transition.duration"), `;
}

.p-datepicker-select-month {
    padding: `).concat(t("datepicker.select.month.padding"), `;
    color: `).concat(t("datepicker.select.month.color"), `;
    border-radius: `).concat(t("datepicker.select.month.border.radius"), `;
}

.p-datepicker-select-year {
    padding: `).concat(t("datepicker.select.year.padding"), `;
    color: `).concat(t("datepicker.select.year.color"), `;
    border-radius: `).concat(t("datepicker.select.year.border.radius"), `;
}

.p-datepicker-select-month:enabled:hover {
    background: `).concat(t("datepicker.select.month.hover.background"), `;
    color: `).concat(t("datepicker.select.month.hover.color"), `;
}

.p-datepicker-select-year:enabled:hover {
    background: `).concat(t("datepicker.select.year.hover.background"), `;
    color: `).concat(t("datepicker.select.year.hover.color"), `;
}

.p-datepicker-select-month:focus-visible,
.p-datepicker-select-year:focus-visible {
    box-shadow: `).concat(t("datepicker.date.focus.ring.shadow"), `;
    outline: `).concat(t("datepicker.date.focus.ring.width"), " ").concat(t("datepicker.date.focus.ring.style"), " ").concat(t("datepicker.date.focus.ring.color"), `;
    outline-offset: `).concat(t("datepicker.date.focus.ring.offset"), `;
}

.p-datepicker-calendar-container {
    display: flex;
}

.p-datepicker-calendar-container .p-datepicker-calendar {
    flex: 1 1 auto;
    border-inline-start: 1px solid `).concat(t("datepicker.group.border.color"), `;
    padding-inline-end: `).concat(t("datepicker.group.gap"), `;
    padding-inline-start: `).concat(t("datepicker.group.gap"), `;
}

.p-datepicker-calendar-container .p-datepicker-calendar:first-child {
    padding-inline-start: 0;
    border-inline-start: 0 none;
}

.p-datepicker-calendar-container .p-datepicker-calendar:last-child {
    padding-inline-end: 0;
}

.p-datepicker-day-view {
    width: 100%;
    border-collapse: collapse;
    font-size: 1rem;
    margin: `).concat(t("datepicker.day.view.margin"), `;
}

.p-datepicker-weekday-cell {
    padding: `).concat(t("datepicker.week.day.padding"), `;
}

.p-datepicker-weekday {
    font-weight: `).concat(t("datepicker.week.day.font.weight"), `;
    color: `).concat(t("datepicker.week.day.color"), `;
}

.p-datepicker-day-cell {
    padding: `).concat(t("datepicker.date.padding"), `;
}

.p-datepicker-day {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    width: `).concat(t("datepicker.date.width"), `;
    height: `).concat(t("datepicker.date.height"), `;
    border-radius: `).concat(t("datepicker.date.border.radius"), `;
    transition: background `).concat(t("datepicker.transition.duration"), ", color ").concat(t("datepicker.transition.duration"), ", border-color ").concat(t("datepicker.transition.duration"), ", box-shadow ").concat(t("datepicker.transition.duration"), ", outline-color ").concat(t("datepicker.transition.duration"), `;
    border: 1px solid transparent;
    outline-color: transparent;
    color: `).concat(t("datepicker.date.color"), `;
}

.p-datepicker-day:not(.p-datepicker-day-selected):not(.p-disabled):hover {
    background: `).concat(t("datepicker.date.hover.background"), `;
    color: `).concat(t("datepicker.date.hover.color"), `;
}

.p-datepicker-day:focus-visible {
    box-shadow: `).concat(t("datepicker.date.focus.ring.shadow"), `;
    outline: `).concat(t("datepicker.date.focus.ring.width"), " ").concat(t("datepicker.date.focus.ring.style"), " ").concat(t("datepicker.date.focus.ring.color"), `;
    outline-offset: `).concat(t("datepicker.date.focus.ring.offset"), `;
}

.p-datepicker-day-selected {
    background: `).concat(t("datepicker.date.selected.background"), `;
    color: `).concat(t("datepicker.date.selected.color"), `;
}

.p-datepicker-day-selected-range {
    background: `).concat(t("datepicker.date.range.selected.background"), `;
    color: `).concat(t("datepicker.date.range.selected.color"), `;
}

.p-datepicker-today > .p-datepicker-day {
    background: `).concat(t("datepicker.today.background"), `;
    color: `).concat(t("datepicker.today.color"), `;
}

.p-datepicker-today > .p-datepicker-day-selected {
    background: `).concat(t("datepicker.date.selected.background"), `;
    color: `).concat(t("datepicker.date.selected.color"), `;
}

.p-datepicker-today > .p-datepicker-day-selected-range {
    background: `).concat(t("datepicker.date.range.selected.background"), `;
    color: `).concat(t("datepicker.date.range.selected.color"), `;
}

.p-datepicker-weeknumber {
    text-align: center;
}

.p-datepicker-month-view {
    margin: `).concat(t("datepicker.month.view.margin"), `;
}

.p-datepicker-month {
    width: 33.3%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    padding: `).concat(t("datepicker.month.padding"), `;
    transition: background `).concat(t("datepicker.transition.duration"), ", color ").concat(t("datepicker.transition.duration"), ", border-color ").concat(t("datepicker.transition.duration"), ", box-shadow ").concat(t("datepicker.transition.duration"), ", outline-color ").concat(t("datepicker.transition.duration"), `;
    border-radius: `).concat(t("datepicker.month.border.radius"), `;
    outline-color: transparent;
    color: `).concat(t("datepicker.date.color"), `;
}

.p-datepicker-month:not(.p-disabled):not(.p-datepicker-month-selected):hover {
    color: `).concat(t("datepicker.date.hover.color"), `;
    background: `).concat(t("datepicker.date.hover.background"), `;
}

.p-datepicker-month-selected {
    color: `).concat(t("datepicker.date.selected.color"), `;
    background: `).concat(t("datepicker.date.selected.background"), `;
}

.p-datepicker-month:not(.p-disabled):focus-visible {
    box-shadow: `).concat(t("datepicker.date.focus.ring.shadow"), `;
    outline: `).concat(t("datepicker.date.focus.ring.width"), " ").concat(t("datepicker.date.focus.ring.style"), " ").concat(t("datepicker.date.focus.ring.color"), `;
    outline-offset: `).concat(t("datepicker.date.focus.ring.offset"), `;
}

.p-datepicker-year-view {
    margin: `).concat(t("datepicker.year.view.margin"), `;
}

.p-datepicker-year {
    width: 50%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    padding: `).concat(t("datepicker.year.padding"), `;
    transition: background `).concat(t("datepicker.transition.duration"), ", color ").concat(t("datepicker.transition.duration"), ", border-color ").concat(t("datepicker.transition.duration"), ", box-shadow ").concat(t("datepicker.transition.duration"), ", outline-color ").concat(t("datepicker.transition.duration"), `;
    border-radius: `).concat(t("datepicker.year.border.radius"), `;
    outline-color: transparent;
    color: `).concat(t("datepicker.date.color"), `;
}

.p-datepicker-year:not(.p-disabled):not(.p-datepicker-year-selected):hover {
    color: `).concat(t("datepicker.date.hover.color"), `;
    background: `).concat(t("datepicker.date.hover.background"), `;
}

.p-datepicker-year-selected {
    color: `).concat(t("datepicker.date.selected.color"), `;
    background: `).concat(t("datepicker.date.selected.background"), `;
}

.p-datepicker-year:not(.p-disabled):focus-visible {
    box-shadow: `).concat(t("datepicker.date.focus.ring.shadow"), `;
    outline: `).concat(t("datepicker.date.focus.ring.width"), " ").concat(t("datepicker.date.focus.ring.style"), " ").concat(t("datepicker.date.focus.ring.color"), `;
    outline-offset: `).concat(t("datepicker.date.focus.ring.offset"), `;
}

.p-datepicker-buttonbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: `).concat(t("datepicker.buttonbar.padding"), `;
    border-block-start: 1px solid `).concat(t("datepicker.buttonbar.border.color"), `;
}

.p-datepicker-buttonbar .p-button {
    width: auto;
}

.p-datepicker-time-picker {
    display: flex;
    justify-content: center;
    align-items: center;
    border-block-start: 1px solid `).concat(t("datepicker.time.picker.border.color"), `;
    padding: 0;
    gap: `).concat(t("datepicker.time.picker.gap"), `;
}

.p-datepicker-calendar-container + .p-datepicker-time-picker {
    padding: `).concat(t("datepicker.time.picker.padding"), `;
}

.p-datepicker-time-picker > div {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: `).concat(t("datepicker.time.picker.button.gap"), `;
}

.p-datepicker-time-picker span {
    font-size: 1rem;
}

.p-datepicker-timeonly .p-datepicker-time-picker {
    border-block-start: 0 none;
}

.p-datepicker:has(.p-inputtext-sm) .p-datepicker-dropdown {
    width: `).concat(t("datepicker.dropdown.sm.width"), `;
}

.p-datepicker:has(.p-inputtext-sm) .p-datepicker-dropdown .p-icon,
.p-datepicker:has(.p-inputtext-sm) .p-datepicker-input-icon {
    font-size: `).concat(t("form.field.sm.font.size"), `;
    width: `).concat(t("form.field.sm.font.size"), `;
    height: `).concat(t("form.field.sm.font.size"), `;
}

.p-datepicker:has(.p-inputtext-lg) .p-datepicker-dropdown {
    width: `).concat(t("datepicker.dropdown.lg.width"), `;
}

.p-datepicker:has(.p-inputtext-lg) .p-datepicker-dropdown .p-icon,
.p-datepicker:has(.p-inputtext-lg) .p-datepicker-input-icon {
    font-size: `).concat(t("form.field.lg.font.size"), `;
    width: `).concat(t("form.field.lg.font.size"), `;
    height: `).concat(t("form.field.lg.font.size"), `;
}
`);
}, c0 = {
  root: function(o) {
    var t = o.props;
    return {
      position: t.appendTo === "self" ? "relative" : void 0
    };
  }
}, d0 = {
  root: function(o) {
    var t = o.instance, r = o.state;
    return ["p-datepicker p-component p-inputwrapper", {
      "p-invalid": t.$invalid,
      "p-inputwrapper-filled": t.$filled,
      "p-inputwrapper-focus": r.focused || r.overlayVisible,
      "p-focus": r.focused || r.overlayVisible,
      "p-datepicker-fluid": t.$fluid
    }];
  },
  pcInputText: "p-datepicker-input",
  dropdown: "p-datepicker-dropdown",
  inputIconContainer: "p-datepicker-input-icon-container",
  inputIcon: "p-datepicker-input-icon",
  panel: function(o) {
    var t = o.props;
    return ["p-datepicker-panel p-component", {
      "p-datepicker-panel-inline": t.inline,
      "p-disabled": t.disabled,
      "p-datepicker-timeonly": t.timeOnly
    }];
  },
  calendarContainer: "p-datepicker-calendar-container",
  calendar: "p-datepicker-calendar",
  header: "p-datepicker-header",
  pcPrevButton: "p-datepicker-prev-button",
  title: "p-datepicker-title",
  selectMonth: "p-datepicker-select-month",
  selectYear: "p-datepicker-select-year",
  decade: "p-datepicker-decade",
  pcNextButton: "p-datepicker-next-button",
  dayView: "p-datepicker-day-view",
  weekHeader: "p-datepicker-weekheader p-disabled",
  weekNumber: "p-datepicker-weeknumber",
  weekLabelContainer: "p-datepicker-weeklabel-container p-disabled",
  weekDayCell: "p-datepicker-weekday-cell",
  weekDay: "p-datepicker-weekday",
  dayCell: function(o) {
    var t = o.date;
    return ["p-datepicker-day-cell", {
      "p-datepicker-other-month": t.otherMonth,
      "p-datepicker-today": t.today
    }];
  },
  day: function(o) {
    var t = o.instance, r = o.props, n = o.date, i = "";
    return t.isRangeSelection() && t.isSelected(n) && n.selectable && (i = t.isDateEquals(r.modelValue[0], n) || t.isDateEquals(r.modelValue[1], n) ? "p-datepicker-day-selected" : "p-datepicker-day-selected-range"), ["p-datepicker-day", {
      "p-datepicker-day-selected": !t.isRangeSelection() && t.isSelected(n) && n.selectable,
      "p-disabled": r.disabled || !n.selectable
    }, i];
  },
  monthView: "p-datepicker-month-view",
  month: function(o) {
    var t = o.instance, r = o.props, n = o.month, i = o.index;
    return ["p-datepicker-month", {
      "p-datepicker-month-selected": t.isMonthSelected(i),
      "p-disabled": r.disabled || !n.selectable
    }];
  },
  yearView: "p-datepicker-year-view",
  year: function(o) {
    var t = o.instance, r = o.props, n = o.year;
    return ["p-datepicker-year", {
      "p-datepicker-year-selected": t.isYearSelected(n.value),
      "p-disabled": r.disabled || !n.selectable
    }];
  },
  timePicker: "p-datepicker-time-picker",
  hourPicker: "p-datepicker-hour-picker",
  pcIncrementButton: "p-datepicker-increment-button",
  pcDecrementButton: "p-datepicker-decrement-button",
  separator: "p-datepicker-separator",
  minutePicker: "p-datepicker-minute-picker",
  secondPicker: "p-datepicker-second-picker",
  ampmPicker: "p-datepicker-ampm-picker",
  buttonbar: "p-datepicker-buttonbar",
  pcTodayButton: "p-datepicker-today-button",
  pcClearButton: "p-datepicker-clear-button"
}, u0 = Q.extend({
  name: "datepicker",
  theme: s0,
  classes: d0,
  inlineStyles: c0
}), p0 = {
  name: "BaseDatePicker",
  extends: jr,
  props: {
    selectionMode: {
      type: String,
      default: "single"
    },
    dateFormat: {
      type: String,
      default: null
    },
    inline: {
      type: Boolean,
      default: !1
    },
    showOtherMonths: {
      type: Boolean,
      default: !0
    },
    selectOtherMonths: {
      type: Boolean,
      default: !1
    },
    showIcon: {
      type: Boolean,
      default: !1
    },
    iconDisplay: {
      type: String,
      default: "button"
    },
    icon: {
      type: String,
      default: void 0
    },
    prevIcon: {
      type: String,
      default: void 0
    },
    nextIcon: {
      type: String,
      default: void 0
    },
    incrementIcon: {
      type: String,
      default: void 0
    },
    decrementIcon: {
      type: String,
      default: void 0
    },
    numberOfMonths: {
      type: Number,
      default: 1
    },
    responsiveOptions: Array,
    breakpoint: {
      type: String,
      default: "769px"
    },
    view: {
      type: String,
      default: "date"
    },
    minDate: {
      type: Date,
      value: null
    },
    maxDate: {
      type: Date,
      value: null
    },
    disabledDates: {
      type: Array,
      value: null
    },
    disabledDays: {
      type: Array,
      value: null
    },
    maxDateCount: {
      type: Number,
      value: null
    },
    showOnFocus: {
      type: Boolean,
      default: !0
    },
    autoZIndex: {
      type: Boolean,
      default: !0
    },
    baseZIndex: {
      type: Number,
      default: 0
    },
    showButtonBar: {
      type: Boolean,
      default: !1
    },
    shortYearCutoff: {
      type: String,
      default: "+10"
    },
    showTime: {
      type: Boolean,
      default: !1
    },
    timeOnly: {
      type: Boolean,
      default: !1
    },
    hourFormat: {
      type: String,
      default: "24"
    },
    stepHour: {
      type: Number,
      default: 1
    },
    stepMinute: {
      type: Number,
      default: 1
    },
    stepSecond: {
      type: Number,
      default: 1
    },
    showSeconds: {
      type: Boolean,
      default: !1
    },
    hideOnDateTimeSelect: {
      type: Boolean,
      default: !1
    },
    hideOnRangeSelection: {
      type: Boolean,
      default: !1
    },
    timeSeparator: {
      type: String,
      default: ":"
    },
    showWeek: {
      type: Boolean,
      default: !1
    },
    manualInput: {
      type: Boolean,
      default: !0
    },
    appendTo: {
      type: [String, Object],
      default: "body"
    },
    readonly: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    panelClass: {
      type: [String, Object],
      default: null
    },
    panelStyle: {
      type: Object,
      default: null
    },
    todayButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          size: "small"
        };
      }
    },
    clearButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          size: "small"
        };
      }
    },
    navigatorButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          rounded: !0
        };
      }
    },
    timepickerButtonProps: {
      type: Object,
      default: function() {
        return {
          severity: "secondary",
          text: !0,
          rounded: !0
        };
      }
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: u0,
  provide: function() {
    return {
      $pcDatePicker: this,
      $parentInstance: this
    };
  }
};
function pr(e) {
  "@babel/helpers - typeof";
  return pr = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, pr(e);
}
function Jt(e) {
  return g0(e) || h0(e) || Da(e) || f0();
}
function f0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h0(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function g0(e) {
  if (Array.isArray(e)) return fr(e);
}
function er(e, o) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!t) {
    if (Array.isArray(e) || (t = Da(e)) || o) {
      t && (e = t);
      var r = 0, n = function() {
      };
      return { s: n, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(d) {
        throw d;
      }, f: n };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, l = !1;
  return { s: function() {
    t = t.call(e);
  }, n: function() {
    var d = t.next();
    return a = d.done, d;
  }, e: function(d) {
    l = !0, i = d;
  }, f: function() {
    try {
      a || t.return == null || t.return();
    } finally {
      if (l) throw i;
    }
  } };
}
function Da(e, o) {
  if (e) {
    if (typeof e == "string") return fr(e, o);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? fr(e, o) : void 0;
  }
}
function fr(e, o) {
  (o == null || o > e.length) && (o = e.length);
  for (var t = 0, r = Array(o); t < o; t++) r[t] = e[t];
  return r;
}
var Oa = {
  name: "DatePicker",
  extends: p0,
  inheritAttrs: !1,
  emits: ["show", "hide", "input", "month-change", "year-change", "date-select", "today-click", "clear-click", "focus", "blur", "keydown"],
  inject: {
    $pcFluid: {
      default: null
    }
  },
  navigationState: null,
  timePickerChange: !1,
  scrollHandler: null,
  outsideClickListener: null,
  resizeListener: null,
  matchMediaListener: null,
  overlay: null,
  input: null,
  previousButton: null,
  nextButton: null,
  timePickerTimer: null,
  preventFocus: !1,
  typeUpdate: !1,
  data: function() {
    return {
      d_id: this.id,
      currentMonth: null,
      currentYear: null,
      currentHour: null,
      currentMinute: null,
      currentSecond: null,
      pm: null,
      focused: !1,
      overlayVisible: !1,
      currentView: this.view,
      query: null,
      queryMatches: !1
    };
  },
  watch: {
    id: function(o) {
      this.d_id = o || In();
    },
    modelValue: function(o) {
      this.updateCurrentMetaData(), !this.typeUpdate && !this.inline && this.input && (this.input.value = this.inputFieldValue), this.typeUpdate = !1;
    },
    showTime: function() {
      this.updateCurrentMetaData();
    },
    minDate: function() {
      this.updateCurrentMetaData();
    },
    maxDate: function() {
      this.updateCurrentMetaData();
    },
    months: function() {
      this.overlay && (this.focused || (this.inline && (this.preventFocus = !0), setTimeout(this.updateFocus, 0)));
    },
    numberOfMonths: function() {
      this.destroyResponsiveStyleElement(), this.createResponsiveStyle();
    },
    responsiveOptions: function() {
      this.destroyResponsiveStyleElement(), this.createResponsiveStyle();
    },
    currentView: function() {
      var o = this;
      Promise.resolve(null).then(function() {
        return o.alignOverlay();
      });
    },
    view: function(o) {
      this.currentView = o;
    }
  },
  created: function() {
    this.updateCurrentMetaData();
  },
  mounted: function() {
    this.d_id = this.d_id || In(), this.createResponsiveStyle(), this.bindMatchMediaListener(), this.inline ? this.disabled || (this.preventFocus = !0, this.initFocusableCell()) : this.input.value = this.inputFieldValue;
  },
  updated: function() {
    this.overlay && (this.preventFocus = !0, setTimeout(this.updateFocus, 0)), this.input && this.selectionStart != null && this.selectionEnd != null && (this.input.selectionStart = this.selectionStart, this.input.selectionEnd = this.selectionEnd, this.selectionStart = null, this.selectionEnd = null);
  },
  beforeUnmount: function() {
    this.timePickerTimer && clearTimeout(this.timePickerTimer), this.destroyResponsiveStyleElement(), this.unbindOutsideClickListener(), this.unbindResizeListener(), this.unbindMatchMediaListener(), this.scrollHandler && (this.scrollHandler.destroy(), this.scrollHandler = null), this.overlay && this.autoZIndex && qt.clear(this.overlay), this.overlay = null;
  },
  methods: {
    isComparable: function() {
      return this.d_value != null && typeof this.d_value != "string";
    },
    isSelected: function(o) {
      if (!this.isComparable())
        return !1;
      if (this.d_value) {
        if (this.isSingleSelection())
          return this.isDateEquals(this.d_value, o);
        if (this.isMultipleSelection()) {
          var t = !1, r = er(this.d_value), n;
          try {
            for (r.s(); !(n = r.n()).done; ) {
              var i = n.value;
              if (t = this.isDateEquals(i, o), t)
                break;
            }
          } catch (a) {
            r.e(a);
          } finally {
            r.f();
          }
          return t;
        } else if (this.isRangeSelection())
          return this.d_value[1] ? this.isDateEquals(this.d_value[0], o) || this.isDateEquals(this.d_value[1], o) || this.isDateBetween(this.d_value[0], this.d_value[1], o) : this.isDateEquals(this.d_value[0], o);
      }
      return !1;
    },
    isMonthSelected: function(o) {
      var t = this;
      if (!this.isComparable()) return !1;
      if (this.isMultipleSelection())
        return this.d_value.some(function(s) {
          return s.getMonth() === o && s.getFullYear() === t.currentYear;
        });
      if (this.isRangeSelection())
        if (this.d_value[1]) {
          var i = new Date(this.currentYear, o, 1), a = new Date(this.d_value[0].getFullYear(), this.d_value[0].getMonth(), 1), l = new Date(this.d_value[1].getFullYear(), this.d_value[1].getMonth(), 1);
          return i >= a && i <= l;
        } else {
          var r, n;
          return ((r = this.d_value[0]) === null || r === void 0 ? void 0 : r.getFullYear()) === this.currentYear && ((n = this.d_value[0]) === null || n === void 0 ? void 0 : n.getMonth()) === o;
        }
      else
        return this.d_value.getMonth() === o && this.d_value.getFullYear() === this.currentYear;
    },
    isYearSelected: function(o) {
      if (!this.isComparable()) return !1;
      if (this.isMultipleSelection())
        return this.d_value.some(function(n) {
          return n.getFullYear() === o;
        });
      if (this.isRangeSelection()) {
        var t = this.d_value[0] ? this.d_value[0].getFullYear() : null, r = this.d_value[1] ? this.d_value[1].getFullYear() : null;
        return t === o || r === o || t < o && r > o;
      } else
        return this.d_value.getFullYear() === o;
    },
    isDateEquals: function(o, t) {
      return o ? o.getDate() === t.day && o.getMonth() === t.month && o.getFullYear() === t.year : !1;
    },
    isDateBetween: function(o, t, r) {
      var n = !1;
      if (o && t) {
        var i = new Date(r.year, r.month, r.day);
        return o.getTime() <= i.getTime() && t.getTime() >= i.getTime();
      }
      return n;
    },
    getFirstDayOfMonthIndex: function(o, t) {
      var r = /* @__PURE__ */ new Date();
      r.setDate(1), r.setMonth(o), r.setFullYear(t);
      var n = r.getDay() + this.sundayIndex;
      return n >= 7 ? n - 7 : n;
    },
    getDaysCountInMonth: function(o, t) {
      return 32 - this.daylightSavingAdjust(new Date(t, o, 32)).getDate();
    },
    getDaysCountInPrevMonth: function(o, t) {
      var r = this.getPreviousMonthAndYear(o, t);
      return this.getDaysCountInMonth(r.month, r.year);
    },
    getPreviousMonthAndYear: function(o, t) {
      var r, n;
      return o === 0 ? (r = 11, n = t - 1) : (r = o - 1, n = t), {
        month: r,
        year: n
      };
    },
    getNextMonthAndYear: function(o, t) {
      var r, n;
      return o === 11 ? (r = 0, n = t + 1) : (r = o + 1, n = t), {
        month: r,
        year: n
      };
    },
    daylightSavingAdjust: function(o) {
      return o ? (o.setHours(o.getHours() > 12 ? o.getHours() + 2 : 0), o) : null;
    },
    isToday: function(o, t, r, n) {
      return o.getDate() === t && o.getMonth() === r && o.getFullYear() === n;
    },
    isSelectable: function(o, t, r, n) {
      var i = !0, a = !0, l = !0, s = !0;
      return n && !this.selectOtherMonths ? !1 : (this.minDate && (this.minDate.getFullYear() > r || this.minDate.getFullYear() === r && (this.minDate.getMonth() > t || this.minDate.getMonth() === t && this.minDate.getDate() > o)) && (i = !1), this.maxDate && (this.maxDate.getFullYear() < r || this.maxDate.getFullYear() === r && (this.maxDate.getMonth() < t || this.maxDate.getMonth() === t && this.maxDate.getDate() < o)) && (a = !1), this.disabledDates && (l = !this.isDateDisabled(o, t, r)), this.disabledDays && (s = !this.isDayDisabled(o, t, r)), i && a && l && s);
    },
    onOverlayEnter: function(o) {
      var t = this.inline ? void 0 : {
        position: "absolute",
        top: "0",
        left: "0"
      };
      dd(o, t), this.autoZIndex && qt.set("overlay", o, this.baseZIndex || this.$primevue.config.zIndex.overlay), this.alignOverlay(), this.$emit("show");
    },
    onOverlayEnterComplete: function() {
      this.bindOutsideClickListener(), this.bindScrollListener(), this.bindResizeListener();
    },
    onOverlayAfterLeave: function(o) {
      this.autoZIndex && qt.clear(o);
    },
    onOverlayLeave: function() {
      this.currentView = this.view, this.unbindOutsideClickListener(), this.unbindScrollListener(), this.unbindResizeListener(), this.$emit("hide"), this.overlay = null;
    },
    onPrevButtonClick: function(o) {
      this.navigationState = {
        backward: !0,
        button: !0
      }, this.navBackward(o);
    },
    onNextButtonClick: function(o) {
      this.navigationState = {
        backward: !1,
        button: !0
      }, this.navForward(o);
    },
    navBackward: function(o) {
      o.preventDefault(), this.isEnabled() && (this.currentView === "month" ? (this.decrementYear(), this.$emit("year-change", {
        month: this.currentMonth,
        year: this.currentYear
      })) : this.currentView === "year" ? this.decrementDecade() : o.shiftKey ? this.decrementYear() : (this.currentMonth === 0 ? (this.currentMonth = 11, this.decrementYear()) : this.currentMonth--, this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })));
    },
    navForward: function(o) {
      o.preventDefault(), this.isEnabled() && (this.currentView === "month" ? (this.incrementYear(), this.$emit("year-change", {
        month: this.currentMonth,
        year: this.currentYear
      })) : this.currentView === "year" ? this.incrementDecade() : o.shiftKey ? this.incrementYear() : (this.currentMonth === 11 ? (this.currentMonth = 0, this.incrementYear()) : this.currentMonth++, this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })));
    },
    decrementYear: function() {
      this.currentYear--;
    },
    decrementDecade: function() {
      this.currentYear = this.currentYear - 10;
    },
    incrementYear: function() {
      this.currentYear++;
    },
    incrementDecade: function() {
      this.currentYear = this.currentYear + 10;
    },
    switchToMonthView: function(o) {
      this.currentView = "month", setTimeout(this.updateFocus, 0), o.preventDefault();
    },
    switchToYearView: function(o) {
      this.currentView = "year", setTimeout(this.updateFocus, 0), o.preventDefault();
    },
    isEnabled: function() {
      return !this.disabled && !this.readonly;
    },
    updateCurrentTimeMeta: function(o) {
      var t = o.getHours();
      this.hourFormat === "12" && (this.pm = t > 11, t >= 12 && (t = t == 12 ? 12 : t - 12)), this.currentHour = Math.floor(t / this.stepHour) * this.stepHour, this.currentMinute = Math.floor(o.getMinutes() / this.stepMinute) * this.stepMinute, this.currentSecond = Math.floor(o.getSeconds() / this.stepSecond) * this.stepSecond;
    },
    bindOutsideClickListener: function() {
      var o = this;
      this.outsideClickListener || (this.outsideClickListener = function(t) {
        o.overlayVisible && o.isOutsideClicked(t) && (o.overlayVisible = !1);
      }, document.addEventListener("mousedown", this.outsideClickListener));
    },
    unbindOutsideClickListener: function() {
      this.outsideClickListener && (document.removeEventListener("mousedown", this.outsideClickListener), this.outsideClickListener = null);
    },
    bindScrollListener: function() {
      var o = this;
      this.scrollHandler || (this.scrollHandler = new Rd(this.$refs.container, function() {
        o.overlayVisible && (o.overlayVisible = !1);
      })), this.scrollHandler.bindScrollListener();
    },
    unbindScrollListener: function() {
      this.scrollHandler && this.scrollHandler.unbindScrollListener();
    },
    bindResizeListener: function() {
      var o = this;
      this.resizeListener || (this.resizeListener = function() {
        o.overlayVisible && !bd() && (o.overlayVisible = !1);
      }, window.addEventListener("resize", this.resizeListener));
    },
    unbindResizeListener: function() {
      this.resizeListener && (window.removeEventListener("resize", this.resizeListener), this.resizeListener = null);
    },
    bindMatchMediaListener: function() {
      var o = this;
      if (!this.matchMediaListener) {
        var t = matchMedia("(max-width: ".concat(this.breakpoint, ")"));
        this.query = t, this.queryMatches = t.matches, this.matchMediaListener = function() {
          o.queryMatches = t.matches, o.mobileActive = !1;
        }, this.query.addEventListener("change", this.matchMediaListener);
      }
    },
    unbindMatchMediaListener: function() {
      this.matchMediaListener && (this.query.removeEventListener("change", this.matchMediaListener), this.matchMediaListener = null);
    },
    isOutsideClicked: function(o) {
      return !(this.$el.isSameNode(o.target) || this.isNavIconClicked(o) || this.$el.contains(o.target) || this.overlay && this.overlay.contains(o.target));
    },
    isNavIconClicked: function(o) {
      return this.previousButton && (this.previousButton.isSameNode(o.target) || this.previousButton.contains(o.target)) || this.nextButton && (this.nextButton.isSameNode(o.target) || this.nextButton.contains(o.target));
    },
    alignOverlay: function() {
      this.overlay && (this.appendTo === "self" || this.inline ? ud(this.overlay, this.$el) : (this.view === "date" ? (this.overlay.style.width = yt(this.overlay) + "px", this.overlay.style.minWidth = yt(this.$el) + "px") : this.overlay.style.width = yt(this.$el) + "px", cd(this.overlay, this.$el)));
    },
    onButtonClick: function() {
      this.isEnabled() && (this.overlayVisible ? this.overlayVisible = !1 : (this.input.focus(), this.overlayVisible = !0));
    },
    isDateDisabled: function(o, t, r) {
      if (this.disabledDates) {
        var n = er(this.disabledDates), i;
        try {
          for (n.s(); !(i = n.n()).done; ) {
            var a = i.value;
            if (a.getFullYear() === r && a.getMonth() === t && a.getDate() === o)
              return !0;
          }
        } catch (l) {
          n.e(l);
        } finally {
          n.f();
        }
      }
      return !1;
    },
    isDayDisabled: function(o, t, r) {
      if (this.disabledDays) {
        var n = new Date(r, t, o), i = n.getDay();
        return this.disabledDays.indexOf(i) !== -1;
      }
      return !1;
    },
    onMonthDropdownChange: function(o) {
      this.currentMonth = parseInt(o), this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      });
    },
    onYearDropdownChange: function(o) {
      this.currentYear = parseInt(o), this.$emit("year-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      });
    },
    onDateSelect: function(o, t) {
      var r = this;
      if (!(this.disabled || !t.selectable)) {
        if (qe(this.overlay, 'table td span:not([data-p-disabled="true"])').forEach(function(i) {
          return i.tabIndex = -1;
        }), o && o.currentTarget.focus(), this.isMultipleSelection() && this.isSelected(t)) {
          var n = this.d_value.filter(function(i) {
            return !r.isDateEquals(i, t);
          });
          this.updateModel(n);
        } else
          this.shouldSelectDate(t) && (t.otherMonth ? (this.currentMonth = t.month, this.currentYear = t.year, this.selectDate(t)) : this.selectDate(t));
        this.isSingleSelection() && (!this.showTime || this.hideOnDateTimeSelect) && (this.input && this.input.focus(), setTimeout(function() {
          r.overlayVisible = !1;
        }, 150));
      }
    },
    selectDate: function(o) {
      var t = this, r = new Date(o.year, o.month, o.day);
      this.showTime && (this.hourFormat === "12" && this.currentHour !== 12 && this.pm ? r.setHours(this.currentHour + 12) : r.setHours(this.currentHour), r.setMinutes(this.currentMinute), r.setSeconds(this.currentSecond)), this.minDate && this.minDate > r && (r = this.minDate, this.currentHour = r.getHours(), this.currentMinute = r.getMinutes(), this.currentSecond = r.getSeconds()), this.maxDate && this.maxDate < r && (r = this.maxDate, this.currentHour = r.getHours(), this.currentMinute = r.getMinutes(), this.currentSecond = r.getSeconds());
      var n = null;
      if (this.isSingleSelection())
        n = r;
      else if (this.isMultipleSelection())
        n = this.d_value ? [].concat(Jt(this.d_value), [r]) : [r];
      else if (this.isRangeSelection())
        if (this.d_value && this.d_value.length) {
          var i = this.d_value[0], a = this.d_value[1];
          !a && r.getTime() >= i.getTime() ? a = r : (i = r, a = null), n = [i, a];
        } else
          n = [r, null];
      n !== null && this.updateModel(n), this.isRangeSelection() && this.hideOnRangeSelection && n[1] !== null && setTimeout(function() {
        t.overlayVisible = !1;
      }, 150), this.$emit("date-select", r);
    },
    updateModel: function(o) {
      this.writeValue(o);
    },
    shouldSelectDate: function() {
      return this.isMultipleSelection() && this.maxDateCount != null ? this.maxDateCount > (this.d_value ? this.d_value.length : 0) : !0;
    },
    isSingleSelection: function() {
      return this.selectionMode === "single";
    },
    isRangeSelection: function() {
      return this.selectionMode === "range";
    },
    isMultipleSelection: function() {
      return this.selectionMode === "multiple";
    },
    formatValue: function(o) {
      if (typeof o == "string")
        return o;
      var t = "";
      if (o)
        try {
          if (this.isSingleSelection())
            t = this.formatDateTime(o);
          else if (this.isMultipleSelection())
            for (var r = 0; r < o.length; r++) {
              var n = this.formatDateTime(o[r]);
              t += n, r !== o.length - 1 && (t += ", ");
            }
          else if (this.isRangeSelection() && o && o.length) {
            var i = o[0], a = o[1];
            t = this.formatDateTime(i), a && (t += " - " + this.formatDateTime(a));
          }
        } catch {
          t = o;
        }
      return t;
    },
    formatDateTime: function(o) {
      var t = null;
      return o && (this.timeOnly ? t = this.formatTime(o) : (t = this.formatDate(o, this.datePattern), this.showTime && (t += " " + this.formatTime(o)))), t;
    },
    formatDate: function(o, t) {
      if (!o)
        return "";
      var r, n = function(c) {
        var f = r + 1 < t.length && t.charAt(r + 1) === c;
        return f && r++, f;
      }, i = function(c, f, u) {
        var p = "" + f;
        if (n(c))
          for (; p.length < u; )
            p = "0" + p;
        return p;
      }, a = function(c, f, u, p) {
        return n(c) ? p[f] : u[f];
      }, l = "", s = !1;
      if (o)
        for (r = 0; r < t.length; r++)
          if (s)
            t.charAt(r) === "'" && !n("'") ? s = !1 : l += t.charAt(r);
          else
            switch (t.charAt(r)) {
              case "d":
                l += i("d", o.getDate(), 2);
                break;
              case "D":
                l += a("D", o.getDay(), this.$primevue.config.locale.dayNamesShort, this.$primevue.config.locale.dayNames);
                break;
              case "o":
                l += i("o", Math.round((new Date(o.getFullYear(), o.getMonth(), o.getDate()).getTime() - new Date(o.getFullYear(), 0, 0).getTime()) / 864e5), 3);
                break;
              case "m":
                l += i("m", o.getMonth() + 1, 2);
                break;
              case "M":
                l += a("M", o.getMonth(), this.$primevue.config.locale.monthNamesShort, this.$primevue.config.locale.monthNames);
                break;
              case "y":
                l += n("y") ? o.getFullYear() : (o.getFullYear() % 100 < 10 ? "0" : "") + o.getFullYear() % 100;
                break;
              case "@":
                l += o.getTime();
                break;
              case "!":
                l += o.getTime() * 1e4 + this.ticksTo1970;
                break;
              case "'":
                n("'") ? l += "'" : s = !0;
                break;
              default:
                l += t.charAt(r);
            }
      return l;
    },
    formatTime: function(o) {
      if (!o)
        return "";
      var t = "", r = o.getHours(), n = o.getMinutes(), i = o.getSeconds();
      return this.hourFormat === "12" && r > 11 && r !== 12 && (r -= 12), this.hourFormat === "12" ? t += r === 0 ? 12 : r < 10 ? "0" + r : r : t += r < 10 ? "0" + r : r, t += ":", t += n < 10 ? "0" + n : n, this.showSeconds && (t += ":", t += i < 10 ? "0" + i : i), this.hourFormat === "12" && (t += o.getHours() > 11 ? " ".concat(this.$primevue.config.locale.pm) : " ".concat(this.$primevue.config.locale.am)), t;
    },
    onTodayButtonClick: function(o) {
      var t = /* @__PURE__ */ new Date(), r = {
        day: t.getDate(),
        month: t.getMonth(),
        year: t.getFullYear(),
        otherMonth: t.getMonth() !== this.currentMonth || t.getFullYear() !== this.currentYear,
        today: !0,
        selectable: !0
      };
      this.onDateSelect(null, r), this.$emit("today-click", t), o.preventDefault();
    },
    onClearButtonClick: function(o) {
      this.updateModel(null), this.overlayVisible = !1, this.$emit("clear-click", o), o.preventDefault();
    },
    onTimePickerElementMouseDown: function(o, t, r) {
      this.isEnabled() && (this.repeat(o, null, t, r), o.preventDefault());
    },
    onTimePickerElementMouseUp: function(o) {
      this.isEnabled() && (this.clearTimePickerTimer(), this.updateModelTime(), o.preventDefault());
    },
    onTimePickerElementMouseLeave: function() {
      this.clearTimePickerTimer();
    },
    repeat: function(o, t, r, n) {
      var i = this, a = t || 500;
      switch (this.clearTimePickerTimer(), this.timePickerTimer = setTimeout(function() {
        i.repeat(o, 100, r, n);
      }, a), r) {
        case 0:
          n === 1 ? this.incrementHour(o) : this.decrementHour(o);
          break;
        case 1:
          n === 1 ? this.incrementMinute(o) : this.decrementMinute(o);
          break;
        case 2:
          n === 1 ? this.incrementSecond(o) : this.decrementSecond(o);
          break;
      }
    },
    convertTo24Hour: function(o, t) {
      return this.hourFormat == "12" ? o === 12 ? t ? 12 : 0 : t ? o + 12 : o : o;
    },
    validateTime: function(o, t, r, n) {
      var i = this.isComparable() ? this.d_value : this.viewDate, a = this.convertTo24Hour(o, n);
      this.isRangeSelection() && (i = this.d_value[1] || this.d_value[0]), this.isMultipleSelection() && (i = this.d_value[this.d_value.length - 1]);
      var l = i ? i.toDateString() : null;
      return !(this.minDate && l && this.minDate.toDateString() === l && (this.minDate.getHours() > a || this.minDate.getHours() === a && (this.minDate.getMinutes() > t || this.minDate.getMinutes() === t && this.minDate.getSeconds() > r)) || this.maxDate && l && this.maxDate.toDateString() === l && (this.maxDate.getHours() < a || this.maxDate.getHours() === a && (this.maxDate.getMinutes() < t || this.maxDate.getMinutes() === t && this.maxDate.getSeconds() < r)));
    },
    incrementHour: function(o) {
      var t = this.currentHour, r = this.currentHour + Number(this.stepHour), n = this.pm;
      this.hourFormat == "24" ? r = r >= 24 ? r - 24 : r : this.hourFormat == "12" && (t < 12 && r > 11 && (n = !this.pm), r = r >= 13 ? r - 12 : r), this.validateTime(r, this.currentMinute, this.currentSecond, n) && (this.currentHour = r, this.pm = n), o.preventDefault();
    },
    decrementHour: function(o) {
      var t = this.currentHour - this.stepHour, r = this.pm;
      this.hourFormat == "24" ? t = t < 0 ? 24 + t : t : this.hourFormat == "12" && (this.currentHour === 12 && (r = !this.pm), t = t <= 0 ? 12 + t : t), this.validateTime(t, this.currentMinute, this.currentSecond, r) && (this.currentHour = t, this.pm = r), o.preventDefault();
    },
    incrementMinute: function(o) {
      var t = this.currentMinute + Number(this.stepMinute);
      this.validateTime(this.currentHour, t, this.currentSecond, this.pm) && (this.currentMinute = t > 59 ? t - 60 : t), o.preventDefault();
    },
    decrementMinute: function(o) {
      var t = this.currentMinute - this.stepMinute;
      t = t < 0 ? 60 + t : t, this.validateTime(this.currentHour, t, this.currentSecond, this.pm) && (this.currentMinute = t), o.preventDefault();
    },
    incrementSecond: function(o) {
      var t = this.currentSecond + Number(this.stepSecond);
      this.validateTime(this.currentHour, this.currentMinute, t, this.pm) && (this.currentSecond = t > 59 ? t - 60 : t), o.preventDefault();
    },
    decrementSecond: function(o) {
      var t = this.currentSecond - this.stepSecond;
      t = t < 0 ? 60 + t : t, this.validateTime(this.currentHour, this.currentMinute, t, this.pm) && (this.currentSecond = t), o.preventDefault();
    },
    updateModelTime: function() {
      var o = this;
      this.timePickerChange = !0;
      var t = this.isComparable() ? this.d_value : this.viewDate;
      this.isRangeSelection() && (t = this.d_value[1] || this.d_value[0]), this.isMultipleSelection() && (t = this.d_value[this.d_value.length - 1]), t = t ? new Date(t.getTime()) : /* @__PURE__ */ new Date(), this.hourFormat == "12" ? this.currentHour === 12 ? t.setHours(this.pm ? 12 : 0) : t.setHours(this.pm ? this.currentHour + 12 : this.currentHour) : t.setHours(this.currentHour), t.setMinutes(this.currentMinute), t.setSeconds(this.currentSecond), this.isRangeSelection() && (this.d_value[1] ? t = [this.d_value[0], t] : t = [t, null]), this.isMultipleSelection() && (t = [].concat(Jt(this.d_value.slice(0, -1)), [t])), this.updateModel(t), this.$emit("date-select", t), setTimeout(function() {
        return o.timePickerChange = !1;
      }, 0);
    },
    toggleAMPM: function(o) {
      var t = this.validateTime(this.currentHour, this.currentMinute, this.currentSecond, !this.pm);
      !t && (this.maxDate || this.minDate) || (this.pm = !this.pm, this.updateModelTime(), o.preventDefault());
    },
    clearTimePickerTimer: function() {
      this.timePickerTimer && clearInterval(this.timePickerTimer);
    },
    onMonthSelect: function(o, t) {
      t.month;
      var r = t.index;
      this.view === "month" ? this.onDateSelect(o, {
        year: this.currentYear,
        month: r,
        day: 1,
        selectable: !0
      }) : (this.currentMonth = r, this.currentView = "date", this.$emit("month-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })), setTimeout(this.updateFocus, 0);
    },
    onYearSelect: function(o, t) {
      this.view === "year" ? this.onDateSelect(o, {
        year: t.value,
        month: 0,
        day: 1,
        selectable: !0
      }) : (this.currentYear = t.value, this.currentView = "month", this.$emit("year-change", {
        month: this.currentMonth + 1,
        year: this.currentYear
      })), setTimeout(this.updateFocus, 0);
    },
    updateCurrentMetaData: function() {
      var o = this.viewDate;
      this.currentMonth = o.getMonth(), this.currentYear = o.getFullYear(), (this.showTime || this.timeOnly) && this.updateCurrentTimeMeta(o);
    },
    isValidSelection: function(o) {
      var t = this;
      if (o == null)
        return !0;
      var r = !0;
      return this.isSingleSelection() ? this.isSelectable(o.getDate(), o.getMonth(), o.getFullYear(), !1) || (r = !1) : o.every(function(n) {
        return t.isSelectable(n.getDate(), n.getMonth(), n.getFullYear(), !1);
      }) && this.isRangeSelection() && (r = o.length > 1 && o[1] >= o[0]), r;
    },
    parseValue: function(o) {
      if (!o || o.trim().length === 0)
        return null;
      var t;
      if (this.isSingleSelection())
        t = this.parseDateTime(o);
      else if (this.isMultipleSelection()) {
        var r = o.split(",");
        t = [];
        var n = er(r), i;
        try {
          for (n.s(); !(i = n.n()).done; ) {
            var a = i.value;
            t.push(this.parseDateTime(a.trim()));
          }
        } catch (d) {
          n.e(d);
        } finally {
          n.f();
        }
      } else if (this.isRangeSelection()) {
        var l = o.split(" - ");
        t = [];
        for (var s = 0; s < l.length; s++)
          t[s] = this.parseDateTime(l[s].trim());
      }
      return t;
    },
    parseDateTime: function(o) {
      var t, r = o.split(" ");
      if (this.timeOnly)
        t = /* @__PURE__ */ new Date(), this.populateTime(t, r[0], r[1]);
      else {
        var n = this.datePattern;
        this.showTime ? (t = this.parseDate(r[0], n), this.populateTime(t, r[1], r[2])) : t = this.parseDate(o, n);
      }
      return t;
    },
    populateTime: function(o, t, r) {
      if (this.hourFormat == "12" && !r)
        throw "Invalid Time";
      this.pm = r === this.$primevue.config.locale.pm || r === this.$primevue.config.locale.pm.toLowerCase();
      var n = this.parseTime(t);
      o.setHours(n.hour), o.setMinutes(n.minute), o.setSeconds(n.second);
    },
    parseTime: function(o) {
      var t = o.split(":"), r = this.showSeconds ? 3 : 2, n = /^[0-9][0-9]$/;
      if (t.length !== r || !t[0].match(n) || !t[1].match(n) || this.showSeconds && !t[2].match(n))
        throw "Invalid time";
      var i = parseInt(t[0]), a = parseInt(t[1]), l = this.showSeconds ? parseInt(t[2]) : null;
      if (isNaN(i) || isNaN(a) || i > 23 || a > 59 || this.hourFormat == "12" && i > 12 || this.showSeconds && (isNaN(l) || l > 59))
        throw "Invalid time";
      return this.hourFormat == "12" && i !== 12 && this.pm ? i += 12 : this.hourFormat == "12" && i == 12 && !this.pm && (i = 0), {
        hour: i,
        minute: a,
        second: l
      };
    },
    parseDate: function(o, t) {
      if (t == null || o == null)
        throw "Invalid arguments";
      if (o = pr(o) === "object" ? o.toString() : o + "", o === "")
        return null;
      var r, n, i, a = 0, l = typeof this.shortYearCutoff != "string" ? this.shortYearCutoff : (/* @__PURE__ */ new Date()).getFullYear() % 100 + parseInt(this.shortYearCutoff, 10), s = -1, d = -1, c = -1, f = -1, u = !1, p, h = function(b) {
        var x = r + 1 < t.length && t.charAt(r + 1) === b;
        return x && r++, x;
      }, m = function(b) {
        var x = h(b), D = b === "@" ? 14 : b === "!" ? 20 : b === "y" && x ? 4 : b === "o" ? 3 : 2, _ = b === "y" ? D : 1, T = new RegExp("^\\d{" + _ + "," + D + "}"), O = o.substring(a).match(T);
        if (!O)
          throw "Missing number at position " + a;
        return a += O[0].length, parseInt(O[0], 10);
      }, v = function(b, x, D) {
        for (var _ = -1, T = h(b) ? D : x, O = [], Y = 0; Y < T.length; Y++)
          O.push([Y, T[Y]]);
        O.sort(function(X, ae) {
          return -(X[1].length - ae[1].length);
        });
        for (var j = 0; j < O.length; j++) {
          var q = O[j][1];
          if (o.substr(a, q.length).toLowerCase() === q.toLowerCase()) {
            _ = O[j][0], a += q.length;
            break;
          }
        }
        if (_ !== -1)
          return _ + 1;
        throw "Unknown name at position " + a;
      }, C = function() {
        if (o.charAt(a) !== t.charAt(r))
          throw "Unexpected literal at position " + a;
        a++;
      };
      for (this.currentView === "month" && (c = 1), this.currentView === "year" && (c = 1, d = 1), r = 0; r < t.length; r++)
        if (u)
          t.charAt(r) === "'" && !h("'") ? u = !1 : C();
        else
          switch (t.charAt(r)) {
            case "d":
              c = m("d");
              break;
            case "D":
              v("D", this.$primevue.config.locale.dayNamesShort, this.$primevue.config.locale.dayNames);
              break;
            case "o":
              f = m("o");
              break;
            case "m":
              d = m("m");
              break;
            case "M":
              d = v("M", this.$primevue.config.locale.monthNamesShort, this.$primevue.config.locale.monthNames);
              break;
            case "y":
              s = m("y");
              break;
            case "@":
              p = new Date(m("@")), s = p.getFullYear(), d = p.getMonth() + 1, c = p.getDate();
              break;
            case "!":
              p = new Date((m("!") - this.ticksTo1970) / 1e4), s = p.getFullYear(), d = p.getMonth() + 1, c = p.getDate();
              break;
            case "'":
              h("'") ? C() : u = !0;
              break;
            default:
              C();
          }
      if (a < o.length && (i = o.substr(a), !/^\s+/.test(i)))
        throw "Extra/unparsed characters found in date: " + i;
      if (s === -1 ? s = (/* @__PURE__ */ new Date()).getFullYear() : s < 100 && (s += (/* @__PURE__ */ new Date()).getFullYear() - (/* @__PURE__ */ new Date()).getFullYear() % 100 + (s <= l ? 0 : -100)), f > -1) {
        d = 1, c = f;
        do {
          if (n = this.getDaysCountInMonth(s, d - 1), c <= n)
            break;
          d++, c -= n;
        } while (!0);
      }
      if (p = this.daylightSavingAdjust(new Date(s, d - 1, c)), p.getFullYear() !== s || p.getMonth() + 1 !== d || p.getDate() !== c)
        throw "Invalid date";
      return p;
    },
    getWeekNumber: function(o) {
      var t = new Date(o.getTime());
      t.setDate(t.getDate() + 4 - (t.getDay() || 7));
      var r = t.getTime();
      return t.setMonth(0), t.setDate(1), Math.floor(Math.round((r - t.getTime()) / 864e5) / 7) + 1;
    },
    onDateCellKeydown: function(o, t, r) {
      var n = o.currentTarget, i = n.parentElement, a = Oo(i);
      switch (o.code) {
        case "ArrowDown": {
          n.tabIndex = "-1";
          var l = i.parentElement.nextElementSibling;
          if (l) {
            var s = Oo(i.parentElement), d = Array.from(i.parentElement.parentElement.children), c = d.slice(s + 1), f = c.find(function(oe) {
              var de = oe.children[a].children[0];
              return !so(de, "data-p-disabled");
            });
            if (f) {
              var u = f.children[a].children[0];
              u.tabIndex = "0", u.focus();
            } else
              this.navigationState = {
                backward: !1
              }, this.navForward(o);
          } else
            this.navigationState = {
              backward: !1
            }, this.navForward(o);
          o.preventDefault();
          break;
        }
        case "ArrowUp": {
          if (n.tabIndex = "-1", o.altKey)
            this.overlayVisible = !1, this.focused = !0;
          else {
            var p = i.parentElement.previousElementSibling;
            if (p) {
              var h = Oo(i.parentElement), m = Array.from(i.parentElement.parentElement.children), v = m.slice(0, h).reverse(), C = v.find(function(oe) {
                var de = oe.children[a].children[0];
                return !so(de, "data-p-disabled");
              });
              if (C) {
                var w = C.children[a].children[0];
                w.tabIndex = "0", w.focus();
              } else
                this.navigationState = {
                  backward: !0
                }, this.navBackward(o);
            } else
              this.navigationState = {
                backward: !0
              }, this.navBackward(o);
          }
          o.preventDefault();
          break;
        }
        case "ArrowLeft": {
          n.tabIndex = "-1";
          var b = i.previousElementSibling;
          if (b) {
            var x = Array.from(i.parentElement.children), D = x.slice(0, a).reverse(), _ = D.find(function(oe) {
              var de = oe.children[0];
              return !so(de, "data-p-disabled");
            });
            if (_) {
              var T = _.children[0];
              T.tabIndex = "0", T.focus();
            } else
              this.navigateToMonth(o, !0, r);
          } else
            this.navigateToMonth(o, !0, r);
          o.preventDefault();
          break;
        }
        case "ArrowRight": {
          n.tabIndex = "-1";
          var O = i.nextElementSibling;
          if (O) {
            var Y = Array.from(i.parentElement.children), j = Y.slice(a + 1), q = j.find(function(oe) {
              var de = oe.children[0];
              return !so(de, "data-p-disabled");
            });
            if (q) {
              var X = q.children[0];
              X.tabIndex = "0", X.focus();
            } else
              this.navigateToMonth(o, !1, r);
          } else
            this.navigateToMonth(o, !1, r);
          o.preventDefault();
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onDateSelect(o, t), o.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, o.preventDefault();
          break;
        }
        case "Tab": {
          this.inline || this.trapFocus(o);
          break;
        }
        case "Home": {
          n.tabIndex = "-1";
          var ae = i.parentElement, J = ae.children[0].children[0];
          so(J, "data-p-disabled") ? this.navigateToMonth(o, !0, r) : (J.tabIndex = "0", J.focus()), o.preventDefault();
          break;
        }
        case "End": {
          n.tabIndex = "-1";
          var re = i.parentElement, ne = re.children[re.children.length - 1].children[0];
          so(ne, "data-p-disabled") ? this.navigateToMonth(o, !1, r) : (ne.tabIndex = "0", ne.focus()), o.preventDefault();
          break;
        }
        case "PageUp": {
          n.tabIndex = "-1", o.shiftKey ? (this.navigationState = {
            backward: !0
          }, this.navBackward(o)) : this.navigateToMonth(o, !0, r), o.preventDefault();
          break;
        }
        case "PageDown": {
          n.tabIndex = "-1", o.shiftKey ? (this.navigationState = {
            backward: !1
          }, this.navForward(o)) : this.navigateToMonth(o, !1, r), o.preventDefault();
          break;
        }
      }
    },
    navigateToMonth: function(o, t, r) {
      if (t)
        if (this.numberOfMonths === 1 || r === 0)
          this.navigationState = {
            backward: !0
          }, this.navBackward(o);
        else {
          var n = this.overlay.children[r - 1], i = qe(n, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])'), a = i[i.length - 1];
          a.tabIndex = "0", a.focus();
        }
      else if (this.numberOfMonths === 1 || r === this.numberOfMonths - 1)
        this.navigationState = {
          backward: !1
        }, this.navForward(o);
      else {
        var l = this.overlay.children[r + 1], s = Ce(l, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
        s.tabIndex = "0", s.focus();
      }
    },
    onMonthCellKeydown: function(o, t) {
      var r = o.currentTarget;
      switch (o.code) {
        case "ArrowUp":
        case "ArrowDown": {
          r.tabIndex = "-1";
          var n = r.parentElement.children, i = Oo(r), a = n[o.code === "ArrowDown" ? i + 3 : i - 3];
          a && (a.tabIndex = "0", a.focus()), o.preventDefault();
          break;
        }
        case "ArrowLeft": {
          r.tabIndex = "-1";
          var l = r.previousElementSibling;
          l ? (l.tabIndex = "0", l.focus()) : (this.navigationState = {
            backward: !0
          }, this.navBackward(o)), o.preventDefault();
          break;
        }
        case "ArrowRight": {
          r.tabIndex = "-1";
          var s = r.nextElementSibling;
          s ? (s.tabIndex = "0", s.focus()) : (this.navigationState = {
            backward: !1
          }, this.navForward(o)), o.preventDefault();
          break;
        }
        case "PageUp": {
          if (o.shiftKey) return;
          this.navigationState = {
            backward: !0
          }, this.navBackward(o);
          break;
        }
        case "PageDown": {
          if (o.shiftKey) return;
          this.navigationState = {
            backward: !1
          }, this.navForward(o);
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onMonthSelect(o, t), o.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, o.preventDefault();
          break;
        }
        case "Tab": {
          this.trapFocus(o);
          break;
        }
      }
    },
    onYearCellKeydown: function(o, t) {
      var r = o.currentTarget;
      switch (o.code) {
        case "ArrowUp":
        case "ArrowDown": {
          r.tabIndex = "-1";
          var n = r.parentElement.children, i = Oo(r), a = n[o.code === "ArrowDown" ? i + 2 : i - 2];
          a && (a.tabIndex = "0", a.focus()), o.preventDefault();
          break;
        }
        case "ArrowLeft": {
          r.tabIndex = "-1";
          var l = r.previousElementSibling;
          l ? (l.tabIndex = "0", l.focus()) : (this.navigationState = {
            backward: !0
          }, this.navBackward(o)), o.preventDefault();
          break;
        }
        case "ArrowRight": {
          r.tabIndex = "-1";
          var s = r.nextElementSibling;
          s ? (s.tabIndex = "0", s.focus()) : (this.navigationState = {
            backward: !1
          }, this.navForward(o)), o.preventDefault();
          break;
        }
        case "PageUp": {
          if (o.shiftKey) return;
          this.navigationState = {
            backward: !0
          }, this.navBackward(o);
          break;
        }
        case "PageDown": {
          if (o.shiftKey) return;
          this.navigationState = {
            backward: !1
          }, this.navForward(o);
          break;
        }
        case "Enter":
        case "NumpadEnter":
        case "Space": {
          this.onYearSelect(o, t), o.preventDefault();
          break;
        }
        case "Escape": {
          this.overlayVisible = !1, o.preventDefault();
          break;
        }
        case "Tab": {
          this.trapFocus(o);
          break;
        }
      }
    },
    updateFocus: function() {
      var o;
      if (this.navigationState) {
        if (this.navigationState.button)
          this.initFocusableCell(), this.navigationState.backward ? this.previousButton.focus() : this.nextButton.focus();
        else {
          if (this.navigationState.backward) {
            var t;
            this.currentView === "month" ? t = qe(this.overlay, '[data-pc-section="monthview"] [data-pc-section="month"]:not([data-p-disabled="true"])') : this.currentView === "year" ? t = qe(this.overlay, '[data-pc-section="yearview"] [data-pc-section="year"]:not([data-p-disabled="true"])') : t = qe(this.overlay, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])'), t && t.length > 0 && (o = t[t.length - 1]);
          } else
            this.currentView === "month" ? o = Ce(this.overlay, '[data-pc-section="monthview"] [data-pc-section="month"]:not([data-p-disabled="true"])') : this.currentView === "year" ? o = Ce(this.overlay, '[data-pc-section="yearview"] [data-pc-section="year"]:not([data-p-disabled="true"])') : o = Ce(this.overlay, 'table td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
          o && (o.tabIndex = "0", o.focus());
        }
        this.navigationState = null;
      } else
        this.initFocusableCell();
    },
    initFocusableCell: function() {
      var o;
      if (this.currentView === "month") {
        var t = qe(this.overlay, '[data-pc-section="monthview"] [data-pc-section="month"]'), r = Ce(this.overlay, '[data-pc-section="monthview"] [data-pc-section="month"][data-p-selected="true"]');
        t.forEach(function(l) {
          return l.tabIndex = -1;
        }), o = r || t[0];
      } else if (this.currentView === "year") {
        var n = qe(this.overlay, '[data-pc-section="yearview"] [data-pc-section="year"]'), i = Ce(this.overlay, '[data-pc-section="yearview"] [data-pc-section="year"][data-p-selected="true"]');
        n.forEach(function(l) {
          return l.tabIndex = -1;
        }), o = i || n[0];
      } else if (o = Ce(this.overlay, 'span[data-p-selected="true"]'), !o) {
        var a = Ce(this.overlay, 'td[data-p-today="true"] span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
        a ? o = a : o = Ce(this.overlay, '.p-datepicker-calendar td span:not([data-p-disabled="true"]):not([data-p-ink="true"])');
      }
      o && (o.tabIndex = "0", this.preventFocus = !1);
    },
    trapFocus: function(o) {
      o.preventDefault();
      var t = Pn(this.overlay);
      if (t && t.length > 0)
        if (!document.activeElement)
          t[0].focus();
        else {
          var r = t.indexOf(document.activeElement);
          if (o.shiftKey)
            r === -1 || r === 0 ? t[t.length - 1].focus() : t[r - 1].focus();
          else if (r === -1)
            if (this.timeOnly)
              t[0].focus();
            else {
              for (var n = null, i = 0; i < t.length; i++)
                if (t[i].tagName === "SPAN") {
                  n = i;
                  break;
                }
              t[n].focus();
            }
          else r === t.length - 1 ? t[0].focus() : t[r + 1].focus();
        }
    },
    onContainerButtonKeydown: function(o) {
      switch (o.code) {
        case "Tab":
          this.trapFocus(o);
          break;
        case "Escape":
          this.overlayVisible = !1, o.preventDefault();
          break;
      }
      this.$emit("keydown", o);
    },
    onInput: function(o) {
      try {
        this.selectionStart = this.input.selectionStart, this.selectionEnd = this.input.selectionEnd;
        var t = this.parseValue(o.target.value);
        this.isValidSelection(t) && (this.typeUpdate = !0, this.updateModel(t));
      } catch {
      }
      this.$emit("input", o);
    },
    onInputClick: function() {
      this.showOnFocus && this.isEnabled() && !this.overlayVisible && (this.overlayVisible = !0);
    },
    onFocus: function(o) {
      this.showOnFocus && this.isEnabled() && (this.overlayVisible = !0), this.focused = !0, this.$emit("focus", o);
    },
    onBlur: function(o) {
      var t, r;
      this.$emit("blur", {
        originalEvent: o,
        value: o.target.value
      }), (t = (r = this.formField).onBlur) === null || t === void 0 || t.call(r), this.focused = !1, o.target.value = this.formatValue(this.d_value);
    },
    onKeyDown: function(o) {
      if (o.code === "ArrowDown" && this.overlay)
        this.trapFocus(o);
      else if (o.code === "ArrowDown" && !this.overlay)
        this.overlayVisible = !0;
      else if (o.code === "Escape")
        this.overlayVisible && (this.overlayVisible = !1, o.preventDefault());
      else if (o.code === "Tab")
        this.overlay && Pn(this.overlay).forEach(function(n) {
          return n.tabIndex = "-1";
        }), this.overlayVisible && (this.overlayVisible = !1);
      else if (o.code === "Enter") {
        var t;
        if (this.manualInput && o.target.value !== null && ((t = o.target.value) === null || t === void 0 ? void 0 : t.trim()) !== "")
          try {
            var r = this.parseValue(o.target.value);
            this.isValidSelection(r) && (this.overlayVisible = !1);
          } catch {
          }
        this.$emit("keydown", o);
      }
    },
    overlayRef: function(o) {
      this.overlay = o;
    },
    inputRef: function(o) {
      this.input = o ? o.$el : void 0;
    },
    previousButtonRef: function(o) {
      this.previousButton = o ? o.$el : void 0;
    },
    nextButtonRef: function(o) {
      this.nextButton = o ? o.$el : void 0;
    },
    getMonthName: function(o) {
      return this.$primevue.config.locale.monthNames[o];
    },
    getYear: function(o) {
      return this.currentView === "month" ? this.currentYear : o.year;
    },
    onOverlayClick: function(o) {
      o.stopPropagation(), this.inline || a0.emit("overlay-click", {
        originalEvent: o,
        target: this.$el
      });
    },
    onOverlayKeyDown: function(o) {
      switch (o.code) {
        case "Escape":
          this.inline || (this.input.focus(), this.overlayVisible = !1);
          break;
      }
    },
    onOverlayMouseUp: function(o) {
      this.onOverlayClick(o);
    },
    createResponsiveStyle: function() {
      if (this.numberOfMonths > 1 && this.responsiveOptions && !this.isUnstyled) {
        if (!this.responsiveStyleElement) {
          var o;
          this.responsiveStyleElement = document.createElement("style"), this.responsiveStyleElement.type = "text/css", da(this.responsiveStyleElement, "nonce", (o = this.$primevue) === null || o === void 0 || (o = o.config) === null || o === void 0 || (o = o.csp) === null || o === void 0 ? void 0 : o.nonce), document.body.appendChild(this.responsiveStyleElement);
        }
        var t = "";
        if (this.responsiveOptions)
          for (var r = $d(), n = Jt(this.responsiveOptions).filter(function(f) {
            return !!(f.breakpoint && f.numMonths);
          }).sort(function(f, u) {
            return -1 * r(f.breakpoint, u.breakpoint);
          }), i = 0; i < n.length; i++) {
            for (var a = n[i], l = a.breakpoint, s = a.numMonths, d = `
                            .p-datepicker-panel[`.concat(this.$attrSelector, "] .p-datepicker-calendar:nth-child(").concat(s, `) .p-datepicker-next-button {
                                display: inline-flex;
                            }
                        `), c = s; c < this.numberOfMonths; c++)
              d += `
                                .p-datepicker-panel[`.concat(this.$attrSelector, "] .p-datepicker-calendar:nth-child(").concat(c + 1, `) {
                                    display: none;
                                }
                            `);
            t += `
                            @media screen and (max-width: `.concat(l, `) {
                                `).concat(d, `
                            }
                        `);
          }
        this.responsiveStyleElement.innerHTML = t;
      }
    },
    destroyResponsiveStyleElement: function() {
      this.responsiveStyleElement && (this.responsiveStyleElement.remove(), this.responsiveStyleElement = null);
    }
  },
  computed: {
    viewDate: function() {
      var o = this.d_value;
      if (o && Array.isArray(o) && (this.isRangeSelection() ? o = this.inline ? o[0] : o[1] || o[0] : this.isMultipleSelection() && (o = o[o.length - 1])), o && typeof o != "string")
        return o;
      var t = /* @__PURE__ */ new Date();
      return this.maxDate && this.maxDate < t ? this.maxDate : this.minDate && this.minDate > t ? this.minDate : t;
    },
    inputFieldValue: function() {
      return this.formatValue(this.d_value);
    },
    months: function() {
      for (var o = [], t = 0; t < this.numberOfMonths; t++) {
        var r = this.currentMonth + t, n = this.currentYear;
        r > 11 && (r = r % 11 - 1, n = n + 1);
        for (var i = [], a = this.getFirstDayOfMonthIndex(r, n), l = this.getDaysCountInMonth(r, n), s = this.getDaysCountInPrevMonth(r, n), d = 1, c = /* @__PURE__ */ new Date(), f = [], u = Math.ceil((l + a) / 7), p = 0; p < u; p++) {
          var h = [];
          if (p == 0) {
            for (var m = s - a + 1; m <= s; m++) {
              var v = this.getPreviousMonthAndYear(r, n);
              h.push({
                day: m,
                month: v.month,
                year: v.year,
                otherMonth: !0,
                today: this.isToday(c, m, v.month, v.year),
                selectable: this.isSelectable(m, v.month, v.year, !0)
              });
            }
            for (var C = 7 - h.length, w = 0; w < C; w++)
              h.push({
                day: d,
                month: r,
                year: n,
                today: this.isToday(c, d, r, n),
                selectable: this.isSelectable(d, r, n, !1)
              }), d++;
          } else
            for (var b = 0; b < 7; b++) {
              if (d > l) {
                var x = this.getNextMonthAndYear(r, n);
                h.push({
                  day: d - l,
                  month: x.month,
                  year: x.year,
                  otherMonth: !0,
                  today: this.isToday(c, d - l, x.month, x.year),
                  selectable: this.isSelectable(d - l, x.month, x.year, !0)
                });
              } else
                h.push({
                  day: d,
                  month: r,
                  year: n,
                  today: this.isToday(c, d, r, n),
                  selectable: this.isSelectable(d, r, n, !1)
                });
              d++;
            }
          this.showWeek && f.push(this.getWeekNumber(new Date(h[0].year, h[0].month, h[0].day))), i.push(h);
        }
        o.push({
          month: r,
          year: n,
          dates: i,
          weekNumbers: f
        });
      }
      return o;
    },
    weekDays: function() {
      for (var o = [], t = this.$primevue.config.locale.firstDayOfWeek, r = 0; r < 7; r++)
        o.push(this.$primevue.config.locale.dayNamesMin[t]), t = t == 6 ? 0 : ++t;
      return o;
    },
    ticksTo1970: function() {
      return (1969 * 365 + Math.floor(1970 / 4) - Math.floor(1970 / 100) + Math.floor(1970 / 400)) * 24 * 60 * 60 * 1e7;
    },
    sundayIndex: function() {
      return this.$primevue.config.locale.firstDayOfWeek > 0 ? 7 - this.$primevue.config.locale.firstDayOfWeek : 0;
    },
    datePattern: function() {
      return this.dateFormat || this.$primevue.config.locale.dateFormat;
    },
    monthPickerValues: function() {
      for (var o = this, t = [], r = function(a) {
        if (o.minDate) {
          var l = o.minDate.getMonth(), s = o.minDate.getFullYear();
          if (o.currentYear < s || o.currentYear === s && a < l)
            return !1;
        }
        if (o.maxDate) {
          var d = o.maxDate.getMonth(), c = o.maxDate.getFullYear();
          if (o.currentYear > c || o.currentYear === c && a > d)
            return !1;
        }
        return !0;
      }, n = 0; n <= 11; n++)
        t.push({
          value: this.$primevue.config.locale.monthNamesShort[n],
          selectable: r(n)
        });
      return t;
    },
    yearPickerValues: function() {
      for (var o = this, t = [], r = this.currentYear - this.currentYear % 10, n = function(l) {
        return !(o.minDate && o.minDate.getFullYear() > l || o.maxDate && o.maxDate.getFullYear() < l);
      }, i = 0; i < 10; i++)
        t.push({
          value: r + i,
          selectable: n(r + i)
        });
      return t;
    },
    formattedCurrentHour: function() {
      return this.currentHour == 0 ? this.currentHour + 12 : this.currentHour < 10 ? "0" + this.currentHour : this.currentHour;
    },
    formattedCurrentMinute: function() {
      return this.currentMinute < 10 ? "0" + this.currentMinute : this.currentMinute;
    },
    formattedCurrentSecond: function() {
      return this.currentSecond < 10 ? "0" + this.currentSecond : this.currentSecond;
    },
    todayLabel: function() {
      return this.$primevue.config.locale.today;
    },
    clearLabel: function() {
      return this.$primevue.config.locale.clear;
    },
    weekHeaderLabel: function() {
      return this.$primevue.config.locale.weekHeader;
    },
    monthNames: function() {
      return this.$primevue.config.locale.monthNames;
    },
    switchViewButtonDisabled: function() {
      return this.numberOfMonths > 1 || this.disabled;
    },
    panelId: function() {
      return this.d_id + "_panel";
    }
  },
  components: {
    InputText: Ta,
    Button: Ma,
    Portal: Pa,
    CalendarIcon: ka,
    ChevronLeftIcon: Ca,
    ChevronRightIcon: xa,
    ChevronUpIcon: Sa,
    ChevronDownIcon: wa
  },
  directives: {
    ripple: _a
  }
}, m0 = ["id"], b0 = ["disabled", "aria-label", "aria-expanded", "aria-controls"], v0 = ["id", "role", "aria-modal", "aria-label"], y0 = ["disabled", "aria-label"], k0 = ["disabled", "aria-label"], w0 = ["disabled", "aria-label"], C0 = ["disabled", "aria-label"], x0 = ["data-p-disabled"], S0 = ["abbr"], $0 = ["data-p-disabled"], B0 = ["aria-label", "data-p-today", "data-p-other-month"], _0 = ["onClick", "onKeydown", "aria-selected", "aria-disabled", "data-p-disabled", "data-p-selected"], M0 = ["onClick", "onKeydown", "data-p-disabled", "data-p-selected"], T0 = ["onClick", "onKeydown", "data-p-disabled", "data-p-selected"];
function P0(e, o, t, r, n, i) {
  var a = Re("InputText"), l = Re("Button"), s = Re("Portal"), d = xr("ripple");
  return g(), $("span", y({
    ref: "container",
    id: n.d_id,
    class: e.cx("root"),
    style: e.sx("root")
  }, e.ptmi("root")), [e.inline ? I("", !0) : (g(), M(a, {
    key: 0,
    ref: i.inputRef,
    id: e.inputId,
    role: "combobox",
    class: L([e.inputClass, e.cx("pcInputText")]),
    style: ht(e.inputStyle),
    value: i.inputFieldValue,
    placeholder: e.placeholder,
    name: e.name,
    size: e.size,
    invalid: e.invalid,
    variant: e.variant,
    fluid: e.fluid,
    unstyled: e.unstyled,
    autocomplete: "off",
    "aria-autocomplete": "none",
    "aria-haspopup": "dialog",
    "aria-expanded": n.overlayVisible,
    "aria-controls": i.panelId,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    inputmode: "none",
    disabled: e.disabled,
    readonly: !e.manualInput || e.readonly,
    tabindex: 0,
    onInput: i.onInput,
    onClick: i.onInputClick,
    onFocus: i.onFocus,
    onBlur: i.onBlur,
    onKeydown: i.onKeyDown,
    pt: e.ptm("pcInputText")
  }, null, 8, ["id", "class", "style", "value", "placeholder", "name", "size", "invalid", "variant", "fluid", "unstyled", "aria-expanded", "aria-controls", "aria-labelledby", "aria-label", "disabled", "readonly", "onInput", "onClick", "onFocus", "onBlur", "onKeydown", "pt"])), e.showIcon && e.iconDisplay === "button" && !e.inline ? B(e.$slots, "dropdownbutton", {
    key: 1,
    toggleCallback: i.onButtonClick
  }, function() {
    return [P("button", y({
      class: e.cx("dropdown"),
      disabled: e.disabled,
      onClick: o[0] || (o[0] = function() {
        return i.onButtonClick && i.onButtonClick.apply(i, arguments);
      }),
      type: "button",
      "aria-label": e.$primevue.config.locale.chooseDate,
      "aria-haspopup": "dialog",
      "aria-expanded": n.overlayVisible,
      "aria-controls": i.panelId
    }, e.ptm("dropdown")), [B(e.$slots, "dropdownicon", {
      class: L(e.icon)
    }, function() {
      return [(g(), M(fe(e.icon ? "span" : "CalendarIcon"), y({
        class: e.icon
      }, e.ptm("dropdownIcon")), null, 16, ["class"]))];
    })], 16, b0)];
  }) : e.showIcon && e.iconDisplay === "input" && !e.inline ? (g(), $(pe, {
    key: 2
  }, [e.$slots.inputicon || e.showIcon ? (g(), $("span", y({
    key: 0,
    class: e.cx("inputIconContainer")
  }, e.ptm("inputIconContainer")), [B(e.$slots, "inputicon", {
    class: L(e.cx("inputIcon")),
    clickCallback: i.onButtonClick
  }, function() {
    return [(g(), M(fe(e.icon ? "i" : "CalendarIcon"), y({
      class: [e.icon, e.cx("inputIcon")],
      onClick: i.onButtonClick
    }, e.ptm("inputicon")), null, 16, ["class", "onClick"]))];
  })], 16)) : I("", !0)], 64)) : I("", !0), R(s, {
    appendTo: e.appendTo,
    disabled: e.inline
  }, {
    default: S(function() {
      return [R(mi, y({
        name: "p-connected-overlay",
        onEnter: o[58] || (o[58] = function(c) {
          return i.onOverlayEnter(c);
        }),
        onAfterEnter: i.onOverlayEnterComplete,
        onAfterLeave: i.onOverlayAfterLeave,
        onLeave: i.onOverlayLeave
      }, e.ptm("transition")), {
        default: S(function() {
          return [e.inline || n.overlayVisible ? (g(), $("div", y({
            key: 0,
            ref: i.overlayRef,
            id: i.panelId,
            class: [e.cx("panel"), e.panelClass],
            style: e.panelStyle,
            role: e.inline ? null : "dialog",
            "aria-modal": e.inline ? null : "true",
            "aria-label": e.$primevue.config.locale.chooseDate,
            onClick: o[55] || (o[55] = function() {
              return i.onOverlayClick && i.onOverlayClick.apply(i, arguments);
            }),
            onKeydown: o[56] || (o[56] = function() {
              return i.onOverlayKeyDown && i.onOverlayKeyDown.apply(i, arguments);
            }),
            onMouseup: o[57] || (o[57] = function() {
              return i.onOverlayMouseUp && i.onOverlayMouseUp.apply(i, arguments);
            })
          }, e.ptm("panel")), [e.timeOnly ? I("", !0) : (g(), $(pe, {
            key: 0
          }, [P("div", y({
            class: e.cx("calendarContainer")
          }, e.ptm("calendarContainer")), [(g(!0), $(pe, null, Ze(i.months, function(c, f) {
            return g(), $("div", y({
              key: c.month + c.year,
              class: e.cx("calendar"),
              ref_for: !0
            }, e.ptm("calendar")), [P("div", y({
              class: e.cx("header"),
              ref_for: !0
            }, e.ptm("header")), [B(e.$slots, "header"), co(R(l, y({
              ref_for: !0,
              ref: i.previousButtonRef,
              class: e.cx("pcPrevButton"),
              disabled: e.disabled,
              "aria-label": n.currentView === "year" ? e.$primevue.config.locale.prevDecade : n.currentView === "month" ? e.$primevue.config.locale.prevYear : e.$primevue.config.locale.prevMonth,
              unstyled: e.unstyled,
              onClick: i.onPrevButtonClick,
              onKeydown: i.onContainerButtonKeydown
            }, e.navigatorButtonProps, {
              pt: e.ptm("pcPrevButton"),
              "data-pc-group-section": "navigator"
            }), {
              icon: S(function(u) {
                return [B(e.$slots, "previcon", {}, function() {
                  return [(g(), M(fe(e.prevIcon ? "span" : "ChevronLeftIcon"), y({
                    class: [e.prevIcon, u.class],
                    ref_for: !0
                  }, e.ptm("pcPrevButton").icon), null, 16, ["class"]))];
                })];
              }),
              _: 2
            }, 1040, ["class", "disabled", "aria-label", "unstyled", "onClick", "onKeydown", "pt"]), [[qr, f === 0]]), P("div", y({
              class: e.cx("title"),
              ref_for: !0
            }, e.ptm("title")), [e.$primevue.config.locale.showMonthAfterYear ? (g(), $(pe, {
              key: 0
            }, [n.currentView !== "year" ? (g(), $("button", y({
              key: 0,
              type: "button",
              onClick: o[1] || (o[1] = function() {
                return i.switchToYearView && i.switchToYearView.apply(i, arguments);
              }),
              onKeydown: o[2] || (o[2] = function() {
                return i.onContainerButtonKeydown && i.onContainerButtonKeydown.apply(i, arguments);
              }),
              class: e.cx("selectYear"),
              disabled: i.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseYear,
              ref_for: !0
            }, e.ptm("selectYear"), {
              "data-pc-group-section": "view"
            }), z(i.getYear(c)), 17, y0)) : I("", !0), n.currentView === "date" ? (g(), $("button", y({
              key: 1,
              type: "button",
              onClick: o[3] || (o[3] = function() {
                return i.switchToMonthView && i.switchToMonthView.apply(i, arguments);
              }),
              onKeydown: o[4] || (o[4] = function() {
                return i.onContainerButtonKeydown && i.onContainerButtonKeydown.apply(i, arguments);
              }),
              class: e.cx("selectMonth"),
              disabled: i.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseMonth,
              ref_for: !0
            }, e.ptm("selectMonth"), {
              "data-pc-group-section": "view"
            }), z(i.getMonthName(c.month)), 17, k0)) : I("", !0)], 64)) : (g(), $(pe, {
              key: 1
            }, [n.currentView === "date" ? (g(), $("button", y({
              key: 0,
              type: "button",
              onClick: o[5] || (o[5] = function() {
                return i.switchToMonthView && i.switchToMonthView.apply(i, arguments);
              }),
              onKeydown: o[6] || (o[6] = function() {
                return i.onContainerButtonKeydown && i.onContainerButtonKeydown.apply(i, arguments);
              }),
              class: e.cx("selectMonth"),
              disabled: i.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseMonth,
              ref_for: !0
            }, e.ptm("selectMonth"), {
              "data-pc-group-section": "view"
            }), z(i.getMonthName(c.month)), 17, w0)) : I("", !0), n.currentView !== "year" ? (g(), $("button", y({
              key: 1,
              type: "button",
              onClick: o[7] || (o[7] = function() {
                return i.switchToYearView && i.switchToYearView.apply(i, arguments);
              }),
              onKeydown: o[8] || (o[8] = function() {
                return i.onContainerButtonKeydown && i.onContainerButtonKeydown.apply(i, arguments);
              }),
              class: e.cx("selectYear"),
              disabled: i.switchViewButtonDisabled,
              "aria-label": e.$primevue.config.locale.chooseYear,
              ref_for: !0
            }, e.ptm("selectYear"), {
              "data-pc-group-section": "view"
            }), z(i.getYear(c)), 17, C0)) : I("", !0)], 64)), n.currentView === "year" ? (g(), $("span", y({
              key: 2,
              class: e.cx("decade"),
              ref_for: !0
            }, e.ptm("decade")), [B(e.$slots, "decade", {
              years: i.yearPickerValues
            }, function() {
              return [ie(z(i.yearPickerValues[0].value) + " - " + z(i.yearPickerValues[i.yearPickerValues.length - 1].value), 1)];
            })], 16)) : I("", !0)], 16), co(R(l, y({
              ref_for: !0,
              ref: i.nextButtonRef,
              class: e.cx("pcNextButton"),
              disabled: e.disabled,
              "aria-label": n.currentView === "year" ? e.$primevue.config.locale.nextDecade : n.currentView === "month" ? e.$primevue.config.locale.nextYear : e.$primevue.config.locale.nextMonth,
              unstyled: e.unstyled,
              onClick: i.onNextButtonClick,
              onKeydown: i.onContainerButtonKeydown
            }, e.navigatorButtonProps, {
              pt: e.ptm("pcNextButton"),
              "data-pc-group-section": "navigator"
            }), {
              icon: S(function(u) {
                return [B(e.$slots, "nexticon", {}, function() {
                  return [(g(), M(fe(e.nextIcon ? "span" : "ChevronRightIcon"), y({
                    class: [e.nextIcon, u.class],
                    ref_for: !0
                  }, e.ptm("pcNextButton").icon), null, 16, ["class"]))];
                })];
              }),
              _: 2
            }, 1040, ["class", "disabled", "aria-label", "unstyled", "onClick", "onKeydown", "pt"]), [[qr, e.numberOfMonths === 1 ? !0 : f === e.numberOfMonths - 1]])], 16), n.currentView === "date" ? (g(), $("table", y({
              key: 0,
              class: e.cx("dayView"),
              role: "grid",
              ref_for: !0
            }, e.ptm("dayView")), [P("thead", y({
              ref_for: !0
            }, e.ptm("tableHeader")), [P("tr", y({
              ref_for: !0
            }, e.ptm("tableHeaderRow")), [e.showWeek ? (g(), $("th", y({
              key: 0,
              scope: "col",
              class: e.cx("weekHeader"),
              ref_for: !0
            }, e.ptm("weekHeader", {
              context: {
                disabled: e.showWeek
              }
            }), {
              "data-p-disabled": e.showWeek,
              "data-pc-group-section": "tableheadercell"
            }), [B(e.$slots, "weekheaderlabel", {}, function() {
              return [P("span", y({
                ref_for: !0
              }, e.ptm("weekHeaderLabel", {
                context: {
                  disabled: e.showWeek
                }
              }), {
                "data-pc-group-section": "tableheadercelllabel"
              }), z(i.weekHeaderLabel), 17)];
            })], 16, x0)) : I("", !0), (g(!0), $(pe, null, Ze(i.weekDays, function(u) {
              return g(), $("th", y({
                key: u,
                scope: "col",
                abbr: u,
                ref_for: !0
              }, e.ptm("tableHeaderCell"), {
                "data-pc-group-section": "tableheadercell",
                class: e.cx("weekDayCell")
              }), [P("span", y({
                class: e.cx("weekDay"),
                ref_for: !0
              }, e.ptm("weekDay"), {
                "data-pc-group-section": "tableheadercelllabel"
              }), z(u), 17)], 16, S0);
            }), 128))], 16)], 16), P("tbody", y({
              ref_for: !0
            }, e.ptm("tableBody")), [(g(!0), $(pe, null, Ze(c.dates, function(u, p) {
              return g(), $("tr", y({
                key: u[0].day + "" + u[0].month,
                ref_for: !0
              }, e.ptm("tableBodyRow")), [e.showWeek ? (g(), $("td", y({
                key: 0,
                class: e.cx("weekNumber"),
                ref_for: !0
              }, e.ptm("weekNumber"), {
                "data-pc-group-section": "tablebodycell"
              }), [P("span", y({
                class: e.cx("weekLabelContainer"),
                ref_for: !0
              }, e.ptm("weekLabelContainer", {
                context: {
                  disabled: e.showWeek
                }
              }), {
                "data-p-disabled": e.showWeek,
                "data-pc-group-section": "tablebodycelllabel"
              }), [B(e.$slots, "weeklabel", {
                weekNumber: c.weekNumbers[p]
              }, function() {
                return [c.weekNumbers[p] < 10 ? (g(), $("span", y({
                  key: 0,
                  style: {
                    visibility: "hidden"
                  },
                  ref_for: !0
                }, e.ptm("weekLabel")), "0", 16)) : I("", !0), ie(" " + z(c.weekNumbers[p]), 1)];
              })], 16, $0)], 16)) : I("", !0), (g(!0), $(pe, null, Ze(u, function(h) {
                return g(), $("td", y({
                  key: h.day + "" + h.month,
                  "aria-label": h.day,
                  class: e.cx("dayCell", {
                    date: h
                  }),
                  ref_for: !0
                }, e.ptm("dayCell", {
                  context: {
                    date: h,
                    today: h.today,
                    otherMonth: h.otherMonth,
                    selected: i.isSelected(h),
                    disabled: !h.selectable
                  }
                }), {
                  "data-p-today": h.today,
                  "data-p-other-month": h.otherMonth,
                  "data-pc-group-section": "tablebodycell"
                }), [e.showOtherMonths || !h.otherMonth ? co((g(), $("span", y({
                  key: 0,
                  class: e.cx("day", {
                    date: h
                  }),
                  onClick: function(v) {
                    return i.onDateSelect(v, h);
                  },
                  draggable: "false",
                  onKeydown: function(v) {
                    return i.onDateCellKeydown(v, h, f);
                  },
                  "aria-selected": i.isSelected(h),
                  "aria-disabled": !h.selectable,
                  ref_for: !0
                }, e.ptm("day", {
                  context: {
                    date: h,
                    today: h.today,
                    otherMonth: h.otherMonth,
                    selected: i.isSelected(h),
                    disabled: !h.selectable
                  }
                }), {
                  "data-p-disabled": !h.selectable,
                  "data-p-selected": i.isSelected(h),
                  "data-pc-group-section": "tablebodycelllabel"
                }), [B(e.$slots, "date", {
                  date: h
                }, function() {
                  return [ie(z(h.day), 1)];
                })], 16, _0)), [[d]]) : I("", !0), i.isSelected(h) ? (g(), $("div", y({
                  key: 1,
                  class: "p-hidden-accessible",
                  "aria-live": "polite",
                  ref_for: !0
                }, e.ptm("hiddenSelectedDay"), {
                  "data-p-hidden-accessible": !0
                }), z(h.day), 17)) : I("", !0)], 16, B0);
              }), 128))], 16);
            }), 128))], 16)], 16)) : I("", !0)], 16);
          }), 128))], 16), n.currentView === "month" ? (g(), $("div", y({
            key: 0,
            class: e.cx("monthView")
          }, e.ptm("monthView")), [(g(!0), $(pe, null, Ze(i.monthPickerValues, function(c, f) {
            return co((g(), $("span", y({
              key: c,
              onClick: function(p) {
                return i.onMonthSelect(p, {
                  month: c,
                  index: f
                });
              },
              onKeydown: function(p) {
                return i.onMonthCellKeydown(p, {
                  month: c,
                  index: f
                });
              },
              class: e.cx("month", {
                month: c,
                index: f
              }),
              ref_for: !0
            }, e.ptm("month", {
              context: {
                month: c,
                monthIndex: f,
                selected: i.isMonthSelected(f),
                disabled: !c.selectable
              }
            }), {
              "data-p-disabled": !c.selectable,
              "data-p-selected": i.isMonthSelected(f)
            }), [ie(z(c.value) + " ", 1), i.isMonthSelected(f) ? (g(), $("div", y({
              key: 0,
              class: "p-hidden-accessible",
              "aria-live": "polite",
              ref_for: !0
            }, e.ptm("hiddenMonth"), {
              "data-p-hidden-accessible": !0
            }), z(c.value), 17)) : I("", !0)], 16, M0)), [[d]]);
          }), 128))], 16)) : I("", !0), n.currentView === "year" ? (g(), $("div", y({
            key: 1,
            class: e.cx("yearView")
          }, e.ptm("yearView")), [(g(!0), $(pe, null, Ze(i.yearPickerValues, function(c) {
            return co((g(), $("span", y({
              key: c.value,
              onClick: function(u) {
                return i.onYearSelect(u, c);
              },
              onKeydown: function(u) {
                return i.onYearCellKeydown(u, c);
              },
              class: e.cx("year", {
                year: c
              }),
              ref_for: !0
            }, e.ptm("year", {
              context: {
                year: c,
                selected: i.isYearSelected(c.value),
                disabled: !c.selectable
              }
            }), {
              "data-p-disabled": !c.selectable,
              "data-p-selected": i.isYearSelected(c.value)
            }), [ie(z(c.value) + " ", 1), i.isYearSelected(c.value) ? (g(), $("div", y({
              key: 0,
              class: "p-hidden-accessible",
              "aria-live": "polite",
              ref_for: !0
            }, e.ptm("hiddenYear"), {
              "data-p-hidden-accessible": !0
            }), z(c.value), 17)) : I("", !0)], 16, T0)), [[d]]);
          }), 128))], 16)) : I("", !0)], 64)), (e.showTime || e.timeOnly) && n.currentView === "date" ? (g(), $("div", y({
            key: 1,
            class: e.cx("timePicker")
          }, e.ptm("timePicker")), [P("div", y({
            class: e.cx("hourPicker")
          }, e.ptm("hourPicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [R(l, y({
            class: e.cx("pcIncrementButton"),
            "aria-label": e.$primevue.config.locale.nextHour,
            unstyled: e.unstyled,
            onMousedown: o[9] || (o[9] = function(c) {
              return i.onTimePickerElementMouseDown(c, 0, 1);
            }),
            onMouseup: o[10] || (o[10] = function(c) {
              return i.onTimePickerElementMouseUp(c);
            }),
            onKeydown: [i.onContainerButtonKeydown, o[12] || (o[12] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 0, 1);
            }, ["enter"])), o[13] || (o[13] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 0, 1);
            }, ["space"]))],
            onMouseleave: o[11] || (o[11] = function(c) {
              return i.onTimePickerElementMouseLeave();
            }),
            onKeyup: [o[14] || (o[14] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["enter"])), o[15] || (o[15] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["space"]))]
          }, e.timepickerButtonProps, {
            pt: e.ptm("pcIncrementButton"),
            "data-pc-group-section": "timepickerbutton"
          }), {
            icon: S(function(c) {
              return [B(e.$slots, "incrementicon", {}, function() {
                return [(g(), M(fe(e.incrementIcon ? "span" : "ChevronUpIcon"), y({
                  class: [e.incrementIcon, c.class]
                }, e.ptm("pcIncrementButton").icon, {
                  "data-pc-group-section": "timepickerlabel"
                }), null, 16, ["class"]))];
              })];
            }),
            _: 3
          }, 16, ["class", "aria-label", "unstyled", "onKeydown", "pt"]), P("span", y(e.ptm("hour"), {
            "data-pc-group-section": "timepickerlabel"
          }), z(i.formattedCurrentHour), 17), R(l, y({
            class: e.cx("pcDecrementButton"),
            "aria-label": e.$primevue.config.locale.prevHour,
            unstyled: e.unstyled,
            onMousedown: o[16] || (o[16] = function(c) {
              return i.onTimePickerElementMouseDown(c, 0, -1);
            }),
            onMouseup: o[17] || (o[17] = function(c) {
              return i.onTimePickerElementMouseUp(c);
            }),
            onKeydown: [i.onContainerButtonKeydown, o[19] || (o[19] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 0, -1);
            }, ["enter"])), o[20] || (o[20] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 0, -1);
            }, ["space"]))],
            onMouseleave: o[18] || (o[18] = function(c) {
              return i.onTimePickerElementMouseLeave();
            }),
            onKeyup: [o[21] || (o[21] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["enter"])), o[22] || (o[22] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["space"]))]
          }, e.timepickerButtonProps, {
            pt: e.ptm("pcDecrementButton"),
            "data-pc-group-section": "timepickerbutton"
          }), {
            icon: S(function(c) {
              return [B(e.$slots, "decrementicon", {}, function() {
                return [(g(), M(fe(e.decrementIcon ? "span" : "ChevronDownIcon"), y({
                  class: [e.decrementIcon, c.class]
                }, e.ptm("pcDecrementButton").icon, {
                  "data-pc-group-section": "timepickerlabel"
                }), null, 16, ["class"]))];
              })];
            }),
            _: 3
          }, 16, ["class", "aria-label", "unstyled", "onKeydown", "pt"])], 16), P("div", y(e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [P("span", y(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), z(e.timeSeparator), 17)], 16), P("div", y({
            class: e.cx("minutePicker")
          }, e.ptm("minutePicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [R(l, y({
            class: e.cx("pcIncrementButton"),
            "aria-label": e.$primevue.config.locale.nextMinute,
            disabled: e.disabled,
            unstyled: e.unstyled,
            onMousedown: o[23] || (o[23] = function(c) {
              return i.onTimePickerElementMouseDown(c, 1, 1);
            }),
            onMouseup: o[24] || (o[24] = function(c) {
              return i.onTimePickerElementMouseUp(c);
            }),
            onKeydown: [i.onContainerButtonKeydown, o[26] || (o[26] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 1, 1);
            }, ["enter"])), o[27] || (o[27] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 1, 1);
            }, ["space"]))],
            onMouseleave: o[25] || (o[25] = function(c) {
              return i.onTimePickerElementMouseLeave();
            }),
            onKeyup: [o[28] || (o[28] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["enter"])), o[29] || (o[29] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["space"]))]
          }, e.timepickerButtonProps, {
            pt: e.ptm("pcIncrementButton"),
            "data-pc-group-section": "timepickerbutton"
          }), {
            icon: S(function(c) {
              return [B(e.$slots, "incrementicon", {}, function() {
                return [(g(), M(fe(e.incrementIcon ? "span" : "ChevronUpIcon"), y({
                  class: [e.incrementIcon, c.class]
                }, e.ptm("pcIncrementButton").icon, {
                  "data-pc-group-section": "timepickerlabel"
                }), null, 16, ["class"]))];
              })];
            }),
            _: 3
          }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"]), P("span", y(e.ptm("minute"), {
            "data-pc-group-section": "timepickerlabel"
          }), z(i.formattedCurrentMinute), 17), R(l, y({
            class: e.cx("pcDecrementButton"),
            "aria-label": e.$primevue.config.locale.prevMinute,
            disabled: e.disabled,
            onMousedown: o[30] || (o[30] = function(c) {
              return i.onTimePickerElementMouseDown(c, 1, -1);
            }),
            onMouseup: o[31] || (o[31] = function(c) {
              return i.onTimePickerElementMouseUp(c);
            }),
            onKeydown: [i.onContainerButtonKeydown, o[33] || (o[33] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 1, -1);
            }, ["enter"])), o[34] || (o[34] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 1, -1);
            }, ["space"]))],
            onMouseleave: o[32] || (o[32] = function(c) {
              return i.onTimePickerElementMouseLeave();
            }),
            onKeyup: [o[35] || (o[35] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["enter"])), o[36] || (o[36] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["space"]))]
          }, e.timepickerButtonProps, {
            pt: e.ptm("pcDecrementButton"),
            "data-pc-group-section": "timepickerbutton"
          }), {
            icon: S(function(c) {
              return [B(e.$slots, "decrementicon", {}, function() {
                return [(g(), M(fe(e.decrementIcon ? "span" : "ChevronDownIcon"), y({
                  class: [e.decrementIcon, c.class]
                }, e.ptm("pcDecrementButton").icon, {
                  "data-pc-group-section": "timepickerlabel"
                }), null, 16, ["class"]))];
              })];
            }),
            _: 3
          }, 16, ["class", "aria-label", "disabled", "onKeydown", "pt"])], 16), e.showSeconds ? (g(), $("div", y({
            key: 0,
            class: e.cx("separatorContainer")
          }, e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [P("span", y(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), z(e.timeSeparator), 17)], 16)) : I("", !0), e.showSeconds ? (g(), $("div", y({
            key: 1,
            class: e.cx("secondPicker")
          }, e.ptm("secondPicker"), {
            "data-pc-group-section": "timepickerContainer"
          }), [R(l, y({
            class: e.cx("pcIncrementButton"),
            "aria-label": e.$primevue.config.locale.nextSecond,
            disabled: e.disabled,
            unstyled: e.unstyled,
            onMousedown: o[37] || (o[37] = function(c) {
              return i.onTimePickerElementMouseDown(c, 2, 1);
            }),
            onMouseup: o[38] || (o[38] = function(c) {
              return i.onTimePickerElementMouseUp(c);
            }),
            onKeydown: [i.onContainerButtonKeydown, o[40] || (o[40] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 2, 1);
            }, ["enter"])), o[41] || (o[41] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 2, 1);
            }, ["space"]))],
            onMouseleave: o[39] || (o[39] = function(c) {
              return i.onTimePickerElementMouseLeave();
            }),
            onKeyup: [o[42] || (o[42] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["enter"])), o[43] || (o[43] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["space"]))]
          }, e.timepickerButtonProps, {
            pt: e.ptm("pcIncrementButton"),
            "data-pc-group-section": "timepickerbutton"
          }), {
            icon: S(function(c) {
              return [B(e.$slots, "incrementicon", {}, function() {
                return [(g(), M(fe(e.incrementIcon ? "span" : "ChevronUpIcon"), y({
                  class: [e.incrementIcon, c.class]
                }, e.ptm("pcIncrementButton").icon, {
                  "data-pc-group-section": "timepickerlabel"
                }), null, 16, ["class"]))];
              })];
            }),
            _: 3
          }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"]), P("span", y(e.ptm("second"), {
            "data-pc-group-section": "timepickerlabel"
          }), z(i.formattedCurrentSecond), 17), R(l, y({
            class: e.cx("pcDecrementButton"),
            "aria-label": e.$primevue.config.locale.prevSecond,
            disabled: e.disabled,
            unstyled: e.unstyled,
            onMousedown: o[44] || (o[44] = function(c) {
              return i.onTimePickerElementMouseDown(c, 2, -1);
            }),
            onMouseup: o[45] || (o[45] = function(c) {
              return i.onTimePickerElementMouseUp(c);
            }),
            onKeydown: [i.onContainerButtonKeydown, o[47] || (o[47] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 2, -1);
            }, ["enter"])), o[48] || (o[48] = K(function(c) {
              return i.onTimePickerElementMouseDown(c, 2, -1);
            }, ["space"]))],
            onMouseleave: o[46] || (o[46] = function(c) {
              return i.onTimePickerElementMouseLeave();
            }),
            onKeyup: [o[49] || (o[49] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["enter"])), o[50] || (o[50] = K(function(c) {
              return i.onTimePickerElementMouseUp(c);
            }, ["space"]))]
          }, e.timepickerButtonProps, {
            pt: e.ptm("pcDecrementButton"),
            "data-pc-group-section": "timepickerbutton"
          }), {
            icon: S(function(c) {
              return [B(e.$slots, "decrementicon", {}, function() {
                return [(g(), M(fe(e.decrementIcon ? "span" : "ChevronDownIcon"), y({
                  class: [e.decrementIcon, c.class]
                }, e.ptm("pcDecrementButton").icon, {
                  "data-pc-group-section": "timepickerlabel"
                }), null, 16, ["class"]))];
              })];
            }),
            _: 3
          }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"])], 16)) : I("", !0), e.hourFormat == "12" ? (g(), $("div", y({
            key: 2,
            class: e.cx("separatorContainer")
          }, e.ptm("separatorContainer"), {
            "data-pc-group-section": "timepickerContainer"
          }), [P("span", y(e.ptm("separator"), {
            "data-pc-group-section": "timepickerlabel"
          }), z(e.timeSeparator), 17)], 16)) : I("", !0), e.hourFormat == "12" ? (g(), $("div", y({
            key: 3,
            class: e.cx("ampmPicker")
          }, e.ptm("ampmPicker")), [R(l, y({
            class: e.cx("pcIncrementButton"),
            "aria-label": e.$primevue.config.locale.am,
            disabled: e.disabled,
            unstyled: e.unstyled,
            onClick: o[51] || (o[51] = function(c) {
              return i.toggleAMPM(c);
            }),
            onKeydown: i.onContainerButtonKeydown
          }, e.timepickerButtonProps, {
            pt: e.ptm("pcIncrementButton"),
            "data-pc-group-section": "timepickerbutton"
          }), {
            icon: S(function(c) {
              return [B(e.$slots, "incrementicon", {
                class: L(e.cx("incrementIcon"))
              }, function() {
                return [(g(), M(fe(e.incrementIcon ? "span" : "ChevronUpIcon"), y({
                  class: [e.cx("incrementIcon"), c.class]
                }, e.ptm("pcIncrementButton").icon, {
                  "data-pc-group-section": "timepickerlabel"
                }), null, 16, ["class"]))];
              })];
            }),
            _: 3
          }, 16, ["class", "aria-label", "disabled", "unstyled", "onKeydown", "pt"]), P("span", y(e.ptm("ampm"), {
            "data-pc-group-section": "timepickerlabel"
          }), z(n.pm ? e.$primevue.config.locale.pm : e.$primevue.config.locale.am), 17), R(l, y({
            class: e.cx("pcDecrementButton"),
            "aria-label": e.$primevue.config.locale.pm,
            disabled: e.disabled,
            onClick: o[52] || (o[52] = function(c) {
              return i.toggleAMPM(c);
            }),
            onKeydown: i.onContainerButtonKeydown
          }, e.timepickerButtonProps, {
            pt: e.ptm("pcDecrementButton"),
            "data-pc-group-section": "timepickerbutton"
          }), {
            icon: S(function(c) {
              return [B(e.$slots, "decrementicon", {
                class: L(e.cx("decrementIcon"))
              }, function() {
                return [(g(), M(fe(e.decrementIcon ? "span" : "ChevronDownIcon"), y({
                  class: [e.cx("decrementIcon"), c.class]
                }, e.ptm("pcDecrementButton").icon, {
                  "data-pc-group-section": "timepickerlabel"
                }), null, 16, ["class"]))];
              })];
            }),
            _: 3
          }, 16, ["class", "aria-label", "disabled", "onKeydown", "pt"])], 16)) : I("", !0)], 16)) : I("", !0), e.showButtonBar ? (g(), $("div", y({
            key: 2,
            class: e.cx("buttonbar")
          }, e.ptm("buttonbar")), [R(l, y({
            label: i.todayLabel,
            onClick: o[53] || (o[53] = function(c) {
              return i.onTodayButtonClick(c);
            }),
            class: e.cx("pcTodayButton"),
            unstyled: e.unstyled,
            onKeydown: i.onContainerButtonKeydown
          }, e.todayButtonProps, {
            pt: e.ptm("pcTodayButton"),
            "data-pc-group-section": "button"
          }), null, 16, ["label", "class", "unstyled", "onKeydown", "pt"]), R(l, y({
            label: i.clearLabel,
            onClick: o[54] || (o[54] = function(c) {
              return i.onClearButtonClick(c);
            }),
            class: e.cx("pcClearButton"),
            unstyled: e.unstyled,
            onKeydown: i.onContainerButtonKeydown
          }, e.clearButtonProps, {
            pt: e.ptm("pcClearButton"),
            "data-pc-group-section": "button"
          }), null, 16, ["label", "class", "unstyled", "onKeydown", "pt"])], 16)) : I("", !0), B(e.$slots, "footer")], 16, v0)) : I("", !0)];
        }),
        _: 3
      }, 16, ["onAfterEnter", "onAfterLeave", "onLeave"])];
    }),
    _: 3
  }, 8, ["appendTo", "disabled"])], 16, m0);
}
Oa.render = P0;
const D0 = /* @__PURE__ */ A({
  __name: "BgDatePicker",
  props: {
    showTime: { type: Boolean, default: !1 },
    selectionMode: { default: "single" },
    inline: { type: Boolean, default: !1 },
    view: { default: "date" }
  },
  setup(e) {
    return (o, t) => (g(), M(U, {
      is: k(Oa),
      deep: "",
      "show-time": o.showTime,
      "pt:root": o.$style.root,
      "pt:panel": o.$style.panel,
      "pt:day-view": o.$style.dayView,
      "pt:month-view": o.$style.monthView,
      "pt:year-view": o.$style.yearView,
      "pt:day-cell": o.$style.dayCell,
      "pt:day": o.$style.day,
      "pt:header": o.$style.header,
      "pt:title": o.$style.title,
      size: "small",
      view: o.view,
      "date-format": o.view === "date" ? "dd/mm/yy" : "mm/yy",
      "show-button-bar": "",
      "selection-mode": o.selectionMode,
      inline: o.inline
    }, null, 8, ["is", "show-time", "pt:root", "pt:panel", "pt:day-view", "pt:month-view", "pt:year-view", "pt:day-cell", "pt:day", "pt:header", "pt:title", "view", "date-format", "selection-mode", "inline"]));
  }
}), O0 = "_root_1apmb_2", R0 = "_nav-button_1apmb_6", L0 = "_panel_1apmb_12", A0 = "_day-view_1apmb_17", I0 = "_month-view_1apmb_18", E0 = "_year-view_1apmb_19", z0 = "_day-cell_1apmb_23", N0 = "_header_1apmb_27", H0 = "_title_1apmb_31", V0 = {
  root: O0,
  navButton: R0,
  panel: L0,
  dayView: A0,
  monthView: I0,
  yearView: E0,
  dayCell: z0,
  header: N0,
  title: H0
}, F0 = {
  $style: V0
}, Jn = /* @__PURE__ */ W(D0, [["__cssModules", F0]]);
class Qe {
  constructor(o) {
    Gr(this, "date");
    this.date = o || /* @__PURE__ */ new Date();
  }
  get name() {
    return $l(Intl.DateTimeFormat("pt-BR", { month: "long" }).format(this.date));
  }
  get label() {
    return this.date.getFullYear() === (/* @__PURE__ */ new Date()).getFullYear() ? this.name : `${this.name} ${this.date.getFullYear()}`;
  }
  get startDate() {
    return new Date(this.date.getFullYear(), this.date.getMonth(), 1);
  }
  get endDate() {
    return new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0, 23, 59, 59, 999);
  }
  next() {
    return new Qe(new Date(this.date.getFullYear(), this.date.getMonth() + 1));
  }
  previous() {
    return new Qe(new Date(this.date.getFullYear(), this.date.getMonth() - 1));
  }
}
const ei = (e, o) => e.getFullYear() === o.getFullYear() && e.getMonth() === o.getMonth() && e.getDate() === o.getDate(), Ra = (e, o, t) => {
  const r = e[o];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((n, i) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      i.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + o + (o.split("/").length !== t ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
};
var j0 = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  panel: {
    borderWidth: "0 0 1px 0",
    borderColor: "{content.border.color}"
  },
  header: {
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{text.color}",
    padding: "1.125rem",
    fontWeight: "600",
    borderRadius: "0",
    borderWidth: "0",
    borderColor: "{content.border.color}",
    background: "{content.background}",
    hoverBackground: "{content.background}",
    activeBackground: "{content.background}",
    activeHoverBackground: "{content.background}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}"
    },
    toggleIcon: {
      color: "{text.muted.color}",
      hoverColor: "{text.color}",
      activeColor: "{text.color}",
      activeHoverColor: "{text.color}"
    },
    first: {
      topBorderRadius: "{content.border.radius}",
      borderWidth: "0"
    },
    last: {
      bottomBorderRadius: "{content.border.radius}",
      activeBottomBorderRadius: "0"
    }
  },
  content: {
    borderWidth: "0",
    borderColor: "{content.border.color}",
    background: "{content.background}",
    color: "{text.color}",
    padding: "0 1.125rem 1.125rem 1.125rem"
  }
}, Z0 = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}"
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}"
  },
  list: {
    padding: "{list.padding}",
    gap: "{list.gap}"
  },
  option: {
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusBackground: "{list.option.selected.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    selectedColor: "{list.option.selected.color}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}"
  },
  optionGroup: {
    background: "{list.option.group.background}",
    color: "{list.option.group.color}",
    fontWeight: "{list.option.group.font.weight}",
    padding: "{list.option.group.padding}"
  },
  dropdown: {
    width: "2.5rem",
    sm: {
      width: "2rem"
    },
    lg: {
      width: "3rem"
    },
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.border.color}",
    activeBorderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  chip: {
    borderRadius: "{border.radius.sm}"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  },
  colorScheme: {
    light: {
      chip: {
        focusBackground: "{surface.200}",
        focusColor: "{surface.800}"
      },
      dropdown: {
        background: "{surface.100}",
        hoverBackground: "{surface.200}",
        activeBackground: "{surface.300}",
        color: "{surface.600}",
        hoverColor: "{surface.700}",
        activeColor: "{surface.800}"
      }
    },
    dark: {
      chip: {
        focusBackground: "{surface.700}",
        focusColor: "{surface.0}"
      },
      dropdown: {
        background: "{surface.800}",
        hoverBackground: "{surface.700}",
        activeBackground: "{surface.600}",
        color: "{surface.300}",
        hoverColor: "{surface.200}",
        activeColor: "{surface.100}"
      }
    }
  }
}, W0 = {
  root: {
    width: "2rem",
    height: "2rem",
    fontSize: "1rem",
    background: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}"
  },
  icon: {
    size: "1rem"
  },
  group: {
    borderColor: "{content.background}",
    offset: "-0.75rem"
  },
  lg: {
    width: "3rem",
    height: "3rem",
    fontSize: "1.5rem",
    icon: {
      size: "1.5rem"
    },
    group: {
      offset: "-1rem"
    }
  },
  xl: {
    width: "4rem",
    height: "4rem",
    fontSize: "2rem",
    icon: {
      size: "2rem"
    },
    group: {
      offset: "-1.5rem"
    }
  }
}, Y0 = {
  root: {
    borderRadius: "{border.radius.md}",
    padding: "0 0.5rem",
    fontSize: "0.75rem",
    fontWeight: "700",
    minWidth: "1.5rem",
    height: "1.5rem"
  },
  dot: {
    size: "0.5rem"
  },
  sm: {
    fontSize: "0.625rem",
    minWidth: "1.25rem",
    height: "1.25rem"
  },
  lg: {
    fontSize: "0.875rem",
    minWidth: "1.75rem",
    height: "1.75rem"
  },
  xl: {
    fontSize: "1rem",
    minWidth: "2rem",
    height: "2rem"
  },
  colorScheme: {
    light: {
      primary: {
        background: "{primary.color}",
        color: "{primary.contrast.color}"
      },
      secondary: {
        background: "{surface.100}",
        color: "{surface.600}"
      },
      success: {
        background: "{green.500}",
        color: "{surface.0}"
      },
      info: {
        background: "{sky.500}",
        color: "{surface.0}"
      },
      warn: {
        background: "{orange.500}",
        color: "{surface.0}"
      },
      danger: {
        background: "{red.500}",
        color: "{surface.0}"
      },
      contrast: {
        background: "{surface.950}",
        color: "{surface.0}"
      }
    },
    dark: {
      primary: {
        background: "{primary.color}",
        color: "{primary.contrast.color}"
      },
      secondary: {
        background: "{surface.800}",
        color: "{surface.300}"
      },
      success: {
        background: "{green.400}",
        color: "{green.950}"
      },
      info: {
        background: "{sky.400}",
        color: "{sky.950}"
      },
      warn: {
        background: "{orange.400}",
        color: "{orange.950}"
      },
      danger: {
        background: "{red.400}",
        color: "{red.950}"
      },
      contrast: {
        background: "{surface.0}",
        color: "{surface.950}"
      }
    }
  }
}, K0 = {
  primitive: {
    borderRadius: {
      none: "0",
      xs: "2px",
      sm: "4px",
      md: "6px",
      lg: "8px",
      xl: "12px"
    },
    emerald: {
      50: "#ecfdf5",
      100: "#d1fae5",
      200: "#a7f3d0",
      300: "#6ee7b7",
      400: "#34d399",
      500: "#10b981",
      600: "#059669",
      700: "#047857",
      800: "#065f46",
      900: "#064e3b",
      950: "#022c22"
    },
    green: {
      50: "#f0fdf4",
      100: "#dcfce7",
      200: "#bbf7d0",
      300: "#86efac",
      400: "#4ade80",
      500: "#22c55e",
      600: "#16a34a",
      700: "#15803d",
      800: "#166534",
      900: "#14532d",
      950: "#052e16"
    },
    lime: {
      50: "#f7fee7",
      100: "#ecfccb",
      200: "#d9f99d",
      300: "#bef264",
      400: "#a3e635",
      500: "#84cc16",
      600: "#65a30d",
      700: "#4d7c0f",
      800: "#3f6212",
      900: "#365314",
      950: "#1a2e05"
    },
    red: {
      50: "#fef2f2",
      100: "#fee2e2",
      200: "#fecaca",
      300: "#fca5a5",
      400: "#f87171",
      500: "#ef4444",
      600: "#dc2626",
      700: "#b91c1c",
      800: "#991b1b",
      900: "#7f1d1d",
      950: "#450a0a"
    },
    orange: {
      50: "#fff7ed",
      100: "#ffedd5",
      200: "#fed7aa",
      300: "#fdba74",
      400: "#fb923c",
      500: "#f97316",
      600: "#ea580c",
      700: "#c2410c",
      800: "#9a3412",
      900: "#7c2d12",
      950: "#431407"
    },
    amber: {
      50: "#fffbeb",
      100: "#fef3c7",
      200: "#fde68a",
      300: "#fcd34d",
      400: "#fbbf24",
      500: "#f59e0b",
      600: "#d97706",
      700: "#b45309",
      800: "#92400e",
      900: "#78350f",
      950: "#451a03"
    },
    yellow: {
      50: "#fefce8",
      100: "#fef9c3",
      200: "#fef08a",
      300: "#fde047",
      400: "#facc15",
      500: "#eab308",
      600: "#ca8a04",
      700: "#a16207",
      800: "#854d0e",
      900: "#713f12",
      950: "#422006"
    },
    teal: {
      50: "#f0fdfa",
      100: "#ccfbf1",
      200: "#99f6e4",
      300: "#5eead4",
      400: "#2dd4bf",
      500: "#14b8a6",
      600: "#0d9488",
      700: "#0f766e",
      800: "#115e59",
      900: "#134e4a",
      950: "#042f2e"
    },
    cyan: {
      50: "#ecfeff",
      100: "#cffafe",
      200: "#a5f3fc",
      300: "#67e8f9",
      400: "#22d3ee",
      500: "#06b6d4",
      600: "#0891b2",
      700: "#0e7490",
      800: "#155e75",
      900: "#164e63",
      950: "#083344"
    },
    sky: {
      50: "#f0f9ff",
      100: "#e0f2fe",
      200: "#bae6fd",
      300: "#7dd3fc",
      400: "#38bdf8",
      500: "#0ea5e9",
      600: "#0284c7",
      700: "#0369a1",
      800: "#075985",
      900: "#0c4a6e",
      950: "#082f49"
    },
    blue: {
      50: "#eff6ff",
      100: "#dbeafe",
      200: "#bfdbfe",
      300: "#93c5fd",
      400: "#60a5fa",
      500: "#3b82f6",
      600: "#2563eb",
      700: "#1d4ed8",
      800: "#1e40af",
      900: "#1e3a8a",
      950: "#172554"
    },
    indigo: {
      50: "#eef2ff",
      100: "#e0e7ff",
      200: "#c7d2fe",
      300: "#a5b4fc",
      400: "#818cf8",
      500: "#6366f1",
      600: "#4f46e5",
      700: "#4338ca",
      800: "#3730a3",
      900: "#312e81",
      950: "#1e1b4b"
    },
    violet: {
      50: "#f5f3ff",
      100: "#ede9fe",
      200: "#ddd6fe",
      300: "#c4b5fd",
      400: "#a78bfa",
      500: "#8b5cf6",
      600: "#7c3aed",
      700: "#6d28d9",
      800: "#5b21b6",
      900: "#4c1d95",
      950: "#2e1065"
    },
    purple: {
      50: "#faf5ff",
      100: "#f3e8ff",
      200: "#e9d5ff",
      300: "#d8b4fe",
      400: "#c084fc",
      500: "#a855f7",
      600: "#9333ea",
      700: "#7e22ce",
      800: "#6b21a8",
      900: "#581c87",
      950: "#3b0764"
    },
    fuchsia: {
      50: "#fdf4ff",
      100: "#fae8ff",
      200: "#f5d0fe",
      300: "#f0abfc",
      400: "#e879f9",
      500: "#d946ef",
      600: "#c026d3",
      700: "#a21caf",
      800: "#86198f",
      900: "#701a75",
      950: "#4a044e"
    },
    pink: {
      50: "#fdf2f8",
      100: "#fce7f3",
      200: "#fbcfe8",
      300: "#f9a8d4",
      400: "#f472b6",
      500: "#ec4899",
      600: "#db2777",
      700: "#be185d",
      800: "#9d174d",
      900: "#831843",
      950: "#500724"
    },
    rose: {
      50: "#fff1f2",
      100: "#ffe4e6",
      200: "#fecdd3",
      300: "#fda4af",
      400: "#fb7185",
      500: "#f43f5e",
      600: "#e11d48",
      700: "#be123c",
      800: "#9f1239",
      900: "#881337",
      950: "#4c0519"
    },
    slate: {
      50: "#f8fafc",
      100: "#f1f5f9",
      200: "#e2e8f0",
      300: "#cbd5e1",
      400: "#94a3b8",
      500: "#64748b",
      600: "#475569",
      700: "#334155",
      800: "#1e293b",
      900: "#0f172a",
      950: "#020617"
    },
    gray: {
      50: "#f9fafb",
      100: "#f3f4f6",
      200: "#e5e7eb",
      300: "#d1d5db",
      400: "#9ca3af",
      500: "#6b7280",
      600: "#4b5563",
      700: "#374151",
      800: "#1f2937",
      900: "#111827",
      950: "#030712"
    },
    zinc: {
      50: "#fafafa",
      100: "#f4f4f5",
      200: "#e4e4e7",
      300: "#d4d4d8",
      400: "#a1a1aa",
      500: "#71717a",
      600: "#52525b",
      700: "#3f3f46",
      800: "#27272a",
      900: "#18181b",
      950: "#09090b"
    },
    neutral: {
      50: "#fafafa",
      100: "#f5f5f5",
      200: "#e5e5e5",
      300: "#d4d4d4",
      400: "#a3a3a3",
      500: "#737373",
      600: "#525252",
      700: "#404040",
      800: "#262626",
      900: "#171717",
      950: "#0a0a0a"
    },
    stone: {
      50: "#fafaf9",
      100: "#f5f5f4",
      200: "#e7e5e4",
      300: "#d6d3d1",
      400: "#a8a29e",
      500: "#78716c",
      600: "#57534e",
      700: "#44403c",
      800: "#292524",
      900: "#1c1917",
      950: "#0c0a09"
    }
  },
  semantic: {
    transitionDuration: "0.2s",
    focusRing: {
      width: "1px",
      style: "solid",
      color: "{primary.color}",
      offset: "2px",
      shadow: "none"
    },
    disabledOpacity: "0.6",
    iconSize: "1rem",
    anchorGutter: "2px",
    primary: {
      50: "{emerald.50}",
      100: "{emerald.100}",
      200: "{emerald.200}",
      300: "{emerald.300}",
      400: "{emerald.400}",
      500: "{emerald.500}",
      600: "{emerald.600}",
      700: "{emerald.700}",
      800: "{emerald.800}",
      900: "{emerald.900}",
      950: "{emerald.950}"
    },
    formField: {
      paddingX: "0.75rem",
      paddingY: "0.5rem",
      sm: {
        fontSize: "0.875rem",
        paddingX: "0.625rem",
        paddingY: "0.375rem"
      },
      lg: {
        fontSize: "1.125rem",
        paddingX: "0.875rem",
        paddingY: "0.625rem"
      },
      borderRadius: "{border.radius.md}",
      focusRing: {
        width: "0",
        style: "none",
        color: "transparent",
        offset: "0",
        shadow: "none"
      },
      transitionDuration: "{transition.duration}"
    },
    list: {
      padding: "0.25rem 0.25rem",
      gap: "2px",
      header: {
        padding: "0.5rem 1rem 0.25rem 1rem"
      },
      option: {
        padding: "0.5rem 0.75rem",
        borderRadius: "{border.radius.sm}"
      },
      optionGroup: {
        padding: "0.5rem 0.75rem",
        fontWeight: "600"
      }
    },
    content: {
      borderRadius: "{border.radius.md}"
    },
    mask: {
      transitionDuration: "0.15s"
    },
    navigation: {
      list: {
        padding: "0.25rem 0.25rem",
        gap: "2px"
      },
      item: {
        padding: "0.5rem 0.75rem",
        borderRadius: "{border.radius.sm}",
        gap: "0.5rem"
      },
      submenuLabel: {
        padding: "0.5rem 0.75rem",
        fontWeight: "600"
      },
      submenuIcon: {
        size: "0.875rem"
      }
    },
    overlay: {
      select: {
        borderRadius: "{border.radius.md}",
        shadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)"
      },
      popover: {
        borderRadius: "{border.radius.md}",
        padding: "0.75rem",
        shadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)"
      },
      modal: {
        borderRadius: "{border.radius.xl}",
        padding: "1.25rem",
        shadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)"
      },
      navigation: {
        shadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)"
      }
    },
    colorScheme: {
      light: {
        surface: {
          0: "#ffffff",
          50: "{slate.50}",
          100: "{slate.100}",
          200: "{slate.200}",
          300: "{slate.300}",
          400: "{slate.400}",
          500: "{slate.500}",
          600: "{slate.600}",
          700: "{slate.700}",
          800: "{slate.800}",
          900: "{slate.900}",
          950: "{slate.950}"
        },
        primary: {
          color: "{primary.500}",
          contrastColor: "#ffffff",
          hoverColor: "{primary.600}",
          activeColor: "{primary.700}"
        },
        highlight: {
          background: "{primary.50}",
          focusBackground: "{primary.100}",
          color: "{primary.700}",
          focusColor: "{primary.800}"
        },
        mask: {
          background: "rgba(0,0,0,0.4)",
          color: "{surface.200}"
        },
        formField: {
          background: "{surface.0}",
          disabledBackground: "{surface.200}",
          filledBackground: "{surface.50}",
          filledHoverBackground: "{surface.50}",
          filledFocusBackground: "{surface.50}",
          borderColor: "{surface.300}",
          hoverBorderColor: "{surface.400}",
          focusBorderColor: "{primary.color}",
          invalidBorderColor: "{red.400}",
          color: "{surface.700}",
          disabledColor: "{surface.500}",
          placeholderColor: "{surface.500}",
          invalidPlaceholderColor: "{red.600}",
          floatLabelColor: "{surface.500}",
          floatLabelFocusColor: "{primary.600}",
          floatLabelActiveColor: "{surface.500}",
          floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
          iconColor: "{surface.400}",
          shadow: "0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)"
        },
        text: {
          color: "{surface.700}",
          hoverColor: "{surface.800}",
          mutedColor: "{surface.500}",
          hoverMutedColor: "{surface.600}"
        },
        content: {
          background: "{surface.0}",
          hoverBackground: "{surface.100}",
          borderColor: "{surface.200}",
          color: "{text.color}",
          hoverColor: "{text.hover.color}"
        },
        overlay: {
          select: {
            background: "{surface.0}",
            borderColor: "{surface.200}",
            color: "{text.color}"
          },
          popover: {
            background: "{surface.0}",
            borderColor: "{surface.200}",
            color: "{text.color}"
          },
          modal: {
            background: "{surface.0}",
            borderColor: "{surface.200}",
            color: "{text.color}"
          }
        },
        list: {
          option: {
            focusBackground: "{surface.100}",
            selectedBackground: "{highlight.background}",
            selectedFocusBackground: "{highlight.focus.background}",
            color: "{text.color}",
            focusColor: "{text.hover.color}",
            selectedColor: "{highlight.color}",
            selectedFocusColor: "{highlight.focus.color}",
            icon: {
              color: "{surface.400}",
              focusColor: "{surface.500}"
            }
          },
          optionGroup: {
            background: "transparent",
            color: "{text.muted.color}"
          }
        },
        navigation: {
          item: {
            focusBackground: "{surface.100}",
            activeBackground: "{surface.100}",
            color: "{text.color}",
            focusColor: "{text.hover.color}",
            activeColor: "{text.hover.color}",
            icon: {
              color: "{surface.400}",
              focusColor: "{surface.500}",
              activeColor: "{surface.500}"
            }
          },
          submenuLabel: {
            background: "transparent",
            color: "{text.muted.color}"
          },
          submenuIcon: {
            color: "{surface.400}",
            focusColor: "{surface.500}",
            activeColor: "{surface.500}"
          }
        }
      },
      dark: {
        surface: {
          0: "#ffffff",
          50: "{zinc.50}",
          100: "{zinc.100}",
          200: "{zinc.200}",
          300: "{zinc.300}",
          400: "{zinc.400}",
          500: "{zinc.500}",
          600: "{zinc.600}",
          700: "{zinc.700}",
          800: "{zinc.800}",
          900: "{zinc.900}",
          950: "{zinc.950}"
        },
        primary: {
          color: "{primary.400}",
          contrastColor: "{surface.900}",
          hoverColor: "{primary.300}",
          activeColor: "{primary.200}"
        },
        highlight: {
          background: "color-mix(in srgb, {primary.400}, transparent 84%)",
          focusBackground: "color-mix(in srgb, {primary.400}, transparent 76%)",
          color: "rgba(255,255,255,.87)",
          focusColor: "rgba(255,255,255,.87)"
        },
        mask: {
          background: "rgba(0,0,0,0.6)",
          color: "{surface.200}"
        },
        formField: {
          background: "{surface.950}",
          disabledBackground: "{surface.700}",
          filledBackground: "{surface.800}",
          filledHoverBackground: "{surface.800}",
          filledFocusBackground: "{surface.800}",
          borderColor: "{surface.600}",
          hoverBorderColor: "{surface.500}",
          focusBorderColor: "{primary.color}",
          invalidBorderColor: "{red.300}",
          color: "{surface.0}",
          disabledColor: "{surface.400}",
          placeholderColor: "{surface.400}",
          invalidPlaceholderColor: "{red.400}",
          floatLabelColor: "{surface.400}",
          floatLabelFocusColor: "{primary.color}",
          floatLabelActiveColor: "{surface.400}",
          floatLabelInvalidColor: "{form.field.invalid.placeholder.color}",
          iconColor: "{surface.400}",
          shadow: "0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)"
        },
        text: {
          color: "{surface.0}",
          hoverColor: "{surface.0}",
          mutedColor: "{surface.400}",
          hoverMutedColor: "{surface.300}"
        },
        content: {
          background: "{surface.900}",
          hoverBackground: "{surface.800}",
          borderColor: "{surface.700}",
          color: "{text.color}",
          hoverColor: "{text.hover.color}"
        },
        overlay: {
          select: {
            background: "{surface.900}",
            borderColor: "{surface.700}",
            color: "{text.color}"
          },
          popover: {
            background: "{surface.900}",
            borderColor: "{surface.700}",
            color: "{text.color}"
          },
          modal: {
            background: "{surface.900}",
            borderColor: "{surface.700}",
            color: "{text.color}"
          }
        },
        list: {
          option: {
            focusBackground: "{surface.800}",
            selectedBackground: "{highlight.background}",
            selectedFocusBackground: "{highlight.focus.background}",
            color: "{text.color}",
            focusColor: "{text.hover.color}",
            selectedColor: "{highlight.color}",
            selectedFocusColor: "{highlight.focus.color}",
            icon: {
              color: "{surface.500}",
              focusColor: "{surface.400}"
            }
          },
          optionGroup: {
            background: "transparent",
            color: "{text.muted.color}"
          }
        },
        navigation: {
          item: {
            focusBackground: "{surface.800}",
            activeBackground: "{surface.800}",
            color: "{text.color}",
            focusColor: "{text.hover.color}",
            activeColor: "{text.hover.color}",
            icon: {
              color: "{surface.500}",
              focusColor: "{surface.400}",
              activeColor: "{surface.400}"
            }
          },
          submenuLabel: {
            background: "transparent",
            color: "{text.muted.color}"
          },
          submenuIcon: {
            color: "{surface.500}",
            focusColor: "{surface.400}",
            activeColor: "{surface.400}"
          }
        }
      }
    }
  }
}, U0 = {
  root: {
    borderRadius: "{content.border.radius}"
  }
}, G0 = {
  root: {
    padding: "1rem",
    background: "{content.background}",
    gap: "0.5rem",
    transitionDuration: "{transition.duration}"
  },
  item: {
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    borderRadius: "{content.border.radius}",
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      hoverColor: "{navigation.item.icon.focus.color}"
    },
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  separator: {
    color: "{navigation.item.icon.color}"
  }
}, q0 = {
  root: {
    borderRadius: "{form.field.border.radius}",
    roundedBorderRadius: "2rem",
    gap: "0.5rem",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    iconOnlyWidth: "2.5rem",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    },
    label: {
      fontWeight: "500"
    },
    raisedShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      offset: "{focus.ring.offset}"
    },
    badgeSize: "1rem",
    transitionDuration: "{form.field.transition.duration}"
  },
  colorScheme: {
    light: {
      root: {
        primary: {
          background: "{primary.color}",
          hoverBackground: "{primary.hover.color}",
          activeBackground: "{primary.active.color}",
          borderColor: "{primary.color}",
          hoverBorderColor: "{primary.hover.color}",
          activeBorderColor: "{primary.active.color}",
          color: "{primary.contrast.color}",
          hoverColor: "{primary.contrast.color}",
          activeColor: "{primary.contrast.color}",
          focusRing: {
            color: "{primary.color}",
            shadow: "none"
          }
        },
        secondary: {
          background: "{surface.100}",
          hoverBackground: "{surface.200}",
          activeBackground: "{surface.300}",
          borderColor: "{surface.100}",
          hoverBorderColor: "{surface.200}",
          activeBorderColor: "{surface.300}",
          color: "{surface.600}",
          hoverColor: "{surface.700}",
          activeColor: "{surface.800}",
          focusRing: {
            color: "{surface.600}",
            shadow: "none"
          }
        },
        info: {
          background: "{sky.500}",
          hoverBackground: "{sky.600}",
          activeBackground: "{sky.700}",
          borderColor: "{sky.500}",
          hoverBorderColor: "{sky.600}",
          activeBorderColor: "{sky.700}",
          color: "#ffffff",
          hoverColor: "#ffffff",
          activeColor: "#ffffff",
          focusRing: {
            color: "{sky.500}",
            shadow: "none"
          }
        },
        success: {
          background: "{green.500}",
          hoverBackground: "{green.600}",
          activeBackground: "{green.700}",
          borderColor: "{green.500}",
          hoverBorderColor: "{green.600}",
          activeBorderColor: "{green.700}",
          color: "#ffffff",
          hoverColor: "#ffffff",
          activeColor: "#ffffff",
          focusRing: {
            color: "{green.500}",
            shadow: "none"
          }
        },
        warn: {
          background: "{orange.500}",
          hoverBackground: "{orange.600}",
          activeBackground: "{orange.700}",
          borderColor: "{orange.500}",
          hoverBorderColor: "{orange.600}",
          activeBorderColor: "{orange.700}",
          color: "#ffffff",
          hoverColor: "#ffffff",
          activeColor: "#ffffff",
          focusRing: {
            color: "{orange.500}",
            shadow: "none"
          }
        },
        help: {
          background: "{purple.500}",
          hoverBackground: "{purple.600}",
          activeBackground: "{purple.700}",
          borderColor: "{purple.500}",
          hoverBorderColor: "{purple.600}",
          activeBorderColor: "{purple.700}",
          color: "#ffffff",
          hoverColor: "#ffffff",
          activeColor: "#ffffff",
          focusRing: {
            color: "{purple.500}",
            shadow: "none"
          }
        },
        danger: {
          background: "{red.500}",
          hoverBackground: "{red.600}",
          activeBackground: "{red.700}",
          borderColor: "{red.500}",
          hoverBorderColor: "{red.600}",
          activeBorderColor: "{red.700}",
          color: "#ffffff",
          hoverColor: "#ffffff",
          activeColor: "#ffffff",
          focusRing: {
            color: "{red.500}",
            shadow: "none"
          }
        },
        contrast: {
          background: "{surface.950}",
          hoverBackground: "{surface.900}",
          activeBackground: "{surface.800}",
          borderColor: "{surface.950}",
          hoverBorderColor: "{surface.900}",
          activeBorderColor: "{surface.800}",
          color: "{surface.0}",
          hoverColor: "{surface.0}",
          activeColor: "{surface.0}",
          focusRing: {
            color: "{surface.950}",
            shadow: "none"
          }
        }
      },
      outlined: {
        primary: {
          hoverBackground: "{primary.50}",
          activeBackground: "{primary.100}",
          borderColor: "{primary.200}",
          color: "{primary.color}"
        },
        secondary: {
          hoverBackground: "{surface.50}",
          activeBackground: "{surface.100}",
          borderColor: "{surface.200}",
          color: "{surface.500}"
        },
        success: {
          hoverBackground: "{green.50}",
          activeBackground: "{green.100}",
          borderColor: "{green.200}",
          color: "{green.500}"
        },
        info: {
          hoverBackground: "{sky.50}",
          activeBackground: "{sky.100}",
          borderColor: "{sky.200}",
          color: "{sky.500}"
        },
        warn: {
          hoverBackground: "{orange.50}",
          activeBackground: "{orange.100}",
          borderColor: "{orange.200}",
          color: "{orange.500}"
        },
        help: {
          hoverBackground: "{purple.50}",
          activeBackground: "{purple.100}",
          borderColor: "{purple.200}",
          color: "{purple.500}"
        },
        danger: {
          hoverBackground: "{red.50}",
          activeBackground: "{red.100}",
          borderColor: "{red.200}",
          color: "{red.500}"
        },
        contrast: {
          hoverBackground: "{surface.50}",
          activeBackground: "{surface.100}",
          borderColor: "{surface.700}",
          color: "{surface.950}"
        },
        plain: {
          hoverBackground: "{surface.50}",
          activeBackground: "{surface.100}",
          borderColor: "{surface.200}",
          color: "{surface.700}"
        }
      },
      text: {
        primary: {
          hoverBackground: "{primary.50}",
          activeBackground: "{primary.100}",
          color: "{primary.color}"
        },
        secondary: {
          hoverBackground: "{surface.50}",
          activeBackground: "{surface.100}",
          color: "{surface.500}"
        },
        success: {
          hoverBackground: "{green.50}",
          activeBackground: "{green.100}",
          color: "{green.500}"
        },
        info: {
          hoverBackground: "{sky.50}",
          activeBackground: "{sky.100}",
          color: "{sky.500}"
        },
        warn: {
          hoverBackground: "{orange.50}",
          activeBackground: "{orange.100}",
          color: "{orange.500}"
        },
        help: {
          hoverBackground: "{purple.50}",
          activeBackground: "{purple.100}",
          color: "{purple.500}"
        },
        danger: {
          hoverBackground: "{red.50}",
          activeBackground: "{red.100}",
          color: "{red.500}"
        },
        contrast: {
          hoverBackground: "{surface.50}",
          activeBackground: "{surface.100}",
          color: "{surface.950}"
        },
        plain: {
          hoverBackground: "{surface.50}",
          activeBackground: "{surface.100}",
          color: "{surface.700}"
        }
      },
      link: {
        color: "{primary.color}",
        hoverColor: "{primary.color}",
        activeColor: "{primary.color}"
      }
    },
    dark: {
      root: {
        primary: {
          background: "{primary.color}",
          hoverBackground: "{primary.hover.color}",
          activeBackground: "{primary.active.color}",
          borderColor: "{primary.color}",
          hoverBorderColor: "{primary.hover.color}",
          activeBorderColor: "{primary.active.color}",
          color: "{primary.contrast.color}",
          hoverColor: "{primary.contrast.color}",
          activeColor: "{primary.contrast.color}",
          focusRing: {
            color: "{primary.color}",
            shadow: "none"
          }
        },
        secondary: {
          background: "{surface.800}",
          hoverBackground: "{surface.700}",
          activeBackground: "{surface.600}",
          borderColor: "{surface.800}",
          hoverBorderColor: "{surface.700}",
          activeBorderColor: "{surface.600}",
          color: "{surface.300}",
          hoverColor: "{surface.200}",
          activeColor: "{surface.100}",
          focusRing: {
            color: "{surface.300}",
            shadow: "none"
          }
        },
        info: {
          background: "{sky.400}",
          hoverBackground: "{sky.300}",
          activeBackground: "{sky.200}",
          borderColor: "{sky.400}",
          hoverBorderColor: "{sky.300}",
          activeBorderColor: "{sky.200}",
          color: "{sky.950}",
          hoverColor: "{sky.950}",
          activeColor: "{sky.950}",
          focusRing: {
            color: "{sky.400}",
            shadow: "none"
          }
        },
        success: {
          background: "{green.400}",
          hoverBackground: "{green.300}",
          activeBackground: "{green.200}",
          borderColor: "{green.400}",
          hoverBorderColor: "{green.300}",
          activeBorderColor: "{green.200}",
          color: "{green.950}",
          hoverColor: "{green.950}",
          activeColor: "{green.950}",
          focusRing: {
            color: "{green.400}",
            shadow: "none"
          }
        },
        warn: {
          background: "{orange.400}",
          hoverBackground: "{orange.300}",
          activeBackground: "{orange.200}",
          borderColor: "{orange.400}",
          hoverBorderColor: "{orange.300}",
          activeBorderColor: "{orange.200}",
          color: "{orange.950}",
          hoverColor: "{orange.950}",
          activeColor: "{orange.950}",
          focusRing: {
            color: "{orange.400}",
            shadow: "none"
          }
        },
        help: {
          background: "{purple.400}",
          hoverBackground: "{purple.300}",
          activeBackground: "{purple.200}",
          borderColor: "{purple.400}",
          hoverBorderColor: "{purple.300}",
          activeBorderColor: "{purple.200}",
          color: "{purple.950}",
          hoverColor: "{purple.950}",
          activeColor: "{purple.950}",
          focusRing: {
            color: "{purple.400}",
            shadow: "none"
          }
        },
        danger: {
          background: "{red.400}",
          hoverBackground: "{red.300}",
          activeBackground: "{red.200}",
          borderColor: "{red.400}",
          hoverBorderColor: "{red.300}",
          activeBorderColor: "{red.200}",
          color: "{red.950}",
          hoverColor: "{red.950}",
          activeColor: "{red.950}",
          focusRing: {
            color: "{red.400}",
            shadow: "none"
          }
        },
        contrast: {
          background: "{surface.0}",
          hoverBackground: "{surface.100}",
          activeBackground: "{surface.200}",
          borderColor: "{surface.0}",
          hoverBorderColor: "{surface.100}",
          activeBorderColor: "{surface.200}",
          color: "{surface.950}",
          hoverColor: "{surface.950}",
          activeColor: "{surface.950}",
          focusRing: {
            color: "{surface.0}",
            shadow: "none"
          }
        }
      },
      outlined: {
        primary: {
          hoverBackground: "color-mix(in srgb, {primary.color}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {primary.color}, transparent 84%)",
          borderColor: "{primary.700}",
          color: "{primary.color}"
        },
        secondary: {
          hoverBackground: "rgba(255,255,255,0.04)",
          activeBackground: "rgba(255,255,255,0.16)",
          borderColor: "{surface.700}",
          color: "{surface.400}"
        },
        success: {
          hoverBackground: "color-mix(in srgb, {green.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {green.400}, transparent 84%)",
          borderColor: "{green.700}",
          color: "{green.400}"
        },
        info: {
          hoverBackground: "color-mix(in srgb, {sky.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {sky.400}, transparent 84%)",
          borderColor: "{sky.700}",
          color: "{sky.400}"
        },
        warn: {
          hoverBackground: "color-mix(in srgb, {orange.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {orange.400}, transparent 84%)",
          borderColor: "{orange.700}",
          color: "{orange.400}"
        },
        help: {
          hoverBackground: "color-mix(in srgb, {purple.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {purple.400}, transparent 84%)",
          borderColor: "{purple.700}",
          color: "{purple.400}"
        },
        danger: {
          hoverBackground: "color-mix(in srgb, {red.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {red.400}, transparent 84%)",
          borderColor: "{red.700}",
          color: "{red.400}"
        },
        contrast: {
          hoverBackground: "{surface.800}",
          activeBackground: "{surface.700}",
          borderColor: "{surface.500}",
          color: "{surface.0}"
        },
        plain: {
          hoverBackground: "{surface.800}",
          activeBackground: "{surface.700}",
          borderColor: "{surface.600}",
          color: "{surface.0}"
        }
      },
      text: {
        primary: {
          hoverBackground: "color-mix(in srgb, {primary.color}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {primary.color}, transparent 84%)",
          color: "{primary.color}"
        },
        secondary: {
          hoverBackground: "{surface.800}",
          activeBackground: "{surface.700}",
          color: "{surface.400}"
        },
        success: {
          hoverBackground: "color-mix(in srgb, {green.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {green.400}, transparent 84%)",
          color: "{green.400}"
        },
        info: {
          hoverBackground: "color-mix(in srgb, {sky.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {sky.400}, transparent 84%)",
          color: "{sky.400}"
        },
        warn: {
          hoverBackground: "color-mix(in srgb, {orange.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {orange.400}, transparent 84%)",
          color: "{orange.400}"
        },
        help: {
          hoverBackground: "color-mix(in srgb, {purple.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {purple.400}, transparent 84%)",
          color: "{purple.400}"
        },
        danger: {
          hoverBackground: "color-mix(in srgb, {red.400}, transparent 96%)",
          activeBackground: "color-mix(in srgb, {red.400}, transparent 84%)",
          color: "{red.400}"
        },
        contrast: {
          hoverBackground: "{surface.800}",
          activeBackground: "{surface.700}",
          color: "{surface.0}"
        },
        plain: {
          hoverBackground: "{surface.800}",
          activeBackground: "{surface.700}",
          color: "{surface.0}"
        }
      },
      link: {
        color: "{primary.color}",
        hoverColor: "{primary.color}",
        activeColor: "{primary.color}"
      }
    }
  }
}, X0 = {
  root: {
    background: "{content.background}",
    borderRadius: "{border.radius.xl}",
    color: "{content.color}",
    shadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px -1px rgba(0, 0, 0, 0.1)"
  },
  body: {
    padding: "1.25rem",
    gap: "0.5rem"
  },
  caption: {
    gap: "0.5rem"
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "500"
  },
  subtitle: {
    color: "{text.muted.color}"
  }
}, Q0 = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  content: {
    gap: "0.25rem"
  },
  indicatorList: {
    padding: "1rem",
    gap: "0.5rem"
  },
  indicator: {
    width: "2rem",
    height: "0.5rem",
    borderRadius: "{content.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  colorScheme: {
    light: {
      indicator: {
        background: "{surface.200}",
        hoverBackground: "{surface.300}",
        activeBackground: "{primary.color}"
      }
    },
    dark: {
      indicator: {
        background: "{surface.700}",
        hoverBackground: "{surface.600}",
        activeBackground: "{primary.color}"
      }
    }
  }
}, J0 = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    }
  },
  dropdown: {
    width: "2.5rem",
    color: "{form.field.icon.color}"
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}"
  },
  list: {
    padding: "{list.padding}",
    gap: "{list.gap}",
    mobileIndent: "1rem"
  },
  option: {
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusBackground: "{list.option.selected.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    selectedColor: "{list.option.selected.color}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}",
    icon: {
      color: "{list.option.icon.color}",
      focusColor: "{list.option.icon.focus.color}",
      size: "0.875rem"
    }
  },
  clearIcon: {
    color: "{form.field.icon.color}"
  }
}, ep = {
  root: {
    borderRadius: "{border.radius.sm}",
    width: "1.25rem",
    height: "1.25rem",
    background: "{form.field.background}",
    checkedBackground: "{primary.color}",
    checkedHoverBackground: "{primary.hover.color}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.border.color}",
    checkedBorderColor: "{primary.color}",
    checkedHoverBorderColor: "{primary.hover.color}",
    checkedFocusBorderColor: "{primary.color}",
    checkedDisabledBorderColor: "{form.field.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    shadow: "{form.field.shadow}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      width: "1rem",
      height: "1rem"
    },
    lg: {
      width: "1.5rem",
      height: "1.5rem"
    }
  },
  icon: {
    size: "0.875rem",
    color: "{form.field.color}",
    checkedColor: "{primary.contrast.color}",
    checkedHoverColor: "{primary.contrast.color}",
    disabledColor: "{form.field.disabled.color}",
    sm: {
      size: "0.75rem"
    },
    lg: {
      size: "1rem"
    }
  }
}, op = {
  root: {
    borderRadius: "16px",
    paddingX: "0.75rem",
    paddingY: "0.5rem",
    gap: "0.5rem",
    transitionDuration: "{transition.duration}"
  },
  image: {
    width: "2rem",
    height: "2rem"
  },
  icon: {
    size: "1rem"
  },
  removeIcon: {
    size: "1rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    }
  },
  colorScheme: {
    light: {
      root: {
        background: "{surface.100}",
        color: "{surface.800}"
      },
      icon: {
        color: "{surface.800}"
      },
      removeIcon: {
        color: "{surface.800}"
      }
    },
    dark: {
      root: {
        background: "{surface.800}",
        color: "{surface.0}"
      },
      icon: {
        color: "{surface.0}"
      },
      removeIcon: {
        color: "{surface.0}"
      }
    }
  }
}, tp = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  preview: {
    width: "1.5rem",
    height: "1.5rem",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  panel: {
    shadow: "{overlay.popover.shadow}",
    borderRadius: "{overlay.popover.borderRadius}"
  },
  colorScheme: {
    light: {
      panel: {
        background: "{surface.800}",
        borderColor: "{surface.900}"
      },
      handle: {
        color: "{surface.0}"
      }
    },
    dark: {
      panel: {
        background: "{surface.900}",
        borderColor: "{surface.700}"
      },
      handle: {
        color: "{surface.0}"
      }
    }
  }
}, rp = {
  icon: {
    size: "2rem",
    color: "{overlay.modal.color}"
  },
  content: {
    gap: "1rem"
  }
}, np = {
  root: {
    background: "{overlay.popover.background}",
    borderColor: "{overlay.popover.border.color}",
    color: "{overlay.popover.color}",
    borderRadius: "{overlay.popover.border.radius}",
    shadow: "{overlay.popover.shadow}",
    gutter: "10px",
    arrowOffset: "1.25rem"
  },
  content: {
    padding: "{overlay.popover.padding}",
    gap: "1rem"
  },
  icon: {
    size: "1.5rem",
    color: "{overlay.popover.color}"
  },
  footer: {
    gap: "0.5rem",
    padding: "0 {overlay.popover.padding} {overlay.popover.padding} {overlay.popover.padding}"
  }
}, ip = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
    shadow: "{overlay.navigation.shadow}",
    transitionDuration: "{transition.duration}"
  },
  list: {
    padding: "{navigation.list.padding}",
    gap: "{navigation.list.gap}"
  },
  item: {
    focusBackground: "{navigation.item.focus.background}",
    activeBackground: "{navigation.item.active.background}",
    color: "{navigation.item.color}",
    focusColor: "{navigation.item.focus.color}",
    activeColor: "{navigation.item.active.color}",
    padding: "{navigation.item.padding}",
    borderRadius: "{navigation.item.border.radius}",
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
      activeColor: "{navigation.item.icon.active.color}"
    }
  },
  submenu: {
    mobileIndent: "1rem"
  },
  submenuIcon: {
    size: "{navigation.submenu.icon.size}",
    color: "{navigation.submenu.icon.color}",
    focusColor: "{navigation.submenu.icon.focus.color}",
    activeColor: "{navigation.submenu.icon.active.color}"
  },
  separator: {
    borderColor: "{content.border.color}"
  }
}, ap = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  header: {
    background: "{content.background}",
    borderColor: "{datatable.border.color}",
    color: "{content.color}",
    borderWidth: "0 0 1px 0",
    padding: "0.75rem 1rem"
  },
  headerCell: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}",
    borderColor: "{datatable.border.color}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{highlight.color}",
    gap: "0.5rem",
    padding: "0.75rem 1rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}"
    }
  },
  columnTitle: {
    fontWeight: "600"
  },
  row: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{highlight.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}"
    }
  },
  bodyCell: {
    borderColor: "{datatable.border.color}",
    padding: "0.75rem 1rem"
  },
  footerCell: {
    background: "{content.background}",
    borderColor: "{datatable.border.color}",
    color: "{content.color}",
    padding: "0.75rem 1rem"
  },
  columnFooter: {
    fontWeight: "600"
  },
  footer: {
    background: "{content.background}",
    borderColor: "{datatable.border.color}",
    color: "{content.color}",
    borderWidth: "0 0 1px 0",
    padding: "0.75rem 1rem"
  },
  dropPoint: {
    color: "{primary.color}"
  },
  columnResizerWidth: "0.5rem",
  resizeIndicator: {
    width: "1px",
    color: "{primary.color}"
  },
  sortIcon: {
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}",
    size: "0.875rem"
  },
  loadingIcon: {
    size: "2rem"
  },
  rowToggleButton: {
    hoverBackground: "{content.hover.background}",
    selectedHoverBackground: "{content.background}",
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    selectedHoverColor: "{primary.color}",
    size: "1.75rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  filter: {
    inlineGap: "0.5rem",
    overlaySelect: {
      background: "{overlay.select.background}",
      borderColor: "{overlay.select.border.color}",
      borderRadius: "{overlay.select.border.radius}",
      color: "{overlay.select.color}",
      shadow: "{overlay.select.shadow}"
    },
    overlayPopover: {
      background: "{overlay.popover.background}",
      borderColor: "{overlay.popover.border.color}",
      borderRadius: "{overlay.popover.border.radius}",
      color: "{overlay.popover.color}",
      shadow: "{overlay.popover.shadow}",
      padding: "{overlay.popover.padding}",
      gap: "0.5rem"
    },
    rule: {
      borderColor: "{content.border.color}"
    },
    constraintList: {
      padding: "{list.padding}",
      gap: "{list.gap}"
    },
    constraint: {
      focusBackground: "{list.option.focus.background}",
      selectedBackground: "{list.option.selected.background}",
      selectedFocusBackground: "{list.option.selected.focus.background}",
      color: "{list.option.color}",
      focusColor: "{list.option.focus.color}",
      selectedColor: "{list.option.selected.color}",
      selectedFocusColor: "{list.option.selected.focus.color}",
      separator: {
        borderColor: "{content.border.color}"
      },
      padding: "{list.option.padding}",
      borderRadius: "{list.option.border.radius}"
    }
  },
  paginatorTop: {
    borderColor: "{datatable.border.color}",
    borderWidth: "0 0 1px 0"
  },
  paginatorBottom: {
    borderColor: "{datatable.border.color}",
    borderWidth: "0 0 1px 0"
  },
  colorScheme: {
    light: {
      root: {
        borderColor: "{content.border.color}"
      },
      row: {
        stripedBackground: "{surface.50}"
      },
      bodyCell: {
        selectedBorderColor: "{primary.100}"
      }
    },
    dark: {
      root: {
        borderColor: "{surface.800}"
      },
      row: {
        stripedBackground: "{surface.950}"
      },
      bodyCell: {
        selectedBorderColor: "{primary.900}"
      }
    }
  }
}, lp = {
  root: {
    borderColor: "transparent",
    borderWidth: "0",
    borderRadius: "0",
    padding: "0"
  },
  header: {
    background: "{content.background}",
    color: "{content.color}",
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0",
    padding: "0.75rem 1rem",
    borderRadius: "0"
  },
  content: {
    background: "{content.background}",
    color: "{content.color}",
    borderColor: "transparent",
    borderWidth: "0",
    padding: "0",
    borderRadius: "0"
  },
  footer: {
    background: "{content.background}",
    color: "{content.color}",
    borderColor: "{content.border.color}",
    borderWidth: "1px 0 0 0",
    padding: "0.75rem 1rem",
    borderRadius: "0"
  },
  paginatorTop: {
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0"
  },
  paginatorBottom: {
    borderColor: "{content.border.color}",
    borderWidth: "1px 0 0 0"
  }
}, sp = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  panel: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
    shadow: "{overlay.popover.shadow}",
    padding: "{overlay.popover.padding}"
  },
  header: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    padding: "0 0 0.5rem 0"
  },
  title: {
    gap: "0.5rem",
    fontWeight: "500"
  },
  dropdown: {
    width: "2.5rem",
    sm: {
      width: "2rem"
    },
    lg: {
      width: "3rem"
    },
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.border.color}",
    activeBorderColor: "{form.field.border.color}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  inputIcon: {
    color: "{form.field.icon.color}"
  },
  selectMonth: {
    hoverBackground: "{content.hover.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    padding: "0.25rem 0.5rem",
    borderRadius: "{content.border.radius}"
  },
  selectYear: {
    hoverBackground: "{content.hover.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    padding: "0.25rem 0.5rem",
    borderRadius: "{content.border.radius}"
  },
  group: {
    borderColor: "{content.border.color}",
    gap: "{overlay.popover.padding}"
  },
  dayView: {
    margin: "0.5rem 0 0 0"
  },
  weekDay: {
    padding: "0.25rem",
    fontWeight: "500",
    color: "{content.color}"
  },
  date: {
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{primary.color}",
    rangeSelectedBackground: "{highlight.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{primary.contrast.color}",
    rangeSelectedColor: "{highlight.color}",
    width: "2rem",
    height: "2rem",
    borderRadius: "50%",
    padding: "0.25rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  monthView: {
    margin: "0.5rem 0 0 0"
  },
  month: {
    padding: "0.375rem",
    borderRadius: "{content.border.radius}"
  },
  yearView: {
    margin: "0.5rem 0 0 0"
  },
  year: {
    padding: "0.375rem",
    borderRadius: "{content.border.radius}"
  },
  buttonbar: {
    padding: "0.5rem 0 0 0",
    borderColor: "{content.border.color}"
  },
  timePicker: {
    padding: "0.5rem 0 0 0",
    borderColor: "{content.border.color}",
    gap: "0.5rem",
    buttonGap: "0.25rem"
  },
  colorScheme: {
    light: {
      dropdown: {
        background: "{surface.100}",
        hoverBackground: "{surface.200}",
        activeBackground: "{surface.300}",
        color: "{surface.600}",
        hoverColor: "{surface.700}",
        activeColor: "{surface.800}"
      },
      today: {
        background: "{surface.200}",
        color: "{surface.900}"
      }
    },
    dark: {
      dropdown: {
        background: "{surface.800}",
        hoverBackground: "{surface.700}",
        activeBackground: "{surface.600}",
        color: "{surface.300}",
        hoverColor: "{surface.200}",
        activeColor: "{surface.100}"
      },
      today: {
        background: "{surface.700}",
        color: "{surface.0}"
      }
    }
  }
}, cp = {
  root: {
    background: "{overlay.modal.background}",
    borderColor: "{overlay.modal.border.color}",
    color: "{overlay.modal.color}",
    borderRadius: "{overlay.modal.border.radius}",
    shadow: "{overlay.modal.shadow}"
  },
  header: {
    padding: "{overlay.modal.padding}",
    gap: "0.5rem"
  },
  title: {
    fontSize: "1.25rem",
    fontWeight: "600"
  },
  content: {
    padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}"
  },
  footer: {
    padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}",
    gap: "0.5rem"
  }
}, dp = {
  root: {
    borderColor: "{content.border.color}"
  },
  content: {
    background: "{content.background}",
    color: "{text.color}"
  },
  horizontal: {
    margin: "1rem 0",
    padding: "0 1rem",
    content: {
      padding: "0 0.5rem"
    }
  },
  vertical: {
    margin: "0 1rem",
    padding: "0.5rem 0",
    content: {
      padding: "0.5rem 0"
    }
  }
}, up = {
  root: {
    background: "rgba(255, 255, 255, 0.1)",
    borderColor: "rgba(255, 255, 255, 0.2)",
    padding: "0.5rem",
    borderRadius: "{border.radius.xl}"
  },
  item: {
    borderRadius: "{content.border.radius}",
    padding: "0.5rem",
    size: "3rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  }
}, pp = {
  root: {
    background: "{overlay.modal.background}",
    borderColor: "{overlay.modal.border.color}",
    color: "{overlay.modal.color}",
    shadow: "{overlay.modal.shadow}"
  },
  header: {
    padding: "{overlay.modal.padding}"
  },
  title: {
    fontSize: "1.5rem",
    fontWeight: "600"
  },
  content: {
    padding: "0 {overlay.modal.padding} {overlay.modal.padding} {overlay.modal.padding}"
  },
  footer: {
    padding: "{overlay.modal.padding}"
  }
}, fp = {
  toolbar: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}"
  },
  toolbarItem: {
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}"
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}",
    padding: "{list.padding}"
  },
  overlayOption: {
    focusBackground: "{list.option.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}"
  },
  content: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}"
  }
}, hp = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    color: "{content.color}",
    padding: "0 1.125rem 1.125rem 1.125rem",
    transitionDuration: "{transition.duration}"
  },
  legend: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    borderRadius: "{content.border.radius}",
    borderWidth: "1px",
    borderColor: "transparent",
    padding: "0.5rem 0.75rem",
    gap: "0.5rem",
    fontWeight: "600",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  toggleIcon: {
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}"
  },
  content: {
    padding: "0"
  }
}, gp = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  header: {
    background: "transparent",
    color: "{text.color}",
    padding: "1.125rem",
    borderColor: "unset",
    borderWidth: "0",
    borderRadius: "0",
    gap: "0.5rem"
  },
  content: {
    highlightBorderColor: "{primary.color}",
    padding: "0 1.125rem 1.125rem 1.125rem",
    gap: "1rem"
  },
  file: {
    padding: "1rem",
    gap: "1rem",
    borderColor: "{content.border.color}",
    info: {
      gap: "0.5rem"
    }
  },
  fileList: {
    gap: "0.5rem"
  },
  progressbar: {
    height: "0.25rem"
  },
  basic: {
    gap: "0.5rem"
  }
}, mp = {
  root: {
    color: "{form.field.float.label.color}",
    focusColor: "{form.field.float.label.focus.color}",
    activeColor: "{form.field.float.label.active.color}",
    invalidColor: "{form.field.float.label.invalid.color}",
    transitionDuration: "0.2s",
    positionX: "{form.field.padding.x}",
    positionY: "{form.field.padding.y}",
    fontWeight: "500",
    active: {
      fontSize: "0.75rem",
      fontWeight: "400"
    }
  },
  over: {
    active: {
      top: "-1.25rem"
    }
  },
  in: {
    input: {
      paddingTop: "1.5rem",
      paddingBottom: "{form.field.padding.y}"
    },
    active: {
      top: "{form.field.padding.y}"
    }
  },
  on: {
    borderRadius: "{border.radius.xs}",
    active: {
      background: "{form.field.background}",
      padding: "0 0.125rem"
    }
  }
}, bp = {
  root: {
    borderWidth: "1px",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    transitionDuration: "{transition.duration}"
  },
  navButton: {
    background: "rgba(255, 255, 255, 0.1)",
    hoverBackground: "rgba(255, 255, 255, 0.2)",
    color: "{surface.100}",
    hoverColor: "{surface.0}",
    size: "3rem",
    gutter: "0.5rem",
    prev: {
      borderRadius: "50%"
    },
    next: {
      borderRadius: "50%"
    },
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  navIcon: {
    size: "1.5rem"
  },
  thumbnailsContent: {
    background: "{content.background}",
    padding: "1rem 0.25rem"
  },
  thumbnailNavButton: {
    size: "2rem",
    borderRadius: "{content.border.radius}",
    gutter: "0.5rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  thumbnailNavButtonIcon: {
    size: "1rem"
  },
  caption: {
    background: "rgba(0, 0, 0, 0.5)",
    color: "{surface.100}",
    padding: "1rem"
  },
  indicatorList: {
    gap: "0.5rem",
    padding: "1rem"
  },
  indicatorButton: {
    width: "1rem",
    height: "1rem",
    activeBackground: "{primary.color}",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  insetIndicatorList: {
    background: "rgba(0, 0, 0, 0.5)"
  },
  insetIndicatorButton: {
    background: "rgba(255, 255, 255, 0.4)",
    hoverBackground: "rgba(255, 255, 255, 0.6)",
    activeBackground: "rgba(255, 255, 255, 0.9)"
  },
  closeButton: {
    size: "3rem",
    gutter: "0.5rem",
    background: "rgba(255, 255, 255, 0.1)",
    hoverBackground: "rgba(255, 255, 255, 0.2)",
    color: "{surface.50}",
    hoverColor: "{surface.0}",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  closeButtonIcon: {
    size: "1.5rem"
  },
  colorScheme: {
    light: {
      thumbnailNavButton: {
        hoverBackground: "{surface.100}",
        color: "{surface.600}",
        hoverColor: "{surface.700}"
      },
      indicatorButton: {
        background: "{surface.200}",
        hoverBackground: "{surface.300}"
      }
    },
    dark: {
      thumbnailNavButton: {
        hoverBackground: "{surface.700}",
        color: "{surface.400}",
        hoverColor: "{surface.0}"
      },
      indicatorButton: {
        background: "{surface.700}",
        hoverBackground: "{surface.600}"
      }
    }
  }
}, vp = {
  icon: {
    color: "{form.field.icon.color}"
  }
}, yp = {
  root: {
    color: "{form.field.float.label.color}",
    focusColor: "{form.field.float.label.focus.color}",
    invalidColor: "{form.field.float.label.invalid.color}",
    transitionDuration: "0.2s",
    positionX: "{form.field.padding.x}",
    top: "{form.field.padding.y}",
    fontSize: "0.75rem",
    fontWeight: "400"
  },
  input: {
    paddingTop: "1.5rem",
    paddingBottom: "{form.field.padding.y}"
  }
}, kp = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  preview: {
    icon: {
      size: "1.5rem"
    },
    mask: {
      background: "{mask.background}",
      color: "{mask.color}"
    }
  },
  toolbar: {
    position: {
      left: "auto",
      right: "1rem",
      top: "1rem",
      bottom: "auto"
    },
    blur: "8px",
    background: "rgba(255,255,255,0.1)",
    borderColor: "rgba(255,255,255,0.2)",
    borderWidth: "1px",
    borderRadius: "30px",
    padding: ".5rem",
    gap: "0.5rem"
  },
  action: {
    hoverBackground: "rgba(255,255,255,0.1)",
    color: "{surface.50}",
    hoverColor: "{surface.0}",
    size: "3rem",
    iconSize: "1.5rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  }
}, wp = {
  handle: {
    size: "15px",
    hoverSize: "30px",
    background: "rgba(255,255,255,0.3)",
    hoverBackground: "rgba(255,255,255,0.3)",
    borderColor: "unset",
    hoverBorderColor: "unset",
    borderWidth: "0",
    borderRadius: "50%",
    transitionDuration: "{transition.duration}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "rgba(255,255,255,0.3)",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  }
}, Cp = {
  root: {
    padding: "{form.field.padding.y} {form.field.padding.x}",
    borderRadius: "{content.border.radius}",
    gap: "0.5rem"
  },
  text: {
    fontWeight: "500"
  },
  icon: {
    size: "1rem"
  },
  colorScheme: {
    light: {
      info: {
        background: "color-mix(in srgb, {blue.50}, transparent 5%)",
        borderColor: "{blue.200}",
        color: "{blue.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)"
      },
      success: {
        background: "color-mix(in srgb, {green.50}, transparent 5%)",
        borderColor: "{green.200}",
        color: "{green.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)"
      },
      warn: {
        background: "color-mix(in srgb,{yellow.50}, transparent 5%)",
        borderColor: "{yellow.200}",
        color: "{yellow.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)"
      },
      error: {
        background: "color-mix(in srgb, {red.50}, transparent 5%)",
        borderColor: "{red.200}",
        color: "{red.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)"
      },
      secondary: {
        background: "{surface.100}",
        borderColor: "{surface.200}",
        color: "{surface.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)"
      },
      contrast: {
        background: "{surface.900}",
        borderColor: "{surface.950}",
        color: "{surface.50}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)"
      }
    },
    dark: {
      info: {
        background: "color-mix(in srgb, {blue.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {blue.700}, transparent 64%)",
        color: "{blue.500}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)"
      },
      success: {
        background: "color-mix(in srgb, {green.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {green.700}, transparent 64%)",
        color: "{green.500}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)"
      },
      warn: {
        background: "color-mix(in srgb, {yellow.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {yellow.700}, transparent 64%)",
        color: "{yellow.500}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)"
      },
      error: {
        background: "color-mix(in srgb, {red.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {red.700}, transparent 64%)",
        color: "{red.500}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)"
      },
      secondary: {
        background: "{surface.800}",
        borderColor: "{surface.700}",
        color: "{surface.300}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)"
      },
      contrast: {
        background: "{surface.0}",
        borderColor: "{surface.100}",
        color: "{surface.950}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)"
      }
    }
  }
}, xp = {
  root: {
    padding: "{form.field.padding.y} {form.field.padding.x}",
    borderRadius: "{content.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    transitionDuration: "{transition.duration}"
  },
  display: {
    hoverBackground: "{content.hover.background}",
    hoverColor: "{content.hover.color}"
  }
}, Sp = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}"
  },
  chip: {
    borderRadius: "{border.radius.sm}"
  },
  colorScheme: {
    light: {
      chip: {
        focusBackground: "{surface.200}",
        color: "{surface.800}"
      }
    },
    dark: {
      chip: {
        focusBackground: "{surface.700}",
        color: "{surface.0}"
      }
    }
  }
}, $p = {
  addon: {
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    color: "{form.field.icon.color}",
    borderRadius: "{form.field.border.radius}",
    padding: "0.5rem",
    minWidth: "2.5rem"
  }
}, Bp = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  button: {
    width: "2.5rem",
    borderRadius: "{form.field.border.radius}",
    verticalPadding: "{form.field.padding.y}"
  },
  colorScheme: {
    light: {
      button: {
        background: "transparent",
        hoverBackground: "{surface.100}",
        activeBackground: "{surface.200}",
        borderColor: "{form.field.border.color}",
        hoverBorderColor: "{form.field.border.color}",
        activeBorderColor: "{form.field.border.color}",
        color: "{surface.400}",
        hoverColor: "{surface.500}",
        activeColor: "{surface.600}"
      }
    },
    dark: {
      button: {
        background: "transparent",
        hoverBackground: "{surface.800}",
        activeBackground: "{surface.700}",
        borderColor: "{form.field.border.color}",
        hoverBorderColor: "{form.field.border.color}",
        activeBorderColor: "{form.field.border.color}",
        color: "{surface.400}",
        hoverColor: "{surface.300}",
        activeColor: "{surface.200}"
      }
    }
  }
}, _p = {
  root: {
    gap: "0.5rem"
  },
  input: {
    width: "2.5rem",
    sm: {
      width: "2rem"
    },
    lg: {
      width: "3rem"
    }
  }
}, Mp = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    }
  }
}, Tp = {
  root: {
    transitionDuration: "{transition.duration}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  value: {
    background: "{primary.color}"
  },
  range: {
    background: "{content.border.color}"
  },
  text: {
    color: "{text.muted.color}"
  }
}, Pp = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    borderColor: "{form.field.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    shadow: "{form.field.shadow}",
    borderRadius: "{form.field.border.radius}",
    transitionDuration: "{form.field.transition.duration}"
  },
  list: {
    padding: "{list.padding}",
    gap: "{list.gap}",
    header: {
      padding: "{list.header.padding}"
    }
  },
  option: {
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusBackground: "{list.option.selected.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    selectedColor: "{list.option.selected.color}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}"
  },
  optionGroup: {
    background: "{list.option.group.background}",
    color: "{list.option.group.color}",
    fontWeight: "{list.option.group.font.weight}",
    padding: "{list.option.group.padding}"
  },
  checkmark: {
    color: "{list.option.color}",
    gutterStart: "-0.375rem",
    gutterEnd: "0.375rem"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  },
  colorScheme: {
    light: {
      option: {
        stripedBackground: "{surface.50}"
      }
    },
    dark: {
      option: {
        stripedBackground: "{surface.900}"
      }
    }
  }
}, Dp = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    color: "{content.color}",
    gap: "0.5rem",
    verticalOrientation: {
      padding: "{navigation.list.padding}",
      gap: "{navigation.list.gap}"
    },
    horizontalOrientation: {
      padding: "0.5rem 0.75rem",
      gap: "0.5rem"
    },
    transitionDuration: "{transition.duration}"
  },
  baseItem: {
    borderRadius: "{content.border.radius}",
    padding: "{navigation.item.padding}"
  },
  item: {
    focusBackground: "{navigation.item.focus.background}",
    activeBackground: "{navigation.item.active.background}",
    color: "{navigation.item.color}",
    focusColor: "{navigation.item.focus.color}",
    activeColor: "{navigation.item.active.color}",
    padding: "{navigation.item.padding}",
    borderRadius: "{navigation.item.border.radius}",
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
      activeColor: "{navigation.item.icon.active.color}"
    }
  },
  overlay: {
    padding: "0",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    color: "{content.color}",
    shadow: "{overlay.navigation.shadow}",
    gap: "0.5rem"
  },
  submenu: {
    padding: "{navigation.list.padding}",
    gap: "{navigation.list.gap}"
  },
  submenuLabel: {
    padding: "{navigation.submenu.label.padding}",
    fontWeight: "{navigation.submenu.label.font.weight}",
    background: "{navigation.submenu.label.background.}",
    color: "{navigation.submenu.label.color}"
  },
  submenuIcon: {
    size: "{navigation.submenu.icon.size}",
    color: "{navigation.submenu.icon.color}",
    focusColor: "{navigation.submenu.icon.focus.color}",
    activeColor: "{navigation.submenu.icon.active.color}"
  },
  separator: {
    borderColor: "{content.border.color}"
  },
  mobileButton: {
    borderRadius: "50%",
    size: "1.75rem",
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}",
    hoverBackground: "{content.hover.background}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  }
}, Op = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
    shadow: "{overlay.navigation.shadow}",
    transitionDuration: "{transition.duration}"
  },
  list: {
    padding: "{navigation.list.padding}",
    gap: "{navigation.list.gap}"
  },
  item: {
    focusBackground: "{navigation.item.focus.background}",
    color: "{navigation.item.color}",
    focusColor: "{navigation.item.focus.color}",
    padding: "{navigation.item.padding}",
    borderRadius: "{navigation.item.border.radius}",
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}"
    }
  },
  submenuLabel: {
    padding: "{navigation.submenu.label.padding}",
    fontWeight: "{navigation.submenu.label.font.weight}",
    background: "{navigation.submenu.label.background}",
    color: "{navigation.submenu.label.color}"
  },
  separator: {
    borderColor: "{content.border.color}"
  }
}, Rp = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    color: "{content.color}",
    gap: "0.5rem",
    padding: "0.5rem 0.75rem",
    transitionDuration: "{transition.duration}"
  },
  baseItem: {
    borderRadius: "{content.border.radius}",
    padding: "{navigation.item.padding}"
  },
  item: {
    focusBackground: "{navigation.item.focus.background}",
    activeBackground: "{navigation.item.active.background}",
    color: "{navigation.item.color}",
    focusColor: "{navigation.item.focus.color}",
    activeColor: "{navigation.item.active.color}",
    padding: "{navigation.item.padding}",
    borderRadius: "{navigation.item.border.radius}",
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
      activeColor: "{navigation.item.icon.active.color}"
    }
  },
  submenu: {
    padding: "{navigation.list.padding}",
    gap: "{navigation.list.gap}",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    shadow: "{overlay.navigation.shadow}",
    mobileIndent: "1rem",
    icon: {
      size: "{navigation.submenu.icon.size}",
      color: "{navigation.submenu.icon.color}",
      focusColor: "{navigation.submenu.icon.focus.color}",
      activeColor: "{navigation.submenu.icon.active.color}"
    }
  },
  separator: {
    borderColor: "{content.border.color}"
  },
  mobileButton: {
    borderRadius: "50%",
    size: "1.75rem",
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}",
    hoverBackground: "{content.hover.background}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  }
}, Lp = {
  root: {
    borderRadius: "{content.border.radius}",
    borderWidth: "1px",
    transitionDuration: "{transition.duration}"
  },
  content: {
    padding: "0.5rem 0.75rem",
    gap: "0.5rem",
    sm: {
      padding: "0.375rem 0.625rem"
    },
    lg: {
      padding: "0.625rem 0.875rem"
    }
  },
  text: {
    fontSize: "1rem",
    fontWeight: "500",
    sm: {
      fontSize: "0.875rem"
    },
    lg: {
      fontSize: "1.125rem"
    }
  },
  icon: {
    size: "1.125rem",
    sm: {
      size: "1rem"
    },
    lg: {
      size: "1.25rem"
    }
  },
  closeButton: {
    width: "1.75rem",
    height: "1.75rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      offset: "{focus.ring.offset}"
    }
  },
  closeIcon: {
    size: "1rem",
    sm: {
      size: "0.875rem"
    },
    lg: {
      size: "1.125rem"
    }
  },
  outlined: {
    root: {
      borderWidth: "1px"
    }
  },
  simple: {
    content: {
      padding: "0"
    }
  },
  colorScheme: {
    light: {
      info: {
        background: "color-mix(in srgb, {blue.50}, transparent 5%)",
        borderColor: "{blue.200}",
        color: "{blue.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{blue.100}",
          focusRing: {
            color: "{blue.600}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{blue.600}",
          borderColor: "{blue.600}"
        },
        simple: {
          color: "{blue.600}"
        }
      },
      success: {
        background: "color-mix(in srgb, {green.50}, transparent 5%)",
        borderColor: "{green.200}",
        color: "{green.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{green.100}",
          focusRing: {
            color: "{green.600}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{green.600}",
          borderColor: "{green.600}"
        },
        simple: {
          color: "{green.600}"
        }
      },
      warn: {
        background: "color-mix(in srgb,{yellow.50}, transparent 5%)",
        borderColor: "{yellow.200}",
        color: "{yellow.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{yellow.100}",
          focusRing: {
            color: "{yellow.600}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{yellow.600}",
          borderColor: "{yellow.600}"
        },
        simple: {
          color: "{yellow.600}"
        }
      },
      error: {
        background: "color-mix(in srgb, {red.50}, transparent 5%)",
        borderColor: "{red.200}",
        color: "{red.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{red.100}",
          focusRing: {
            color: "{red.600}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{red.600}",
          borderColor: "{red.600}"
        },
        simple: {
          color: "{red.600}"
        }
      },
      secondary: {
        background: "{surface.100}",
        borderColor: "{surface.200}",
        color: "{surface.600}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{surface.200}",
          focusRing: {
            color: "{surface.600}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{surface.500}",
          borderColor: "{surface.500}"
        },
        simple: {
          color: "{surface.500}"
        }
      },
      contrast: {
        background: "{surface.900}",
        borderColor: "{surface.950}",
        color: "{surface.50}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
        closeButton: {
          hoverBackground: "{surface.800}",
          focusRing: {
            color: "{surface.50}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{surface.950}",
          borderColor: "{surface.950}"
        },
        simple: {
          color: "{surface.950}"
        }
      }
    },
    dark: {
      info: {
        background: "color-mix(in srgb, {blue.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {blue.700}, transparent 64%)",
        color: "{blue.500}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "rgba(255, 255, 255, 0.05)",
          focusRing: {
            color: "{blue.500}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{blue.500}",
          borderColor: "{blue.500}"
        },
        simple: {
          color: "{blue.500}"
        }
      },
      success: {
        background: "color-mix(in srgb, {green.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {green.700}, transparent 64%)",
        color: "{green.500}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "rgba(255, 255, 255, 0.05)",
          focusRing: {
            color: "{green.500}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{green.500}",
          borderColor: "{green.500}"
        },
        simple: {
          color: "{green.500}"
        }
      },
      warn: {
        background: "color-mix(in srgb, {yellow.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {yellow.700}, transparent 64%)",
        color: "{yellow.500}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "rgba(255, 255, 255, 0.05)",
          focusRing: {
            color: "{yellow.500}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{yellow.500}",
          borderColor: "{yellow.500}"
        },
        simple: {
          color: "{yellow.500}"
        }
      },
      error: {
        background: "color-mix(in srgb, {red.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {red.700}, transparent 64%)",
        color: "{red.500}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "rgba(255, 255, 255, 0.05)",
          focusRing: {
            color: "{red.500}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{red.500}",
          borderColor: "{red.500}"
        },
        simple: {
          color: "{red.500}"
        }
      },
      secondary: {
        background: "{surface.800}",
        borderColor: "{surface.700}",
        color: "{surface.300}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{surface.700}",
          focusRing: {
            color: "{surface.300}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{surface.400}",
          borderColor: "{surface.400}"
        },
        simple: {
          color: "{surface.400}"
        }
      },
      contrast: {
        background: "{surface.0}",
        borderColor: "{surface.100}",
        color: "{surface.950}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
        closeButton: {
          hoverBackground: "{surface.100}",
          focusRing: {
            color: "{surface.950}",
            shadow: "none"
          }
        },
        outlined: {
          color: "{surface.0}",
          borderColor: "{surface.0}"
        },
        simple: {
          color: "{surface.0}"
        }
      }
    }
  }
}, Ap = {
  root: {
    borderRadius: "{content.border.radius}",
    gap: "1rem"
  },
  meters: {
    background: "{content.border.color}",
    size: "0.5rem"
  },
  label: {
    gap: "0.5rem"
  },
  labelMarker: {
    size: "0.5rem"
  },
  labelIcon: {
    size: "1rem"
  },
  labelList: {
    verticalGap: "0.5rem",
    horizontalGap: "1rem"
  }
}, Ip = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    }
  },
  dropdown: {
    width: "2.5rem",
    color: "{form.field.icon.color}"
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}"
  },
  list: {
    padding: "{list.padding}",
    gap: "{list.gap}",
    header: {
      padding: "{list.header.padding}"
    }
  },
  option: {
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusBackground: "{list.option.selected.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    selectedColor: "{list.option.selected.color}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}",
    gap: "0.5rem"
  },
  optionGroup: {
    background: "{list.option.group.background}",
    color: "{list.option.group.color}",
    fontWeight: "{list.option.group.font.weight}",
    padding: "{list.option.group.padding}"
  },
  clearIcon: {
    color: "{form.field.icon.color}"
  },
  chip: {
    borderRadius: "{border.radius.sm}"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  }
}, Ep = {
  root: {
    gap: "1.125rem"
  },
  controls: {
    gap: "0.5rem"
  }
}, zp = {
  root: {
    gutter: "0.75rem",
    transitionDuration: "{transition.duration}"
  },
  node: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    selectedColor: "{highlight.color}",
    hoverColor: "{content.hover.color}",
    padding: "0.75rem 1rem",
    toggleablePadding: "0.75rem 1rem 1.25rem 1rem",
    borderRadius: "{content.border.radius}"
  },
  nodeToggleButton: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    borderColor: "{content.border.color}",
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    size: "1.5rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  connector: {
    color: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    height: "24px"
  }
}, Np = {
  root: {
    outline: {
      width: "2px",
      color: "{content.background}"
    }
  }
}, Hp = {
  root: {
    padding: "0.5rem 1rem",
    gap: "0.25rem",
    borderRadius: "{content.border.radius}",
    background: "{content.background}",
    color: "{content.color}",
    transitionDuration: "{transition.duration}"
  },
  navButton: {
    background: "transparent",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}",
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}",
    selectedColor: "{highlight.color}",
    width: "2.5rem",
    height: "2.5rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  currentPageReport: {
    color: "{text.muted.color}"
  },
  jumpToPageInput: {
    maxWidth: "2.5rem"
  }
}, Vp = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}"
  },
  header: {
    background: "transparent",
    color: "{text.color}",
    padding: "1.125rem",
    borderColor: "{content.border.color}",
    borderWidth: "0",
    borderRadius: "0"
  },
  toggleableHeader: {
    padding: "0.375rem 1.125rem"
  },
  title: {
    fontWeight: "600"
  },
  content: {
    padding: "0 1.125rem 1.125rem 1.125rem"
  },
  footer: {
    padding: "0 1.125rem 1.125rem 1.125rem"
  }
}, Fp = {
  root: {
    gap: "0.5rem",
    transitionDuration: "{transition.duration}"
  },
  panel: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderWidth: "1px",
    color: "{content.color}",
    padding: "0.25rem 0.25rem",
    borderRadius: "{content.border.radius}",
    first: {
      borderWidth: "1px",
      topBorderRadius: "{content.border.radius}"
    },
    last: {
      borderWidth: "1px",
      bottomBorderRadius: "{content.border.radius}"
    }
  },
  item: {
    focusBackground: "{navigation.item.focus.background}",
    color: "{navigation.item.color}",
    focusColor: "{navigation.item.focus.color}",
    gap: "0.5rem",
    padding: "{navigation.item.padding}",
    borderRadius: "{content.border.radius}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}"
    }
  },
  submenu: {
    indent: "1rem"
  },
  submenuIcon: {
    color: "{navigation.submenu.icon.color}",
    focusColor: "{navigation.submenu.icon.focus.color}"
  }
}, jp = {
  meter: {
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    height: ".75rem"
  },
  icon: {
    color: "{form.field.icon.color}"
  },
  overlay: {
    background: "{overlay.popover.background}",
    borderColor: "{overlay.popover.border.color}",
    borderRadius: "{overlay.popover.border.radius}",
    color: "{overlay.popover.color}",
    padding: "{overlay.popover.padding}",
    shadow: "{overlay.popover.shadow}"
  },
  content: {
    gap: "0.5rem"
  },
  colorScheme: {
    light: {
      strength: {
        weakBackground: "{red.500}",
        mediumBackground: "{amber.500}",
        strongBackground: "{green.500}"
      }
    },
    dark: {
      strength: {
        weakBackground: "{red.400}",
        mediumBackground: "{amber.400}",
        strongBackground: "{green.400}"
      }
    }
  }
}, Zp = {
  root: {
    gap: "1.125rem"
  },
  controls: {
    gap: "0.5rem"
  }
}, Wp = {
  root: {
    background: "{overlay.popover.background}",
    borderColor: "{overlay.popover.border.color}",
    color: "{overlay.popover.color}",
    borderRadius: "{overlay.popover.border.radius}",
    shadow: "{overlay.popover.shadow}",
    gutter: "10px",
    arrowOffset: "1.25rem"
  },
  content: {
    padding: "{overlay.popover.padding}"
  }
}, Yp = {
  root: {
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    height: "1.25rem"
  },
  value: {
    background: "{primary.color}"
  },
  label: {
    color: "{primary.contrast.color}",
    fontSize: "0.75rem",
    fontWeight: "600"
  }
}, Kp = {
  colorScheme: {
    light: {
      root: {
        "color.1": "{red.500}",
        "color.2": "{blue.500}",
        "color.3": "{green.500}",
        "color.4": "{yellow.500}"
      }
    },
    dark: {
      root: {
        "color.1": "{red.400}",
        "color.2": "{blue.400}",
        "color.3": "{green.400}",
        "color.4": "{yellow.400}"
      }
    }
  }
}, Up = {
  root: {
    width: "1.25rem",
    height: "1.25rem",
    background: "{form.field.background}",
    checkedBackground: "{primary.color}",
    checkedHoverBackground: "{primary.hover.color}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.border.color}",
    checkedBorderColor: "{primary.color}",
    checkedHoverBorderColor: "{primary.hover.color}",
    checkedFocusBorderColor: "{primary.color}",
    checkedDisabledBorderColor: "{form.field.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    shadow: "{form.field.shadow}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      width: "1rem",
      height: "1rem"
    },
    lg: {
      width: "1.5rem",
      height: "1.5rem"
    }
  },
  icon: {
    size: "0.75rem",
    checkedColor: "{primary.contrast.color}",
    checkedHoverColor: "{primary.contrast.color}",
    disabledColor: "{form.field.disabled.color}",
    sm: {
      size: "0.5rem"
    },
    lg: {
      size: "1rem"
    }
  }
}, Gp = {
  root: {
    gap: "0.25rem",
    transitionDuration: "{transition.duration}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  icon: {
    size: "1rem",
    color: "{text.muted.color}",
    hoverColor: "{primary.color}",
    activeColor: "{primary.color}"
  }
}, qp = {
  colorScheme: {
    light: {
      root: {
        background: "rgba(0,0,0,0.1)"
      }
    },
    dark: {
      root: {
        background: "rgba(255,255,255,0.3)"
      }
    }
  }
}, Xp = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  bar: {
    size: "9px",
    borderRadius: "{border.radius.sm}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  colorScheme: {
    light: {
      bar: {
        background: "{surface.100}"
      }
    },
    dark: {
      bar: {
        background: "{surface.800}"
      }
    }
  }
}, Qp = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    }
  },
  dropdown: {
    width: "2.5rem",
    color: "{form.field.icon.color}"
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}"
  },
  list: {
    padding: "{list.padding}",
    gap: "{list.gap}",
    header: {
      padding: "{list.header.padding}"
    }
  },
  option: {
    focusBackground: "{list.option.focus.background}",
    selectedBackground: "{list.option.selected.background}",
    selectedFocusBackground: "{list.option.selected.focus.background}",
    color: "{list.option.color}",
    focusColor: "{list.option.focus.color}",
    selectedColor: "{list.option.selected.color}",
    selectedFocusColor: "{list.option.selected.focus.color}",
    padding: "{list.option.padding}",
    borderRadius: "{list.option.border.radius}"
  },
  optionGroup: {
    background: "{list.option.group.background}",
    color: "{list.option.group.color}",
    fontWeight: "{list.option.group.font.weight}",
    padding: "{list.option.group.padding}"
  },
  clearIcon: {
    color: "{form.field.icon.color}"
  },
  checkmark: {
    color: "{list.option.color}",
    gutterStart: "-0.375rem",
    gutterEnd: "0.375rem"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  }
}, Jp = {
  root: {
    borderRadius: "{form.field.border.radius}"
  },
  colorScheme: {
    light: {
      root: {
        invalidBorderColor: "{form.field.invalid.border.color}"
      }
    },
    dark: {
      root: {
        invalidBorderColor: "{form.field.invalid.border.color}"
      }
    }
  }
}, ef = {
  root: {
    borderRadius: "{content.border.radius}"
  },
  colorScheme: {
    light: {
      root: {
        background: "{surface.200}",
        animationBackground: "rgba(255,255,255,0.4)"
      }
    },
    dark: {
      root: {
        background: "rgba(255, 255, 255, 0.06)",
        animationBackground: "rgba(255, 255, 255, 0.04)"
      }
    }
  }
}, of = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  track: {
    background: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    size: "3px"
  },
  range: {
    background: "{primary.color}"
  },
  handle: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    background: "{content.border.color}",
    hoverBackground: "{content.border.color}",
    content: {
      borderRadius: "50%",
      hoverBackground: "{content.background}",
      width: "16px",
      height: "16px",
      shadow: "0px 0.5px 0px 0px rgba(0, 0, 0, 0.08), 0px 1px 1px 0px rgba(0, 0, 0, 0.14)"
    },
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  colorScheme: {
    light: {
      handle: {
        contentBackground: "{surface.0}"
      }
    },
    dark: {
      handle: {
        contentBackground: "{surface.950}"
      }
    }
  }
}, tf = {
  root: {
    gap: "0.5rem",
    transitionDuration: "{transition.duration}"
  }
}, rf = {
  root: {
    borderRadius: "{form.field.border.radius}",
    roundedBorderRadius: "2rem",
    raisedShadow: "0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12)"
  }
}, nf = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    transitionDuration: "{transition.duration}"
  },
  gutter: {
    background: "{content.border.color}"
  },
  handle: {
    size: "24px",
    background: "transparent",
    borderRadius: "{content.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  }
}, af = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  separator: {
    background: "{content.border.color}",
    activeBackground: "{primary.color}",
    margin: "0 0 0 1.625rem",
    size: "2px"
  },
  step: {
    padding: "0.5rem",
    gap: "1rem"
  },
  stepHeader: {
    padding: "0",
    borderRadius: "{content.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    gap: "0.5rem"
  },
  stepTitle: {
    color: "{text.muted.color}",
    activeColor: "{primary.color}",
    fontWeight: "500"
  },
  stepNumber: {
    background: "{content.background}",
    activeBackground: "{content.background}",
    borderColor: "{content.border.color}",
    activeBorderColor: "{content.border.color}",
    color: "{text.muted.color}",
    activeColor: "{primary.color}",
    size: "2rem",
    fontSize: "1.143rem",
    fontWeight: "500",
    borderRadius: "50%",
    shadow: "0px 0.5px 0px 0px rgba(0, 0, 0, 0.06), 0px 1px 1px 0px rgba(0, 0, 0, 0.12)"
  },
  steppanels: {
    padding: "0.875rem 0.5rem 1.125rem 0.5rem"
  },
  steppanel: {
    background: "{content.background}",
    color: "{content.color}",
    padding: "0",
    indent: "1rem"
  }
}, lf = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  separator: {
    background: "{content.border.color}"
  },
  itemLink: {
    borderRadius: "{content.border.radius}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    gap: "0.5rem"
  },
  itemLabel: {
    color: "{text.muted.color}",
    activeColor: "{primary.color}",
    fontWeight: "500"
  },
  itemNumber: {
    background: "{content.background}",
    activeBackground: "{content.background}",
    borderColor: "{content.border.color}",
    activeBorderColor: "{content.border.color}",
    color: "{text.muted.color}",
    activeColor: "{primary.color}",
    size: "2rem",
    fontSize: "1.143rem",
    fontWeight: "500",
    borderRadius: "50%",
    shadow: "0px 0.5px 0px 0px rgba(0, 0, 0, 0.06), 0px 1px 1px 0px rgba(0, 0, 0, 0.12)"
  }
}, sf = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  tablist: {
    borderWidth: "0 0 1px 0",
    background: "{content.background}",
    borderColor: "{content.border.color}"
  },
  item: {
    background: "transparent",
    hoverBackground: "transparent",
    activeBackground: "transparent",
    borderWidth: "0 0 1px 0",
    borderColor: "{content.border.color}",
    hoverBorderColor: "{content.border.color}",
    activeBorderColor: "{primary.color}",
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}",
    padding: "1rem 1.125rem",
    fontWeight: "600",
    margin: "0 0 -1px 0",
    gap: "0.5rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  itemIcon: {
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}"
  },
  activeBar: {
    height: "1px",
    bottom: "-1px",
    background: "{primary.color}"
  }
}, cf = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  tablist: {
    borderWidth: "0 0 1px 0",
    background: "{content.background}",
    borderColor: "{content.border.color}"
  },
  tab: {
    background: "transparent",
    hoverBackground: "transparent",
    activeBackground: "transparent",
    borderWidth: "0 0 1px 0",
    borderColor: "{content.border.color}",
    hoverBorderColor: "{content.border.color}",
    activeBorderColor: "{primary.color}",
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}",
    padding: "1rem 1.125rem",
    fontWeight: "600",
    margin: "0 0 -1px 0",
    gap: "0.5rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}"
    }
  },
  tabpanel: {
    background: "{content.background}",
    color: "{content.color}",
    padding: "0.875rem 1.125rem 1.125rem 1.125rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "inset {focus.ring.shadow}"
    }
  },
  navButton: {
    background: "{content.background}",
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    width: "2.5rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}"
    }
  },
  activeBar: {
    height: "1px",
    bottom: "-1px",
    background: "{primary.color}"
  },
  colorScheme: {
    light: {
      navButton: {
        shadow: "0px 0px 10px 50px rgba(255, 255, 255, 0.6)"
      }
    },
    dark: {
      navButton: {
        shadow: "0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%)"
      }
    }
  }
}, df = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  tabList: {
    background: "{content.background}",
    borderColor: "{content.border.color}"
  },
  tab: {
    borderColor: "{content.border.color}",
    activeBorderColor: "{primary.color}",
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    activeColor: "{primary.color}"
  },
  tabPanel: {
    background: "{content.background}",
    color: "{content.color}"
  },
  navButton: {
    background: "{content.background}",
    color: "{text.muted.color}",
    hoverColor: "{text.color}"
  },
  colorScheme: {
    light: {
      navButton: {
        shadow: "0px 0px 10px 50px rgba(255, 255, 255, 0.6)"
      }
    },
    dark: {
      navButton: {
        shadow: "0px 0px 10px 50px color-mix(in srgb, {content.background}, transparent 50%)"
      }
    }
  }
}, uf = {
  root: {
    fontSize: "0.875rem",
    fontWeight: "700",
    padding: "0.25rem 0.5rem",
    gap: "0.25rem",
    borderRadius: "{content.border.radius}",
    roundedBorderRadius: "{border.radius.xl}"
  },
  icon: {
    size: "0.75rem"
  },
  colorScheme: {
    light: {
      primary: {
        background: "{primary.100}",
        color: "{primary.700}"
      },
      secondary: {
        background: "{surface.100}",
        color: "{surface.600}"
      },
      success: {
        background: "{green.100}",
        color: "{green.700}"
      },
      info: {
        background: "{sky.100}",
        color: "{sky.700}"
      },
      warn: {
        background: "{orange.100}",
        color: "{orange.700}"
      },
      danger: {
        background: "{red.100}",
        color: "{red.700}"
      },
      contrast: {
        background: "{surface.950}",
        color: "{surface.0}"
      }
    },
    dark: {
      primary: {
        background: "color-mix(in srgb, {primary.500}, transparent 84%)",
        color: "{primary.300}"
      },
      secondary: {
        background: "{surface.800}",
        color: "{surface.300}"
      },
      success: {
        background: "color-mix(in srgb, {green.500}, transparent 84%)",
        color: "{green.300}"
      },
      info: {
        background: "color-mix(in srgb, {sky.500}, transparent 84%)",
        color: "{sky.300}"
      },
      warn: {
        background: "color-mix(in srgb, {orange.500}, transparent 84%)",
        color: "{orange.300}"
      },
      danger: {
        background: "color-mix(in srgb, {red.500}, transparent 84%)",
        color: "{red.300}"
      },
      contrast: {
        background: "{surface.0}",
        color: "{surface.950}"
      }
    }
  }
}, pf = {
  root: {
    background: "{form.field.background}",
    borderColor: "{form.field.border.color}",
    color: "{form.field.color}",
    height: "18rem",
    padding: "{form.field.padding.y} {form.field.padding.x}",
    borderRadius: "{form.field.border.radius}"
  },
  prompt: {
    gap: "0.25rem"
  },
  commandResponse: {
    margin: "2px 0"
  }
}, ff = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    }
  }
}, hf = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    color: "{content.color}",
    borderRadius: "{content.border.radius}",
    shadow: "{overlay.navigation.shadow}",
    transitionDuration: "{transition.duration}"
  },
  list: {
    padding: "{navigation.list.padding}",
    gap: "{navigation.list.gap}"
  },
  item: {
    focusBackground: "{navigation.item.focus.background}",
    activeBackground: "{navigation.item.active.background}",
    color: "{navigation.item.color}",
    focusColor: "{navigation.item.focus.color}",
    activeColor: "{navigation.item.active.color}",
    padding: "{navigation.item.padding}",
    borderRadius: "{navigation.item.border.radius}",
    gap: "{navigation.item.gap}",
    icon: {
      color: "{navigation.item.icon.color}",
      focusColor: "{navigation.item.icon.focus.color}",
      activeColor: "{navigation.item.icon.active.color}"
    }
  },
  submenu: {
    mobileIndent: "1rem"
  },
  submenuIcon: {
    size: "{navigation.submenu.icon.size}",
    color: "{navigation.submenu.icon.color}",
    focusColor: "{navigation.submenu.icon.focus.color}",
    activeColor: "{navigation.submenu.icon.active.color}"
  },
  separator: {
    borderColor: "{content.border.color}"
  }
}, gf = {
  event: {
    minHeight: "5rem"
  },
  horizontal: {
    eventContent: {
      padding: "1rem 0"
    }
  },
  vertical: {
    eventContent: {
      padding: "0 1rem"
    }
  },
  eventMarker: {
    size: "1.125rem",
    borderRadius: "50%",
    borderWidth: "2px",
    background: "{content.background}",
    borderColor: "{content.border.color}",
    content: {
      borderRadius: "50%",
      size: "0.375rem",
      background: "{primary.color}",
      insetShadow: "0px 0.5px 0px 0px rgba(0, 0, 0, 0.06), 0px 1px 1px 0px rgba(0, 0, 0, 0.12)"
    }
  },
  eventConnector: {
    color: "{content.border.color}",
    size: "2px"
  }
}, mf = {
  root: {
    width: "25rem",
    borderRadius: "{content.border.radius}",
    borderWidth: "1px",
    transitionDuration: "{transition.duration}"
  },
  icon: {
    size: "1.125rem"
  },
  content: {
    padding: "{overlay.popover.padding}",
    gap: "0.5rem"
  },
  text: {
    gap: "0.5rem"
  },
  summary: {
    fontWeight: "500",
    fontSize: "1rem"
  },
  detail: {
    fontWeight: "500",
    fontSize: "0.875rem"
  },
  closeButton: {
    width: "1.75rem",
    height: "1.75rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      offset: "{focus.ring.offset}"
    }
  },
  closeIcon: {
    size: "1rem"
  },
  colorScheme: {
    light: {
      blur: "1.5px",
      info: {
        background: "color-mix(in srgb, {blue.50}, transparent 5%)",
        borderColor: "{blue.200}",
        color: "{blue.600}",
        detailColor: "{surface.700}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{blue.100}",
          focusRing: {
            color: "{blue.600}",
            shadow: "none"
          }
        }
      },
      success: {
        background: "color-mix(in srgb, {green.50}, transparent 5%)",
        borderColor: "{green.200}",
        color: "{green.600}",
        detailColor: "{surface.700}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{green.100}",
          focusRing: {
            color: "{green.600}",
            shadow: "none"
          }
        }
      },
      warn: {
        background: "color-mix(in srgb,{yellow.50}, transparent 5%)",
        borderColor: "{yellow.200}",
        color: "{yellow.600}",
        detailColor: "{surface.700}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{yellow.100}",
          focusRing: {
            color: "{yellow.600}",
            shadow: "none"
          }
        }
      },
      error: {
        background: "color-mix(in srgb, {red.50}, transparent 5%)",
        borderColor: "{red.200}",
        color: "{red.600}",
        detailColor: "{surface.700}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{red.100}",
          focusRing: {
            color: "{red.600}",
            shadow: "none"
          }
        }
      },
      secondary: {
        background: "{surface.100}",
        borderColor: "{surface.200}",
        color: "{surface.600}",
        detailColor: "{surface.700}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{surface.200}",
          focusRing: {
            color: "{surface.600}",
            shadow: "none"
          }
        }
      },
      contrast: {
        background: "{surface.900}",
        borderColor: "{surface.950}",
        color: "{surface.50}",
        detailColor: "{surface.0}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
        closeButton: {
          hoverBackground: "{surface.800}",
          focusRing: {
            color: "{surface.50}",
            shadow: "none"
          }
        }
      }
    },
    dark: {
      blur: "10px",
      info: {
        background: "color-mix(in srgb, {blue.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {blue.700}, transparent 64%)",
        color: "{blue.500}",
        detailColor: "{surface.0}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {blue.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "rgba(255, 255, 255, 0.05)",
          focusRing: {
            color: "{blue.500}",
            shadow: "none"
          }
        }
      },
      success: {
        background: "color-mix(in srgb, {green.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {green.700}, transparent 64%)",
        color: "{green.500}",
        detailColor: "{surface.0}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {green.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "rgba(255, 255, 255, 0.05)",
          focusRing: {
            color: "{green.500}",
            shadow: "none"
          }
        }
      },
      warn: {
        background: "color-mix(in srgb, {yellow.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {yellow.700}, transparent 64%)",
        color: "{yellow.500}",
        detailColor: "{surface.0}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {yellow.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "rgba(255, 255, 255, 0.05)",
          focusRing: {
            color: "{yellow.500}",
            shadow: "none"
          }
        }
      },
      error: {
        background: "color-mix(in srgb, {red.500}, transparent 84%)",
        borderColor: "color-mix(in srgb, {red.700}, transparent 64%)",
        color: "{red.500}",
        detailColor: "{surface.0}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {red.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "rgba(255, 255, 255, 0.05)",
          focusRing: {
            color: "{red.500}",
            shadow: "none"
          }
        }
      },
      secondary: {
        background: "{surface.800}",
        borderColor: "{surface.700}",
        color: "{surface.300}",
        detailColor: "{surface.0}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.500}, transparent 96%)",
        closeButton: {
          hoverBackground: "{surface.700}",
          focusRing: {
            color: "{surface.300}",
            shadow: "none"
          }
        }
      },
      contrast: {
        background: "{surface.0}",
        borderColor: "{surface.100}",
        color: "{surface.950}",
        detailColor: "{surface.950}",
        shadow: "0px 4px 8px 0px color-mix(in srgb, {surface.950}, transparent 96%)",
        closeButton: {
          hoverBackground: "{surface.100}",
          focusRing: {
            color: "{surface.950}",
            shadow: "none"
          }
        }
      }
    }
  }
}, bf = {
  root: {
    padding: "0.5rem 1rem",
    borderRadius: "{content.border.radius}",
    gap: "0.5rem",
    fontWeight: "500",
    disabledBackground: "{form.field.disabled.background}",
    disabledBorderColor: "{form.field.disabled.background}",
    disabledColor: "{form.field.disabled.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      padding: "0.375rem 0.75rem"
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      padding: "0.625rem 1.25rem"
    }
  },
  icon: {
    disabledColor: "{form.field.disabled.color}"
  },
  content: {
    left: "0.25rem",
    top: "0.25rem",
    checkedShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 2px 0px rgba(0, 0, 0, 0.04)"
  },
  colorScheme: {
    light: {
      root: {
        background: "{surface.100}",
        checkedBackground: "{surface.100}",
        hoverBackground: "{surface.100}",
        borderColor: "{surface.100}",
        color: "{surface.500}",
        hoverColor: "{surface.700}",
        checkedColor: "{surface.900}",
        checkedBorderColor: "{surface.100}"
      },
      content: {
        checkedBackground: "{surface.0}"
      },
      icon: {
        color: "{surface.500}",
        hoverColor: "{surface.700}",
        checkedColor: "{surface.900}"
      }
    },
    dark: {
      root: {
        background: "{surface.950}",
        checkedBackground: "{surface.950}",
        hoverBackground: "{surface.950}",
        borderColor: "{surface.950}",
        color: "{surface.400}",
        hoverColor: "{surface.300}",
        checkedColor: "{surface.0}",
        checkedBorderColor: "{surface.950}"
      },
      content: {
        checkedBackground: "{surface.800}"
      },
      icon: {
        color: "{surface.400}",
        hoverColor: "{surface.300}",
        checkedColor: "{surface.0}"
      }
    }
  }
}, vf = {
  root: {
    width: "2.5rem",
    height: "1.5rem",
    borderRadius: "30px",
    gap: "0.25rem",
    shadow: "{form.field.shadow}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    },
    borderWidth: "1px",
    borderColor: "transparent",
    hoverBorderColor: "transparent",
    checkedBorderColor: "transparent",
    checkedHoverBorderColor: "transparent",
    invalidBorderColor: "{form.field.invalid.border.color}",
    transitionDuration: "{form.field.transition.duration}",
    slideDuration: "0.2s"
  },
  handle: {
    borderRadius: "50%",
    size: "1rem"
  },
  colorScheme: {
    light: {
      root: {
        background: "{surface.300}",
        disabledBackground: "{form.field.disabled.background}",
        hoverBackground: "{surface.400}",
        checkedBackground: "{primary.color}",
        checkedHoverBackground: "{primary.hover.color}"
      },
      handle: {
        background: "{surface.0}",
        disabledBackground: "{form.field.disabled.color}",
        hoverBackground: "{surface.0}",
        checkedBackground: "{surface.0}",
        checkedHoverBackground: "{surface.0}",
        color: "{text.muted.color}",
        hoverColor: "{text.color}",
        checkedColor: "{primary.color}",
        checkedHoverColor: "{primary.hover.color}"
      }
    },
    dark: {
      root: {
        background: "{surface.700}",
        disabledBackground: "{surface.600}",
        hoverBackground: "{surface.600}",
        checkedBackground: "{primary.color}",
        checkedHoverBackground: "{primary.hover.color}"
      },
      handle: {
        background: "{surface.400}",
        disabledBackground: "{surface.900}",
        hoverBackground: "{surface.300}",
        checkedBackground: "{surface.900}",
        checkedHoverBackground: "{surface.900}",
        color: "{surface.900}",
        hoverColor: "{surface.800}",
        checkedColor: "{primary.color}",
        checkedHoverColor: "{primary.hover.color}"
      }
    }
  }
}, yf = {
  root: {
    background: "{content.background}",
    borderColor: "{content.border.color}",
    borderRadius: "{content.border.radius}",
    color: "{content.color}",
    gap: "0.5rem",
    padding: "0.75rem"
  }
}, kf = {
  root: {
    maxWidth: "12.5rem",
    gutter: "0.25rem",
    shadow: "{overlay.popover.shadow}",
    padding: "0.5rem 0.75rem",
    borderRadius: "{overlay.popover.border.radius}"
  },
  colorScheme: {
    light: {
      root: {
        background: "{surface.700}",
        color: "{surface.0}"
      }
    },
    dark: {
      root: {
        background: "{surface.700}",
        color: "{surface.0}"
      }
    }
  }
}, wf = {
  root: {
    background: "{content.background}",
    color: "{content.color}",
    padding: "1rem",
    gap: "2px",
    indent: "1rem",
    transitionDuration: "{transition.duration}"
  },
  node: {
    padding: "0.25rem 0.5rem",
    borderRadius: "{content.border.radius}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}",
    color: "{text.color}",
    hoverColor: "{text.hover.color}",
    selectedColor: "{highlight.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}"
    },
    gap: "0.25rem"
  },
  nodeIcon: {
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}",
    selectedColor: "{highlight.color}"
  },
  nodeToggleButton: {
    borderRadius: "50%",
    size: "1.75rem",
    hoverBackground: "{content.hover.background}",
    selectedHoverBackground: "{content.background}",
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}",
    selectedHoverColor: "{primary.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  loadingIcon: {
    size: "2rem"
  },
  filter: {
    margin: "0 0 0.5rem 0"
  }
}, Cf = {
  root: {
    background: "{form.field.background}",
    disabledBackground: "{form.field.disabled.background}",
    filledBackground: "{form.field.filled.background}",
    filledHoverBackground: "{form.field.filled.hover.background}",
    filledFocusBackground: "{form.field.filled.focus.background}",
    borderColor: "{form.field.border.color}",
    hoverBorderColor: "{form.field.hover.border.color}",
    focusBorderColor: "{form.field.focus.border.color}",
    invalidBorderColor: "{form.field.invalid.border.color}",
    color: "{form.field.color}",
    disabledColor: "{form.field.disabled.color}",
    placeholderColor: "{form.field.placeholder.color}",
    invalidPlaceholderColor: "{form.field.invalid.placeholder.color}",
    shadow: "{form.field.shadow}",
    paddingX: "{form.field.padding.x}",
    paddingY: "{form.field.padding.y}",
    borderRadius: "{form.field.border.radius}",
    focusRing: {
      width: "{form.field.focus.ring.width}",
      style: "{form.field.focus.ring.style}",
      color: "{form.field.focus.ring.color}",
      offset: "{form.field.focus.ring.offset}",
      shadow: "{form.field.focus.ring.shadow}"
    },
    transitionDuration: "{form.field.transition.duration}",
    sm: {
      fontSize: "{form.field.sm.font.size}",
      paddingX: "{form.field.sm.padding.x}",
      paddingY: "{form.field.sm.padding.y}"
    },
    lg: {
      fontSize: "{form.field.lg.font.size}",
      paddingX: "{form.field.lg.padding.x}",
      paddingY: "{form.field.lg.padding.y}"
    }
  },
  dropdown: {
    width: "2.5rem",
    color: "{form.field.icon.color}"
  },
  overlay: {
    background: "{overlay.select.background}",
    borderColor: "{overlay.select.border.color}",
    borderRadius: "{overlay.select.border.radius}",
    color: "{overlay.select.color}",
    shadow: "{overlay.select.shadow}"
  },
  tree: {
    padding: "{list.padding}"
  },
  clearIcon: {
    color: "{form.field.icon.color}"
  },
  emptyMessage: {
    padding: "{list.option.padding}"
  },
  chip: {
    borderRadius: "{border.radius.sm}"
  }
}, xf = {
  root: {
    transitionDuration: "{transition.duration}"
  },
  header: {
    background: "{content.background}",
    borderColor: "{treetable.border.color}",
    color: "{content.color}",
    borderWidth: "0 0 1px 0",
    padding: "0.75rem 1rem"
  },
  headerCell: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}",
    borderColor: "{treetable.border.color}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{highlight.color}",
    gap: "0.5rem",
    padding: "0.75rem 1rem",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}"
    }
  },
  columnTitle: {
    fontWeight: "600"
  },
  row: {
    background: "{content.background}",
    hoverBackground: "{content.hover.background}",
    selectedBackground: "{highlight.background}",
    color: "{content.color}",
    hoverColor: "{content.hover.color}",
    selectedColor: "{highlight.color}",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "-1px",
      shadow: "{focus.ring.shadow}"
    }
  },
  bodyCell: {
    borderColor: "{treetable.border.color}",
    padding: "0.75rem 1rem",
    gap: "0.5rem"
  },
  footerCell: {
    background: "{content.background}",
    borderColor: "{treetable.border.color}",
    color: "{content.color}",
    padding: "0.75rem 1rem"
  },
  columnFooter: {
    fontWeight: "600"
  },
  footer: {
    background: "{content.background}",
    borderColor: "{treetable.border.color}",
    color: "{content.color}",
    borderWidth: "0 0 1px 0",
    padding: "0.75rem 1rem"
  },
  columnResizerWidth: "0.5rem",
  resizeIndicator: {
    width: "1px",
    color: "{primary.color}"
  },
  sortIcon: {
    color: "{text.muted.color}",
    hoverColor: "{text.hover.muted.color}",
    size: "0.875rem"
  },
  loadingIcon: {
    size: "2rem"
  },
  nodeToggleButton: {
    hoverBackground: "{content.hover.background}",
    selectedHoverBackground: "{content.background}",
    color: "{text.muted.color}",
    hoverColor: "{text.color}",
    selectedHoverColor: "{primary.color}",
    size: "1.75rem",
    borderRadius: "50%",
    focusRing: {
      width: "{focus.ring.width}",
      style: "{focus.ring.style}",
      color: "{focus.ring.color}",
      offset: "{focus.ring.offset}",
      shadow: "{focus.ring.shadow}"
    }
  },
  paginatorTop: {
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0"
  },
  paginatorBottom: {
    borderColor: "{content.border.color}",
    borderWidth: "0 0 1px 0"
  },
  colorScheme: {
    light: {
      root: {
        borderColor: "{content.border.color}"
      },
      bodyCell: {
        selectedBorderColor: "{primary.100}"
      }
    },
    dark: {
      root: {
        borderColor: "{surface.800}"
      },
      bodyCell: {
        selectedBorderColor: "{primary.900}"
      }
    }
  }
}, Sf = {
  loader: {
    mask: {
      background: "{content.background}",
      color: "{text.muted.color}"
    },
    icon: {
      size: "2rem"
    }
  }
};
function tt(e) {
  "@babel/helpers - typeof";
  return tt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, tt(e);
}
function oi(e, o) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ti(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = arguments[o] != null ? arguments[o] : {};
    o % 2 ? oi(Object(t), !0).forEach(function(r) {
      $f(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : oi(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function $f(e, o, t) {
  return (o = Bf(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function Bf(e) {
  var o = _f(e, "string");
  return tt(o) == "symbol" ? o : o + "";
}
function _f(e, o) {
  if (tt(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (tt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
var Mf = ti(ti({}, K0), {}, {
  components: {
    accordion: j0,
    autocomplete: Z0,
    avatar: W0,
    badge: Y0,
    blockui: U0,
    breadcrumb: G0,
    button: q0,
    datepicker: sp,
    card: X0,
    carousel: Q0,
    cascadeselect: J0,
    checkbox: ep,
    chip: op,
    colorpicker: tp,
    confirmdialog: rp,
    confirmpopup: np,
    contextmenu: ip,
    dataview: lp,
    datatable: ap,
    dialog: cp,
    divider: dp,
    dock: up,
    drawer: pp,
    editor: fp,
    fieldset: hp,
    fileupload: gp,
    iftalabel: yp,
    floatlabel: mp,
    galleria: bp,
    iconfield: vp,
    image: kp,
    imagecompare: wp,
    inlinemessage: Cp,
    inplace: xp,
    inputchips: Sp,
    inputgroup: $p,
    inputnumber: Bp,
    inputotp: _p,
    inputtext: Mp,
    knob: Tp,
    listbox: Pp,
    megamenu: Dp,
    menu: Op,
    menubar: Rp,
    message: Lp,
    metergroup: Ap,
    multiselect: Ip,
    orderlist: Ep,
    organizationchart: zp,
    overlaybadge: Np,
    popover: Wp,
    paginator: Hp,
    password: jp,
    panel: Vp,
    panelmenu: Fp,
    picklist: Zp,
    progressbar: Yp,
    progressspinner: Kp,
    radiobutton: Up,
    rating: Gp,
    scrollpanel: Xp,
    select: Qp,
    selectbutton: Jp,
    skeleton: ef,
    slider: of,
    speeddial: tf,
    splitter: nf,
    splitbutton: rf,
    stepper: af,
    steps: lf,
    tabmenu: sf,
    tabs: cf,
    tabview: df,
    textarea: ff,
    tieredmenu: hf,
    tag: uf,
    terminal: pf,
    timeline: gf,
    togglebutton: bf,
    toggleswitch: vf,
    tree: wf,
    treeselect: Cf,
    treetable: xf,
    toast: mf,
    toolbar: yf,
    virtualscroller: Sf
  },
  directives: {
    tooltip: kf,
    ripple: qp
  }
});
const Tf = Ed(Mf, {
  semantic: {
    primary: {
      50: le.blue.light,
      100: le.blue.light,
      200: le.blue.semiLight,
      300: le.blue.semiLight,
      400: le.blue.normal,
      500: le.blue.normal,
      600: le.blue.semiDark,
      700: le.blue.semiDark,
      800: le.blue.dark,
      900: le.blue.dark,
      950: le.blue.dark
    }
  },
  components: {
    datepicker: {
      date: {
        width: "1.75rem",
        height: "1.75rem"
      }
    },
    radiobutton: {
      checked: {
        background: le.grey.white,
        hover: {
          background: le.grey.white
        }
      },
      icon: {
        checked: {
          color: le.blue.normal,
          hover: {
            color: le.blue.semiDark
          }
        }
      }
    }
  }
});
var ue = {
  STARTS_WITH: "startsWith",
  CONTAINS: "contains",
  NOT_CONTAINS: "notContains",
  ENDS_WITH: "endsWith",
  EQUALS: "equals",
  NOT_EQUALS: "notEquals",
  IN: "in",
  LESS_THAN: "lt",
  LESS_THAN_OR_EQUAL_TO: "lte",
  GREATER_THAN: "gt",
  GREATER_THAN_OR_EQUAL_TO: "gte",
  BETWEEN: "between",
  DATE_IS: "dateIs",
  DATE_IS_NOT: "dateIsNot",
  DATE_BEFORE: "dateBefore",
  DATE_AFTER: "dateAfter"
};
function rt(e) {
  "@babel/helpers - typeof";
  return rt = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(o) {
    return typeof o;
  } : function(o) {
    return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, rt(e);
}
function ri(e, o) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    o && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ft(e) {
  for (var o = 1; o < arguments.length; o++) {
    var t = arguments[o] != null ? arguments[o] : {};
    o % 2 ? ri(Object(t), !0).forEach(function(r) {
      Pf(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ri(Object(t)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function Pf(e, o, t) {
  return (o = Df(o)) in e ? Object.defineProperty(e, o, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[o] = t, e;
}
function Df(e) {
  var o = Of(e, "string");
  return rt(o) == "symbol" ? o : o + "";
}
function Of(e, o) {
  if (rt(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(e, o || "default");
    if (rt(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (o === "string" ? String : Number)(e);
}
var Rf = {
  ripple: !1,
  inputStyle: null,
  inputVariant: null,
  locale: {
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Greater than or equal to",
    dateIs: "Date is",
    dateIsNot: "Date is not",
    dateBefore: "Date is before",
    dateAfter: "Date is after",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    completed: "Completed",
    pending: "Pending",
    fileSizeTypes: ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    chooseYear: "Choose Year",
    chooseMonth: "Choose Month",
    chooseDate: "Choose Date",
    prevDecade: "Previous Decade",
    nextDecade: "Next Decade",
    prevYear: "Previous Year",
    nextYear: "Next Year",
    prevMonth: "Previous Month",
    nextMonth: "Next Month",
    prevHour: "Previous Hour",
    nextHour: "Next Hour",
    prevMinute: "Previous Minute",
    nextMinute: "Next Minute",
    prevSecond: "Previous Second",
    nextSecond: "Next Second",
    am: "am",
    pm: "pm",
    today: "Today",
    weekHeader: "Wk",
    firstDayOfWeek: 0,
    showMonthAfterYear: !1,
    dateFormat: "mm/dd/yy",
    weak: "Weak",
    medium: "Medium",
    strong: "Strong",
    passwordPrompt: "Enter a password",
    emptyFilterMessage: "No results found",
    searchMessage: "{0} results are available",
    selectionMessage: "{0} items selected",
    emptySelectionMessage: "No selected item",
    emptySearchMessage: "No results found",
    fileChosenMessage: "{0} files",
    noFileChosenMessage: "No file chosen",
    emptyMessage: "No available options",
    aria: {
      trueLabel: "True",
      falseLabel: "False",
      nullLabel: "Not Selected",
      star: "1 star",
      stars: "{star} stars",
      selectAll: "All items selected",
      unselectAll: "All items unselected",
      close: "Close",
      previous: "Previous",
      next: "Next",
      navigation: "Navigation",
      scrollTop: "Scroll Top",
      moveTop: "Move Top",
      moveUp: "Move Up",
      moveDown: "Move Down",
      moveBottom: "Move Bottom",
      moveToTarget: "Move to Target",
      moveToSource: "Move to Source",
      moveAllToTarget: "Move All to Target",
      moveAllToSource: "Move All to Source",
      pageLabel: "Page {page}",
      firstPageLabel: "First Page",
      lastPageLabel: "Last Page",
      nextPageLabel: "Next Page",
      prevPageLabel: "Previous Page",
      rowsPerPageLabel: "Rows per page",
      jumpToPageDropdownLabel: "Jump to Page Dropdown",
      jumpToPageInputLabel: "Jump to Page Input",
      selectRow: "Row Selected",
      unselectRow: "Row Unselected",
      expandRow: "Row Expanded",
      collapseRow: "Row Collapsed",
      showFilterMenu: "Show Filter Menu",
      hideFilterMenu: "Hide Filter Menu",
      filterOperator: "Filter Operator",
      filterConstraint: "Filter Constraint",
      editRow: "Row Edit",
      saveEdit: "Save Edit",
      cancelEdit: "Cancel Edit",
      listView: "List View",
      gridView: "Grid View",
      slide: "Slide",
      slideNumber: "{slideNumber}",
      zoomImage: "Zoom Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      rotateRight: "Rotate Right",
      rotateLeft: "Rotate Left",
      listLabel: "Option List"
    }
  },
  filterMatchModeOptions: {
    text: [ue.STARTS_WITH, ue.CONTAINS, ue.NOT_CONTAINS, ue.ENDS_WITH, ue.EQUALS, ue.NOT_EQUALS],
    numeric: [ue.EQUALS, ue.NOT_EQUALS, ue.LESS_THAN, ue.LESS_THAN_OR_EQUAL_TO, ue.GREATER_THAN, ue.GREATER_THAN_OR_EQUAL_TO],
    date: [ue.DATE_IS, ue.DATE_IS_NOT, ue.DATE_BEFORE, ue.DATE_AFTER]
  },
  zIndex: {
    modal: 1100,
    overlay: 1e3,
    menu: 1e3,
    tooltip: 1100
  },
  theme: void 0,
  unstyled: !1,
  pt: void 0,
  ptOptions: {
    mergeSections: !0,
    mergeProps: !1
  },
  csp: {
    nonce: void 0
  }
}, Lf = Symbol();
function Af(e, o) {
  var t = {
    config: Ot(o)
  };
  return e.config.globalProperties.$primevue = t, e.provide(Lf, t), If(), Ef(e, t), t;
}
var ko = [];
function If() {
  Se.clear(), ko.forEach(function(e) {
    return e == null ? void 0 : e();
  }), ko = [];
}
function Ef(e, o) {
  var t = Z(!1), r = function() {
    var d;
    if (((d = o.config) === null || d === void 0 ? void 0 : d.theme) !== "none" && !G.isStyleNameLoaded("common")) {
      var c, f, u = ((c = Q.getCommonTheme) === null || c === void 0 ? void 0 : c.call(Q)) || {}, p = u.primitive, h = u.semantic, m = u.global, v = u.style, C = {
        nonce: (f = o.config) === null || f === void 0 || (f = f.csp) === null || f === void 0 ? void 0 : f.nonce
      };
      Q.load(p == null ? void 0 : p.css, ft({
        name: "primitive-variables"
      }, C)), Q.load(h == null ? void 0 : h.css, ft({
        name: "semantic-variables"
      }, C)), Q.load(m == null ? void 0 : m.css, ft({
        name: "global-variables"
      }, C)), Q.loadTheme(ft({
        name: "global-style"
      }, C), v), G.setLoadedStyleName("common");
    }
  };
  Se.on("theme:change", function(s) {
    t.value || (e.config.globalProperties.$primevue.config.theme = s, t.value = !0);
  });
  var n = se(o.config, function(s, d) {
    yo.emit("config:change", {
      newValue: s,
      oldValue: d
    });
  }, {
    immediate: !0,
    deep: !0
  }), i = se(function() {
    return o.config.ripple;
  }, function(s, d) {
    yo.emit("config:ripple:change", {
      newValue: s,
      oldValue: d
    });
  }, {
    immediate: !0,
    deep: !0
  }), a = se(function() {
    return o.config.theme;
  }, function(s, d) {
    t.value || G.setTheme(s), o.config.unstyled || r(), t.value = !1, yo.emit("config:theme:change", {
      newValue: s,
      oldValue: d
    });
  }, {
    immediate: !0,
    deep: !1
  }), l = se(function() {
    return o.config.unstyled;
  }, function(s, d) {
    !s && o.config.theme && r(), yo.emit("config:unstyled:change", {
      newValue: s,
      oldValue: d
    });
  }, {
    immediate: !0,
    deep: !0
  });
  ko.push(n), ko.push(i), ko.push(a), ko.push(l);
}
var zf = {
  install: function(o, t) {
    var r = ua(Rf, t);
    Af(o, r);
  }
};
const La = Symbol("BridgeIK"), Nf = {
  locale: "pt-br"
};
function Hf() {
  const e = So(La);
  if (!e)
    throw new Error("Bridge is not installed!");
  return e;
}
async function Vf(e, o) {
  const t = {
    config: Ot(o)
  };
  return e.provide(La, t), e.use(zf, {
    theme: {
      preset: Tf,
      options: {
        prefix: "bg",
        darkModeSelector: ".bg-dark",
        cssLayer: {
          name: "primeui",
          order: "bridge-reset, primeui, bridge"
        }
      }
    }
  }), await Ff(e, o), t;
}
async function Ff(e, o) {
  const { $primevue: t } = e.config.globalProperties;
  try {
    const r = await Ra(/* @__PURE__ */ Object.assign({ "../../node_modules/primelocale/ar-tn.json": () => import("./ar-tn-BscyYN6O.js"), "../../node_modules/primelocale/ar.json": () => import("./ar-BZtvLFAi.js"), "../../node_modules/primelocale/bg.json": () => import("./bg--y7LSGwX.js"), "../../node_modules/primelocale/bn.json": () => import("./bn-4_M4WJU9.js"), "../../node_modules/primelocale/ca.json": () => import("./ca-q_PKKZPj.js"), "../../node_modules/primelocale/ckb.json": () => import("./ckb-psgdCk5j.js"), "../../node_modules/primelocale/cs.json": () => import("./cs-D6N02lBp.js"), "../../node_modules/primelocale/da.json": () => import("./da-CrkpQ8qB.js"), "../../node_modules/primelocale/de-at.json": () => import("./de-at-CBUKPBrT.js"), "../../node_modules/primelocale/de-ch.json": () => import("./de-ch-Btqd1dvw.js"), "../../node_modules/primelocale/de.json": () => import("./de-UFctySjd.js"), "../../node_modules/primelocale/el.json": () => import("./el-Clm4RyjU.js"), "../../node_modules/primelocale/en-au.json": () => import("./en-au-CFOMtDQg.js"), "../../node_modules/primelocale/en-gb.json": () => import("./en-gb-DwIoq9j-.js"), "../../node_modules/primelocale/en.json": () => import("./en-C21PAazi.js"), "../../node_modules/primelocale/es.json": () => import("./es-CwWtL5ix.js"), "../../node_modules/primelocale/fa.json": () => import("./fa-D1RoYwPM.js"), "../../node_modules/primelocale/fi.json": () => import("./fi-g0bAyAjd.js"), "../../node_modules/primelocale/fr.json": () => import("./fr-CBJso37C.js"), "../../node_modules/primelocale/he.json": () => import("./he-DYnP8xFP.js"), "../../node_modules/primelocale/hi.json": () => import("./hi-CqxVcVMa.js"), "../../node_modules/primelocale/hr.json": () => import("./hr-DQ0Pi8a3.js"), "../../node_modules/primelocale/hu.json": () => import("./hu-_tbpIbSm.js"), "../../node_modules/primelocale/id.json": () => import("./id-wqw9JACO.js"), "../../node_modules/primelocale/it.json": () => import("./it-BHQ6TU71.js"), "../../node_modules/primelocale/ja.json": () => import("./ja-B9jHeGNQ.js"), "../../node_modules/primelocale/kk.json": () => import("./kk-Bny8LUc6.js"), "../../node_modules/primelocale/km.json": () => import("./km-1fvT6lEg.js"), "../../node_modules/primelocale/ko.json": () => import("./ko-BddzZrL3.js"), "../../node_modules/primelocale/ku.json": () => import("./ku-pAlZ9o0Y.js"), "../../node_modules/primelocale/ky.json": () => import("./ky-Bf1JayZF.js"), "../../node_modules/primelocale/lt.json": () => import("./lt-Cti8Bg1v.js"), "../../node_modules/primelocale/lv.json": () => import("./lv-CC2Vkqw5.js"), "../../node_modules/primelocale/ms.json": () => import("./ms-CHtmBpp5.js"), "../../node_modules/primelocale/nb-no.json": () => import("./nb-no-B_oKVZvY.js"), "../../node_modules/primelocale/nl.json": () => import("./nl-CO-m4qF2.js"), "../../node_modules/primelocale/package.json": () => import("./package-kJNPAmWy.js"), "../../node_modules/primelocale/pl.json": () => import("./pl-HAiLWIKB.js"), "../../node_modules/primelocale/pt-br.json": () => import("./pt-br-GGwP8I2q.js"), "../../node_modules/primelocale/pt.json": () => import("./pt-Diu0lrgQ.js"), "../../node_modules/primelocale/ro.json": () => import("./ro-El-msxqF.js"), "../../node_modules/primelocale/ru.json": () => import("./ru-QKkaB-Nf.js"), "../../node_modules/primelocale/sk.json": () => import("./sk-Bdj5_lLw.js"), "../../node_modules/primelocale/sl.json": () => import("./sl-CqFKE41q.js"), "../../node_modules/primelocale/sr-rs.json": () => import("./sr-rs-CoE7hf1V.js"), "../../node_modules/primelocale/sv.json": () => import("./sv-BvTWFMvW.js"), "../../node_modules/primelocale/th.json": () => import("./th-C9HzgMjo.js"), "../../node_modules/primelocale/tr.json": () => import("./tr-fefBSWHT.js"), "../../node_modules/primelocale/uk.json": () => import("./uk-DvPNOcui.js"), "../../node_modules/primelocale/uz.json": () => import("./uz-M1NU-4nv.js"), "../../node_modules/primelocale/vi.json": () => import("./vi-DTSbJzdD.js"), "../../node_modules/primelocale/zh-CN.json": () => import("./zh-CN-iM5yv3VG.js"), "../../node_modules/primelocale/zh-TW.json": () => import("./zh-TW-B2w1u4DZ.js") }), `../../node_modules/primelocale/${o.locale}.json`, 5);
    t.config.locale = r.default[o.locale];
  } catch (r) {
    console.warn(`Locale ${o.locale} not found!`, r);
  }
}
const hg = {
  install: (e, o) => {
    Vf(e, {
      ...Nf,
      ...o
    });
  }
};
var jf = function(o) {
  var t = o.dt;
  return `
.p-radiobutton {
    position: relative;
    display: inline-flex;
    user-select: none;
    vertical-align: bottom;
    width: `.concat(t("radiobutton.width"), `;
    height: `).concat(t("radiobutton.height"), `;
}

.p-radiobutton-input {
    cursor: pointer;
    appearance: none;
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    z-index: 1;
    outline: 0 none;
    border: 1px solid transparent;
    border-radius: 50%;
}

.p-radiobutton-box {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 1px solid `).concat(t("radiobutton.border.color"), `;
    background: `).concat(t("radiobutton.background"), `;
    width: `).concat(t("radiobutton.width"), `;
    height: `).concat(t("radiobutton.height"), `;
    transition: background `).concat(t("radiobutton.transition.duration"), ", color ").concat(t("radiobutton.transition.duration"), ", border-color ").concat(t("radiobutton.transition.duration"), ", box-shadow ").concat(t("radiobutton.transition.duration"), ", outline-color ").concat(t("radiobutton.transition.duration"), `;
    outline-color: transparent;
    box-shadow: `).concat(t("radiobutton.shadow"), `;
}

.p-radiobutton-icon {
    transition-duration: `).concat(t("radiobutton.transition.duration"), `;
    background: transparent;
    font-size: `).concat(t("radiobutton.icon.size"), `;
    width: `).concat(t("radiobutton.icon.size"), `;
    height: `).concat(t("radiobutton.icon.size"), `;
    border-radius: 50%;
    backface-visibility: hidden;
    transform: translateZ(0) scale(0.1);
}

.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {
    border-color: `).concat(t("radiobutton.hover.border.color"), `;
}

.p-radiobutton-checked .p-radiobutton-box {
    border-color: `).concat(t("radiobutton.checked.border.color"), `;
    background: `).concat(t("radiobutton.checked.background"), `;
}

.p-radiobutton-checked .p-radiobutton-box .p-radiobutton-icon {
    background: `).concat(t("radiobutton.icon.checked.color"), `;
    transform: translateZ(0) scale(1, 1);
    visibility: visible;
}

.p-radiobutton-checked:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {
    border-color: `).concat(t("radiobutton.checked.hover.border.color"), `;
    background: `).concat(t("radiobutton.checked.hover.background"), `;
}

.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover).p-radiobutton-checked .p-radiobutton-box .p-radiobutton-icon {
    background: `).concat(t("radiobutton.icon.checked.hover.color"), `;
}

.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:focus-visible) .p-radiobutton-box {
    border-color: `).concat(t("radiobutton.focus.border.color"), `;
    box-shadow: `).concat(t("radiobutton.focus.ring.shadow"), `;
    outline: `).concat(t("radiobutton.focus.ring.width"), " ").concat(t("radiobutton.focus.ring.style"), " ").concat(t("radiobutton.focus.ring.color"), `;
    outline-offset: `).concat(t("radiobutton.focus.ring.offset"), `;
}

.p-radiobutton-checked:not(.p-disabled):has(.p-radiobutton-input:focus-visible) .p-radiobutton-box {
    border-color: `).concat(t("radiobutton.checked.focus.border.color"), `;
}

.p-radiobutton.p-invalid > .p-radiobutton-box {
    border-color: `).concat(t("radiobutton.invalid.border.color"), `;
}

.p-radiobutton.p-variant-filled .p-radiobutton-box {
    background: `).concat(t("radiobutton.filled.background"), `;
}

.p-radiobutton.p-variant-filled.p-radiobutton-checked .p-radiobutton-box {
    background: `).concat(t("radiobutton.checked.background"), `;
}

.p-radiobutton.p-variant-filled:not(.p-disabled):has(.p-radiobutton-input:hover).p-radiobutton-checked .p-radiobutton-box {
    background: `).concat(t("radiobutton.checked.hover.background"), `;
}

.p-radiobutton.p-disabled {
    opacity: 1;
}

.p-radiobutton.p-disabled .p-radiobutton-box {
    background: `).concat(t("radiobutton.disabled.background"), `;
    border-color: `).concat(t("radiobutton.checked.disabled.border.color"), `;
}

.p-radiobutton-checked.p-disabled .p-radiobutton-box .p-radiobutton-icon {
    background: `).concat(t("radiobutton.icon.disabled.color"), `;
}

.p-radiobutton-sm,
.p-radiobutton-sm .p-radiobutton-box {
    width: `).concat(t("radiobutton.sm.width"), `;
    height: `).concat(t("radiobutton.sm.height"), `;
}

.p-radiobutton-sm .p-radiobutton-icon {
    font-size: `).concat(t("radiobutton.icon.sm.size"), `;
    width: `).concat(t("radiobutton.icon.sm.size"), `;
    height: `).concat(t("radiobutton.icon.sm.size"), `;
}

.p-radiobutton-lg,
.p-radiobutton-lg .p-radiobutton-box {
    width: `).concat(t("radiobutton.lg.width"), `;
    height: `).concat(t("radiobutton.lg.height"), `;
}

.p-radiobutton-lg .p-radiobutton-icon {
    font-size: `).concat(t("radiobutton.icon.lg.size"), `;
    width: `).concat(t("radiobutton.icon.lg.size"), `;
    height: `).concat(t("radiobutton.icon.lg.size"), `;
}
`);
}, Zf = {
  root: function(o) {
    var t = o.instance, r = o.props;
    return ["p-radiobutton p-component", {
      "p-radiobutton-checked": t.checked,
      "p-disabled": r.disabled,
      "p-invalid": t.$pcRadioButtonGroup ? t.$pcRadioButtonGroup.$invalid : t.$invalid,
      "p-variant-filled": t.$variant === "filled",
      "p-radiobutton-sm p-inputfield-sm": r.size === "small",
      "p-radiobutton-lg p-inputfield-lg": r.size === "large"
    }];
  },
  box: "p-radiobutton-box",
  input: "p-radiobutton-input",
  icon: "p-radiobutton-icon"
}, Wf = Q.extend({
  name: "radiobutton",
  theme: jf,
  classes: Zf
}), Yf = {
  name: "BaseRadioButton",
  extends: jr,
  props: {
    value: null,
    binary: Boolean,
    readonly: {
      type: Boolean,
      default: !1
    },
    tabindex: {
      type: Number,
      default: null
    },
    inputId: {
      type: String,
      default: null
    },
    inputClass: {
      type: [String, Object],
      default: null
    },
    inputStyle: {
      type: Object,
      default: null
    },
    ariaLabelledby: {
      type: String,
      default: null
    },
    ariaLabel: {
      type: String,
      default: null
    }
  },
  style: Wf,
  provide: function() {
    return {
      $pcRadioButton: this,
      $parentInstance: this
    };
  }
}, hr = {
  name: "RadioButton",
  extends: Yf,
  inheritAttrs: !1,
  emits: ["change", "focus", "blur"],
  inject: {
    $pcRadioButtonGroup: {
      default: void 0
    }
  },
  methods: {
    getPTOptions: function(o) {
      var t = o === "root" ? this.ptmi : this.ptm;
      return t(o, {
        context: {
          checked: this.checked,
          disabled: this.disabled
        }
      });
    },
    onChange: function(o) {
      if (!this.disabled && !this.readonly) {
        var t = this.binary ? !this.checked : this.value;
        this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.writeValue(t, o) : this.writeValue(t, o), this.$emit("change", o);
      }
    },
    onFocus: function(o) {
      this.$emit("focus", o);
    },
    onBlur: function(o) {
      var t, r;
      this.$emit("blur", o), (t = (r = this.formField).onBlur) === null || t === void 0 || t.call(r, o);
    }
  },
  computed: {
    groupName: function() {
      return this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.groupName : this.$formName;
    },
    checked: function() {
      var o = this.$pcRadioButtonGroup ? this.$pcRadioButtonGroup.d_value : this.d_value;
      return o != null && (this.binary ? !!o : xd(o, this.value));
    }
  }
}, Kf = ["data-p-checked", "data-p-disabled"], Uf = ["id", "value", "name", "checked", "tabindex", "disabled", "readonly", "aria-labelledby", "aria-label", "aria-invalid"];
function Gf(e, o, t, r, n, i) {
  return g(), $("div", y({
    class: e.cx("root")
  }, i.getPTOptions("root"), {
    "data-p-checked": i.checked,
    "data-p-disabled": e.disabled
  }), [P("input", y({
    id: e.inputId,
    type: "radio",
    class: [e.cx("input"), e.inputClass],
    style: e.inputStyle,
    value: e.value,
    name: i.groupName,
    checked: i.checked,
    tabindex: e.tabindex,
    disabled: e.disabled,
    readonly: e.readonly,
    "aria-labelledby": e.ariaLabelledby,
    "aria-label": e.ariaLabel,
    "aria-invalid": e.invalid || void 0,
    onFocus: o[0] || (o[0] = function() {
      return i.onFocus && i.onFocus.apply(i, arguments);
    }),
    onBlur: o[1] || (o[1] = function() {
      return i.onBlur && i.onBlur.apply(i, arguments);
    }),
    onChange: o[2] || (o[2] = function() {
      return i.onChange && i.onChange.apply(i, arguments);
    })
  }, i.getPTOptions("input")), null, 16, Uf), P("div", y({
    class: e.cx("box")
  }, i.getPTOptions("box")), [P("div", y({
    class: e.cx("icon")
  }, i.getPTOptions("icon")), null, 16)], 16)], 16, Kf);
}
hr.render = Gf;
const Aa = (e) => (fi("data-v-142e2ea6"), e = e(), hi(), e), qf = /* @__PURE__ */ Aa(() => /* @__PURE__ */ P("label", { for: "month" }, "Mês", -1)), Xf = /* @__PURE__ */ Aa(() => /* @__PURE__ */ P("label", { for: "period" }, "Definir período", -1)), Qf = /* @__PURE__ */ A({
  __name: "BgDateFilter",
  props: /* @__PURE__ */ $o({
    fullWidth: { type: Boolean }
  }, {
    startDate: {
      default: () => new Qe(/* @__PURE__ */ new Date()).startDate
    },
    startDateModifiers: {},
    endDate: {
      default: () => new Qe(/* @__PURE__ */ new Date()).endDate
    },
    endDateModifiers: {}
  }),
  emits: /* @__PURE__ */ $o(["cancel", "apply"], ["update:startDate", "update:endDate"]),
  setup(e, { emit: o }) {
    const t = Object.freeze(new Qe(/* @__PURE__ */ new Date())), r = Z("month"), n = o, i = kt(e, "startDate"), a = kt(e, "endDate"), l = H(() => new Qe(i.value)), s = Z([i.value, a.value]), d = Z(l.value), c = Z(), f = async () => {
      if (!i.value && !a.value) {
        i.value = t.startDate, a.value = t.endDate, d.value = t, s.value = [t.startDate, t.endDate];
        return;
      }
      r.value = u.value ? "month" : "period", d.value = l.value, s.value = [i.value, a.value];
    }, u = H(() => i.value && a.value && ei(i.value, l.value.startDate) && ei(a.value, l.value.endDate));
    se([() => i.value, () => a.value], f, {
      immediate: !0
    });
    const p = Hf(), h = H(() => !i.value || !a.value ? "" : u.value ? l.value.label : `${i.value.toLocaleDateString(
      p.config.locale
    )} - ${a.value.toLocaleDateString(p.config.locale)}`), m = () => {
      n("cancel"), v();
    }, v = () => {
      var _;
      (_ = c.value) == null || _.close();
    }, C = () => {
      i.value = d.value.startDate, a.value = d.value.endDate, s.value = [d.value.startDate, d.value.endDate];
    }, w = () => {
      var _;
      !s.value[0] && s.value[1] && (s.value[0] = s.value[1]), s.value[0] && !s.value[1] && (s.value[1] = s.value[0]), (_ = s.value[1]) == null || _.setHours(23, 59, 59, 999), i.value = s.value[0], a.value = s.value[1], d.value = new Qe(s.value[0]);
    }, b = () => {
      const _ = d.value.next();
      i.value = _.startDate, a.value = _.endDate;
    }, x = () => {
      const _ = d.value.previous();
      i.value = _.startDate, a.value = _.endDate;
    }, D = () => {
      r.value === "month" ? C() : w(), n("apply", {
        startDate: i.value,
        endDate: a.value
      }), v();
    };
    return (_, T) => (g(), M(k(Ir), {
      ref_key: "popover",
      ref: c,
      "focus-trigger-on-close": "",
      "aria-label": h.value,
      role: "dialog",
      onClose: m
    }, {
      button: S((O) => [
        P("div", {
          class: L(_.$style.trigger)
        }, [
          R(k(Oe), {
            icon: "caret-left",
            "aria-label": "Mês anterior",
            variant: "outline",
            size: "sm",
            onClick: x
          }),
          R(k(Oe), y({
            class: { [_.$style.fullWidth]: _.fullWidth }
          }, O, {
            variant: "outline",
            "right-icon": "caret-down",
            size: "sm"
          }), {
            default: S(() => [
              ie(z(h.value), 1)
            ]),
            _: 2
          }, 1040, ["class"]),
          R(k(Oe), {
            icon: "caret-right",
            "aria-label": "Mês seguinte",
            variant: "outline",
            size: "sm",
            onClick: b
          })
        ], 2)
      ]),
      default: S(() => [
        P("div", {
          class: L(_.$style.container)
        }, [
          P("div", {
            class: L(_.$style.radioContainer)
          }, [
            P("div", null, [
              R(k(hr), {
                modelValue: r.value,
                "onUpdate:modelValue": T[0] || (T[0] = (O) => r.value = O),
                "input-id": "month",
                name: "date",
                value: "month"
              }, null, 8, ["modelValue"]),
              qf
            ]),
            P("div", null, [
              R(k(hr), {
                modelValue: r.value,
                "onUpdate:modelValue": T[1] || (T[1] = (O) => r.value = O),
                "input-id": "period",
                name: "date",
                value: "period"
              }, null, 8, ["modelValue"]),
              Xf
            ])
          ], 2),
          r.value === "month" ? (g(), M(k(Jn), {
            key: 0,
            modelValue: d.value.date,
            "onUpdate:modelValue": T[2] || (T[2] = (O) => d.value.date = O),
            "pt:pc-clear-button": {
              root: {
                style: {
                  display: "none"
                }
              }
            },
            view: "month",
            inline: "",
            "selection-mode": "single"
          }, null, 8, ["modelValue"])) : r.value === "period" ? (g(), M(k(Jn), {
            key: 1,
            modelValue: s.value,
            "onUpdate:modelValue": T[3] || (T[3] = (O) => s.value = O),
            view: "date",
            inline: "",
            "pt:pc-clear-button": {
              root: {
                style: {
                  display: "none"
                }
              }
            },
            "selection-mode": "range"
          }, null, 8, ["modelValue"])) : I("", !0),
          P("div", {
            class: L(_.$style.footer),
            role: "toolbar"
          }, [
            R(k(Oe), {
              size: "sm",
              variant: "outline",
              "full-width": "",
              onClick: m
            }, {
              default: S(() => [
                ie(" Cancelar ")
              ]),
              _: 1
            }),
            R(k(Oe), {
              size: "sm",
              "full-width": "",
              onClick: D
            }, {
              default: S(() => [
                ie(" Aplicar ")
              ]),
              _: 1
            })
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["aria-label"]));
  }
}), Jf = "_container_1rirq_2", e1 = "_radio-container_1rirq_9", o1 = "_footer_1rirq_24", t1 = "_trigger_1rirq_30", r1 = "_full-width_1rirq_51", n1 = {
  container: Jf,
  radioContainer: e1,
  footer: o1,
  trigger: t1,
  fullWidth: r1
}, i1 = {
  $style: n1
}, gg = /* @__PURE__ */ W(Qf, [["__cssModules", i1], ["__scopeId", "data-v-142e2ea6"]]), Ia = Symbol("BgFiltersRegister"), Ea = Symbol("BgFiltersList"), a1 = Symbol("BgFiltersContext"), za = () => a1, l1 = Symbol("BgFilterContext"), Na = () => l1, s1 = ["aria-label", "aria-activedescendant"], c1 = /* @__PURE__ */ A({
  __name: "BgFilters",
  props: /* @__PURE__ */ $o({
    label: { default: "Filtros" }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ $o(["apply", "cancel"], ["update:modelValue"]),
  setup(e, { emit: o }) {
    const t = o, r = kt(e, "modelValue"), n = Z({}), i = Z();
    ro(za(), {
      filters: n
    });
    const a = () => {
      n.value = structuredClone(Xr(r.value || {}));
    }, l = () => {
      var h;
      r.value = structuredClone(Xr(n.value)), (h = i.value) == null || h.close();
    }, s = () => {
      var h;
      (h = i.value) == null || h.close(), a(), t("cancel");
    }, d = () => {
      var h, m;
      (m = (h = p.value) == null ? void 0 : h.ref) == null || m.toggle();
    }, { items: c } = Or({
      injectionKey: Ia
    }), { next: f, prev: u, activeItem: p } = Dr({
      injectionKey: Ea,
      items: c
    });
    return se(() => r, a, {
      immediate: !0,
      deep: !0
    }), (h, m) => (g(), M(k(Ir), {
      ref_key: "popover",
      ref: i,
      "focus-trigger-on-close": "",
      "aria-label": h.label,
      role: "dialog",
      onClose: s
    }, {
      button: S((v) => [
        R(k(Oe), y(v, {
          variant: "outline",
          "left-icon": "filter",
          size: "sm"
        }), {
          default: S(() => [
            ie(z(h.label), 1)
          ]),
          _: 2
        }, 1040)
      ]),
      default: S(() => [
        P("div", {
          class: L(h.$style.container)
        }, [
          P("div", {
            class: L(h.$style.list),
            role: "listbox",
            tabindex: "0",
            "aria-multiselectable": "true",
            "aria-label": h.label,
            "aria-activedescendant": k(p) && k(p).id,
            onKeydown: [
              m[0] || (m[0] = K(
                //@ts-ignore
                (...v) => k(f) && k(f)(...v),
                ["down"]
              )),
              m[1] || (m[1] = K(
                //@ts-ignore
                (...v) => k(u) && k(u)(...v),
                ["up"]
              )),
              K(d, ["space"])
            ]
          }, [
            B(h.$slots, "default")
          ], 42, s1),
          P("div", {
            class: L(h.$style.footer),
            role: "toolbar"
          }, [
            R(k(Oe), {
              size: "sm",
              variant: "outline",
              "full-width": "",
              onClick: s
            }, {
              default: S(() => [
                ie(" Cancelar ")
              ]),
              _: 1
            }),
            R(k(Oe), {
              size: "sm",
              "full-width": "",
              onClick: l
            }, {
              default: S(() => [
                ie(" Aplicar ")
              ]),
              _: 1
            })
          ], 2)
        ], 2)
      ]),
      _: 3
    }, 8, ["aria-label"]));
  }
}), d1 = "_container_5ulsx_2", u1 = "_list_5ulsx_9", p1 = "_footer_5ulsx_14", f1 = {
  container: d1,
  list: u1,
  footer: p1
}, h1 = {
  $style: f1
}, gr = /* @__PURE__ */ W(c1, [["__cssModules", h1]]), g1 = /* @__PURE__ */ A({
  __name: "BgFilter",
  props: {
    label: {}
  },
  setup(e) {
    const o = nt(), t = Bo(), { filters: r } = To({
      parentName: gr.name,
      injectionKey: za()
    });
    return r.value[o] || (r.value[o] = {}), ro(Na(), {
      filterKey: o,
      filters: r
    }), (n, i) => (g(), M(k(U), {
      is: "ul",
      role: "group",
      "aria-labelledby": k(t),
      class: L(n.$style.group)
    }, {
      default: S(() => [
        R(k(U), {
          is: "li",
          id: k(t),
          class: L(n.$style.label),
          role: "presentation"
        }, {
          default: S(() => [
            R(k(Fa), {
              type: "label",
              color: "grey-semi-light"
            }, {
              default: S(() => [
                ie(z(n.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["id", "class"]),
        B(n.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["aria-labelledby", "class"]));
  }
}), m1 = "_label_ipiy3_2", b1 = "_group_ipiy3_7", v1 = {
  label: m1,
  group: b1
}, y1 = {
  $style: v1
}, k1 = /* @__PURE__ */ W(g1, [["__cssModules", y1], ["__scopeId", "data-v-e21511f0"]]), w1 = ["id", "aria-checked", "aria-labelledby"], C1 = ["id"], x1 = /* @__PURE__ */ A({
  __name: "BgFilterOption",
  props: {
    label: {}
  },
  setup(e, { expose: o }) {
    const t = nt(), r = Bo(), { isActive: n } = Et({
      injectionKey: Ea,
      parentName: gr.name
    }), { filterKey: i, filters: a } = To({
      parentName: k1.name,
      injectionKey: Na()
    }), { id: l } = Rr({
      parentName: gr.name,
      injectionKey: Ia
    }), s = H({
      get: () => a.value[i][t],
      set: (c) => {
        a.value[i][t] = c;
      }
    }), d = () => {
      s.value = !s.value;
    };
    return s.value === void 0 && (s.value = !1), o({ toggle: d }), (c, f) => (g(), M(k(U), {
      is: "li",
      role: "option",
      class: L({
        [c.$style.focus]: k(n)
      }),
      onClick: d
    }, {
      default: S(() => [
        P("div", {
          class: L([c.$style.content])
        }, [
          P("div", {
            id: k(l),
            "aria-checked": s.value,
            role: "checkbox",
            "aria-labelledby": k(r)
          }, null, 8, w1),
          P("label", { id: k(r) }, z(c.label), 9, C1)
        ], 2)
      ]),
      _: 1
    }, 8, ["class"]));
  }
}), S1 = "_content_1vy1d_7", $1 = "_focus_1vy1d_49", B1 = {
  content: S1,
  focus: $1
}, _1 = {
  $style: B1
}, mg = /* @__PURE__ */ W(x1, [["__cssModules", _1], ["__scopeId", "data-v-0caca3a6"]]), M1 = ["src"], bg = /* @__PURE__ */ A({
  __name: "BgIllustration",
  props: {
    name: {}
  },
  setup(e) {
    const o = e, t = Z();
    return io(o, ["name"]), se(
      () => o.name,
      (r) => {
        Ra(/* @__PURE__ */ Object.assign({ "./illustrations/boy-explaining.svg": () => import("./boy-explaining-CYC0bpAf.js"), "./illustrations/boy-holding-security-badge.svg": () => import("./boy-holding-security-badge-CIx74uMR.js"), "./illustrations/boy-talking.svg": () => import("./boy-talking-CJB2JEkS.js"), "./illustrations/girl-exchanging-currency.svg": () => import("./girl-exchanging-currency-Co2jD6Wj.js"), "./illustrations/girl-laptop-deadline.svg": () => import("./girl-laptop-deadline-DoCYyKgJ.js"), "./illustrations/girl-looking-pix-alert.svg": () => import("./girl-looking-pix-alert-C-4lhvUe.js"), "./illustrations/girl-with-checkout.svg": () => import("./girl-with-checkout-DtmgZhCp.js") }), `./illustrations/${r}.svg`, 3).then((n) => {
          t.value = n.default;
        });
      },
      {
        immediate: !0
      }
    ), (r, n) => (g(), $("img", {
      src: t.value,
      alt: ""
    }, null, 8, M1));
  }
}), Zr = ({ to: e }) => {
  let o;
  if (!H(() => typeof e == "string" && e.startsWith("http")).value)
    try {
      o = Tl({ to: e });
    } catch (r) {
      console.warn('You need vue-router installed to use the "to" property.', r);
    }
  return o;
}, Wr = /* @__PURE__ */ A({
  __name: "BgLink",
  props: {
    to: {},
    activeClass: {},
    routerLink: {}
  },
  setup(e) {
    const o = e, t = o.routerLink ? Z(o.routerLink) : Z(), r = H(() => typeof o.to == "string" && o.to.startsWith("http"));
    return !r.value && !o.routerLink && (t.value = Zr({ to: o.to })), (n, i) => {
      var a, l, s;
      return r.value ? (g(), M(k(U), y({
        key: 0,
        is: "a"
      }, n.$attrs, {
        href: n.to,
        target: "_blank"
      }), {
        default: S(() => [
          B(n.$slots, "default")
        ]),
        _: 3
      }, 16, ["href"])) : (g(), M(k(U), {
        key: 1,
        is: "a",
        class: L({ [n.activeClass || ""]: (a = k(t)) == null ? void 0 : a.isActive }),
        href: (l = k(t)) == null ? void 0 : l.href,
        onClick: (s = k(t)) == null ? void 0 : s.navigate
      }, {
        default: S(() => [
          B(n.$slots, "default")
        ]),
        _: 3
      }, 8, ["class", "href", "onClick"]));
    };
  }
}), Ha = Symbol("Menu"), mr = Symbol("MenuItemGroup"), T1 = /* @__PURE__ */ A({
  __name: "BgMenu",
  props: {
    offset: { type: [Number, Function] }
  },
  setup(e) {
    const o = Z();
    return ro(Ha, { close: () => {
      var r;
      (r = o.value) == null || r.close();
    } }), (r, n) => (g(), M(k(Ir), {
      ref_key: "popover",
      ref: o,
      offset: r.offset,
      role: "menu"
    }, {
      button: S((i) => [
        B(r.$slots, "button", wr(Cr(i)), void 0, !0)
      ]),
      default: S(() => [
        P("ul", null, [
          B(r.$slots, "default", {}, void 0, !0)
        ]),
        B(r.$slots, "footer", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["offset"]));
  }
}), P1 = {}, D1 = {
  $style: P1
}, O1 = /* @__PURE__ */ W(T1, [["__cssModules", D1], ["__scopeId", "data-v-49a6a15e"]]), R1 = /* @__PURE__ */ A({
  __name: "BgMenuItem",
  props: {
    borderTop: { type: Boolean },
    onClick: { type: Function },
    to: {}
  },
  setup(e) {
    He((l) => ({
      ccba37e2: i
    }));
    const o = So(Ha), t = So(mr, null), r = t == null ? void 0 : t.title, n = (t == null ? void 0 : t.level) ?? 0, i = `calc(${xe.sm} + ${n + (t && !r ? -1 : 0)} * ${xe.sm})`;
    if (!o)
      throw new Error("<bg-menu-item> must be used inside a <bg-menu> component");
    const { close: a } = o;
    return (l, s) => (g(), M(k(U), {
      is: "li",
      role: "presentation",
      class: L({
        [l.$style.borderTop]: l.borderTop,
        [l.$style.clickable]: l.onClick || l.to
      })
    }, {
      default: S(() => [
        l.to ? (g(), M(k(Wr), {
          key: 0,
          role: "menuitem",
          to: l.to,
          class: L([l.$style.content]),
          onClick: s[0] || (s[0] = Qr((d) => k(a)(), ["stop"]))
        }, {
          default: S(() => [
            B(l.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["to", "class"])) : l.onClick ? (g(), M(k(U), {
          key: 1,
          is: "button",
          role: "menuitem",
          class: L([l.$style.content]),
          onClick: s[1] || (s[1] = Qr((d) => {
            l.onClick(), k(a)();
          }, ["stop"]))
        }, {
          default: S(() => [
            B(l.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["class"])) : (g(), M(k(U), {
          key: 2,
          is: "div",
          class: L([l.$style.content])
        }, {
          default: S(() => [
            B(l.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["class"]))
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), L1 = "_content_1mwho_6", A1 = "_border-top_1mwho_21", I1 = "_border-bottom_1mwho_25", E1 = "_clickable_1mwho_29", z1 = {
  content: L1,
  borderTop: A1,
  borderBottom: I1,
  clickable: E1
}, N1 = {
  $style: z1
}, br = /* @__PURE__ */ W(R1, [["__cssModules", N1], ["__scopeId", "data-v-f40352af"]]);
var we = /* @__PURE__ */ ((e) => (e.label = "label", e.BodySm = "body-sm", e.BodyMd = "body-md", e.H1 = "h1", e.H2 = "h2", e.H3 = "h3", e.H4 = "h4", e.H5 = "h5", e.H6 = "h6", e))(we || {}), Va = /* @__PURE__ */ ((e) => (e.Regular = "regular", e.Bold = "bold", e.SemiBold = "semi-bold", e))(Va || {});
const H1 = /* @__PURE__ */ A({
  __name: "BgText",
  props: {
    is: {},
    type: { default: we.BodySm },
    weight: { default: Va.Regular },
    color: {}
  },
  setup(e) {
    He((a) => ({
      "5d1d7104": n.value,
      "4666614e": i.value
    }));
    const o = e, t = () => ({
      [we.label]: {
        is: o.is || "small",
        font: Fe.label
      },
      [we.BodySm]: {
        is: o.is || "p",
        font: Fe.bodySm
      },
      [we.BodyMd]: {
        is: o.is || "p",
        font: Fe.bodyMd
      },
      [we.H1]: {
        is: o.is || "h1",
        font: Fe.h1
      },
      [we.H2]: {
        is: o.is || "h2",
        font: Fe.h2
      },
      [we.H3]: {
        is: o.is || "h3",
        font: Fe.h3
      },
      [we.H4]: {
        is: o.is || "h4",
        font: Fe.h4
      },
      [we.H5]: {
        is: o.is || "h5",
        font: Fe.h5
      },
      [we.H6]: {
        is: o.is || "h6",
        font: Fe.h6
      }
    }), r = H(() => t()[o.type].is), n = H(
      () => t()[o.type].font[Bl(o.weight)]
    ), i = H(() => o.color ? ce(o.color) : void 0);
    return (a, l) => (g(), M(k(U), {
      is: r.value,
      class: L(a.$style.font)
    }, {
      default: S(() => [
        B(a.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["is", "class"]));
  }
}), V1 = "_font_o5f7b_2", F1 = {
  font: V1
}, j1 = {
  $style: F1
}, Fa = /* @__PURE__ */ W(H1, [["__cssModules", j1], ["__scopeId", "data-v-cc579116"]]), Z1 = ["id"], W1 = /* @__PURE__ */ A({
  __name: "BgMenuItemGroup",
  props: {
    title: {}
  },
  setup(e) {
    const o = e, { level: t } = So(mr, { level: 0 }), r = Bo();
    return ro(mr, {
      level: t + 1,
      title: o.title
    }), (n, i) => (g(), M(k(U), {
      is: "li",
      role: "menuitem",
      "aria-labelledby": k(r),
      class: L({
        [n.$style.group]: !0
      })
    }, {
      default: S(() => [
        n.title ? (g(), $("div", {
          key: 0,
          id: k(r),
          class: L(n.$style.title)
        }, [
          R(k(Fa), {
            type: "label",
            color: "grey-semi-light"
          }, {
            default: S(() => [
              ie(z(n.title), 1)
            ]),
            _: 1
          })
        ], 10, Z1)) : I("", !0),
        R(k(U), { is: "ul" }, {
          default: S(() => [
            B(n.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["aria-labelledby", "class"]));
  }
}), Y1 = "_title_1lk9u_2", K1 = "_group_1lk9u_7", U1 = "_border-top_1lk9u_12", G1 = "_border-bottom_1lk9u_16", q1 = {
  title: Y1,
  group: K1,
  borderTop: U1,
  borderBottom: G1
}, X1 = {
  $style: q1
}, ni = /* @__PURE__ */ W(W1, [["__cssModules", X1], ["__scopeId", "data-v-d27d87e0"]]), Q1 = /* @__PURE__ */ A({
  __name: "BgMenuItemFooter",
  props: {
    borderTop: { type: Boolean },
    onClick: { type: Function },
    to: {}
  },
  setup(e) {
    const o = e;
    return (t, r) => (g(), M(br, y(o, {
      class: t.$style.item
    }), {
      default: S(() => [
        B(t.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), J1 = "_item_x2ini_2", eh = {
  item: J1
}, oh = {
  $style: eh
}, th = /* @__PURE__ */ W(Q1, [["__cssModules", oh], ["__scopeId", "data-v-8f1d4cfc"]]), rh = /* @__PURE__ */ A({
  __name: "BgPagination",
  props: /* @__PURE__ */ $o({
    next: {},
    previous: {}
  }, {
    pageCursor: {},
    pageCursorModifiers: {}
  }),
  emits: /* @__PURE__ */ $o(["next", "previous"], ["update:pageCursor"]),
  setup(e, { emit: o }) {
    const t = kt(e, "pageCursor"), r = e, n = () => {
      t.value = r.next, a("next");
    }, i = () => {
      t.value = r.previous, a("previous");
    }, a = o;
    return (l, s) => (g(), $("div", {
      class: L(l.$style.container)
    }, [
      R(Oe, {
        icon: "caret-left",
        "aria-label": "Página anterior",
        variant: "ghost",
        disabled: !r.previous,
        size: "sm",
        onClick: i
      }, null, 8, ["disabled"]),
      R(Oe, {
        icon: "caret-right",
        "aria-label": "Próxima página",
        variant: "ghost",
        size: "sm",
        disabled: !r.next,
        onClick: n
      }, null, 8, ["disabled"])
    ], 2));
  }
}), nh = "_container_1txwr_2", ih = {
  container: nh
}, ah = {
  $style: ih
}, vg = /* @__PURE__ */ W(rh, [["__cssModules", ah]]), ja = Symbol("BgSidebarRegister"), Za = Symbol("BgSidebarList"), Wa = Symbol("BgSidebarGroupContext"), lh = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 104 20"
}, sh = /* @__PURE__ */ _l('<title>Transfeera Logo</title><path fill="#1FD1C2" fill-rule="evenodd" d="M36.844 12.958v-5.25h-1.461a.69.69 0 0 1-.685-.684.69.69 0 0 1 .685-.683h4.462a.69.69 0 0 1 .684.683.69.69 0 0 1-.684.684H38.4v5.25a.69.69 0 0 1-.684.683h-.202a.677.677 0 0 1-.669-.683M45.444 13.253l-1.213-2.206h-1.136v1.833c0 .42-.341.76-.762.761h-.03a.763.763 0 0 1-.763-.761V6.341h3.421c1.524 0 2.472.994 2.472 2.36 0 1.274-.824 1.973-1.617 2.16l.964 1.615a.755.755 0 0 1-.653 1.15.76.76 0 0 1-.684-.373m.373-4.565c0-.606-.467-.978-1.089-.978H43.08v1.973h1.648c.622-.003 1.089-.375 1.089-.995M53.452 13.144l-.28-.73h-3.125l-.28.73a.74.74 0 0 1-.716.497h-.108c-.528 0-.918-.543-.716-1.04l2.068-5.36a1.44 1.44 0 0 1 1.338-.916c.59.005 1.12.368 1.337.917l2.067 5.357a.762.762 0 0 1-.715 1.041h-.109c-.357.001-.653-.185-.761-.496m-1.835-5.25-1.136 3.138h2.27zM60.791 13.175l-3.156-4.302v3.99a.77.77 0 0 1-.779.778.77.77 0 0 1-.777-.778v-5.53c.004-.546.447-.99.995-.993.38 0 .737.178.964.481l3.033 4.1V7.118a.77.77 0 0 1 .777-.777.77.77 0 0 1 .778.777v5.591a.935.935 0 0 1-.933.932 1.16 1.16 0 0 1-.902-.466M63.963 11.933c.233-.342.684-.404 1.027-.188.52.346 1.132.53 1.757.526.855 0 1.275-.373 1.275-.807 0-1.274-4.214-.373-4.214-3.122 0-1.212 1.057-2.237 2.783-2.237.84 0 1.57.171 2.193.527a.734.734 0 0 1 .232 1.056.73.73 0 0 1-.933.202 3.14 3.14 0 0 0-1.617-.42c-.653 0-1.026.28-1.026.715 0 1.15 4.198.373 4.198 3.107 0 1.336-.964 2.345-2.923 2.345-1.058 0-1.883-.263-2.52-.683a.685.685 0 0 1-.232-1.021M70.65 12.958V6.34h4.493a.69.69 0 0 1 .685.683.69.69 0 0 1-.685.684H72.22v1.537h1.461a.69.69 0 0 1 .685.684.69.69 0 0 1-.684.684h-1.462v2.345a.69.69 0 0 1-.685.683h-.188a.683.683 0 0 1-.697-.683M76.9 13.641v-7.3h4.495a.69.69 0 0 1 .684.683.69.69 0 0 1-.684.684H78.47v1.537h1.462a.69.69 0 0 1 .684.684.69.69 0 0 1-.684.684H78.47v1.662h2.924a.69.69 0 0 1 .684.683.69.69 0 0 1-.684.683zM83.292 13.641v-7.3h4.493a.69.69 0 0 1 .685.683.69.69 0 0 1-.685.684h-2.923v1.537h1.462a.69.69 0 0 1 .684.684.69.69 0 0 1-.684.684h-1.462v1.662h2.924a.69.69 0 0 1 .684.683.69.69 0 0 1-.684.683zM93.601 13.253l-1.213-2.206h-1.135v1.833c0 .42-.341.76-.762.761h-.031a.763.763 0 0 1-.762-.761V6.341h3.421c1.524 0 2.472.994 2.472 2.36 0 1.274-.824 1.973-1.617 2.16l.964 1.615a.755.755 0 0 1-.653 1.15.75.75 0 0 1-.684-.373m.373-4.565c0-.606-.466-.978-1.088-.978h-1.649v1.973h1.649c.622-.003 1.088-.375 1.088-.995M101.609 13.144l-.279-.73h-3.126l-.28.73a.74.74 0 0 1-.715.497h-.14c-.527 0-.917-.543-.715-1.04l2.068-5.36a1.44 1.44 0 0 1 1.338-.916c.591.005 1.12.368 1.337.917l2.067 5.357a.762.762 0 0 1-.715 1.041h-.108a.76.76 0 0 1-.732-.496m-1.85-5.25-1.135 3.138h2.286zM11.647 18.833V3.495H9.314v15.338a1.174 1.174 0 0 0 1.168 1.166 1.165 1.165 0 0 0 1.165-1.166M25.642 18.833V5.243H23.31v13.59a1.174 1.174 0 0 0 1.167 1.166 1.165 1.165 0 0 0 1.165-1.166M18.645 14.81v4.024A1.174 1.174 0 0 0 19.812 20a1.174 1.174 0 0 0 1.167-1.166v-2.378a1.945 1.945 0 0 0-1.555-1.91c-.126-.031-.78-.19-.78.264M6.982 12.884v-9.39H4.649v9.11q1.166.117 2.333.28M4.65 15.286v3.547a1.174 1.174 0 0 0 1.167 1.166 1.174 1.174 0 0 0 1.167-1.166v-1.916c0-.997-.75-1.834-1.742-1.942-.08-.016-.593-.03-.593.31" clip-rule="evenodd"></path><path fill="#1FD1C2" fill-rule="evenodd" d="M6.982 3.495a1.167 1.167 0 0 1 2.332 0h2.333A3.497 3.497 0 0 0 8.148 0 3.497 3.497 0 0 0 4.65 3.495zM20.977 5.242a1.167 1.167 0 0 1 2.333 0h2.332a3.497 3.497 0 0 0-3.499-3.495 3.497 3.497 0 0 0-3.498 3.495zM25.02 11.719v2.347q2.401.327 4.758.792a.436.436 0 0 0 .513-.419 2.25 2.25 0 0 0-1.866-2.206q-1.68-.281-3.405-.514M8.242 11.502c-2.563.26-5.112.65-7.635 1.165a.76.76 0 0 0-.607.745 1.433 1.433 0 0 0 1.726 1.398c1.82-.357 3.67-.652 5.52-.87a1.634 1.634 0 0 0 1.462-1.63v-.388c-.016-.25-.218-.45-.466-.42M15.644 11.129c-1.54 0-3.08.046-4.603.14v2.33a75 75 0 0 1 9.89.048c.948.077 1.757-.684 1.757-1.647v-.17a.42.42 0 0 0-.373-.42 86 86 0 0 0-6.671-.281" clip-rule="evenodd"></path><path fill="#1FD1C2" fill-rule="evenodd" d="M8.692 3.605a.508.508 0 0 0-.832-.393l-.007.006-.003.003a.77.77 0 0 0-.075 1.12q.195.213.395.413a.306.306 0 0 0 .521-.216zM22.424 5.109a.775.775 0 0 0-1.025-.18c-1.548.976-5.929 3.162-10.375.186v1.816a9.9 9.9 0 0 0 4.804 1.234c.665 0 1.329-.064 1.983-.188 1.976-.371 3.555-1.203 4.413-1.736a.773.773 0 0 0 .2-1.132" clip-rule="evenodd"></path><path fill="#1FD1C2" fill-rule="evenodd" d="M20.977 6.208v-.966h-2.332v1.773a11 11 0 0 0 2.332-.807M18.645 9.748v2.266c.793.155 1.57.31 2.332.481V8.392a.346.346 0 0 0-.466-.323 13 13 0 0 1-.788.257 1.485 1.485 0 0 0-1.078 1.422" clip-rule="evenodd"></path><path fill="#1FD1C2" fill-rule="evenodd" d="M20.86 1.747h2.56c1.226 0 2.22.992 2.22 2.216v1.28h-1.793l-1.709-2.089-1.79 2.088h-1.71V3.963a2.215 2.215 0 0 1 2.222-2.216M6.863 0h2.56c1.226 0 2.219.992 2.219 2.216v1.279h-1.79L8.143 1.407l-1.79 2.088H4.645V2.216C4.645.992 5.638 0 6.863 0" clip-rule="evenodd"></path>', 6), ch = [
  sh
];
function dh(e, o) {
  return g(), $("svg", lh, [...ch]);
}
const ii = { render: dh }, uh = /* @__PURE__ */ A({
  __name: "BgSidebar",
  props: {
    logoTo: {}
  },
  setup(e) {
    const o = e, { items: t } = Or({
      injectionKey: ja,
      onRegister() {
        r(0);
      }
    }), { activateByIndex: r } = Dr({
      injectionKey: Za,
      items: t
    }), n = Z();
    return o.logoTo && (n.value = Zr({ to: o.logoTo })), (i, a) => (g(), M(k(U), { is: "nav" }, {
      default: S(() => [
        R(k(U), { is: "header" }, {
          default: S(() => [
            B(i.$slots, "logo", {}, () => [
              i.logoTo ? (g(), M(k(Wr), {
                key: 0,
                "router-link": n.value,
                to: i.logoTo
              }, {
                default: S(() => [
                  R(k(ii), { height: "20px" })
                ]),
                _: 1
              }, 8, ["router-link", "to"])) : (g(), M(k(ii), {
                key: 1,
                height: "20px"
              }))
            ], !0)
          ]),
          _: 3
        }),
        R(k(U), { is: "ul" }, {
          default: S(() => [
            B(i.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), ph = {}, fh = {
  $style: ph
}, ai = /* @__PURE__ */ W(uh, [["__cssModules", fh], ["__scopeId", "data-v-4682fb89"]]), hh = /* @__PURE__ */ A({
  render: () => R(Co, {
    name: "alert",
    color: "red-semi-light"
  }, null)
}), gh = /* @__PURE__ */ A({
  render: () => R(As, {
    size: "sm",
    color: "green-semi-light"
  }, {
    default: () => [ie("Novo")]
  })
}), mh = /* @__PURE__ */ A({
  __name: "BgSidebarDecoration",
  props: {
    type: {}
  },
  setup(e) {
    const o = e, t = H(() => ({
      alert: hh,
      new: gh
    })[o.type]);
    return (r, n) => (g(), M(fe(t.value), {
      class: L(r.$style.decoration)
    }, null, 8, ["class"]));
  }
}), bh = "_decoration_1s8ys_2", vh = {
  decoration: bh
}, yh = {
  $style: vh
}, Ya = /* @__PURE__ */ W(mh, [["__cssModules", yh], ["__scopeId", "data-v-95113f13"]]), kh = A({
  name: "BgSidebarGroup"
}), wh = /* @__PURE__ */ A({
  ...kh,
  props: {
    label: {},
    icon: {},
    decoration: {}
  },
  setup(e) {
    const o = e, t = Z(!1), { id: r } = Rr({
      parentName: ai.name,
      injectionKey: ja
    }), { isActive: n, toggle: i, activate: a } = Et({
      parentName: ai.name,
      injectionKey: Za
    });
    return se(n, (l) => {
      t.value = l;
    }), io(o, ["label"]), ro(Wa, {
      activate: a
    }), (l, s) => (g(), M(k(U), { is: "li" }, {
      default: S(() => [
        R(k(U), {
          is: "button",
          "aria-expanded": t.value,
          "aria-controls": k(r),
          class: L(l.$style.group),
          onClick: k(i)
        }, {
          default: S(() => [
            P("span", {
              class: L(l.$style.label)
            }, [
              R(k(Co), {
                class: L(t.value ? l.$style.caretDown : l.$style.caretRight),
                name: "caret-down",
                size: "xs"
              }, null, 8, ["class"]),
              ie(" " + z(l.label), 1)
            ], 2),
            P("span", null, [
              l.decoration ? (g(), M(Ya, {
                key: 0,
                type: l.decoration
              }, null, 8, ["type"])) : l.icon ? (g(), M(k(Co), {
                key: 1,
                name: l.icon.name,
                class: L(l.$style.icon)
              }, null, 8, ["name", "class"])) : I("", !0)
            ])
          ]),
          _: 1
        }, 8, ["aria-expanded", "aria-controls", "class", "onClick"]),
        R(k(U), {
          is: "ul",
          id: k(r),
          hidden: !t.value,
          class: L([l.$style.items])
        }, {
          default: S(() => [
            B(l.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 8, ["id", "hidden", "class"])
      ]),
      _: 3
    }));
  }
}), Ch = "_caret-right_1tota_14", xh = "_caret-down_1tota_19", Sh = "_group_1tota_24", $h = "_icon_1tota_40", Bh = "_label_1tota_45", _h = {
  caretRight: Ch,
  caretDown: xh,
  group: Sh,
  icon: $h,
  label: Bh
}, Mh = {
  $style: _h
}, Th = /* @__PURE__ */ W(wh, [["__cssModules", Mh], ["__scopeId", "data-v-21d114dd"]]), Ph = /* @__PURE__ */ A({
  __name: "BgSidebarItem",
  props: {
    label: {},
    decoration: {},
    to: {}
  },
  setup(e) {
    const o = e, t = Zr({ to: o.to }), { activate: r } = To({
      parentName: Th.name,
      injectionKey: Wa
    });
    return io(o, ["label"]), t && se(t.isActive, (n) => {
      n && r();
    }), (n, i) => (g(), M(k(U), { is: "li" }, {
      default: S(() => [
        R(k(Wr), {
          to: n.to,
          "active-class": n.$style.active,
          class: L(n.$style.content),
          "router-link": k(t)
        }, {
          default: S(() => [
            ie(z(n.label) + " ", 1),
            n.decoration ? (g(), M(Ya, {
              key: 0,
              type: n.decoration
            }, null, 8, ["type"])) : I("", !0)
          ]),
          _: 1
        }, 8, ["to", "active-class", "class", "router-link"])
      ]),
      _: 1
    }));
  }
}), Dh = "_content_13vqd_8", Oh = "_active_13vqd_27", Rh = {
  content: Dh,
  active: Oh
}, Lh = {
  $style: Rh
}, yg = /* @__PURE__ */ W(Ph, [["__cssModules", Lh], ["__scopeId", "data-v-be553028"]]), Ka = Symbol("BgTabsRegister"), Yr = Symbol("BgTabsList"), Ua = Symbol("BgTabs"), Ah = { class: "bg-tabs" }, Ih = { role: "tablist" }, Eh = /* @__PURE__ */ A({
  __name: "BgTabs",
  props: {
    type: { default: "line" },
    activeTab: {}
  },
  emits: ["update:activeTab"],
  setup(e, { emit: o }) {
    const t = e, r = o, n = Ot({}), { items: i } = Or({
      injectionKey: Ka,
      onRegister: (s, d) => {
        n[d] = s, l(t.activeTab);
      }
    }), { activeItem: a, activate: l } = Dr({
      injectionKey: Yr,
      items: i
    });
    return ro(Ua, {
      useIdByKey: (s) => Ml(n, s)
    }), se(
      () => t.activeTab,
      (s) => {
        s && n[s] && l(s);
      }
    ), se(a, (s) => {
      r("update:activeTab", s == null ? void 0 : s.key);
    }), (s, d) => (g(), $("div", Ah, [
      P("div", Ih, [
        B(s.$slots, "tabs", {}, void 0, !0)
      ]),
      B(s.$slots, "panels", {}, void 0, !0)
    ]));
  }
}), kg = /* @__PURE__ */ W(Eh, [["__scopeId", "data-v-7a5cd42f"]]), zh = "_focus-visible-outline_154v1_2", Nh = "_focus-visible-inline_154v1_8", Hh = "_font_154v1_19", vr = {
  focusVisibleOutline: zh,
  focusVisibleInline: Nh,
  font: Hh
}, Vh = A({
  name: "BgTab"
}), Fh = /* @__PURE__ */ A({
  ...Vh,
  setup(e) {
    const o = Z(), { id: t } = Rr({
      parentName: "BgTabs",
      injectionKey: Ka
    }), { next: r, prev: n, activate: i, isActive: a } = Et({
      parentName: "BgTabs",
      injectionKey: Yr
    });
    return se(a, (l) => {
      var s;
      l && ((s = o.value) == null || s.$el.focus());
    }), (l, s) => (g(), M(k(U), {
      is: "button",
      ref_key: "buttonRef",
      ref: o,
      role: "tab",
      class: L([k(vr).focusVisibleInline, k(vr).font]),
      tabindex: k(a) ? 0 : -1,
      "aria-controls": k(t),
      "aria-selected": k(a),
      "data-state": k(a) ? "selected" : "unselected",
      onKeydown: [
        s[0] || (s[0] = K((d) => k(r)(), ["right"])),
        s[1] || (s[1] = K((d) => k(n)(), ["left"]))
      ],
      onClick: k(i)
    }, {
      default: S(() => [
        B(l.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 8, ["class", "tabindex", "aria-controls", "aria-selected", "data-state", "onClick"]));
  }
}), wg = /* @__PURE__ */ W(Fh, [["__scopeId", "data-v-9f4aff6c"]]), jh = ["id", "tabindex"], Zh = A({
  name: "BgTabPanel"
}), Wh = /* @__PURE__ */ A({
  ...Zh,
  setup(e) {
    const { isActive: o } = Et({
      parentName: "BgTabs",
      injectionKey: Yr
    }), { useIdByKey: t } = To({
      parentName: "BgTabs",
      injectionKey: Ua
    }), r = nt(), n = t(r);
    return (i, a) => (g(), $("div", y({
      id: k(n),
      class: k(vr).focusVisibleInline,
      role: "tabpanel",
      tabindex: k(o) ? 0 : -1
    }, { "data-state": k(o) ? "active" : "inactive" }), [
      k(o) ? B(i.$slots, "default", { key: 0 }, void 0, !0) : I("", !0)
    ], 16, jh));
  }
}), Cg = /* @__PURE__ */ W(Wh, [["__scopeId", "data-v-5e9d981b"]]);
var yr = /* @__PURE__ */ ((e) => (e.GreenSemiLight = "green-semi-light", e))(yr || {}), kr = /* @__PURE__ */ ((e) => (e.Sm = "sm", e))(kr || {});
const Yh = /* @__PURE__ */ A({
  __name: "BgAvatar",
  props: {
    fullName: {},
    color: { default: yr.GreenSemiLight },
    size: { default: kr.Sm }
  },
  setup(e) {
    He((i) => ({
      "5016fb68": r.value.backgroundColor,
      "394358cc": r.value.color,
      "094c0790": n.value.height,
      "1faac6d6": n.value.width
    }));
    const o = e;
    io(o, ["fullName"]);
    const t = H(() => {
      const i = o.fullName.split(" ").filter((s) => s.trim() !== ""), a = i[0], l = i.length > 1 ? i[i.length - 1] : "";
      return a.charAt(0).toUpperCase() + (l == null ? void 0 : l.charAt(0).toUpperCase());
    }), r = H(() => ({
      [yr.GreenSemiLight]: {
        backgroundColor: le.green.semiLight,
        color: le.grey.white
      }
    })[o.color]), n = H(() => ({
      [kr.Sm]: {
        fontSize: or[2],
        fontWeight: Pl.semiBold,
        width: "40px",
        height: "40px"
      }
    })[o.size]);
    return (i, a) => (g(), M(k(U), {
      is: "div",
      role: "img",
      "aria-label": `Avatar para ${i.fullName}`
    }, {
      default: S(() => [
        ie(z(t.value), 1)
      ]),
      _: 1
    }, 8, ["aria-label"]));
  }
}), Kh = {}, Uh = {
  $style: Kh
}, li = /* @__PURE__ */ W(Yh, [["__cssModules", Uh], ["__scopeId", "data-v-c2c29505"]]), Gh = {};
function qh(e, o) {
  return g(), $("li", null, [
    B(e.$slots, "default", {}, void 0, !0)
  ]);
}
const Xh = /* @__PURE__ */ W(Gh, [["render", qh], ["__scopeId", "data-v-0a1fbbf0"]]), Qh = { "aria-label": "Main Navigation" }, si = 64, Jh = /* @__PURE__ */ A({
  __name: "BgTopbar",
  props: {
    profileMenuItemGroups: {},
    profileFullName: {},
    footerMenuItems: {}
  },
  setup(e) {
    return He((t) => ({
      ee4e0560: si
    })), io(e, ["profileFullName", "profileMenuItemGroups"]), (t, r) => (g(), $("nav", Qh, [
      R(k(U), { is: "ul" }, {
        default: S(() => [
          B(t.$slots, "left", {}, void 0, !0)
        ]),
        _: 3
      }),
      R(k(U), { is: "ul" }, {
        default: S(() => [
          B(t.$slots, "right", {}, void 0, !0),
          R(Xh, null, {
            default: S(() => [
              R(k(O1), {
                offset: (n) => 1 + (si - n.reference.height) / 2
              }, {
                button: S((n) => [
                  R(k(U), y({ is: "button" }, n), {
                    default: S(() => [
                      R(k(li), { "full-name": t.profileFullName }, null, 8, ["full-name"])
                    ]),
                    _: 2
                  }, 1040)
                ]),
                footer: S(() => [
                  (g(!0), $(pe, null, Ze(t.footerMenuItems, (n) => (g(), M(k(th), {
                    key: n.label,
                    to: n.to,
                    onClick: n.onClick
                  }, {
                    default: S(() => [
                      ie(z(n.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "onClick"]))), 128))
                ]),
                default: S(() => [
                  R(k(ni), null, {
                    default: S(() => [
                      R(k(br), null, {
                        default: S(() => [
                          P("div", {
                            class: L(t.$style.avatarHeader)
                          }, [
                            R(k(li), { "full-name": t.profileFullName }, null, 8, ["full-name"]),
                            ie(" " + z(t.profileFullName), 1)
                          ], 2)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (g(!0), $(pe, null, Ze(t.profileMenuItemGroups, (n) => (g(), M(k(ni), {
                    key: n.label,
                    title: n.label
                  }, {
                    default: S(() => [
                      (g(!0), $(pe, null, Ze(n.items, (i) => (g(), M(k(br), {
                        key: i.label,
                        to: i.to,
                        onClick: i.onClick
                      }, {
                        default: S(() => [
                          ie(z(i.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["to", "onClick"]))), 128))
                    ]),
                    _: 2
                  }, 1032, ["title"]))), 128))
                ]),
                _: 1
              }, 8, ["offset"])
            ]),
            _: 1
          })
        ]),
        _: 3
      })
    ]));
  }
}), eg = "_avatar-header_fg9nk_2", og = {
  avatarHeader: eg
}, tg = {
  $style: og
}, xg = /* @__PURE__ */ W(Jh, [["__cssModules", tg], ["__scopeId", "data-v-1e938a51"]]), rg = (e) => ({
  ...Ga(),
  ...e
}), ng = (e = []) => {
  const o = new URLSearchParams(window.location.search);
  for (const t of e)
    o.delete(t);
  return Ga(o);
}, Ga = (e = new URLSearchParams(window.location.search)) => {
  const o = {};
  for (const [t, r] of e.entries())
    o[t] = r;
  return o;
}, ig = Symbol("DialogStack"), Sg = (e, { router: o }) => {
  const t = (n) => n ? rg({ dialog: `${n}` }) : ng(["dialog"]), r = {
    stack: [],
    get size() {
      return this.stack.length;
    },
    open(n) {
      return this.stack.push({ ref: n }), o.push({ query: t(this.size) });
    },
    async close(n) {
      const i = this.stack.findIndex((a) => a.ref === n);
      if (i !== -1)
        return this.stack.splice(i, 1), this.size === 0 ? o.replace({ query: t(0) }) : o.go(-1);
    },
    async pop() {
      var i, a;
      if (this.size === 0)
        return;
      const n = this.stack.pop();
      await ((a = (i = n == null ? void 0 : n.ref) == null ? void 0 : i.close) == null ? void 0 : a.call(i));
    }
  };
  o.beforeEach(async (n, i, a) => {
    var f, u;
    const l = Number(((f = i == null ? void 0 : i.query) == null ? void 0 : f.dialog) || 0), s = Number(((u = n == null ? void 0 : n.query) == null ? void 0 : u.dialog) || 0), d = l < s, c = l > s;
    return !r.size && s ? a({ ...n, query: t(0) }) : (c && r.size > s && await r.pop(), d ? r.size < s ? a(!1) : a(!!r.size) : a());
  }), e.provide(ig, {
    open: r.open.bind(r),
    close: r.close.bind(r)
  });
};
export {
  As as BgBadge,
  Oe as BgButton,
  cg as BgCard,
  pg as BgColumn,
  na as BgColumnWidths,
  ug as BgColumns,
  ia as BgColumnsHAligns,
  dg as BgColumnsInjectionKey,
  aa as BgColumnsVAligns,
  fg as BgDataTable,
  gg as BgDateFilter,
  k1 as BgFilter,
  mg as BgFilterOption,
  gr as BgFilters,
  Co as BgIcon,
  bg as BgIllustration,
  Wr as BgLink,
  O1 as BgMenu,
  br as BgMenuItem,
  th as BgMenuItemFooter,
  ni as BgMenuItemGroup,
  vg as BgPagination,
  ai as BgSidebar,
  Th as BgSidebarGroup,
  yg as BgSidebarItem,
  Gc as BgStack,
  wg as BgTab,
  Cg as BgTabPanel,
  kg as BgTabs,
  Fa as BgText,
  xg as BgTopbar,
  Xh as BgTopbarItem,
  hg as Bridge,
  Sg as DialogStack,
  ig as DialogStackIK
};
//# sourceMappingURL=bridge.js.map
